var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwagramaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 527.52 518.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2a2a2a;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-91, .cls-92, .cls-93, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-100, .cls-101, .cls-102, .cls-103, .cls-104, .cls-105, .cls-106, .cls-107, .cls-108, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-114, .cls-115, .cls-116, .cls-117, .cls-118, .cls-119, .cls-120, .cls-121, .cls-122, .cls-123, .cls-124, .cls-125, .cls-126, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-132, .cls-133, .cls-134, .cls-135, .cls-136, .cls-137, .cls-138, .cls-139, .cls-140, .cls-141, .cls-142, .cls-143, .cls-144, .cls-145, .cls-146, .cls-147, .cls-148, .cls-149, .cls-150, .cls-151, .cls-152, .cls-153, .cls-154, .cls-155, .cls-156, .cls-157, .cls-158, .cls-159, .cls-160, .cls-161, .cls-162, .cls-163, .cls-164, .cls-165, .cls-166, .cls-167, .cls-168, .cls-169, .cls-170, .cls-171, .cls-172, .cls-173, .cls-174, .cls-175, .cls-176, .cls-177, .cls-178, .cls-179, .cls-180, .cls-181, .cls-182, .cls-183, .cls-184, .cls-185, .cls-186, .cls-187, .cls-188, .cls-189, .cls-190, .cls-191, .cls-192, .cls-193, .cls-194, .cls-195, .cls-196, .cls-197, .cls-198, .cls-199, .cls-200, .cls-201, .cls-202, .cls-203, .cls-204, .cls-205, .cls-206, .cls-207, .cls-208, .cls-209, .cls-210, .cls-211, .cls-212, .cls-213, .cls-214, .cls-215, .cls-216, .cls-217, .cls-218, .cls-219, .cls-220, .cls-221, .cls-222, .cls-223, .cls-224, .cls-225, .cls-226, .cls-227, .cls-228, .cls-229, .cls-230, .cls-231, .cls-232, .cls-233, .cls-234, .cls-235, .cls-236, .cls-237, .cls-238, .cls-239, .cls-240, .cls-241, .cls-242, .cls-243, .cls-244, .cls-245, .cls-246, .cls-247, .cls-248, .cls-249, .cls-250, .cls-251, .cls-252, .cls-253, .cls-254, .cls-255, .cls-256, .cls-257, .cls-258, .cls-259, .cls-260, .cls-261, .cls-262, .cls-263, .cls-264, .cls-265, .cls-266, .cls-267, .cls-268, .cls-269, .cls-270, .cls-271, .cls-272, .cls-273, .cls-274, .cls-275, .cls-276, .cls-277, .cls-278, .cls-279, .cls-280, .cls-281, .cls-282, .cls-283, .cls-284, .cls-285, .cls-286, .cls-287, .cls-288, .cls-289, .cls-290, .cls-291, .cls-292, .cls-293, .cls-294, .cls-295, .cls-296, .cls-297, .cls-298, .cls-299, .cls-300, .cls-301, .cls-302, .cls-303, .cls-304, .cls-305, .cls-306, .cls-307, .cls-308, .cls-309, .cls-310, .cls-311, .cls-312, .cls-313, .cls-314, .cls-315, .cls-316, .cls-317, .cls-318, .cls-319, .cls-320, .cls-321, .cls-322, .cls-323, .cls-324, .cls-325, .cls-326, .cls-327, .cls-328, .cls-329, .cls-330, .cls-331, .cls-332, .cls-333, .cls-334, .cls-335, .cls-336, .cls-337, .cls-338, .cls-339, .cls-340, .cls-341, .cls-342, .cls-343, .cls-344, .cls-345, .cls-346, .cls-347, .cls-348, .cls-349, .cls-350, .cls-351, .cls-352, .cls-353, .cls-354, .cls-355, .cls-356, .cls-357, .cls-358, .cls-359, .cls-360, .cls-361, .cls-362, .cls-363, .cls-364, .cls-365, .cls-366, .cls-367, .cls-368, .cls-369, .cls-370, .cls-371, .cls-372, .cls-373, .cls-374, .cls-375, .cls-376, .cls-377, .cls-378, .cls-379, .cls-380, .cls-381, .cls-382, .cls-383, .cls-384, .cls-385, .cls-386, .cls-387, .cls-388, .cls-389, .cls-390, .cls-391, .cls-392, .cls-393, .cls-394, .cls-395, .cls-396, .cls-397, .cls-398, .cls-399, .cls-400, .cls-401, .cls-402, .cls-403, .cls-404, .cls-405, .cls-406, .cls-407, .cls-408, .cls-409, .cls-410 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-446);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-321);\n      }\n\n      .cls-411 {\n        fill: url(#linear-gradient-304);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-394);\n      }\n\n      .cls-412, .cls-141, .cls-413, .cls-414 {\n        fill: none;\n      }\n\n      .cls-412, .cls-413, .cls-414 {\n        stroke: #231f20;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-473);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-360);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-258);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-265);\n      }\n\n      .cls-415 {\n        fill: url(#linear-gradient-277);\n      }\n\n      .cls-9 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-34);\n      }\n\n      .cls-9, .cls-10, .cls-20, .cls-25, .cls-30, .cls-31, .cls-39, .cls-41, .cls-64, .cls-68, .cls-85, .cls-88, .cls-92, .cls-100, .cls-103, .cls-111, .cls-126, .cls-129, .cls-135, .cls-137, .cls-156, .cls-164, .cls-176, .cls-178, .cls-183, .cls-192, .cls-209, .cls-217, .cls-225, .cls-416, .cls-229, .cls-232, .cls-234, .cls-250, .cls-260, .cls-263, .cls-272, .cls-286, .cls-305, .cls-313, .cls-318, .cls-319, .cls-333, .cls-341, .cls-350, .cls-354, .cls-358, .cls-369, .cls-388, .cls-391, .cls-399 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-9, .cls-10, .cls-20, .cls-25, .cls-30, .cls-31, .cls-39, .cls-41, .cls-64, .cls-68, .cls-85, .cls-88, .cls-92, .cls-100, .cls-103, .cls-111, .cls-126, .cls-129, .cls-135, .cls-137, .cls-156, .cls-164, .cls-176, .cls-178, .cls-183, .cls-192, .cls-209, .cls-217, .cls-225, .cls-229, .cls-232, .cls-234, .cls-250, .cls-260, .cls-263, .cls-272, .cls-286, .cls-305, .cls-313, .cls-318, .cls-319, .cls-333, .cls-341, .cls-350, .cls-354, .cls-358, .cls-369, .cls-391, .cls-399 {\n        opacity: .5;\n      }\n\n      .cls-10 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-12);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-362);\n      }\n\n      .cls-417 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-233);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-366);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-333);\n      }\n\n      .cls-418 {\n        fill: url(#linear-gradient-257);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-296);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-244);\n      }\n\n      .cls-419 {\n        fill: url(#linear-gradient-308);\n      }\n\n      .cls-420 {\n        clip-path: url(#clippath-135);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-127);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-159);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-132);\n      }\n\n      .cls-20 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-21);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-358);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-464);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-283);\n      }\n\n      .cls-421 {\n        fill: url(#linear-gradient-168);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-309);\n      }\n\n      .cls-25 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-32);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-432);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-318);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-88);\n      }\n\n      .cls-422 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-225);\n      }\n\n      .cls-30 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73);\n      }\n\n      .cls-423 {\n        fill: url(#linear-gradient-157);\n      }\n\n      .cls-31 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-3);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-175);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-62);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-458);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-470);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-396);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-92);\n      }\n\n      .cls-39 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-22);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-365);\n      }\n\n      .cls-41 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-4);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-441);\n      }\n\n      .cls-43 {\n        fill: #231f20;\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-463);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-98);\n      }\n\n      .cls-424 {\n        fill: url(#linear-gradient-192);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-139);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-359);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-424);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-328);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-67);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-153);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-138);\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-443);\n      }\n\n      .cls-425 {\n        fill: url(#linear-gradient-263);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-209);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-243);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-370);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-376);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-410);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-428);\n      }\n\n      .cls-426 {\n        fill: url(#linear-gradient-334);\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-191);\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-232);\n      }\n\n      .cls-427 {\n        fill: url(#linear-gradient-205);\n      }\n\n      .cls-428 {\n        fill: url(#linear-gradient-203);\n      }\n\n      .cls-429 {\n        fill: url(#linear-gradient-174);\n      }\n\n      .cls-63 {\n        fill: #fdb714;\n      }\n\n      .cls-430 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-64 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-9);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-392);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-382);\n      }\n\n      .cls-431 {\n        fill: url(#linear-gradient-345);\n      }\n\n      .cls-432 {\n        fill: url(#linear-gradient-214);\n      }\n\n      .cls-433 {\n        fill: url(#linear-gradient-282);\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-275);\n      }\n\n      .cls-68 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-11);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-436);\n      }\n\n      .cls-434 {\n        fill: url(#linear-gradient-179);\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-389);\n      }\n\n      .cls-435 {\n        fill: url(#linear-gradient-167);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-190);\n      }\n\n      .cls-72 {\n        fill: url(#linear-gradient-196);\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-357);\n      }\n\n      .cls-74 {\n        fill: url(#linear-gradient-76);\n      }\n\n      .cls-436 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-385);\n      }\n\n      .cls-76 {\n        fill: url(#linear-gradient-124);\n      }\n\n      .cls-437 {\n        fill: url(#linear-gradient-342);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-378);\n      }\n\n      .cls-438 {\n        fill: url(#linear-gradient-131);\n      }\n\n      .cls-78 {\n        fill: url(#linear-gradient-451);\n      }\n\n      .cls-439 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-440 {\n        fill: url(#linear-gradient-186);\n      }\n\n      .cls-79 {\n        fill: url(#linear-gradient-276);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-418);\n      }\n\n      .cls-441 {\n        fill: url(#linear-gradient-160);\n      }\n\n      .cls-81 {\n        fill: url(#linear-gradient-395);\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-262);\n      }\n\n      .cls-442 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-83 {\n        fill: url(#linear-gradient-206);\n      }\n\n      .cls-443 {\n        fill: url(#linear-gradient-208);\n      }\n\n      .cls-444 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-445 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-84 {\n        fill: url(#linear-gradient-184);\n      }\n\n      .cls-446 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-447 {\n        fill: url(#linear-gradient-130);\n      }\n\n      .cls-85 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-30);\n      }\n\n      .cls-448 {\n        fill: url(#linear-gradient-337);\n      }\n\n      .cls-86 {\n        fill: url(#linear-gradient-406);\n      }\n\n      .cls-87 {\n        fill: url(#linear-gradient-445);\n      }\n\n      .cls-88 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-15);\n      }\n\n      .cls-449 {\n        fill: url(#linear-gradient-329);\n      }\n\n      .cls-450 {\n        isolation: isolate;\n      }\n\n      .cls-89 {\n        fill: url(#linear-gradient-136);\n      }\n\n      .cls-90 {\n        fill: url(#linear-gradient-472);\n      }\n\n      .cls-91 {\n        fill: url(#linear-gradient-429);\n      }\n\n      .cls-92 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-48);\n      }\n\n      .cls-93 {\n        fill: url(#linear-gradient-310);\n      }\n\n      .cls-94 {\n        fill: url(#linear-gradient-377);\n      }\n\n      .cls-95 {\n        fill: url(#linear-gradient-247);\n      }\n\n      .cls-451 {\n        fill: url(#linear-gradient-271);\n      }\n\n      .cls-96 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-97 {\n        fill: url(#linear-gradient-256);\n      }\n\n      .cls-98 {\n        fill: url(#linear-gradient-379);\n      }\n\n      .cls-99 {\n        fill: url(#linear-gradient-364);\n      }\n\n      .cls-452 {\n        fill: url(#linear-gradient-315);\n      }\n\n      .cls-100 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-37);\n      }\n\n      .cls-453 {\n        fill: url(#linear-gradient-319);\n      }\n\n      .cls-101 {\n        fill: #fdc010;\n      }\n\n      .cls-102 {\n        fill: url(#linear-gradient-433);\n      }\n\n      .cls-103 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-31);\n      }\n\n      .cls-104 {\n        fill: url(#linear-gradient-347);\n      }\n\n      .cls-105 {\n        fill: url(#linear-gradient-353);\n      }\n\n      .cls-106 {\n        fill: url(#linear-gradient-104);\n      }\n\n      .cls-454 {\n        fill: url(#linear-gradient-240);\n      }\n\n      .cls-107 {\n        fill: url(#linear-gradient-249);\n      }\n\n      .cls-108 {\n        fill: url(#linear-gradient-400);\n      }\n\n      .cls-455 {\n        fill: url(#linear-gradient-305);\n      }\n\n      .cls-109 {\n        fill: url(#linear-gradient-213);\n      }\n\n      .cls-110 {\n        fill: url(#linear-gradient-422);\n      }\n\n      .cls-111 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-46);\n      }\n\n      .cls-112 {\n        fill: url(#linear-gradient-95);\n      }\n\n      .cls-456 {\n        fill: url(#linear-gradient-331);\n      }\n\n      .cls-457 {\n        fill: url(#linear-gradient-229);\n      }\n\n      .cls-113 {\n        fill: url(#linear-gradient-299);\n      }\n\n      .cls-114 {\n        fill: url(#linear-gradient-393);\n      }\n\n      .cls-115 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-116 {\n        fill: url(#linear-gradient-106);\n      }\n\n      .cls-117 {\n        fill: url(#linear-gradient-423);\n      }\n\n      .cls-118 {\n        fill: url(#linear-gradient-228);\n      }\n\n      .cls-119 {\n        fill: url(#linear-gradient-101);\n      }\n\n      .cls-458 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-120 {\n        fill: url(#linear-gradient-81);\n      }\n\n      .cls-121 {\n        fill: url(#linear-gradient-217);\n      }\n\n      .cls-459 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-460 {\n        fill: url(#linear-gradient-241);\n      }\n\n      .cls-122 {\n        fill: url(#linear-gradient-73);\n      }\n\n      .cls-123 {\n        fill: url(#linear-gradient-91);\n      }\n\n      .cls-461 {\n        fill: url(#linear-gradient-146);\n      }\n\n      .cls-124 {\n        fill: url(#linear-gradient-188);\n      }\n\n      .cls-125 {\n        fill: #fdc888;\n      }\n\n      .cls-126 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-49);\n      }\n\n      .cls-127 {\n        fill: url(#linear-gradient-457);\n      }\n\n      .cls-128 {\n        fill: url(#linear-gradient-222);\n      }\n\n      .cls-129 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-8);\n      }\n\n      .cls-462 {\n        fill: url(#linear-gradient-349);\n      }\n\n      .cls-130 {\n        fill: url(#linear-gradient-151);\n      }\n\n      .cls-131 {\n        fill: url(#linear-gradient-467);\n      }\n\n      .cls-132 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-133 {\n        fill: url(#linear-gradient-187);\n      }\n\n      .cls-463 {\n        fill: url(#linear-gradient-314);\n      }\n\n      .cls-134 {\n        fill: url(#linear-gradient-427);\n      }\n\n      .cls-135 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-24);\n      }\n\n      .cls-136 {\n        fill: url(#linear-gradient-164);\n      }\n\n      .cls-137 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-35);\n      }\n\n      .cls-138 {\n        fill: url(#linear-gradient-306);\n      }\n\n      .cls-464 {\n        fill: url(#linear-gradient-289);\n      }\n\n      .cls-465 {\n        fill: url(#linear-gradient-251);\n      }\n\n      .cls-139 {\n        fill: url(#linear-gradient-133);\n      }\n\n      .cls-466 {\n        fill: url(#linear-gradient-189);\n      }\n\n      .cls-140 {\n        fill: url(#linear-gradient-477);\n      }\n\n      .cls-142 {\n        fill: url(#linear-gradient-254);\n      }\n\n      .cls-467 {\n        fill: url(#linear-gradient-279);\n      }\n\n      .cls-143 {\n        fill: url(#linear-gradient-281);\n      }\n\n      .cls-144 {\n        fill: url(#linear-gradient-103);\n      }\n\n      .cls-145 {\n        fill: url(#linear-gradient-71);\n      }\n\n      .cls-146 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-147 {\n        fill: url(#linear-gradient-471);\n      }\n\n      .cls-148 {\n        fill: url(#linear-gradient-368);\n      }\n\n      .cls-149 {\n        fill: url(#linear-gradient-448);\n      }\n\n      .cls-150 {\n        fill: url(#linear-gradient-63);\n      }\n\n      .cls-151 {\n        fill: url(#linear-gradient-154);\n      }\n\n      .cls-152 {\n        fill: url(#linear-gradient-235);\n      }\n\n      .cls-468 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-153 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-469 {\n        fill: url(#linear-gradient-267);\n      }\n\n      .cls-154 {\n        fill: #059347;\n      }\n\n      .cls-155 {\n        fill: url(#linear-gradient-122);\n      }\n\n      .cls-156 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-10);\n      }\n\n      .cls-470 {\n        fill: url(#linear-gradient-141);\n      }\n\n      .cls-471 {\n        fill: url(#linear-gradient-137);\n      }\n\n      .cls-472 {\n        fill: url(#linear-gradient-156);\n      }\n\n      .cls-157 {\n        fill: url(#linear-gradient-440);\n      }\n\n      .cls-158 {\n        fill: url(#linear-gradient-372);\n      }\n\n      .cls-159 {\n        fill: url(#linear-gradient-336);\n      }\n\n      .cls-160 {\n        fill: url(#linear-gradient-96);\n      }\n\n      .cls-161 {\n        fill: url(#linear-gradient-170);\n      }\n\n      .cls-162 {\n        fill: url(#linear-gradient-165);\n      }\n\n      .cls-473 {\n        fill: url(#linear-gradient-266);\n      }\n\n      .cls-163 {\n        fill: url(#linear-gradient-383);\n      }\n\n      .cls-164 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-16);\n      }\n\n      .cls-165 {\n        fill: url(#linear-gradient-120);\n      }\n\n      .cls-166 {\n        fill: url(#linear-gradient-355);\n      }\n\n      .cls-167 {\n        fill: url(#linear-gradient-239);\n      }\n\n      .cls-168 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-169 {\n        fill: url(#linear-gradient-335);\n      }\n\n      .cls-170 {\n        fill: url(#linear-gradient-439);\n      }\n\n      .cls-171 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_218);\n      }\n\n      .cls-172 {\n        fill: url(#linear-gradient-261);\n      }\n\n      .cls-474 {\n        fill: url(#linear-gradient-248);\n      }\n\n      .cls-173 {\n        fill: url(#linear-gradient-89);\n      }\n\n      .cls-174 {\n        fill: url(#linear-gradient-199);\n      }\n\n      .cls-475 {\n        fill: url(#linear-gradient-341);\n      }\n\n      .cls-175 {\n        fill: url(#linear-gradient-312);\n      }\n\n      .cls-176 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-43);\n      }\n\n      .cls-177 {\n        fill: url(#linear-gradient-346);\n      }\n\n      .cls-178 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-40);\n      }\n\n      .cls-476 {\n        fill: url(#linear-gradient-303);\n      }\n\n      .cls-179 {\n        fill: url(#linear-gradient-147);\n      }\n\n      .cls-477 {\n        fill: url(#linear-gradient-351);\n      }\n\n      .cls-180 {\n        fill: url(#linear-gradient-66);\n      }\n\n      .cls-478 {\n        fill: url(#linear-gradient-171);\n      }\n\n      .cls-181 {\n        fill: url(#linear-gradient-438);\n      }\n\n      .cls-182 {\n        fill: url(#linear-gradient-363);\n      }\n\n      .cls-183 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-25);\n      }\n\n      .cls-184 {\n        fill: url(#linear-gradient-207);\n      }\n\n      .cls-185 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-479 {\n        fill: url(#linear-gradient-350);\n      }\n\n      .cls-186 {\n        fill: url(#linear-gradient-202);\n      }\n\n      .cls-480 {\n        fill: url(#linear-gradient-340);\n      }\n\n      .cls-481 {\n        fill: url(#linear-gradient-223);\n      }\n\n      .cls-187 {\n        fill: url(#linear-gradient-210);\n      }\n\n      .cls-482 {\n        fill: url(#linear-gradient-230);\n      }\n\n      .cls-483 {\n        fill: url(#linear-gradient-288);\n      }\n\n      .cls-188 {\n        fill: url(#linear-gradient-442);\n      }\n\n      .cls-189 {\n        fill: url(#linear-gradient-447);\n      }\n\n      .cls-190 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-191 {\n        fill: url(#linear-gradient-421);\n      }\n\n      .cls-192 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-42);\n      }\n\n      .cls-484 {\n        fill: url(#linear-gradient-297);\n      }\n\n      .cls-193 {\n        fill: url(#linear-gradient-287);\n      }\n\n      .cls-485 {\n        fill: url(#linear-gradient-152);\n      }\n\n      .cls-194 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-195 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-196 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-197 {\n        fill: url(#linear-gradient-466);\n      }\n\n      .cls-198 {\n        fill: url(#linear-gradient-339);\n      }\n\n      .cls-199 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-200 {\n        fill: url(#linear-gradient-425);\n      }\n\n      .cls-201 {\n        fill: url(#linear-gradient-110);\n      }\n\n      .cls-202 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-203 {\n        fill: url(#linear-gradient-323);\n      }\n\n      .cls-204 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-205 {\n        fill: url(#linear-gradient-307);\n      }\n\n      .cls-486 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-206 {\n        fill: url(#linear-gradient-324);\n      }\n\n      .cls-207 {\n        fill: url(#linear-gradient-250);\n      }\n\n      .cls-208 {\n        fill: url(#linear-gradient-60);\n      }\n\n      .cls-209 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-38);\n      }\n\n      .cls-210 {\n        fill: url(#linear-gradient-419);\n      }\n\n      .cls-211 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-212 {\n        fill: url(#linear-gradient-435);\n      }\n\n      .cls-213 {\n        fill: #ffc641;\n      }\n\n      .cls-214 {\n        fill: url(#linear-gradient-434);\n      }\n\n      .cls-215 {\n        fill: url(#linear-gradient-291);\n      }\n\n      .cls-487 {\n        fill: url(#linear-gradient-194);\n      }\n\n      .cls-216 {\n        fill: url(#linear-gradient-185);\n      }\n\n      .cls-217 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-20);\n      }\n\n      .cls-218 {\n        fill: url(#linear-gradient-295);\n      }\n\n      .cls-488 {\n        fill: url(#linear-gradient-231);\n      }\n\n      .cls-219 {\n        fill: url(#linear-gradient-286);\n      }\n\n      .cls-220 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-221 {\n        fill: url(#linear-gradient-212);\n      }\n\n      .cls-222 {\n        fill: url(#linear-gradient-417);\n      }\n\n      .cls-223 {\n        fill: url(#linear-gradient-416);\n      }\n\n      .cls-224 {\n        fill: url(#linear-gradient-330);\n      }\n\n      .cls-489 {\n        fill: url(#linear-gradient-253);\n      }\n\n      .cls-225 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-39);\n      }\n\n      .cls-226 {\n        fill: #2fafe5;\n      }\n\n      .cls-416, .cls-490 {\n        opacity: .45;\n      }\n\n      .cls-491 {\n        fill: url(#linear-gradient-211);\n      }\n\n      .cls-227 {\n        fill: url(#linear-gradient-408);\n      }\n\n      .cls-228 {\n        fill: url(#linear-gradient-374);\n      }\n\n      .cls-229 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-26);\n      }\n\n      .cls-230 {\n        fill: url(#linear-gradient-420);\n      }\n\n      .cls-231 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-232 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-6);\n      }\n\n      .cls-233 {\n        fill: url(#linear-gradient-219);\n      }\n\n      .cls-492 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-234 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-45);\n      }\n\n      .cls-235 {\n        fill: url(#linear-gradient-93);\n      }\n\n      .cls-236 {\n        fill: url(#linear-gradient-284);\n      }\n\n      .cls-237 {\n        fill: url(#linear-gradient-172);\n      }\n\n      .cls-493 {\n        fill: url(#linear-gradient-245);\n      }\n\n      .cls-494 {\n        fill: url(#linear-gradient-290);\n      }\n\n      .cls-238 {\n        fill: url(#linear-gradient-404);\n      }\n\n      .cls-239 {\n        fill: #ffe2b0;\n      }\n\n      .cls-240 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-495 {\n        fill: url(#linear-gradient-252);\n      }\n\n      .cls-241 {\n        fill: url(#linear-gradient-352);\n      }\n\n      .cls-242 {\n        fill: url(#linear-gradient-280);\n      }\n\n      .cls-496 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-243 {\n        fill: url(#linear-gradient-455);\n      }\n\n      .cls-244 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-245 {\n        fill: url(#linear-gradient-399);\n      }\n\n      .cls-497 {\n        fill: url(#linear-gradient-144);\n      }\n\n      .cls-246 {\n        fill: url(#linear-gradient-148);\n      }\n\n      .cls-498 {\n        fill: url(#linear-gradient-326);\n      }\n\n      .cls-247 {\n        fill: url(#linear-gradient-77);\n      }\n\n      .cls-248 {\n        fill: url(#linear-gradient-119);\n      }\n\n      .cls-490 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-249 {\n        fill: url(#linear-gradient-69);\n      }\n\n      .cls-499 {\n        fill: url(#linear-gradient-278);\n      }\n\n      .cls-250 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-2);\n      }\n\n      .cls-251 {\n        fill: url(#linear-gradient-320);\n      }\n\n      .cls-252 {\n        fill: url(#linear-gradient-143);\n      }\n\n      .cls-253 {\n        fill: url(#linear-gradient-125);\n      }\n\n      .cls-254 {\n        fill: url(#linear-gradient-94);\n      }\n\n      .cls-255 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-256 {\n        fill: url(#linear-gradient-391);\n      }\n\n      .cls-257 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-258 {\n        fill: #b5d443;\n      }\n\n      .cls-500 {\n        fill: url(#linear-gradient-242);\n      }\n\n      .cls-501 {\n        fill: url(#linear-gradient-140);\n      }\n\n      .cls-259 {\n        fill: url(#linear-gradient-474);\n      }\n\n      .cls-260 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-36);\n      }\n\n      .cls-261 {\n        fill: url(#linear-gradient-100);\n      }\n\n      .cls-262 {\n        fill: url(#linear-gradient-162);\n      }\n\n      .cls-263 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-27);\n      }\n\n      .cls-264 {\n        fill: url(#linear-gradient-469);\n      }\n\n      .cls-502 {\n        fill: url(#linear-gradient-216);\n      }\n\n      .cls-503 {\n        fill: url(#linear-gradient-260);\n      }\n\n      .cls-265 {\n        fill: url(#linear-gradient-431);\n      }\n\n      .cls-266 {\n        fill: url(#linear-gradient-82);\n      }\n\n      .cls-267 {\n        fill: url(#linear-gradient-105);\n      }\n\n      .cls-268 {\n        fill: url(#linear-gradient-83);\n      }\n\n      .cls-269 {\n        fill: url(#linear-gradient-459);\n      }\n\n      .cls-270 {\n        fill: url(#linear-gradient-367);\n      }\n\n      .cls-504 {\n        fill: url(#linear-gradient-294);\n      }\n\n      .cls-271 {\n        fill: url(#linear-gradient-375);\n      }\n\n      .cls-272 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-29);\n      }\n\n      .cls-273 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-274 {\n        fill: url(#linear-gradient-444);\n      }\n\n      .cls-275 {\n        fill: url(#linear-gradient-90);\n      }\n\n      .cls-276 {\n        fill: url(#linear-gradient-403);\n      }\n\n      .cls-505 {\n        fill: url(#linear-gradient-220);\n      }\n\n      .cls-277 {\n        fill: url(#linear-gradient-298);\n      }\n\n      .cls-506 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-278 {\n        fill: url(#linear-gradient-117);\n      }\n\n      .cls-279 {\n        fill: url(#linear-gradient-465);\n      }\n\n      .cls-507 {\n        fill: url(#linear-gradient-134);\n      }\n\n      .cls-280 {\n        fill: url(#linear-gradient-398);\n      }\n\n      .cls-281 {\n        fill: url(#linear-gradient-221);\n      }\n\n      .cls-282 {\n        fill: url(#linear-gradient-449);\n      }\n\n      .cls-283 {\n        fill: url(#linear-gradient-85);\n      }\n\n      .cls-284 {\n        fill: url(#linear-gradient-65);\n      }\n\n      .cls-508 {\n        fill: url(#linear-gradient-149);\n      }\n\n      .cls-509 {\n        fill: url(#linear-gradient-163);\n      }\n\n      .cls-510 {\n        fill: url(#linear-gradient-197);\n      }\n\n      .cls-285 {\n        fill: url(#linear-gradient-180);\n      }\n\n      .cls-286 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-47);\n      }\n\n      .cls-287 {\n        fill: url(#linear-gradient-407);\n      }\n\n      .cls-288 {\n        fill: url(#linear-gradient-397);\n      }\n\n      .cls-289 {\n        fill: url(#linear-gradient-195);\n      }\n\n      .cls-290 {\n        fill: url(#linear-gradient-224);\n      }\n\n      .cls-291 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-292 {\n        fill: url(#linear-gradient-161);\n      }\n\n      .cls-293 {\n        fill: url(#linear-gradient-381);\n      }\n\n      .cls-294 {\n        fill: url(#linear-gradient-269);\n      }\n\n      .cls-295 {\n        fill: url(#linear-gradient-437);\n      }\n\n      .cls-296 {\n        fill: url(#linear-gradient-415);\n      }\n\n      .cls-297 {\n        fill: url(#linear-gradient-380);\n      }\n\n      .cls-511 {\n        fill: url(#linear-gradient-204);\n      }\n\n      .cls-298 {\n        fill: url(#linear-gradient-173);\n      }\n\n      .cls-299 {\n        fill: url(#linear-gradient-61);\n      }\n\n      .cls-300 {\n        fill: url(#linear-gradient-384);\n      }\n\n      .cls-301 {\n        fill: url(#linear-gradient-348);\n      }\n\n      .cls-302 {\n        fill: url(#linear-gradient-450);\n      }\n\n      .cls-303 {\n        fill: url(#linear-gradient-114);\n      }\n\n      .cls-512 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-304 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-513 {\n        fill: url(#linear-gradient-155);\n      }\n\n      .cls-305 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-13);\n      }\n\n      .cls-306 {\n        fill: url(#linear-gradient-388);\n      }\n\n      .cls-307 {\n        fill: url(#linear-gradient-430);\n      }\n\n      .cls-308 {\n        fill: url(#linear-gradient-456);\n      }\n\n      .cls-309 {\n        fill: url(#linear-gradient-273);\n      }\n\n      .cls-310 {\n        fill: #3c2415;\n      }\n\n      .cls-514 {\n        fill: url(#linear-gradient-234);\n      }\n\n      .cls-311 {\n        fill: url(#linear-gradient-414);\n      }\n\n      .cls-515 {\n        fill: url(#linear-gradient-129);\n      }\n\n      .cls-312 {\n        fill: url(#linear-gradient-343);\n      }\n\n      .cls-413 {\n        stroke-dasharray: 0 0 0 0 0 0 0 0 0 5.03 0 0;\n      }\n\n      .cls-516 {\n        fill: url(#linear-gradient-215);\n      }\n\n      .cls-313 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-18);\n      }\n\n      .cls-314 {\n        fill: url(#linear-gradient-121);\n      }\n\n      .cls-315 {\n        fill: url(#linear-gradient-332);\n      }\n\n      .cls-316 {\n        fill: #fff;\n      }\n\n      .cls-317 {\n        fill: url(#linear-gradient-338);\n      }\n\n      .cls-318 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-41);\n      }\n\n      .cls-319 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-14);\n      }\n\n      .cls-320 {\n        fill: url(#linear-gradient-401);\n      }\n\n      .cls-517 {\n        fill: url(#linear-gradient-285);\n      }\n\n      .cls-321 {\n        fill: url(#linear-gradient-227);\n      }\n\n      .cls-518 {\n        fill: url(#linear-gradient-274);\n      }\n\n      .cls-519 {\n        fill: url(#linear-gradient-200);\n      }\n\n      .cls-520 {\n        fill: url(#linear-gradient-166);\n      }\n\n      .cls-322 {\n        fill: url(#linear-gradient-84);\n      }\n\n      .cls-521 {\n        fill: url(#linear-gradient-226);\n      }\n\n      .cls-323 {\n        fill: url(#linear-gradient-97);\n      }\n\n      .cls-324 {\n        fill: url(#linear-gradient-68);\n      }\n\n      .cls-325 {\n        fill: url(#linear-gradient-238);\n      }\n\n      .cls-326 {\n        fill: url(#linear-gradient-72);\n      }\n\n      .cls-327 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-522 {\n        fill: url(#linear-gradient-322);\n      }\n\n      .cls-328 {\n        fill: url(#linear-gradient-461);\n      }\n\n      .cls-329 {\n        fill: url(#linear-gradient-405);\n      }\n\n      .cls-330 {\n        fill: url(#linear-gradient-468);\n      }\n\n      .cls-331 {\n        fill: url(#linear-gradient-64);\n      }\n\n      .cls-332 {\n        fill: url(#linear-gradient-107);\n      }\n\n      .cls-523 {\n        fill: url(#linear-gradient-300);\n      }\n\n      .cls-333 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-28);\n      }\n\n      .cls-334 {\n        fill: url(#linear-gradient-109);\n      }\n\n      .cls-524 {\n        fill: url(#linear-gradient-181);\n      }\n\n      .cls-335 {\n        fill: url(#linear-gradient-272);\n      }\n\n      .cls-525 {\n        fill: url(#linear-gradient-193);\n      }\n\n      .cls-336 {\n        fill: url(#linear-gradient-145);\n      }\n\n      .cls-337 {\n        fill: url(#linear-gradient-402);\n      }\n\n      .cls-338 {\n        fill: url(#linear-gradient-113);\n      }\n\n      .cls-526 {\n        fill: url(#linear-gradient-237);\n      }\n\n      .cls-527 {\n        fill: url(#linear-gradient-177);\n      }\n\n      .cls-339 {\n        fill: url(#linear-gradient-317);\n      }\n\n      .cls-528 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-340 {\n        fill: url(#linear-gradient-182);\n      }\n\n      .cls-341 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-5);\n      }\n\n      .cls-342 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-343 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-344 {\n        fill: url(#linear-gradient-99);\n      }\n\n      .cls-345 {\n        fill: url(#linear-gradient-475);\n      }\n\n      .cls-346 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-347 {\n        fill: url(#linear-gradient-413);\n      }\n\n      .cls-348 {\n        fill: url(#linear-gradient-452);\n      }\n\n      .cls-349 {\n        fill: url(#linear-gradient-150);\n      }\n\n      .cls-350 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-44);\n      }\n\n      .cls-351 {\n        fill: url(#linear-gradient-198);\n      }\n\n      .cls-529 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-352 {\n        fill: url(#linear-gradient-462);\n      }\n\n      .cls-530 {\n        fill: url(#linear-gradient-142);\n      }\n\n      .cls-353 {\n        fill: url(#linear-gradient-412);\n      }\n\n      .cls-354 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-23);\n      }\n\n      .cls-531 {\n        fill: url(#linear-gradient-255);\n      }\n\n      .cls-532 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-355 {\n        fill: url(#linear-gradient-87);\n      }\n\n      .cls-533 {\n        fill: url(#linear-gradient-178);\n      }\n\n      .cls-356 {\n        fill: url(#linear-gradient-270);\n      }\n\n      .cls-357 {\n        fill: url(#linear-gradient-70);\n      }\n\n      .cls-358 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-17);\n      }\n\n      .cls-359 {\n        fill: url(#linear-gradient-78);\n      }\n\n      .cls-360 {\n        fill: url(#linear-gradient-313);\n      }\n\n      .cls-361 {\n        fill: url(#linear-gradient-86);\n      }\n\n      .cls-362 {\n        fill: url(#linear-gradient-373);\n      }\n\n      .cls-363 {\n        fill: url(#linear-gradient-426);\n      }\n\n      .cls-364 {\n        fill: url(#linear-gradient-74);\n      }\n\n      .cls-534 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-365 {\n        fill: url(#linear-gradient-169);\n      }\n\n      .cls-366 {\n        fill: url(#linear-gradient-102);\n      }\n\n      .cls-535 {\n        fill: url(#linear-gradient-218);\n      }\n\n      .cls-367 {\n        fill: url(#linear-gradient-454);\n      }\n\n      .cls-368 {\n        fill: url(#linear-gradient-356);\n      }\n\n      .cls-369 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-33);\n      }\n\n      .cls-536 {\n        fill: url(#linear-gradient-354);\n      }\n\n      .cls-370 {\n        fill: url(#linear-gradient-386);\n      }\n\n      .cls-371 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-537 {\n        fill: url(#linear-gradient-268);\n      }\n\n      .cls-538 {\n        fill: url(#linear-gradient-325);\n      }\n\n      .cls-372 {\n        fill: url(#linear-gradient-118);\n      }\n\n      .cls-539 {\n        fill: url(#linear-gradient-126);\n      }\n\n      .cls-540 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-373 {\n        fill: url(#linear-gradient-302);\n      }\n\n      .cls-374 {\n        fill: url(#linear-gradient-344);\n      }\n\n      .cls-375 {\n        fill: #f4b21d;\n      }\n\n      .cls-376 {\n        fill: url(#linear-gradient-453);\n      }\n\n      .cls-377 {\n        fill: url(#linear-gradient-112);\n      }\n\n      .cls-378 {\n        fill: url(#linear-gradient-409);\n      }\n\n      .cls-379 {\n        fill: url(#linear-gradient-236);\n      }\n\n      .cls-380 {\n        fill: url(#linear-gradient-369);\n      }\n\n      .cls-381 {\n        fill: url(#linear-gradient-246);\n      }\n\n      .cls-382 {\n        fill: url(#linear-gradient-460);\n      }\n\n      .cls-383 {\n        fill: url(#linear-gradient-259);\n      }\n\n      .cls-384 {\n        fill: url(#linear-gradient-123);\n      }\n\n      .cls-385 {\n        fill: url(#linear-gradient-476);\n      }\n\n      .cls-541 {\n        fill: url(#linear-gradient-292);\n      }\n\n      .cls-386 {\n        fill: url(#linear-gradient-176);\n      }\n\n      .cls-387 {\n        fill: url(#linear-gradient-128);\n      }\n\n      .cls-388 {\n        fill: #991f45;\n        opacity: .1;\n      }\n\n      .cls-389 {\n        fill: url(#linear-gradient-411);\n      }\n\n      .cls-390 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-391 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-7);\n      }\n\n      .cls-392 {\n        fill: url(#linear-gradient-80);\n      }\n\n      .cls-542 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-543 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-393 {\n        fill: url(#linear-gradient-115);\n      }\n\n      .cls-394 {\n        fill: url(#linear-gradient-387);\n      }\n\n      .cls-395 {\n        fill: url(#linear-gradient-264);\n      }\n\n      .cls-396 {\n        fill: url(#linear-gradient-135);\n      }\n\n      .cls-397 {\n        fill: url(#linear-gradient-390);\n      }\n\n      .cls-398 {\n        fill: url(#linear-gradient-158);\n      }\n\n      .cls-399 {\n        fill: url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_73-19);\n      }\n\n      .cls-400 {\n        fill: url(#linear-gradient-116);\n      }\n\n      .cls-414 {\n        stroke-dasharray: 0 0 0 0 0 5.03 0 0;\n      }\n\n      .cls-544 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-401 {\n        fill: url(#linear-gradient-293);\n      }\n\n      .cls-545 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-402 {\n        fill: url(#linear-gradient-79);\n      }\n\n      .cls-403 {\n        fill: url(#linear-gradient-111);\n      }\n\n      .cls-546 {\n        fill: url(#linear-gradient-183);\n      }\n\n      .cls-404 {\n        fill: #f49a1f;\n      }\n\n      .cls-405 {\n        fill: url(#linear-gradient-108);\n      }\n\n      .cls-406 {\n        fill: url(#linear-gradient-301);\n      }\n\n      .cls-547 {\n        fill: url(#linear-gradient-311);\n      }\n\n      .cls-548 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-549 {\n        fill: url(#linear-gradient-316);\n      }\n\n      .cls-550 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-407 {\n        fill: url(#linear-gradient-371);\n      }\n\n      .cls-408 {\n        fill: url(#linear-gradient-201);\n      }\n\n      .cls-551 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-409 {\n        fill: url(#linear-gradient-75);\n      }\n\n      .cls-552 {\n        fill: url(#linear-gradient-327);\n      }\n\n      .cls-410 {\n        fill: url(#linear-gradient-361);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 249.69,
    cy: 187.55,
    fx: 249.69,
    fy: 149.06,
    r: 139.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9fdaf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2baae2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 238.86,
    y1: 129.51,
    x2: 268.06,
    y2: 314.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e8543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cb94d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 128.75,
    y1: 268.84,
    x2: 370.73,
    y2: 268.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72b447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6c634"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 329.96,
    y1: 238.88,
    x2: 330.68,
    y2: 243.44,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 300.52,
    y1: 243.91,
    x2: 300.5,
    y2: 244.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 328.75,
    y1: 243.51,
    x2: 328.78,
    y2: 242.79,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 328.08,
    y1: 245.32,
    x2: 328.27,
    y2: 239.79,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 331.27,
    y1: 245.42,
    x2: 331.45,
    y2: 239.9,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 332.02,
    y1: 245.45,
    x2: 332.2,
    y2: 239.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 334.01,
    y1: 239.88,
    x2: 334.02,
    y2: 239.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 327.44,
    y1: 241.04,
    x2: 327.44,
    y2: 240.91,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 328.75,
    y1: 243.64,
    x2: 328.8,
    y2: 242.12,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 331.27,
    y1: 245.42,
    x2: 331.45,
    y2: 239.9,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 334.6,
    y1: 243.98,
    x2: 334.79,
    y2: 238.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 337.79,
    y1: 244.08,
    x2: 337.97,
    y2: 238.56,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 338.54,
    y1: 244.11,
    x2: 338.72,
    y2: 238.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 334.01,
    y1: 239.87,
    x2: 334.02,
    y2: 239.53,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 337.79,
    y1: 244.08,
    x2: 337.97,
    y2: 238.56,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 322.27,
    y1: 240.09,
    x2: 322.28,
    y2: 239.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 321.51,
    y1: 246.21,
    x2: 321.7,
    y2: 240.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 324.7,
    y1: 246.32,
    x2: 324.88,
    y2: 240.79,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 325.45,
    y1: 246.34,
    x2: 325.63,
    y2: 240.82,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 327.25,
    y1: 246.13,
    x2: 327.43,
    y2: 240.8,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 321.06,
    y1: 242.64,
    x2: 321.1,
    y2: 241.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 324.7,
    y1: 246.32,
    x2: 324.88,
    y2: 240.79,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 448.07,
    y1: 131.46,
    x2: 448.25,
    y2: 125.93,
    gradientTransform: "translate(-110.69 53.86) rotate(7.98)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 451.26,
    y1: 131.56,
    x2: 451.44,
    y2: 126.04,
    gradientTransform: "translate(-110.69 53.86) rotate(7.98)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 452,
    y1: 131.59,
    x2: 452.19,
    y2: 126.06,
    gradientTransform: "translate(-110.69 53.86) rotate(7.98)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 321.17,
    y1: 246.56,
    x2: 321.33,
    y2: 241.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 314.84,
    y1: 242.34,
    x2: 314.86,
    y2: 241.72,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 451.26,
    y1: 131.56,
    x2: 451.44,
    y2: 126.04,
    gradientTransform: "translate(-110.69 53.86) rotate(7.98)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 486.1,
    y1: 64.12,
    x2: 486.28,
    y2: 58.59,
    gradientTransform: "translate(-162.5 85.23) rotate(11.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 489.89,
    y1: 64.84,
    x2: 490.08,
    y2: 59.31,
    gradientTransform: "translate(-162.5 85.23) rotate(11.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 490.51,
    y1: 64.23,
    x2: 490.7,
    y2: 58.7,
    gradientTransform: "translate(-162.5 85.23) rotate(11.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 308.28,
    y1: 242.15,
    x2: 308.29,
    y2: 241.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 300.4,
    y1: 245.12,
    x2: 300.59,
    y2: 239.51,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 490.05,
    y1: 64.16,
    x2: 490.23,
    y2: 58.63,
    gradientTransform: "translate(-162.5 85.23) rotate(11.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 309.15,
    y1: 244.65,
    x2: 309.17,
    y2: 243.91,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 493.23,
    y1: 63.39,
    x2: 493.41,
    y2: 57.87,
    gradientTransform: "translate(-162.5 85.23) rotate(11.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 496.41,
    y1: 63.5,
    x2: 496.6,
    y2: 57.97,
    gradientTransform: "translate(-162.5 85.23) rotate(11.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 497.16,
    y1: 63.52,
    x2: 497.35,
    y2: 58,
    gradientTransform: "translate(-162.5 85.23) rotate(11.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 314.66,
    y1: 246.59,
    x2: 314.81,
    y2: 242.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 308.28,
    y1: 242.14,
    x2: 308.3,
    y2: 241.74,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 309.14,
    y1: 244.79,
    x2: 309.2,
    y2: 243.22,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 496.41,
    y1: 63.5,
    x2: 496.6,
    y2: 57.97,
    gradientTransform: "translate(-162.5 85.23) rotate(11.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 296.25,
    y1: 239.19,
    x2: 296.27,
    y2: 238.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 479.59,
    y1: 64.33,
    x2: 479.77,
    y2: 58.81,
    gradientTransform: "translate(-162.5 85.23) rotate(11.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 482.55,
    y1: 64.65,
    x2: 482.73,
    y2: 59.13,
    gradientTransform: "translate(-162.5 85.23) rotate(11.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 483.87,
    y1: 64.73,
    x2: 484.06,
    y2: 59.2,
    gradientTransform: "translate(-162.5 85.23) rotate(11.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 301.68,
    y1: 246.15,
    x2: 301.85,
    y2: 240.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 294.85,
    y1: 240.92,
    x2: 294.89,
    y2: 239.78,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 482.55,
    y1: 64.65,
    x2: 482.73,
    y2: 59.13,
    gradientTransform: "translate(-162.5 85.23) rotate(11.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 583.29,
    y1: -70.49,
    x2: 583.47,
    y2: -76.01,
    gradientTransform: "translate(-281.74 115.79) rotate(19.55)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 295.59,
    y1: 241.69,
    x2: 295.68,
    y2: 239.22,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 242.86,
    cy: 276.58,
    fx: 289.11,
    fy: 349.4,
    r: 86.27,
    gradientTransform: "translate(-1.08 101.18) scale(1 .63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9cb94d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#017941"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 137.42,
    y1: 237.72,
    x2: 137.42,
    y2: 237.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#017941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cb94d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 137.47,
    y1: 243.06,
    x2: 137.47,
    y2: 236.98,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 138.97,
    y1: 237.7,
    x2: 138.97,
    y2: 237.25,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 139.6,
    y1: 243.97,
    x2: 139.6,
    y2: 239.42,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 141.31,
    y1: 237.44,
    x2: 141.31,
    y2: 237.25,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 142.72,
    y1: 243.84,
    x2: 142.72,
    y2: 238.11,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 144.07,
    y1: 237.44,
    x2: 144.07,
    y2: 237.24,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 144.9,
    y1: 244.38,
    x2: 144.9,
    y2: 239.96,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 145.14,
    y1: 237.44,
    x2: 145.14,
    y2: 237.24,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 146.03,
    y1: 237.57,
    x2: 146.03,
    y2: 237.23,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 147.73,
    y1: 237.57,
    x2: 147.73,
    y2: 237.25,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 147.25,
    y1: 244.15,
    x2: 147.25,
    y2: 238.42,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 151.08,
    y1: 244.72,
    x2: 151.08,
    y2: 240.3,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 151,
    y1: 237.59,
    x2: 151,
    y2: 237.34,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 152.08,
    y1: 237.61,
    x2: 152.08,
    y2: 237.4,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 153.44,
    y1: 244.87,
    x2: 153.44,
    y2: 239.14,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 153.19,
    y1: 237.92,
    x2: 153.19,
    y2: 237.42,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 154.88,
    y1: 237.93,
    x2: 154.88,
    y2: 237.48,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 157.27,
    y1: 245.44,
    x2: 157.27,
    y2: 241.02,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 158.15,
    y1: 237.99,
    x2: 158.15,
    y2: 237.73,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 158.66,
    y1: 245.5,
    x2: 158.66,
    y2: 241.15,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 159.22,
    y1: 238.01,
    x2: 159.22,
    y2: 237.84,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 160.41,
    y1: 238.22,
    x2: 160.41,
    y2: 237.93,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 161.92,
    y1: 238.38,
    x2: 161.92,
    y2: 237.98,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 164.29,
    y1: 238.5,
    x2: 164.29,
    y2: 238.23,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 167.01,
    y1: 238.83,
    x2: 167.01,
    y2: 238.57,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 168.09,
    y1: 238.95,
    x2: 168.09,
    y2: 238.76,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 168.95,
    y1: 239.2,
    x2: 168.95,
    y2: 238.83,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 170.66,
    y1: 239.46,
    x2: 170.66,
    y2: 238.97,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 173.86,
    y1: 239.89,
    x2: 173.86,
    y2: 239.5,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 174.94,
    y1: 240.02,
    x2: 174.94,
    y2: 239.74,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 176.02,
    y1: 240.49,
    x2: 176.02,
    y2: 239.87,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 177.7,
    y1: 240.76,
    x2: 177.7,
    y2: 240.04,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 180.89,
    y1: 241.22,
    x2: 180.89,
    y2: 240.72,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 181.98,
    y1: 241.36,
    x2: 181.98,
    y2: 241.02,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 183.55,
    y1: 242,
    x2: 183.55,
    y2: 241.32,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 184.89,
    y1: 242.26,
    x2: 184.89,
    y2: 241.46,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 186.87,
    y1: 242.62,
    x2: 186.87,
    y2: 241.92,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 189.15,
    y1: 243.15,
    x2: 189.15,
    y2: 242.54,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 190.09,
    y1: 243.32,
    x2: 190.09,
    y2: 242.86,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 190.82,
    y1: 243.63,
    x2: 190.82,
    y2: 243.01,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 192.24,
    y1: 244.02,
    x2: 192.24,
    y2: 243.21,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 194.93,
    y1: 244.67,
    x2: 194.93,
    y2: 244.04,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 195.86,
    y1: 244.85,
    x2: 195.86,
    y2: 244.4,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 196.76,
    y1: 245.36,
    x2: 196.76,
    y2: 244.63,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 198.16,
    y1: 245.75,
    x2: 198.16,
    y2: 244.85,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 200.84,
    y1: 246.43,
    x2: 200.84,
    y2: 245.8,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 201.77,
    y1: 246.62,
    x2: 201.77,
    y2: 246.2,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 203.43,
    y1: 247.44,
    x2: 203.43,
    y2: 246.74,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 204.58,
    y1: 247.8,
    x2: 204.58,
    y2: 246.93,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 206.26,
    y1: 248.38,
    x2: 206.26,
    y2: 247.51,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 208.17,
    y1: 249.08,
    x2: 208.17,
    y2: 248.32,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 208.98,
    y1: 249.31,
    x2: 208.98,
    y2: 248.72,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 209.6,
    y1: 249.67,
    x2: 209.6,
    y2: 248.94,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 210.78,
    y1: 250.18,
    x2: 210.78,
    y2: 249.16,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 213.04,
    y1: 251.04,
    x2: 213.04,
    y2: 250.19,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 213.85,
    y1: 251.27,
    x2: 213.85,
    y2: 250.62,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 215.3,
    y1: 252.28,
    x2: 215.3,
    y2: 250.86,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 217.99,
    y1: 253.21,
    x2: 217.99,
    y2: 252.27,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 218.81,
    y1: 253.46,
    x2: 218.81,
    y2: 252.74,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 220.2,
    y1: 253.92,
    x2: 220.2,
    y2: 253.39,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 221.11,
    y1: 254.34,
    x2: 221.11,
    y2: 253.57,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 222.46,
    y1: 254.97,
    x2: 222.46,
    y2: 254.22,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 223.99,
    y1: 255.72,
    x2: 223.99,
    y2: 255.08,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 224.63,
    y1: 255.97,
    x2: 224.63,
    y2: 255.5,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 225.11,
    y1: 256.33,
    x2: 225.11,
    y2: 255.73,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 226.06,
    y1: 256.88,
    x2: 226.06,
    y2: 255.97,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 227.85,
    y1: 257.78,
    x2: 227.85,
    y2: 257.04,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 228.5,
    y1: 258.03,
    x2: 228.5,
    y2: 257.48,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 229.67,
    y1: 259.04,
    x2: 229.67,
    y2: 257.71,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 231.82,
    y1: 259.37,
    x2: 231.85,
    y2: 260.4,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 232.5,
    y1: 259.72,
    x2: 232.53,
    y2: 260.57,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 145.51,
    y1: 234.99,
    x2: 145.51,
    y2: 228.74,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 144.33,
    y1: 235.57,
    x2: 144.33,
    y2: 230.77,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 140.87,
    y1: 239.04,
    x2: 140.87,
    y2: 231.86,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: -620.27,
    y1: 236.89,
    x2: -620.27,
    y2: 229.68,
    gradientTransform: "translate(760.08)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 143.2,
    y1: 236.89,
    x2: 143.2,
    y2: 232.14,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 161.94,
    y1: 236.99,
    x2: 161.93,
    y2: 231,
    gradientTransform: "translate(-17.85 0) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 145.92,
    y1: 236.27,
    x2: 145.92,
    y2: 229.67,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 139.56,
    y1: 237.23,
    x2: 139.56,
    y2: 232.86,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 143.56,
    y1: 234.14,
    x2: 143.56,
    y2: 229.33,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 141.58,
    y1: 235.25,
    x2: 141.58,
    y2: 229.66,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 142.16,
    y1: 236.34,
    x2: 142.16,
    y2: 230.16,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 152.45,
    y1: 235.15,
    x2: 152.45,
    y2: 228.91,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 151.26,
    y1: 235.73,
    x2: 151.26,
    y2: 230.94,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 147.3,
    y1: 239.21,
    x2: 147.3,
    y2: 232.03,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: -613.84,
    y1: 237.05,
    x2: -613.84,
    y2: 229.85,
    gradientTransform: "translate(760.08)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 149.63,
    y1: 237.06,
    x2: 149.63,
    y2: 232.3,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 168.87,
    y1: 237.16,
    x2: 168.86,
    y2: 231.17,
    gradientTransform: "translate(-17.85 0) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 152.85,
    y1: 236.43,
    x2: 152.85,
    y2: 229.84,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: -2205.89,
    y1: 235.32,
    x2: -2205.89,
    y2: 229.07,
    gradientTransform: "translate(-2068.84) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 138.25,
    y1: 235.9,
    x2: 138.25,
    y2: 231.11,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: -2189.46,
    y1: 237.32,
    x2: -2189.47,
    y2: 231.33,
    gradientTransform: "translate(-2050.99 0) rotate(-180) scale(1 -1) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 136.65,
    y1: 236.6,
    x2: 136.65,
    y2: 229.99,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 145.99,
    y1: 237.39,
    x2: 145.99,
    y2: 233.03,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 149.99,
    y1: 234.3,
    x2: 149.99,
    y2: 229.5,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 148.01,
    y1: 235.42,
    x2: 148.01,
    y2: 229.83,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 148.59,
    y1: 236.51,
    x2: 148.59,
    y2: 230.33,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 159.6,
    y1: 235.55,
    x2: 159.6,
    y2: 229.31,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 158.41,
    y1: 236.14,
    x2: 158.41,
    y2: 231.34,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 154.45,
    y1: 239.61,
    x2: 154.45,
    y2: 232.43,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: -606.69,
    y1: 237.46,
    x2: -606.69,
    y2: 230.25,
    gradientTransform: "translate(760.08)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 156.78,
    y1: 237.46,
    x2: 156.78,
    y2: 232.7,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 176.02,
    y1: 237.56,
    x2: 176.02,
    y2: 231.57,
    gradientTransform: "translate(-17.85 0) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 160,
    y1: 236.83,
    x2: 160,
    y2: 230.23,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 153.14,
    y1: 237.79,
    x2: 153.14,
    y2: 233.43,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 157.14,
    y1: 234.7,
    x2: 157.14,
    y2: 229.9,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 155.16,
    y1: 235.82,
    x2: 155.16,
    y2: 230.23,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 155.74,
    y1: 236.91,
    x2: 155.74,
    y2: 230.73,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 296.5,
    y1: 74.29,
    x2: 295.68,
    y2: 68.28,
    gradientTransform: "translate(-114.74 123.28) rotate(7.68)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 167.82,
    y1: 237.01,
    x2: 167.82,
    y2: 232.3,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 164.64,
    y1: 239.99,
    x2: 164.64,
    y2: 232.88,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: -469.28,
    y1: 76.3,
    x2: -470.27,
    y2: 68.98,
    gradientTransform: "translate(638.52 224.83) rotate(7.68)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 294.04,
    y1: 76.24,
    x2: 293.41,
    y2: 71.57,
    gradientTransform: "translate(-114.74 123.28) rotate(7.68)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 312.69,
    y1: 76.37,
    x2: 311.86,
    y2: 70.31,
    gradientTransform: "translate(-132.43 120.9) rotate(7.68) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 169.4,
    y1: 237.81,
    x2: 169.4,
    y2: 231.44,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 162.77,
    y1: 238.01,
    x2: 162.77,
    y2: 233.55,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 294.42,
    y1: 73.49,
    x2: 293.8,
    y2: 68.89,
    gradientTransform: "translate(-114.74 123.28) rotate(7.68)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 165.19,
    y1: 236.32,
    x2: 165.19,
    y2: 230.82,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 165.64,
    y1: 237.44,
    x2: 165.64,
    y2: 231.36,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 303.43,
    y1: 74.46,
    x2: 302.62,
    y2: 68.44,
    gradientTransform: "translate(-114.74 123.28) rotate(7.68)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 174.67,
    y1: 238.11,
    x2: 174.67,
    y2: 233.4,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 170.99,
    y1: 241.01,
    x2: 170.99,
    y2: 233.91,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: -462.85,
    y1: 76.47,
    x2: -463.84,
    y2: 69.15,
    gradientTransform: "translate(638.52 224.83) rotate(7.68)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 300.47,
    y1: 76.41,
    x2: 299.84,
    y2: 71.74,
    gradientTransform: "translate(-114.74 123.28) rotate(7.68)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 319.62,
    y1: 76.54,
    x2: 318.8,
    y2: 70.48,
    gradientTransform: "translate(-132.43 120.9) rotate(7.68) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 176.25,
    y1: 238.91,
    x2: 176.25,
    y2: 232.53,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: -2356.96,
    y1: 74.69,
    x2: -2356.11,
    y2: 68.38,
    gradientTransform: "translate(-2165.03 -153.11) rotate(-172.32) scale(1 -1)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 161.5,
    y1: 236.52,
    x2: 161.5,
    y2: 231.63,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: -2340.68,
    y1: 76.65,
    x2: -2339.9,
    y2: 70.84,
    gradientTransform: "translate(-2147.34 -150.73) rotate(-172.32) scale(1 -1) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 160.22,
    y1: 237.04,
    x2: 160.22,
    y2: 230.26,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 169.12,
    y1: 239.03,
    x2: 169.12,
    y2: 234.57,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 300.85,
    y1: 73.65,
    x2: 300.23,
    y2: 69.06,
    gradientTransform: "translate(-114.74 123.28) rotate(7.68)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 171.54,
    y1: 237.34,
    x2: 171.54,
    y2: 231.85,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 172,
    y1: 238.47,
    x2: 172,
    y2: 232.39,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 310.58,
    y1: 74.87,
    x2: 309.77,
    y2: 68.85,
    gradientTransform: "translate(-114.74 123.28) rotate(7.68)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 181.7,
    y1: 239.46,
    x2: 181.7,
    y2: 234.75,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 178.02,
    y1: 242.37,
    x2: 178.02,
    y2: 235.27,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: -455.7,
    y1: 76.87,
    x2: -456.69,
    y2: 69.56,
    gradientTransform: "translate(638.52 224.83) rotate(7.68)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 307.62,
    y1: 76.82,
    x2: 306.99,
    y2: 72.14,
    gradientTransform: "translate(-114.74 123.28) rotate(7.68)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 326.77,
    y1: 76.95,
    x2: 325.95,
    y2: 70.88,
    gradientTransform: "translate(-132.43 120.9) rotate(7.68) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 183.28,
    y1: 240.26,
    x2: 183.28,
    y2: 233.89,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 176.15,
    y1: 240.39,
    x2: 176.15,
    y2: 235.93,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 308,
    y1: 74.06,
    x2: 307.38,
    y2: 69.46,
    gradientTransform: "translate(-114.74 123.28) rotate(7.68)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 178.57,
    y1: 238.7,
    x2: 178.57,
    y2: 233.2,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 179.03,
    y1: 239.83,
    x2: 179.03,
    y2: 233.74,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 398.66,
    y1: -47.43,
    x2: 397.49,
    y2: -52.35,
    gradientTransform: "translate(-207.42 195.41) rotate(13.36)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 190.17,
    y1: 241.73,
    x2: 190.17,
    y2: 237.77,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 187.57,
    y1: 243.94,
    x2: 187.57,
    y2: 237.94,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: -366.47,
    y1: -45.6,
    x2: -367.95,
    y2: -51.83,
    gradientTransform: "translate(532.1 371.01) rotate(13.36)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 396.51,
    y1: -45.71,
    x2: 395.58,
    y2: -49.6,
    gradientTransform: "translate(-207.42 195.41) rotate(13.36)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 414.78,
    y1: -45.56,
    x2: 413.55,
    y2: -50.7,
    gradientTransform: "translate(-224.78 191.29) rotate(13.36) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 191.5,
    y1: 242.47,
    x2: 191.5,
    y2: 237.18,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 185.65,
    y1: 242.15,
    x2: 185.65,
    y2: 238.28,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 396.8,
    y1: -48.08,
    x2: 395.91,
    y2: -51.82,
    gradientTransform: "translate(-207.42 195.41) rotate(13.36)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 188,
    y1: 240.89,
    x2: 188,
    y2: 236.27,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 188.3,
    y1: 241.87,
    x2: 188.3,
    y2: 236.75,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 404.63,
    y1: -47.28,
    x2: 403.46,
    y2: -52.21,
    gradientTransform: "translate(-207.42 195.41) rotate(13.36)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 195.95,
    y1: 243.25,
    x2: 195.95,
    y2: 239.29,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 192.93,
    y1: 245.36,
    x2: 192.93,
    y2: 239.36,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: -360.92,
    y1: -45.46,
    x2: -362.4,
    y2: -51.68,
    gradientTransform: "translate(532.1 371.01) rotate(13.36)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 402.05,
    y1: -45.56,
    x2: 401.13,
    y2: -49.45,
    gradientTransform: "translate(-207.42 195.41) rotate(13.36)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 420.76,
    y1: -45.41,
    x2: 419.53,
    y2: -50.56,
    gradientTransform: "translate(-224.78 191.29) rotate(13.36) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 197.28,
    y1: 243.99,
    x2: 197.28,
    y2: 238.7,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: -2460.07,
    y1: -46.99,
    x2: -2458.8,
    y2: -52.35,
    gradientTransform: "translate(-2220.29 -282.52) rotate(-166.64) scale(1 -1)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 184.6,
    y1: 240.78,
    x2: 184.6,
    y2: 236.54,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: -2443.93,
    y1: -45.39,
    x2: -2442.8,
    y2: -50.16,
    gradientTransform: "translate(-2202.92 -278.4) rotate(-166.64) scale(1 -1) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 183.66,
    y1: 241.1,
    x2: 183.66,
    y2: 235.21,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 191.01,
    y1: 243.57,
    x2: 191.01,
    y2: 239.71,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 402.34,
    y1: -47.93,
    x2: 401.45,
    y2: -51.68,
    gradientTransform: "translate(-207.42 195.41) rotate(13.36)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 193.36,
    y1: 242.31,
    x2: 193.36,
    y2: 237.69,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 193.66,
    y1: 243.29,
    x2: 193.66,
    y2: 238.17,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 410.8,
    y1: -46.93,
    x2: 409.63,
    y2: -51.86,
    gradientTransform: "translate(-207.42 195.41) rotate(13.36)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 201.86,
    y1: 245.01,
    x2: 201.86,
    y2: 241.06,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 198.85,
    y1: 247.12,
    x2: 198.85,
    y2: 241.13,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: -354.76,
    y1: -45.11,
    x2: -356.24,
    y2: -51.33,
    gradientTransform: "translate(532.1 371.01) rotate(13.36)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 408.22,
    y1: -45.21,
    x2: 407.29,
    y2: -49.1,
    gradientTransform: "translate(-207.42 195.41) rotate(13.36)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 426.92,
    y1: -45.06,
    x2: 425.69,
    y2: -50.21,
    gradientTransform: "translate(-224.78 191.29) rotate(13.36) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 203.2,
    y1: 245.76,
    x2: 203.2,
    y2: 240.47,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 196.93,
    y1: 245.33,
    x2: 196.93,
    y2: 241.47,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 408.51,
    y1: -47.58,
    x2: 407.62,
    y2: -51.33,
    gradientTransform: "translate(-207.42 195.41) rotate(13.36)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 199.28,
    y1: 244.08,
    x2: 199.28,
    y2: 239.45,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 199.58,
    y1: 245.06,
    x2: 199.58,
    y2: 239.94,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 251.3,
    y1: 136.12,
    x2: 250.9,
    y2: 132.28,
    gradientTransform: "translate(-90.17 82.78) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 144.9,
    y1: 244.44,
    x2: 144.9,
    y2: 241.46,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 142.86,
    y1: 246.39,
    x2: 142.86,
    y2: 241.89,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: -512.34,
    y1: 137.36,
    x2: -512.82,
    y2: 132.76,
    gradientTransform: "translate(665.84 161.25) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 249.76,
    y1: 137.34,
    x2: 249.45,
    y2: 134.37,
    gradientTransform: "translate(-90.17 82.78) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 268.27,
    y1: 137.42,
    x2: 267.87,
    y2: 133.59,
    gradientTransform: "translate(-107.92 80.94) rotate(5.93) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 145.9,
    y1: 244.93,
    x2: 145.9,
    y2: 240.87,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 141.76,
    y1: 245.16,
    x2: 141.76,
    y2: 242.36,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: 250,
    y1: 135.6,
    x2: 249.7,
    y2: 132.67,
    gradientTransform: "translate(-90.17 82.78) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: 143.22,
    y1: 244.05,
    x2: 143.22,
    y2: 240.57,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: 143.53,
    y1: 244.76,
    x2: 143.53,
    y2: 240.91,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: 257.8,
    y1: 135.79,
    x2: 257.4,
    y2: 131.95,
    gradientTransform: "translate(-90.17 82.78) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 151.08,
    y1: 244.78,
    x2: 151.08,
    y2: 241.8,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 147.81,
    y1: 246.7,
    x2: 147.81,
    y2: 242.21,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: -507.73,
    y1: 136.84,
    x2: -508.21,
    y2: 132.23,
    gradientTransform: "translate(665.84 161.25) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 255.18,
    y1: 137.09,
    x2: 254.88,
    y2: 134.12,
    gradientTransform: "translate(-90.17 82.78) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 274.31,
    y1: 137.14,
    x2: 273.91,
    y2: 133.31,
    gradientTransform: "translate(-107.92 80.94) rotate(5.93) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 152.46,
    y1: 245.27,
    x2: 152.46,
    y2: 241.22,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: -2312.41,
    y1: 135.5,
    x2: -2311.86,
    y2: 130.2,
    gradientTransform: "translate(-2147.95 -130.82) rotate(-174.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 139.6,
    y1: 244.04,
    x2: 139.6,
    y2: 240.96,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: -2296.29,
    y1: 137.09,
    x2: -2295.79,
    y2: 132.17,
    gradientTransform: "translate(-2130.2 -128.98) rotate(-174.07) scale(1 -1) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: 137.47,
    y1: 243.74,
    x2: 137.47,
    y2: 238.09,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: 146.28,
    y1: 245.48,
    x2: 146.28,
    y2: 242.67,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: 255.59,
    y1: 135.34,
    x2: 255.28,
    y2: 132.4,
    gradientTransform: "translate(-90.17 82.78) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: 148.31,
    y1: 244.37,
    x2: 148.31,
    y2: 240.88,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: 148.74,
    y1: 245.07,
    x2: 148.74,
    y2: 241.22,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: 264.03,
    y1: 135.87,
    x2: 263.63,
    y2: 132.03,
    gradientTransform: "translate(-90.17 82.78) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: 157.27,
    y1: 245.5,
    x2: 157.27,
    y2: 242.52,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: 154.01,
    y1: 247.42,
    x2: 154.01,
    y2: 242.92,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: -501.47,
    y1: 137.27,
    x2: -501.94,
    y2: 132.66,
    gradientTransform: "translate(665.84 161.25) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: 261.42,
    y1: 137.17,
    x2: 261.11,
    y2: 134.2,
    gradientTransform: "translate(-90.17 82.78) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: 280.54,
    y1: 137.21,
    x2: 280.14,
    y2: 133.39,
    gradientTransform: "translate(-107.92 80.94) rotate(5.93) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: 158.66,
    y1: 245.99,
    x2: 158.66,
    y2: 241.94,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: 152.47,
    y1: 246.19,
    x2: 152.47,
    y2: 243.39,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: 261.82,
    y1: 135.41,
    x2: 261.52,
    y2: 132.48,
    gradientTransform: "translate(-90.17 82.78) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: 154.5,
    y1: 245.08,
    x2: 154.5,
    y2: 241.6,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: 154.93,
    y1: 245.79,
    x2: 154.93,
    y2: 241.94,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    x1: 574.85,
    y1: -328.47,
    x2: 573.37,
    y2: -331.37,
    gradientTransform: "translate(-435.1 285.12) rotate(27.11)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    x1: 225.25,
    y1: 254.86,
    x2: 225.25,
    y2: 252.26,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    x1: 223.7,
    y1: 255.79,
    x2: 223.7,
    y2: 251.8,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    x1: -188.9,
    y1: -326.99,
    x2: -190.97,
    y2: -331.05,
    gradientTransform: "translate(241.46 631.51) rotate(27.11)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    x1: 573.31,
    y1: -327.17,
    x2: 572.09,
    y2: -329.55,
    gradientTransform: "translate(-435.1 285.12) rotate(27.11)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    x1: 590.93,
    y1: -326.95,
    x2: 589.22,
    y2: -330.28,
    gradientTransform: "translate(-450.99 276.99) rotate(27.11) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    x1: 226.15,
    y1: 255.48,
    x2: 226.15,
    y2: 252.13,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    x1: 221.87,
    y1: 254.39,
    x2: 221.87,
    y2: 251.64,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    x1: 573.4,
    y1: -328.84,
    x2: 572.3,
    y2: -331,
    gradientTransform: "translate(-435.1 285.12) rotate(27.11)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    x1: 223.91,
    y1: 253.86,
    x2: 223.91,
    y2: 250.81,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    x1: 223.97,
    y1: 254.56,
    x2: 223.97,
    y2: 251.19,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    x1: 579.22,
    y1: -328.36,
    x2: 577.74,
    y2: -331.26,
    gradientTransform: "translate(-435.1 285.12) rotate(27.11)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    x1: 229.09,
    y1: 256.95,
    x2: 229.09,
    y2: 254.34,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-287",
    x1: 227.26,
    y1: 257.74,
    x2: 227.26,
    y2: 253.74,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-288",
    x1: -184.84,
    y1: -326.88,
    x2: -186.92,
    y2: -330.94,
    gradientTransform: "translate(241.46 631.51) rotate(27.11)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-289",
    x1: 577.36,
    y1: -327.06,
    x2: 576.14,
    y2: -329.44,
    gradientTransform: "translate(-435.1 285.12) rotate(27.11)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-290",
    x1: 595.3,
    y1: -326.84,
    x2: 593.59,
    y2: -330.17,
    gradientTransform: "translate(-450.99 276.99) rotate(27.11) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-291",
    x1: 229.99,
    y1: 257.57,
    x2: 229.99,
    y2: 254.22,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-292",
    x1: -2638.22,
    y1: -328,
    x2: -2636.45,
    y2: -331.47,
    gradientTransform: "translate(-2276.61 -657.7) rotate(-152.89) scale(1 -1)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-293",
    x1: 221.36,
    y1: 253.28,
    x2: 221.36,
    y2: 250.27,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-294",
    x1: -2622.08,
    y1: -326.95,
    x2: -2620.64,
    y2: -329.79,
    gradientTransform: "translate(-2260.73 -649.56) rotate(-152.89) scale(1 -1) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-295",
    x1: 220.69,
    y1: 253.28,
    x2: 220.69,
    y2: 249.07,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-296",
    x1: 225.43,
    y1: 256.33,
    x2: 225.43,
    y2: 253.59,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-297",
    x1: 577.46,
    y1: -328.73,
    x2: 576.35,
    y2: -330.89,
    gradientTransform: "translate(-435.1 285.12) rotate(27.11)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-298",
    x1: 227.47,
    y1: 255.8,
    x2: 227.47,
    y2: 252.76,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-299",
    x1: 227.53,
    y1: 256.51,
    x2: 227.53,
    y2: 253.13,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-300",
    x1: 583.73,
    y1: -328.1,
    x2: 582.25,
    y2: -331,
    gradientTransform: "translate(-435.1 285.12) rotate(27.11)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-301",
    x1: 232.99,
    y1: 259.23,
    x2: 232.99,
    y2: 256.63,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-302",
    x1: 231.15,
    y1: 260.02,
    x2: 231.15,
    y2: 256.03,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-303",
    x1: -180.33,
    y1: -326.63,
    x2: -182.41,
    y2: -330.68,
    gradientTransform: "translate(241.46 631.51) rotate(27.11)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-304",
    x1: 581.87,
    y1: -326.81,
    x2: 580.65,
    y2: -329.19,
    gradientTransform: "translate(-435.1 285.12) rotate(27.11)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-305",
    x1: 599.81,
    y1: -326.58,
    x2: 598.1,
    y2: -329.92,
    gradientTransform: "translate(-450.99 276.99) rotate(27.11) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-306",
    x1: 233.88,
    y1: 259.85,
    x2: 233.88,
    y2: 256.5,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-307",
    x1: 229.33,
    y1: 258.62,
    x2: 229.33,
    y2: 255.87,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-308",
    x1: 581.97,
    y1: -328.47,
    x2: 580.86,
    y2: -330.63,
    gradientTransform: "translate(-435.1 285.12) rotate(27.11)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-309",
    x1: 231.37,
    y1: 258.09,
    x2: 231.37,
    y2: 255.04,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-310",
    x1: 231.42,
    y1: 258.79,
    x2: 231.42,
    y2: 255.41,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-311",
    x1: 503.72,
    y1: -179.44,
    x2: 502.24,
    y2: -183.35,
    gradientTransform: "translate(-324.04 236.83) rotate(20.78)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-312",
    x1: 209.4,
    y1: 247.97,
    x2: 209.4,
    y2: 244.66,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-313",
    x1: 207.33,
    y1: 249.47,
    x2: 207.33,
    y2: 244.44,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-314",
    x1: -260.82,
    y1: -177.74,
    x2: -262.79,
    y2: -182.95,
    gradientTransform: "translate(386.61 506.44) rotate(20.78)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-315",
    x1: 501.84,
    y1: -177.91,
    x2: 500.64,
    y2: -181.06,
    gradientTransform: "translate(-324.04 236.83) rotate(20.78)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-316",
    x1: 519.77,
    y1: -177.7,
    x2: 518.14,
    y2: -182,
    gradientTransform: "translate(-340.73 230.49) rotate(20.78) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-317",
    x1: 210.52,
    y1: 248.68,
    x2: 210.52,
    y2: 244.35,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-318",
    x1: 205.34,
    y1: 247.84,
    x2: 205.34,
    y2: 244.48,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-319",
    x1: 502.02,
    y1: -179.95,
    x2: 500.9,
    y2: -182.89,
    gradientTransform: "translate(-324.04 236.83) rotate(20.78)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-320",
    x1: 207.64,
    y1: 246.98,
    x2: 207.64,
    y2: 243.11,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-321",
    x1: 207.8,
    y1: 247.84,
    x2: 207.8,
    y2: 243.56,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-322",
    x1: 508.96,
    y1: -179.32,
    x2: 507.48,
    y2: -183.22,
    gradientTransform: "translate(-324.04 236.83) rotate(20.78)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-323",
    x1: 214.25,
    y1: 249.95,
    x2: 214.25,
    y2: 246.64,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-324",
    x1: 211.83,
    y1: 251.32,
    x2: 211.83,
    y2: 246.28,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-325",
    x1: -255.96,
    y1: -177.61,
    x2: -257.93,
    y2: -182.82,
    gradientTransform: "translate(386.61 506.44) rotate(20.78)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-326",
    x1: 506.7,
    y1: -177.78,
    x2: 505.51,
    y2: -180.93,
    gradientTransform: "translate(-324.04 236.83) rotate(20.78)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-327",
    x1: 525.01,
    y1: -177.57,
    x2: 523.38,
    y2: -181.87,
    gradientTransform: "translate(-340.73 230.49) rotate(20.78) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-328",
    x1: 215.38,
    y1: 250.65,
    x2: 215.38,
    y2: 246.32,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-329",
    x1: -2565.97,
    y1: -178.95,
    x2: -2564.27,
    y2: -183.42,
    gradientTransform: "translate(-2258.34 -497.04) rotate(-159.22) scale(1 -1)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-330",
    x1: 204.56,
    y1: 246.56,
    x2: 204.56,
    y2: 242.87,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-331",
    x1: -2549.89,
    y1: -177.64,
    x2: -2548.45,
    y2: -181.44,
    gradientTransform: "translate(-2241.65 -490.71) rotate(-159.22) scale(1 -1) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-332",
    x1: 203.74,
    y1: 246.69,
    x2: 203.74,
    y2: 241.55,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-333",
    x1: 209.84,
    y1: 249.68,
    x2: 209.84,
    y2: 246.32,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-334",
    x1: 506.88,
    y1: -179.82,
    x2: 505.77,
    y2: -182.76,
    gradientTransform: "translate(-324.04 236.83) rotate(20.78)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-335",
    x1: 212.14,
    y1: 248.82,
    x2: 212.14,
    y2: 244.96,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-336",
    x1: 212.3,
    y1: 249.68,
    x2: 212.3,
    y2: 245.4,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-337",
    x1: 514.36,
    y1: -179.01,
    x2: 512.88,
    y2: -182.92,
    gradientTransform: "translate(-324.04 236.83) rotate(20.78)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-338",
    x1: 219.2,
    y1: 252.15,
    x2: 219.2,
    y2: 248.85,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-339",
    x1: 216.77,
    y1: 253.53,
    x2: 216.77,
    y2: 248.49,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-340",
    x1: -250.55,
    y1: -177.3,
    x2: -252.53,
    y2: -182.51,
    gradientTransform: "translate(386.61 506.44) rotate(20.78)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-341",
    x1: 512.11,
    y1: -177.47,
    x2: 510.91,
    y2: -180.62,
    gradientTransform: "translate(-324.04 236.83) rotate(20.78)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-342",
    x1: 530.42,
    y1: -177.27,
    x2: 528.78,
    y2: -181.56,
    gradientTransform: "translate(-340.73 230.49) rotate(20.78) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-343",
    x1: 220.32,
    y1: 252.86,
    x2: 220.32,
    y2: 248.53,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-344",
    x1: 214.79,
    y1: 251.89,
    x2: 214.79,
    y2: 248.52,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-345",
    x1: 512.29,
    y1: -179.51,
    x2: 511.17,
    y2: -182.46,
    gradientTransform: "translate(-324.04 236.83) rotate(20.78)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-346",
    x1: 217.09,
    y1: 251.03,
    x2: 217.09,
    y2: 247.16,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-347",
    x1: 217.24,
    y1: 251.89,
    x2: 217.24,
    y2: 247.61,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-348",
    x1: 147.81,
    y1: 246.7,
    x2: 147.81,
    y2: 242.21,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-349",
    x1: -507.73,
    y1: 136.84,
    x2: -508.21,
    y2: 132.23,
    gradientTransform: "translate(665.84 161.25) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-350",
    x1: 255.18,
    y1: 137.09,
    x2: 254.88,
    y2: 134.12,
    gradientTransform: "translate(-90.17 82.78) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-351",
    x1: 274.31,
    y1: 137.14,
    x2: 273.91,
    y2: 133.31,
    gradientTransform: "translate(-107.92 80.94) rotate(5.93) skewX(-.09)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-352",
    x1: 152.46,
    y1: 245.27,
    x2: 152.46,
    y2: 241.22,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-353",
    x1: 146.28,
    y1: 245.48,
    x2: 146.28,
    y2: 242.67,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-354",
    x1: 255.59,
    y1: 135.34,
    x2: 255.28,
    y2: 132.4,
    gradientTransform: "translate(-90.17 82.78) rotate(5.93)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-355",
    x1: 148.31,
    y1: 244.37,
    x2: 148.31,
    y2: 240.88,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-356",
    x1: 148.74,
    y1: 245.07,
    x2: 148.74,
    y2: 241.22,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-135"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M167.86,285.84c22.02,18.78,50.49,30.11,81.59,30.11s60.2-11.58,82.32-30.73c-28.48-2.24-85.57-4.51-119.77-5.25-19.72-.43-34.34,2.63-44.15,5.88Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-357",
    x1: 289.39,
    y1: 263.07,
    x2: 304.83,
    y2: 350.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1a21f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f1a21f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-358",
    x1: 609.7,
    y1: 131.7,
    x2: 610.35,
    y2: 131.7,
    gradientTransform: "translate(-139.72 -161.15) rotate(34.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbcd13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4b21d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-359",
    x1: 102.58,
    y1: 276.03,
    x2: 103.37,
    y2: 276.03,
    gradientTransform: "translate(219.26 6.54) rotate(6.54)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-360",
    x1: 103.23,
    y1: 276.87,
    x2: 104.18,
    y2: 276.87,
    gradientTransform: "translate(219.26 6.54) rotate(6.54)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-361",
    x1: 103.96,
    y1: 278,
    x2: 105.04,
    y2: 278,
    gradientTransform: "translate(219.26 6.54) rotate(6.54)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-362",
    x1: 246.11,
    y1: 268.42,
    x2: 247.23,
    y2: 268.42,
    gradientTransform: "translate(118.68 -24.43) rotate(14.13)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-363",
    x1: 329.04,
    y1: 254.54,
    x2: 330.23,
    y2: 254.54,
    gradientTransform: "translate(61.97 -48.69) rotate(18.63)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-364",
    x1: 363.9,
    y1: 248.11,
    x2: 365.25,
    y2: 248.11,
    gradientTransform: "translate(39.49 -60.93) rotate(20.6)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-365",
    x1: 438.17,
    y1: 228.16,
    x2: 439.66,
    y2: 228.16,
    gradientTransform: "translate(-8.47 -90.13) rotate(24.87)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-366",
    x1: 1082.88,
    y1: -337.29,
    x2: 1084.37,
    y2: -337.29,
    gradientTransform: "translate(1160.84 -433.77) rotate(122.38) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-367",
    x1: 1081.64,
    y1: -338.71,
    x2: 1083.02,
    y2: -338.71,
    gradientTransform: "translate(1160.84 -433.77) rotate(122.38) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-368",
    x1: 1112.23,
    y1: -411.11,
    x2: 1113.41,
    y2: -411.11,
    gradientTransform: "translate(1181.84 -490.14) rotate(118.15) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-369",
    x1: 1110.98,
    y1: -412.59,
    x2: 1112.16,
    y2: -412.59,
    gradientTransform: "translate(1181.84 -490.14) rotate(118.15) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-370",
    x1: 1171.66,
    y1: -628.21,
    x2: 1172.8,
    y2: -628.21,
    gradientTransform: "translate(1225.31 -654.21) rotate(106.35) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-371",
    x1: 1182.05,
    y1: -705.98,
    x2: 1183.11,
    y2: -705.98,
    gradientTransform: "translate(1234.17 -711.76) rotate(102.34) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-372",
    x1: 1187.55,
    y1: -767.65,
    x2: 1188.34,
    y2: -767.65,
    gradientTransform: "translate(1238.47 -758.18) rotate(99.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-373",
    x1: 501.91,
    y1: 215.26,
    x2: 502.43,
    y2: 215.26,
    gradientTransform: "translate(-52.89 -121.18) rotate(25.71)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-374",
    x1: -31.86,
    y1: 299.06,
    x2: -31.22,
    y2: 299.06,
    gradientTransform: "translate(327.24 -8.68) rotate(-2.07)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-375",
    x1: -31.33,
    y1: 299.74,
    x2: -30.56,
    y2: 299.74,
    gradientTransform: "translate(327.24 -8.68) rotate(-2.07)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-376",
    x1: -30.75,
    y1: 300.64,
    x2: -29.88,
    y2: 300.64,
    gradientTransform: "translate(327.24 -8.68) rotate(-2.07)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-377",
    x1: 116.09,
    y1: 309.01,
    x2: 116.99,
    y2: 309.01,
    gradientTransform: "translate(222.47 -24.85) rotate(5.53)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-378",
    x1: 200.89,
    y1: 304.84,
    x2: 201.85,
    y2: 304.84,
    gradientTransform: "translate(164.17 -40.02) rotate(10.01)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-379",
    x1: 238.55,
    y1: 302.59,
    x2: 239.64,
    y2: 302.59,
    gradientTransform: "translate(139 -49.09) rotate(11.99)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-380",
    x1: 317.72,
    y1: 290.94,
    x2: 318.91,
    y2: 290.94,
    gradientTransform: "translate(86.42 -70.42) rotate(16.27)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-381",
    x1: 1161.57,
    y1: -448.61,
    x2: 1162.76,
    y2: -448.61,
    gradientTransform: "translate(1190.98 -585.42) rotate(113.78) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-382",
    x1: 1160.56,
    y1: -449.76,
    x2: 1161.68,
    y2: -449.76,
    gradientTransform: "translate(1190.98 -585.42) rotate(113.78) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-383",
    x1: 1183,
    y1: -528.72,
    x2: 1183.96,
    y2: -528.72,
    gradientTransform: "translate(1204.53 -644.02) rotate(109.54) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-384",
    x1: 1182,
    y1: -529.91,
    x2: 1182.95,
    y2: -529.91,
    gradientTransform: "translate(1204.53 -644.02) rotate(109.54) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-385",
    x1: 1217,
    y1: -757.66,
    x2: 1217.91,
    y2: -757.66,
    gradientTransform: "translate(1223.35 -812.32) rotate(97.74) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-386",
    x1: 1218.7,
    y1: -837,
    x2: 1219.56,
    y2: -837,
    gradientTransform: "translate(1222.48 -870.8) rotate(93.74) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-387",
    x1: 1216.76,
    y1: -899.95,
    x2: 1217.4,
    y2: -899.95,
    gradientTransform: "translate(1219.47 -917.04) rotate(90.59) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-388",
    x1: 315.32,
    y1: 265.57,
    x2: 315.97,
    y2: 265.57,
    gradientTransform: "translate(67.72 -49.64) rotate(16)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-389",
    x1: -221.02,
    y1: 256.64,
    x2: -220.23,
    y2: 256.64,
    gradientTransform: "translate(462.07 -2.8) rotate(-11.78)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-390",
    x1: -220.37,
    y1: 257.48,
    x2: -219.41,
    y2: 257.48,
    gradientTransform: "translate(462.07 -2.8) rotate(-11.78)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-391",
    x1: -219.64,
    y1: 258.6,
    x2: -218.56,
    y2: 258.6,
    gradientTransform: "translate(462.07 -2.8) rotate(-11.78)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-392",
    x1: -76.58,
    y1: 292.32,
    x2: -75.46,
    y2: 292.32,
    gradientTransform: "translate(356.18 -.89) rotate(-4.18)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-393",
    x1: 8.45,
    y1: 303.5,
    x2: 9.64,
    y2: 303.5,
    gradientTransform: "translate(295.48 -5.97) rotate(.31)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-394",
    x1: 46.04,
    y1: 308.38,
    x2: 47.39,
    y2: 308.38,
    gradientTransform: "translate(269.46 -10.86) rotate(2.28)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-395",
    x1: 125.78,
    y1: 311.43,
    x2: 127.27,
    y2: 311.43,
    gradientTransform: "translate(214.62 -23.02) rotate(6.56)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-396",
    x1: 1206.56,
    y1: -635.95,
    x2: 1208.04,
    y2: -635.95,
    gradientTransform: "translate(1216.61 -716.96) rotate(104.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-397",
    x1: 1205.31,
    y1: -637.37,
    x2: 1206.69,
    y2: -637.37,
    gradientTransform: "translate(1216.61 -716.96) rotate(104.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-398",
    x1: 1213.42,
    y1: -719.18,
    x2: 1214.61,
    y2: -719.18,
    gradientTransform: "translate(1219.84 -776.92) rotate(99.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-399",
    x1: 1212.17,
    y1: -720.65,
    x2: 1213.36,
    y2: -720.65,
    gradientTransform: "translate(1219.84 -776.92) rotate(99.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-400",
    x1: 1207.51,
    y1: -950.41,
    x2: 1208.65,
    y2: -950.41,
    gradientTransform: "translate(1209.54 -946.11) rotate(88.03) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-401",
    x1: 1195.51,
    y1: -1029.14,
    x2: 1196.57,
    y2: -1029.14,
    gradientTransform: "translate(1199.13 -1003.57) rotate(84.03) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-402",
    x1: 1183.33,
    y1: -1090.99,
    x2: 1184.11,
    y2: -1090.99,
    gradientTransform: "translate(1188.53 -1049.06) rotate(80.88) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-403",
    x1: 366.09,
    y1: 254.86,
    x2: 366.66,
    y2: 254.86,
    gradientTransform: "translate(26.29 -64.74) rotate(19.57)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-404",
    x1: -170.17,
    y1: 270.71,
    x2: -169.47,
    y2: 270.71,
    gradientTransform: "translate(416.01 6.7) rotate(-8.2)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-405",
    x1: -169.59,
    y1: 271.44,
    x2: -168.76,
    y2: 271.44,
    gradientTransform: "translate(416.01 6.7) rotate(-8.2)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-406",
    x1: -168.96,
    y1: 272.43,
    x2: -168.02,
    y2: 272.43,
    gradientTransform: "translate(416.01 6.7) rotate(-8.2)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-407",
    x1: -25.53,
    y1: 299.87,
    x2: -24.55,
    y2: 299.87,
    gradientTransform: "translate(311.04 1.31) rotate(-.61)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-408",
    x1: 60.7,
    y1: 306.22,
    x2: 61.74,
    y2: 306.22,
    gradientTransform: "translate(249.84 -6.96) rotate(3.88)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-409",
    x1: 97.12,
    y1: 309.6,
    x2: 98.3,
    y2: 309.6,
    gradientTransform: "translate(225.3 -13.84) rotate(5.85)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-410",
    x1: 176.45,
    y1: 308.48,
    x2: 177.74,
    y2: 308.48,
    gradientTransform: "translate(171.53 -29.19) rotate(10.12)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-411",
    x1: 1197.25,
    y1: -586.06,
    x2: 1198.55,
    y2: -586.06,
    gradientTransform: "translate(1214.49 -659.45) rotate(107.64) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-412",
    x1: 1196.16,
    y1: -587.3,
    x2: 1197.37,
    y2: -587.3,
    gradientTransform: "translate(1214.49 -659.45) rotate(107.64) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-413",
    x1: 1207.9,
    y1: -668.55,
    x2: 1208.94,
    y2: -668.55,
    gradientTransform: "translate(1221.59 -718.84) rotate(103.4) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-414",
    x1: 1206.81,
    y1: -669.84,
    x2: 1207.85,
    y2: -669.84,
    gradientTransform: "translate(1221.59 -718.84) rotate(103.4) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-415",
    x1: 1212.97,
    y1: -898.78,
    x2: 1213.97,
    y2: -898.78,
    gradientTransform: "translate(1221.27 -888.47) rotate(91.6) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-416",
    x1: 1205.47,
    y1: -977.87,
    x2: 1206.4,
    y2: -977.87,
    gradientTransform: "translate(1214.32 -947.24) rotate(87.6) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-417",
    x1: 1194.84,
    y1: -1040.41,
    x2: 1195.53,
    y2: -1040.41,
    gradientTransform: "translate(1207.05 -992.09) rotate(84.45) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_218",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 218",
    x1: -1412.5,
    y1: 300.3,
    x2: -1410.45,
    y2: 291.22,
    gradientTransform: "translate(-1165.59) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fabba5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fee1af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1412.9,
    y1: 299.98,
    x2: -1410.48,
    y2: 293.31,
    gradientTransform: "translate(-1165.59) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8976b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-2",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1402.97,
    y1: 304.97,
    x2: -1395.43,
    y2: 286.66,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-3",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1402.83,
    y1: 309.26,
    x2: -1396.15,
    y2: 291.66,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-4",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1402.49,
    y1: 305.16,
    x2: -1394.96,
    y2: 286.85,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-5",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1410.59,
    y1: 301.83,
    x2: -1403.05,
    y2: 283.52,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-6",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1411.63,
    y1: 301.4,
    x2: -1404.1,
    y2: 283.09,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-7",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1413.93,
    y1: 300.46,
    x2: -1406.39,
    y2: 282.15,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-8",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1419.1,
    y1: 303.09,
    x2: -1412.42,
    y2: 285.49,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-9",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1422.2,
    y1: 301.92,
    x2: -1415.52,
    y2: 284.32,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-10",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1415.94,
    y1: 304.29,
    x2: -1409.26,
    y2: 286.69,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-11",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1421.76,
    y1: 302.08,
    x2: -1415.09,
    y2: 284.48,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-12",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1411.04,
    y1: 306.15,
    x2: -1404.36,
    y2: 288.55,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-13",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1411.96,
    y1: 305.8,
    x2: -1405.28,
    y2: 288.2,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-14",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1408.43,
    y1: 307.14,
    x2: -1401.75,
    y2: 289.54,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-15",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1404.28,
    y1: 304.43,
    x2: -1396.74,
    y2: 286.12,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-16",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1411.65,
    y1: 305.92,
    x2: -1404.97,
    y2: 288.32,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-17",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1410.7,
    y1: 306.28,
    x2: -1404.02,
    y2: 288.68,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-18",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 408.14,
    y1: 373.35,
    x2: 415.68,
    y2: 355.03,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-19",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 408.27,
    y1: 377.98,
    x2: 415.11,
    y2: 359.96,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-20",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 408.69,
    y1: 373.5,
    x2: 416.19,
    y2: 355.27,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-21",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 386.15,
    y1: 374.53,
    x2: 393.7,
    y2: 356.18,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-22",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 385.07,
    y1: 374,
    x2: 392.57,
    y2: 355.79,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-23",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 382.62,
    y1: 373.04,
    x2: 390.12,
    y2: 354.83,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-24",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 377.2,
    y1: 375.6,
    x2: 383.82,
    y2: 358.14,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-25",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 373.86,
    y1: 374.41,
    x2: 380.48,
    y2: 356.96,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-26",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 380.47,
    y1: 376.99,
    x2: 387.18,
    y2: 359.32,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-27",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 374.23,
    y1: 374.75,
    x2: 380.94,
    y2: 357.06,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-28",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 399.59,
    y1: 374.54,
    x2: 406.3,
    y2: 356.86,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-29",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 398.59,
    y1: 374.18,
    x2: 405.3,
    y2: 356.5,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-30",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 402.36,
    y1: 375.54,
    x2: 409.07,
    y2: 357.86,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-31",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 406.68,
    y1: 372.93,
    x2: 414.34,
    y2: 354.3,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-32",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 385.1,
    y1: 378.57,
    x2: 391.76,
    y2: 360.99,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-33",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 386.13,
    y1: 378.88,
    x2: 392.77,
    y2: 361.36,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-34",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 435.39,
    y1: 375.45,
    x2: 442.93,
    y2: 357.13,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-35",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 435.52,
    y1: 380.08,
    x2: 442.36,
    y2: 362.07,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-36",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 435.94,
    y1: 375.6,
    x2: 443.44,
    y2: 357.37,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-37",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 413.4,
    y1: 376.63,
    x2: 420.95,
    y2: 358.28,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-38",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 412.32,
    y1: 376.1,
    x2: 419.82,
    y2: 357.89,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-39",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 409.87,
    y1: 375.14,
    x2: 417.37,
    y2: 356.93,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-40",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 404.45,
    y1: 377.7,
    x2: 411.07,
    y2: 360.24,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-41",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 407.72,
    y1: 379.09,
    x2: 414.43,
    y2: 361.42,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-42",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 426.84,
    y1: 376.64,
    x2: 433.55,
    y2: 358.96,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-43",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 425.84,
    y1: 376.28,
    x2: 432.55,
    y2: 358.6,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-44",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 429.61,
    y1: 377.64,
    x2: 436.31,
    y2: 359.96,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-45",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 433.93,
    y1: 375.03,
    x2: 441.59,
    y2: 356.4,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-46",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 412.35,
    y1: 380.67,
    x2: 419.01,
    y2: 363.09,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-47",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: 413.38,
    y1: 380.99,
    x2: 420.02,
    y2: 363.46,
    gradientTransform: "translate(-70.83 -183.63) rotate(94.99) scale(1 -1)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-48",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1415.96,
    y1: 300.85,
    x2: -1415.86,
    y2: 293.16,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73-49",
    "data-name": "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 73",
    x1: -1398.19,
    y1: 301.08,
    x2: -1398.09,
    y2: 293.4,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-418",
    x1: 610.16,
    y1: 121.16,
    x2: 610.73,
    y2: 121.16,
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-419",
    x1: 107.86,
    y1: 266.79,
    x2: 108.55,
    y2: 266.79,
    gradientTransform: "translate(219.26 6.54) rotate(6.54)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-420",
    x1: 108.43,
    y1: 267.52,
    x2: 109.26,
    y2: 267.52,
    gradientTransform: "translate(219.26 6.54) rotate(6.54)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-421",
    x1: 109.06,
    y1: 268.51,
    x2: 110.01,
    y2: 268.51,
    gradientTransform: "translate(219.26 6.54) rotate(6.54)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-422",
    x1: 249.76,
    y1: 258.2,
    x2: 250.75,
    y2: 258.2,
    gradientTransform: "translate(118.68 -24.43) rotate(14.13)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-423",
    x1: 331.74,
    y1: 243.9,
    x2: 332.78,
    y2: 243.9,
    gradientTransform: "translate(61.97 -48.69) rotate(18.63)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-424",
    x1: 366.11,
    y1: 237.19,
    x2: 367.29,
    y2: 237.19,
    gradientTransform: "translate(39.49 -60.93) rotate(20.6)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-425",
    x1: 439.43,
    y1: 216.91,
    x2: 440.73,
    y2: 216.91,
    gradientTransform: "translate(-8.47 -90.13) rotate(24.87)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-426",
    x1: 1071.88,
    y1: -337.74,
    x2: 1073.18,
    y2: -337.74,
    gradientTransform: "translate(1160.84 -433.77) rotate(122.38) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-427",
    x1: 1070.79,
    y1: -338.99,
    x2: 1072,
    y2: -338.99,
    gradientTransform: "translate(1160.84 -433.77) rotate(122.38) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-428",
    x1: 1101.53,
    y1: -410.4,
    x2: 1102.56,
    y2: -410.4,
    gradientTransform: "translate(1181.84 -490.14) rotate(118.15) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-429",
    x1: 1100.43,
    y1: -411.69,
    x2: 1101.47,
    y2: -411.69,
    gradientTransform: "translate(1181.84 -490.14) rotate(118.15) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-430",
    x1: 1161.67,
    y1: -624.97,
    x2: 1162.67,
    y2: -624.97,
    gradientTransform: "translate(1225.31 -654.21) rotate(106.35) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-431",
    x1: 1172.42,
    y1: -701.9,
    x2: 1173.35,
    y2: -701.9,
    gradientTransform: "translate(1234.17 -711.76) rotate(102.34) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-432",
    x1: 1178.22,
    y1: -762.93,
    x2: 1178.9,
    y2: -762.93,
    gradientTransform: "translate(1238.47 -758.18) rotate(99.19) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-433",
    x1: 502.14,
    y1: 205.9,
    x2: 502.59,
    y2: 205.9,
    gradientTransform: "translate(-52.89 -121.18) rotate(25.71)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-434",
    x1: -27.32,
    y1: 290.78,
    x2: -26.76,
    y2: 290.78,
    gradientTransform: "translate(327.24 -8.68) rotate(-2.07)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-435",
    x1: -26.86,
    y1: 291.37,
    x2: -26.19,
    y2: 291.37,
    gradientTransform: "translate(327.24 -8.68) rotate(-2.07)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-436",
    x1: -26.35,
    y1: 292.16,
    x2: -25.59,
    y2: 292.16,
    gradientTransform: "translate(327.24 -8.68) rotate(-2.07)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-437",
    x1: 119.2,
    y1: 299.91,
    x2: 119.99,
    y2: 299.91,
    gradientTransform: "translate(222.47 -24.85) rotate(5.53)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-438",
    x1: 203.17,
    y1: 295.38,
    x2: 204,
    y2: 295.38,
    gradientTransform: "translate(164.17 -40.02) rotate(10.01)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-439",
    x1: 240.4,
    y1: 292.92,
    x2: 241.35,
    y2: 292.92,
    gradientTransform: "translate(139 -49.09) rotate(11.99)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-440",
    x1: 318.74,
    y1: 281,
    x2: 319.78,
    y2: 281,
    gradientTransform: "translate(86.42 -70.42) rotate(16.27)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-441",
    x1: 1151.82,
    y1: -449.09,
    x2: 1152.87,
    y2: -449.09,
    gradientTransform: "translate(1190.98 -585.42) rotate(113.78) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-442",
    x1: 1150.95,
    y1: -450.09,
    x2: 1151.92,
    y2: -450.09,
    gradientTransform: "translate(1190.98 -585.42) rotate(113.78) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-443",
    x1: 1173.5,
    y1: -528.19,
    x2: 1174.33,
    y2: -528.19,
    gradientTransform: "translate(1204.53 -644.02) rotate(109.54) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-444",
    x1: 1172.62,
    y1: -529.23,
    x2: 1173.46,
    y2: -529.23,
    gradientTransform: "translate(1204.53 -644.02) rotate(109.54) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-445",
    x1: 1208.08,
    y1: -754.91,
    x2: 1208.88,
    y2: -754.91,
    gradientTransform: "translate(1223.35 -812.32) rotate(97.74) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-446",
    x1: 1210.09,
    y1: -833.52,
    x2: 1210.84,
    y2: -833.52,
    gradientTransform: "translate(1222.48 -870.8) rotate(93.74) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-447",
    x1: 1208.39,
    y1: -895.9,
    x2: 1208.95,
    y2: -895.9,
    gradientTransform: "translate(1219.47 -917.04) rotate(90.59) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-448",
    x1: 318.06,
    y1: 255.85,
    x2: 318.62,
    y2: 255.85,
    gradientTransform: "translate(67.72 -49.64) rotate(16)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-449",
    x1: -214.1,
    y1: 249.18,
    x2: -213.4,
    y2: 249.18,
    gradientTransform: "translate(462.07 -2.8) rotate(-11.78)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-450",
    x1: -213.53,
    y1: 249.91,
    x2: -212.69,
    y2: 249.91,
    gradientTransform: "translate(462.07 -2.8) rotate(-11.78)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-451",
    x1: -212.89,
    y1: 250.9,
    x2: -211.95,
    y2: 250.9,
    gradientTransform: "translate(462.07 -2.8) rotate(-11.78)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-452",
    x1: -71.07,
    y1: 283.64,
    x2: -70.08,
    y2: 283.64,
    gradientTransform: "translate(356.18 -.89) rotate(-4.18)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-453",
    x1: 13.12,
    y1: 294.25,
    x2: 14.16,
    y2: 294.25,
    gradientTransform: "translate(295.48 -5.97) rotate(.31)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-454",
    x1: 50.27,
    y1: 298.79,
    x2: 51.45,
    y2: 298.79,
    gradientTransform: "translate(269.46 -10.86) rotate(2.28)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-455",
    x1: 129.16,
    y1: 301.36,
    x2: 130.46,
    y2: 301.36,
    gradientTransform: "translate(214.62 -23.02) rotate(6.56)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-456",
    x1: 1196.44,
    y1: -634.15,
    x2: 1197.74,
    y2: -634.15,
    gradientTransform: "translate(1216.61 -716.96) rotate(104.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-457",
    x1: 1195.35,
    y1: -635.4,
    x2: 1196.56,
    y2: -635.4,
    gradientTransform: "translate(1216.61 -716.96) rotate(104.07) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-458",
    x1: 1203.77,
    y1: -716.28,
    x2: 1204.81,
    y2: -716.28,
    gradientTransform: "translate(1219.84 -776.92) rotate(99.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-459",
    x1: 1202.68,
    y1: -717.57,
    x2: 1203.72,
    y2: -717.57,
    gradientTransform: "translate(1219.84 -776.92) rotate(99.83) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-460",
    x1: 1199,
    y1: -945.24,
    x2: 1199.99,
    y2: -945.24,
    gradientTransform: "translate(1209.54 -946.11) rotate(88.03) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-461",
    x1: 1187.49,
    y1: -1023.25,
    x2: 1188.42,
    y2: -1023.25,
    gradientTransform: "translate(1199.13 -1003.57) rotate(84.03) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-462",
    x1: 1175.7,
    y1: -1084.54,
    x2: 1176.38,
    y2: -1084.54,
    gradientTransform: "translate(1188.53 -1049.06) rotate(80.88) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-463",
    x1: 369.38,
    y1: 243.85,
    x2: 369.87,
    y2: 243.85,
    gradientTransform: "translate(26.29 -64.74) rotate(19.57)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-464",
    x1: -162.15,
    y1: 262.38,
    x2: -161.55,
    y2: 262.38,
    gradientTransform: "translate(416.01 6.7) rotate(-8.2)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-465",
    x1: -161.65,
    y1: 263.02,
    x2: -160.93,
    y2: 263.02,
    gradientTransform: "translate(416.01 6.7) rotate(-8.2)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-466",
    x1: -161.1,
    y1: 263.88,
    x2: -160.27,
    y2: 263.88,
    gradientTransform: "translate(416.01 6.7) rotate(-8.2)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-467",
    x1: -19,
    y1: 290.23,
    x2: -18.14,
    y2: 290.23,
    gradientTransform: "translate(311.04 1.31) rotate(-.61)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-468",
    x1: 66.33,
    y1: 295.96,
    x2: 67.24,
    y2: 295.96,
    gradientTransform: "translate(249.84 -6.96) rotate(3.88)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-469",
    x1: 102.29,
    y1: 298.98,
    x2: 103.32,
    y2: 298.98,
    gradientTransform: "translate(225.3 -13.84) rotate(5.85)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-470",
    x1: 180.69,
    y1: 297.34,
    x2: 181.83,
    y2: 297.34,
    gradientTransform: "translate(171.53 -29.19) rotate(10.12)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-471",
    x1: 1185.92,
    y1: -583.51,
    x2: 1187.06,
    y2: -583.51,
    gradientTransform: "translate(1214.49 -659.45) rotate(107.64) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-472",
    x1: 1184.97,
    y1: -584.6,
    x2: 1186.03,
    y2: -584.6,
    gradientTransform: "translate(1214.49 -659.45) rotate(107.64) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-473",
    x1: 1197.06,
    y1: -664.87,
    x2: 1197.97,
    y2: -664.87,
    gradientTransform: "translate(1221.59 -718.84) rotate(103.4) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-474",
    x1: 1196.11,
    y1: -665.99,
    x2: 1197.01,
    y2: -665.99,
    gradientTransform: "translate(1221.59 -718.84) rotate(103.4) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-475",
    x1: 1203.41,
    y1: -892.64,
    x2: 1204.28,
    y2: -892.64,
    gradientTransform: "translate(1221.27 -888.47) rotate(91.6) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-476",
    x1: 1196.47,
    y1: -970.95,
    x2: 1197.28,
    y2: -970.95,
    gradientTransform: "translate(1214.32 -947.24) rotate(87.6) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-477",
    x1: 1186.27,
    y1: -1032.9,
    x2: 1186.87,
    y2: -1032.9,
    gradientTransform: "translate(1207.05 -992.09) rotate(84.45) scale(1 -1)",
    xlinkHref: "#linear-gradient-358"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-257",
    cx: 249.69,
    cy: 187.55,
    rx: 126.82,
    ry: 128.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M376.26,195.08c0,.1,0,.2-.02.3-4.01,67.08-59.11,120.23-126.5,120.23-58.54,0-107.82-40.11-122.37-94.62,5.56-.21,23.86-1.34,60.24-7.41,44.38-7.4,86.44-29.07,87.09-29.41,0,0,0,0,0,0,11.81-3.66,26.89-5.57,43.31-4.97,24.55.9,46.09,7.18,58.23,15.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M357.61,203.91v-22.26c1.31.11,2.72.09,4.18-.07,6.4-.72,11.29-3.98,10.92-7.28-.37-3.3-5.87-5.4-12.27-4.68-.67.07-1.33.18-1.96.31.42-1.07.59-2.18.46-3.31-.6-5.33-7.55-8.92-15.53-8.03-.92.1-1.81.27-2.67.47,1.69-1.7,2.57-3.6,2.35-5.51-.6-5.33-9.5-8.71-19.88-7.54s-18.3,6.43-17.7,11.75c.3,2.67,2.69,4.85,6.29,6.21-1.62-.35-3.34-.59-5.13-.71-10.42-.69-19.15,3.08-19.51,8.43-.36,5.35,7.8,10.25,18.21,10.94,2.48.17,4.87.07,7.07-.23v17.85c-2.56-.75-5.13-1.59-7.73-2.49-16-5.57-36.44-15.29-57.54-23.26v-7.23h2.95l-10.55-7.49-10.22,7.49h3.11v2.05c-1.12-.36-2.23-.71-3.34-1.05v-10.11h6.91l-24.62-17.4-20.92,16.79v-6.52h4.7l-16.84-11.96-16.32,11.96h4.96v15.18c-1.22.46-2.4.92-3.56,1.38v-4.28c1.01,0,1.7.03,1.79.07l-6.44-5.9-6.25,5.91s.76-.01,1.9-.03v8.22c-17.37,8.46-26.5,17.76-31.25,24.6.06,1.04.14,2.07.23,3.1.8,8.91,2.51,17.55,5.02,25.84,15.9,52.39,64.18,90.48,121.27,90.48s105.2-37.96,121.19-90.21c2.83-9.27,4.66-18.99,5.33-29.03-5.72,3.69-11.95,6.15-18.61,7.53ZM340.77,177.89c1.53.18,3.15.19,4.81,0,1.39-.16,2.72-.44,3.96-.83.34,2.03,2.62,3.57,5.84,4.26v23c-4.69.8-9.57,1.08-14.62.91v-27.35ZM329.67,164.58c.86-.2,1.7-.44,2.5-.7-1.56,1.79-2.36,3.87-2.12,5.99.41,3.66,3.82,6.5,8.5,7.63v27.64c-2.91-.17-5.87-.49-8.88-.95v-39.61ZM314.66,182.03c5.87-1.28,9.98-4.18,10.23-7.81.25-3.69-3.56-7.17-9.38-9.2,2.93.56,6.32.7,9.88.3.7-.08,1.39-.18,2.06-.29v38.8c-4.18-.72-8.45-1.7-12.79-2.92v-18.88ZM190.47,158.17h4.7v3.46c-1.58-.08-3.15-.11-4.7-.1v-3.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M340.37,241.02c.01-1.05.14-3.12.85-4.78-.08.12-1.32,1.96-1.4,4.93-.88.25-1.77.49-2.65.71-.09-.84-.3-3.06-.07-4.63,0,0-.39,1.07-.49,3-.12-1.27-.18-2.89.15-4.16,0,0-.79.99-.98,3.41-.14-1.14-.16-2.52.17-3.88,0,0-1.15,1.82-.71,5.31-.26-.81-.82-1.24-1.11-1.42,0,.03-.02.07-.02.11.81,1.1.5,2.43.35,2.9-.2.05-.41.09-.61.13,0-.6.03-1.78.26-3.03-.05-.07-.11-.14-.17-.21.02,0,.09.04.19.1.12-.65.31-1.32.57-1.93-.08.12-1.39,2.06-1.4,5.18-.88.18-1.76.34-2.64.49-.11.02-.22.04-.33.06-.08.01-.16.03-.23.04-.03-.65-.02-1.24,0-1.76-.12-1.27-.18-2.89.15-4.15,0,0-.79.99-.98,3.41-.14-1.14-.16-2.52.17-3.88,0,0-1.15,1.81-.72,5.29.08.26.14.56.14.9.02.12.04.25.07.37-.03,0-.06.01-.09.01.01-.14.02-.27.02-.39-.06-.31-.11-.61-.14-.9-.3-.93-1-1.35-1.23-1.47,0,.01,0,.03,0,.04.84.99.67,2.24.51,2.84-.24.04-.48.07-.71.1-.18.03-.36.05-.55.07-.88.11-1.77.21-2.65.29-.1-.84-.3-3.07-.07-4.64,0,0-.39,1.07-.49,3-.12-1.27-.18-2.89.15-4.16,0,0-.79.99-.98,3.41-.14-1.14-.16-2.51.17-3.88,0,0-.4.63-.64,1.86.09-.11.14-.17.15-.18-.06.1-.12.2-.17.31-.15.84-.23,1.95-.06,3.32-.18-.57-.51-.95-.8-1.19-.03.1-.06.19-.08.29.37.76.32,1.56.21,2.09-.21.01-.43.03-.64.04l-.56.03c-.9.05-1.79.09-2.69.12.02-.86.13-3.06.57-4.57-.04.08-.55,1.09-.9,2.9.05-1.27.22-2.89.72-4.1-.06.05-.93.94-1.44,3.22.02-1.15.19-2.5.7-3.8-.08.1-1.39,1.74-1.44,5.15-.13-.74-.53-1.22-.8-1.47-.02.05-.04.11-.06.16.46.99.19,2.01-.03,2.55-.24,0-.48,0-.73,0-.19,0-.37,0-.56,0-.91,0-1.81-.03-2.71-.06.09-.95.34-2.96.84-4.35-.05.08-.61,1.05-1.08,2.84.13-1.27.4-2.88.98-4.05-.06.05-.99.88-1.64,3.13.09-1.15.35-2.49.94-3.76,0,0-1.48,1.54-1.76,5.03.03.28.02.58-.04.93,0-.32.02-.63.04-.93-.1-.83-.55-1.36-.8-1.59-.02.03-.03.07-.04.1.45.97.2,1.94-.05,2.52-.24-.01-.48-.03-.72-.04.14-.63.39-1.55.77-2.48-.04-.08-.08-.16-.12-.24.01,0,.08.06.17.14.25-.61.57-1.23.94-1.77-.1.1-1.6,1.57-2.3,4.32-.85-.06-1.69-.12-2.53-.2.04-.54.27-3.12.88-4.78-.06.09-.85,1.46-1.33,3.97.09-1.31.33-3.49,1.05-4.97-.06.05-1.06.94-1.7,3.37.07-1.22.31-2.7.96-4.09,0,0-1.85,1.92-1.8,6.32-.46-.04-.91-.09-1.37-.14-.01.07-.02.12-.02.12l-.56-.02s0-.04.01-.06l-.74-.03s.04-.05.09-.15c-.97-.12-1.93-.24-2.9-.38.05-.58.28-3.12.88-4.76-.05.08-.62,1.05-1.08,2.85.13-1.27.4-2.88.98-4.06-.06.05-.99.88-1.64,3.13.09-1.15.35-2.49.94-3.76,0,0-.55.57-1.04,1.8.27-.25.46-.39.5-.42-.22.24-.43.5-.63.77-.2.56-.38,1.24-.49,2.04-.11-.26-.24-.47-.37-.63-.05.09-.09.18-.14.27.27,1.02-.14,1.98-.37,2.4-.2-.03-.39-.06-.59-.09.1-.3.42-1.25.96-2.31-.04-.16-.1-.32-.18-.48-.48.7-.97,1.6-1.33,2.7-21.09-3.4-42.85-10.72-67.39-15.19-53.8-9.95-86.08-4.38-97.31-1.59.38,1.28.78,2.55,1.21,3.81.92,2.66,1.92,5.29,3.01,7.87,19.31,45.95,64.32,78.17,116.76,78.17,40.81,0,77.12-19.51,100.32-49.82,9.08-11.86,16.15-25.37,20.69-40.02-10.46,7.39-20.51,12.18-30.36,15.05ZM309.15,244.45s-.02,0-.03,0c.01-.05.02-.1.03-.14,0,.05,0,.1,0,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M330.64,243.43c-.11.02-.22.04-.33.06-.08.01-.16.03-.23.04-.03-.65-.02-1.24,0-1.76.1-1.91.49-2.99.49-2.99-.24,1.58-.02,3.83.07,4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M301.17,243.98c-.01.07-.02.12-.02.12l-.56-.02s0-.04.01-.06l-.74-.03s.04-.05.09-.15c.22.03.45.05.67.08.07,0,.13.02.2.02.12.02.23.03.35.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M328.84,243.34c-.06-.31-.11-.61-.14-.9.08.26.14.56.14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-446",
    d: "M329.25,243.62c-.52-3.27-2.08-4.53-2.08-4.53,1.24,2.1,1.18,4.68,1.18,4.68l.9-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-506",
    d: "M331.64,243.59c.6-3.23-.46-4.47-.46-4.47.74,2.02-.28,4.59-.28,4.59l.75-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-542",
    d: "M332.95,243.37c.01-2.84-1.61-3.79-1.61-3.79,1.23,1.71.94,3.9.94,3.9l.67-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M334.12,239.7s-.02.07-.02.1c-.05-.07-.11-.14-.17-.21.02,0,.09.04.19.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M327.48,240.97s0,.03,0,.04c-.02-.03-.04-.05-.07-.08.01,0,.04.01.07.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M328.84,243.34c-.06-.31-.11-.61-.14-.9.08.26.14.56.14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-548",
    d: "M330.37,243.8c-.04-4.68,2.16-7.15,2.16-7.15-1.7,3.49-1.13,6.98-1.13,6.98l-1.03.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-550",
    d: "M335.77,242.28c-.52-3.27-2.08-4.53-2.08-4.53,1.24,2.1,1.18,4.68,1.18,4.68l.9-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-442",
    d: "M338.16,242.25c.6-3.23-.46-4.47-.46-4.47.74,2.02-.28,4.59-.28,4.59l.75-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M339.47,242.03c.01-2.84-1.61-3.79-1.61-3.79,1.23,1.71.94,3.9.94,3.9l.67-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M334.12,239.7s-.02.07-.02.1c-.05-.07-.11-.14-.17-.21.02,0,.09.04.19.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-422",
    d: "M336.89,242.46c-.04-4.68,2.16-7.15,2.16-7.15-1.7,3.49-1.13,6.98-1.13,6.98l-1.03.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M322.36,239.72c-.06.1-.12.2-.17.31,0-.04.01-.09.02-.13.09-.11.14-.17.15-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-540",
    d: "M322.68,244.52c-.52-3.27-2.08-4.53-2.08-4.53,1.24,2.1,1.18,4.68,1.18,4.68l.9-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-445",
    d: "M325.07,244.48c.6-3.23-.46-4.47-.46-4.47.74,2.02-.28,4.59-.28,4.59l.75-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-492",
    d: "M326.38,244.27c.01-2.84-1.61-3.79-1.61-3.79,1.23,1.71.94,3.9.94,3.9l.67-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M328.12,238.67c-.31.73-.51,1.54-.64,2.3,0,.01,0,.03,0,.04-.22,1.31-.21,2.49-.2,2.93-.18.03-.36.05-.55.07-.04-3.21,1.32-5.22,1.4-5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M321.34,242.16c-.03.1-.06.19-.08.29-.07-.15-.16-.29-.27-.43-.05-.06-.1-.12-.15-.19.02,0,.09.04.19.1.09.05.2.13.31.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-512",
    d: "M323.8,244.69c-.04-4.68,2.16-7.15,2.16-7.15-1.7,3.49-1.13,6.98-1.13,6.98l-1.03.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-496",
    d: "M316.17,244.76c-.06-3.31-1.43-4.78-1.43-4.78.94,2.25.51,4.8.51,4.8l.91-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-551",
    d: "M318.54,245.06c1.04-3.11.16-4.49.16-4.49.46,2.11-.92,4.51-.92,4.51l.76-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-528",
    d: "M319.87,245.02c.41-2.81-1.06-3.97-1.06-3.97.98,1.86.39,3.99.39,3.99l.67-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M322.36,239.72c-.06.1-.12.2-.17.31-.37.67-.65,1.42-.85,2.12-.03.1-.06.19-.08.29-.24.88-.37,1.66-.43,2.12l-.56.03c.15-1.01.42-1.88.72-2.58.01-.03.02-.06.04-.09.44-1.04.94-1.72,1.19-2.03.09-.11.14-.17.15-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M314.99,242.06c-.02.05-.04.1-.06.16-.05-.12-.12-.23-.19-.34,0-.01-.01-.02-.02-.03,0,0,.01,0,.03.02.04.03.14.09.25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-534",
    d: "M317.25,245.09c.61-4.64,3.13-6.78,3.13-6.78-2.17,3.22-2.09,6.76-2.09,6.76l-1.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-486",
    d: "M302.35,244.11c.15-3.31-1.13-4.86-1.13-4.86.8,2.3.21,4.82.21,4.82l.91.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-459",
    d: "M305.17,245.28c1.23-3.04.44-4.47.44-4.47.32,2.13-1.2,4.44-1.2,4.44l.76.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-529",
    d: "M306.5,244.68c.58-2.78-.81-4.03-.81-4.03.86,1.92.14,4.01.14,4.01l.67.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M308.38,241.96s-.03.07-.04.1c-.04-.08-.08-.16-.12-.24.01,0,.08.06.17.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M300.82,243.93s-.02.06-.03.08h-.19s-.74-.04-.74-.04c0,0,.04-.05.09-.15.25-.45.9-1.83.12-3.16.05.04.82.59.96,1.68.06.44.02.96-.21,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M304.17,244.59c.9-4.59,3.55-6.57,3.55-6.57-2.36,3.08-2.51,6.61-2.51,6.61l-1.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-390",
    d: "M309.14,244.47c0-.32.02-.63.04-.93.03.28.02.58-.04.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-532",
    d: "M309.48,244.82c.15-3.31-1.13-4.86-1.13-4.86.8,2.3.21,4.82.21,4.82l.91.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-468",
    d: "M311.83,245.27c1.23-3.04.44-4.47.44-4.47.32,2.13-1.2,4.44-1.2,4.44l.76.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-436",
    d: "M313.16,245.32c.58-2.78-.81-4.03-.81-4.03.86,1.92.14,4.01.14,4.01l.67.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M315.98,240.19c-.4.57-.73,1.22-.99,1.87-.02.05-.04.1-.06.16-.39.99-.63,1.95-.75,2.54-.19,0-.37,0-.56,0,.27-1.19.7-2.15,1.12-2.88v-.02c.61-1.04,1.19-1.61,1.25-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M308.38,241.96s-.03.07-.04.1c-.04-.08-.08-.16-.12-.24.01,0,.08.06.17.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M309.14,244.47c0-.32.02-.63.04-.93.03.28.02.58-.04.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-543",
    d: "M310.54,245.22c.9-4.59,3.55-6.57,3.55-6.57-2.36,3.08-2.51,6.61-2.51,6.61l-1.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M296.58,238.26c-.22.24-.43.5-.63.77.04-.12.09-.24.13-.35.27-.25.46-.39.5-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-545",
    d: "M295.93,243.01c.15-3.31-1.13-4.86-1.13-4.86.8,2.3.21,4.82.21,4.82l.91.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-544",
    d: "M298.01,243.62c1.23-3.04.44-4.47.44-4.47.32,2.13-1.2,4.44-1.2,4.44l.76.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-458",
    d: "M299.9,243.84c.58-2.78-.81-4.03-.81-4.03.86,1.92.14,4.01.14,4.01l.67.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M303.07,238.93c-1.28,1.83-1.8,4.47-1.9,5.05-.01.07-.02.12-.02.12l-.56-.02s0-.04.01-.06c0-.03.01-.07.02-.1.1-.56.25-1.08.41-1.55.75-2.18,1.95-3.35,2.04-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M295.09,240.43c-.05.09-.09.18-.14.27-.04-.16-.1-.32-.18-.48-.03-.07-.07-.14-.11-.21.01,0,.08.05.16.13.07.07.17.16.26.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-417",
    d: "M296.72,243.57c.9-4.59,3.55-6.57,3.55-6.57-2.36,3.08-2.51,6.61-2.51,6.61l-1.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-439",
    d: "M293.07,242.95c.96-2.67-.25-4.11-.25-4.11.58,2.02-.42,3.99-.42,3.99l.66.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M296.58,238.26c-.22.24-.43.5-.63.77-.33.45-.62.93-.86,1.4-.05.09-.09.18-.14.27-.04-.16-.1-.32-.18-.48.02-.03.04-.05.05-.08.47-.67.93-1.16,1.26-1.47.27-.25.46-.39.5-.42Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M232.94,259.64c-.32.5-.5.83-.5.83l-.36-.18c.17-.29.33-.56.5-.82-.06-.03-.12-.06-.19-.09-.23.54-.34.89-.34.89l-.8-.41c.17-.28.33-.54.49-.79-.32-.15-.65-.3-.97-.45-.24.47-.39.79-.39.79l-.21-.11-.17-.09-.12-.06-.39-.2-.21-.11c.09-.23.18-.45.28-.67-.11.19-.25.4-.41.6l-.6-.31s.26-.22.55-.62c-.1-.04-.2-.09-.29-.14-.17.29-.27.46-.27.46l-.36-.19c.09-.16.18-.31.27-.46-.04-.02-.08-.04-.12-.06-.12.31-.18.51-.18.51l-.8-.41c.09-.16.19-.31.28-.46-.31-.16-.61-.32-.92-.47-.15.3-.24.49-.24.49l-.21-.11-.17-.09-.12-.06-.39-.2-.21-.11c.07-.17.14-.34.2-.5,0,0-.02,0-.02-.01-.09.14-.2.29-.31.44l-.6-.3s.16-.14.38-.4c-.04-.02-.08-.04-.12-.06-.14.23-.21.37-.21.37l-.36-.18c.07-.12.14-.25.21-.36l-.1-.05c-.09.25-.14.4-.14.4l-.79-.41c.07-.12.14-.23.21-.35-.21-.11-.43-.21-.63-.31-.11.22-.17.35-.17.35l-.21-.11-.18-.09h0s-.12-.06-.12-.06l-.39-.2-.21-.11c.04-.11.09-.22.13-.32-.02-.01-.04-.02-.06-.03-.06.09-.14.19-.21.28l-.51-.26c-.02.06-.05.13-.08.19l-.8-.41s.11-.15.28-.42c-.04-.02-.08-.04-.11-.05-.06.15-.13.3-.2.46l-.36-.19s.07-.16.19-.44c-.31-.14-.63-.29-.94-.43-.19.4-.29.65-.29.65l-.45-.17c.1-.23.2-.45.31-.67-.06-.02-.11-.05-.16-.07-.12.45-.18.73-.18.73l-1-.38c.11-.25.23-.49.34-.72-.38-.17-.77-.34-1.15-.5-.18.49-.29.8-.29.8l-.27-.1-.22-.08-.15-.06-.49-.19-.27-.1c.07-.28.15-.54.23-.8-.11.24-.24.48-.4.73l-.75-.29s.27-.29.56-.78c-.12-.05-.24-.1-.36-.14-.17.36-.26.58-.26.58l-.45-.17c.09-.2.18-.4.27-.59-.05-.02-.1-.04-.15-.06-.1.4-.15.64-.15.64l-1-.38c.09-.21.19-.41.29-.61-.39-.16-.77-.31-1.15-.46-.15.4-.23.65-.23.65l-.26-.1-.22-.08-.15-.06-.49-.19-.26-.1c.06-.23.13-.46.19-.67,0,0-.01,0-.02,0-.1.2-.21.41-.34.62l-.75-.28s.2-.21.43-.58c-.06-.02-.11-.04-.17-.06-.15.33-.23.52-.23.52l-.45-.17c.08-.18.16-.35.24-.52-.04-.02-.09-.04-.14-.05-.09.35-.13.56-.13.56l-1-.38c.08-.17.16-.35.24-.51-.27-.1-.53-.2-.8-.29-.12.32-.18.51-.18.51l-.26-.1-.22-.08-.15-.06-.49-.19-.27-.1c.04-.17.09-.33.14-.49-.02,0-.03-.01-.05-.02-.07.15-.16.3-.26.45l-.64-.24c-.02.08-.05.16-.07.24l-1-.38s.14-.23.33-.63c-.05-.02-.11-.04-.16-.05-.06.22-.13.44-.2.67l-.45-.17s.08-.24.2-.65c-.41-.14-.82-.27-1.23-.41-.06.21-.09.33-.09.33l-.53-.13c.04-.12.07-.25.11-.37-.04-.01-.07-.02-.11-.04-.03.25-.04.39-.04.39l-1.19-.28c.05-.15.09-.31.14-.46-.44-.14-.89-.28-1.33-.41-.08.35-.12.56-.12.56l-.31-.07-.26-.06-.18-.04-.58-.14-.31-.07c.03-.23.06-.45.1-.67-.01,0-.03-.01-.04-.01-.07.2-.16.41-.26.63l-.89-.21s.17-.24.37-.65c-.12-.04-.25-.07-.37-.11-.07.24-.11.37-.11.37l-.54-.13c.04-.13.08-.27.12-.4-.04-.01-.08-.02-.12-.04-.03.27-.04.42-.04.42l-1.19-.28c.05-.15.09-.3.14-.44-.45-.13-.89-.25-1.34-.37-.07.31-.11.5-.11.5l-.31-.07-.26-.06-.18-.04-.58-.14-.31-.07c.02-.19.05-.37.08-.55-.02,0-.04-.01-.06-.02-.06.17-.14.34-.22.52l-.89-.21s.13-.19.3-.51c-.05-.01-.1-.03-.15-.04-.08.26-.12.41-.12.41l-.54-.13c.04-.14.08-.28.12-.42-.04-.01-.08-.02-.12-.03-.03.28-.04.44-.04.44l-1.19-.28c.04-.14.09-.29.13-.43-.31-.08-.62-.15-.92-.22-.06.28-.1.44-.1.44l-.31-.07-.26-.06-.18-.04-.58-.14-.31-.07c.02-.15.04-.29.06-.44-.03,0-.06-.01-.09-.02-.05.13-.11.27-.17.41l-.76-.18c-.01.09-.03.19-.05.28l-1.19-.28s.1-.24.25-.65c-.06-.01-.12-.03-.17-.04-.03.22-.07.45-.11.68l-.53-.13s.05-.25.12-.67c-.35-.07-.69-.15-1.03-.22-.03.17-.05.26-.05.26l-.63-.09c.02-.1.04-.2.06-.3-.04,0-.07-.02-.11-.02,0,.2,0,.32,0,.32l-1.4-.19c.03-.13.05-.26.08-.39-.53-.1-1.05-.2-1.57-.3-.04.3-.06.48-.06.48l-.37-.05-.31-.04-.21-.03-.68-.09-.37-.05c0-.19.01-.38.02-.57-.03,0-.06-.01-.09-.02-.05.18-.1.37-.17.56l-1.05-.14s.12-.21.27-.58c-.14-.02-.27-.04-.41-.07-.02.14-.04.22-.04.22l-.63-.09c.01-.08.03-.16.05-.23-.03,0-.06-.01-.09-.02,0,.16,0,.25,0,.25l-1.4-.19c.02-.09.04-.18.06-.27-.52-.08-1.05-.16-1.57-.24-.02.19-.03.3-.03.3l-.37-.05-.31-.04-.21-.03h0s-.68-.09-.68-.09l-.37-.05c0-.11,0-.21.01-.31-.05,0-.1-.01-.15-.02-.03.1-.06.2-.1.3l-1.05-.14s.06-.1.15-.29c-.04,0-.07-.01-.11-.02-.02.09-.02.14-.02.14l-.63-.08s.02-.09.03-.14c-.02,0-.05,0-.07,0,0,.09,0,.14,0,.14l-1.4-.19s.02-.08.02-.12c-.36-.04-.71-.09-1.07-.12,0,.06-.01.1-.01.1l-.37-.05-.31-.04-.21-.03-.68-.09-.37-.05s0-.03,0-.05c-.08,0-.15-.01-.23-.02,0,.01,0,.03-.01.04l-.9-.12c0,.11-.01.22-.02.33l-1.4-.19s.03-.1.08-.28h-.1c0,.08-.01.18-.02.27l-.63-.09s0-.09.02-.25c-.18-.02-.37-.03-.55-.05,0,.1,0,.15,0,.15h-.64c0-.07,0-.13.01-.2-.03,0-.06,0-.09,0,.02.13.03.2.03.2h-1.41c0-.1.01-.2.02-.31-.54-.04-1.07-.08-1.59-.11,0,.27,0,.42,0,.42h-1.96c-.02-.18-.03-.36-.05-.53-.03,0-.07,0-.1,0-.02.17-.06.35-.09.54h-1.06s.09-.22.18-.59c-.14,0-.27-.01-.4-.02,0,.14-.01.21-.01.21h-.64c0-.08,0-.16.01-.23-.03,0-.06,0-.1,0,.02.15.04.24.04.24h-1.41c0-.1.01-.19.02-.29-.54-.02-1.07-.04-1.59-.05,0,.22,0,.34,0,.34h-1.96c-.01-.13-.02-.25-.03-.38-.05,0-.09,0-.14,0-.02.12-.04.25-.07.38h-1.06s.06-.14.13-.39c-.04,0-.09,0-.13,0,0,.15-.01.23-.01.23h-.64c0-.08,0-.15.01-.23h-.09c.02.15.03.23.03.23h-1.42c0-.08.01-.15.02-.23-.37,0-.73,0-1.08,0,0,.15,0,.23,0,.23h-1.96c0-.07-.01-.13-.02-.2-.06,0-.13,0-.19,0-.01.06-.02.13-.04.19h-.91c0,.11.01.22.02.33h-1.41s.03-.17.06-.46c-.05,0-.09,0-.14,0,.01.15.02.3.03.45h-.64s0-.15-.02-.43c-1.62.07-3.04.15-4.25.24.23.56.46,1.12.7,1.68.01.03.03.06.04.1,7.95,18.23,19.98,34.24,34.93,46.83,21.97,18.51,50.23,29.64,81.07,29.64s59.61-11.34,81.67-30.14c7.04-6.01,13.43-12.78,19.03-20.18-57.04,26.45-84.42,9.51-117.35-5.92ZM138.22,244.8l-.74-.06s.4-4.13-.81-7.05c0,0,1.9,2.6,1.55,7.1ZM140.2,245.27l-1.23-.09s1.1-2.91.3-5.23c0,0,1.15,1.46.94,5.33ZM143.13,245.45l-.2-.02h-.13s-.43-.06-.43-.06l-.23-.02c0-.24,0-.47.01-.69-.04.21-.09.44-.16.67l-.67-.07s.88-1.66.23-3.29c0,0,.59.61.65,1.78,0-.07.01-.15.02-.22,0-.06.01-.11.02-.17.02-.15.03-.3.05-.44.01-.09.02-.19.04-.28.02-.12.03-.23.05-.34.01-.09.03-.17.05-.26.02-.11.04-.2.06-.3.03-.14.06-.28.09-.41.01-.06.03-.12.04-.17,0-.04.02-.07.03-.11.02-.07.04-.14.06-.21s.04-.13.06-.2c.04-.13.08-.25.12-.37.05-.14.1-.28.15-.4.02-.06.05-.12.07-.17.02-.06.05-.11.07-.16.02-.04.04-.08.06-.12.05-.1.09-.19.13-.27.02-.03.03-.06.05-.09.01-.03.03-.06.04-.08.02-.04.05-.08.06-.11,0,0,.01-.02.01-.02.01-.02.02-.04.03-.05.01-.02.02-.03.02-.03-.46,1.24-.67,2.58-.77,3.72.52-2.2,1.2-3.01,1.26-3.07-.44,1.14-.68,2.73-.8,3.98.38-1.76.81-2.7.85-2.78-.54,1.84-.76,4.84-.76,4.84l-.23-.02ZM144.03,245.55c.62-3.69,1.68-4.99,1.75-5.07-1.04,2.16-.86,5.16-.86,5.16l-.89-.09ZM148.5,245.79l-.33-.02-.27-.02h-.18s-.6-.06-.6-.06l-.32-.02c0-.25,0-.48.02-.71-.05.22-.12.45-.23.7l-.92-.07s1.13-1.53.42-3.1c-.52,1.63-.74,3.21-.74,3.21l-.4-.04c.49-3.25,1.83-4.95,1.91-5.05-.3.55-.54,1.18-.75,1.8.23.22.72.78.78,1.67.4-3.48,1.94-4.97,1.94-4.97-.64,1.24-.94,2.58-1.07,3.72.12-.36.24-.68.37-.97.04-.09.07-.17.11-.25.04-.08.07-.16.11-.23.06-.11.12-.22.17-.32.03-.05.06-.1.08-.14.03-.05.06-.09.08-.14.09-.15.18-.28.26-.39.06-.08.12-.16.17-.22.03-.03.05-.06.08-.09.02-.03.05-.06.07-.08.01-.02.03-.03.04-.05.01-.01.02-.03.04-.04.01-.01.02-.02.04-.04.01-.01.02-.02.03-.03.05-.05.08-.07.09-.08-.61,1.15-.94,2.74-1.12,4,.53-1.77,1.13-2.72,1.18-2.79-.75,1.84-1.06,4.84-1.06,4.84ZM149.86,245.89c.89-3.81,2.43-5.08,2.43-5.08-1.45,2.16-1.2,5.17-1.2,5.17l-1.23-.09ZM154.7,246.51l-.33-.02-.27-.02-.19-.02h0s-.92-.07-.92-.07c0-.24,0-.48.02-.7-.05.22-.12.44-.23.69l-.92-.07s.95-1.3.55-2.72c-.51,1.33-.72,2.45-.72,2.45l-.55-.04c.25-1.18.65-2.16,1.07-2.92,0-.02-.02-.04-.03-.06,0,0,.02.01.04.03.73-1.33,1.5-2.04,1.57-2.1-.55.72-.97,1.59-1.29,2.4.24.29.53.77.58,1.43.41-3.47,1.94-4.96,1.94-4.96-.64,1.25-.94,2.58-1.08,3.72.16-.49.33-.91.51-1.27.01-.03.03-.07.05-.1.02-.05.05-.1.07-.15.02-.05.05-.09.07-.14.02-.04.05-.09.07-.13.02-.04.05-.09.07-.13.02-.04.05-.08.07-.12.07-.12.14-.22.2-.31.02-.03.04-.06.06-.09.06-.09.12-.16.17-.22.03-.03.05-.06.08-.09.02-.03.05-.06.07-.08.01-.02.03-.03.04-.05.03-.03.05-.06.07-.07.01-.01.02-.02.03-.03.05-.05.08-.07.09-.08-.11.22-.22.45-.32.69-.06.16-.12.33-.18.49-.05.15-.1.3-.14.45-.04.15-.09.31-.12.47-.03.13-.06.26-.09.38-.02.09-.04.18-.06.26-.02.12-.05.23-.07.35-.03.16-.06.32-.08.47-.02.15-.05.3-.07.44.53-1.78,1.13-2.73,1.18-2.8-.75,1.84-1.06,4.84-1.06,4.84ZM156.05,246.61c.89-3.81,2.43-5.08,2.43-5.08-1.45,2.16-1.2,5.17-1.2,5.17l-1.23-.09ZM157.88,246.75l-.55-.04c.69-3.25,2.54-4.95,2.66-5.05-1.52,2.01-2.1,5.09-2.1,5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M137.11,237.83s0-.15-.02-.43c.21-.01.42-.02.63-.02.01.15.02.3.03.45h-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M136.67,237.69s1.9,2.6,1.55,7.1l-.74-.06s.4-4.13-.81-7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M139.21,237.83h-1.41s.03-.17.06-.46c.4-.02.81-.03,1.23-.04.03,0,.06,0,.09,0,.31-.01.63-.02.96-.03-.01.06-.02.13-.04.19h-.91c0,.11.01.22.02.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M138.97,245.18s1.1-2.91.3-5.23c0,0,1.15,1.46.94,5.33l-1.23-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M140.34,237.5c0-.07-.01-.13-.02-.2.13,0,.26,0,.39,0,.22,0,.43,0,.65,0,.09,0,.17,0,.26,0,.1,0,.2,0,.3,0,.12,0,.25,0,.38,0,0,.15,0,.23,0,.23h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M142.13,245.35c0-.24,0-.47.01-.69-.04.21-.09.44-.16.67l-.67-.07s.88-1.66.23-3.29c0,0,.59.61.65,1.78.28-3.49,1.39-4.98,1.39-4.98-.46,1.25-.68,2.58-.77,3.72.52-2.2,1.2-3.01,1.26-3.07-.44,1.14-.68,2.73-.8,3.98.38-1.76.81-2.7.85-2.78-.54,1.84-.76,4.84-.76,4.84l-.23-.02-.2-.02h-.13s-.43-.06-.43-.06l-.23-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M144.78,237.5h-1.42c0-.08.01-.15.02-.23.45,0,.9,0,1.37,0,.02.15.03.23.03.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M145.78,240.48c-1.04,2.16-.86,5.16-.86,5.16l-.89-.09c.62-3.69,1.68-4.99,1.75-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M145.46,237.5h-.64c0-.08,0-.15.01-.23.21,0,.42,0,.63,0,0,.15-.01.23-.01.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M145.47,237.66s.06-.14.13-.39c.33,0,.66,0,1,.01-.02.12-.04.25-.07.38h-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M146.77,237.66c-.01-.13-.02-.25-.03-.38.13,0,.27,0,.4,0,.21,0,.42,0,.63.01.1,0,.19,0,.29,0,.09,0,.19,0,.28,0,.13,0,.25,0,.38,0,0,.22,0,.34,0,.34h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M148.83,239.09c-.64,1.24-.94,2.58-1.07,3.72.75-2.3,1.75-3.07,1.75-3.07-.62,1.15-.95,2.74-1.12,4,.53-1.77,1.13-2.72,1.18-2.79-.75,1.84-1.06,4.84-1.06,4.84l-.33-.02-.27-.02h-.18s-.6-.06-.6-.06l-.32-.02c0-.25,0-.48.02-.71-.05.22-.12.45-.23.7l-.92-.07s1.13-1.53.42-3.1c-.52,1.63-.74,3.21-.74,3.21l-.4-.04c.49-3.25,1.83-4.95,1.91-5.05-.3.55-.54,1.18-.75,1.8.23.22.72.78.78,1.67.4-3.48,1.94-4.97,1.94-4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M151.1,245.98l-1.23-.09c.89-3.81,2.43-5.08,2.43-5.08-1.45,2.16-1.2,5.17-1.2,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M151.7,237.66h-1.41c0-.1.01-.19.02-.29.45.01.9.03,1.36.05.02.15.04.24.04.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M152.39,237.66h-.64c0-.08,0-.16.01-.23.21,0,.42.02.63.03,0,.14-.01.21-.01.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M153.79,240.94c-.55.72-.97,1.59-1.29,2.4.24.29.53.77.58,1.43.41-3.47,1.94-4.96,1.94-4.96-.64,1.25-.94,2.58-1.08,3.72.75-2.29,1.75-3.07,1.75-3.07-.62,1.15-.95,2.75-1.12,4.01.53-1.78,1.13-2.73,1.18-2.8-.75,1.84-1.06,4.84-1.06,4.84l-.33-.02-.27-.02-.19-.02h0s-.92-.07-.92-.07c0-.24,0-.48.02-.7-.05.22-.12.44-.23.69l-.92-.07s.95-1.3.55-2.72c-.51,1.33-.72,2.45-.72,2.45l-.55-.04c.25-1.18.65-2.16,1.07-2.92,0-.02-.02-.04-.03-.06,0,0,.02.01.04.04.73-1.33,1.5-2.04,1.57-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M153.68,238.06h-1.06s.09-.22.18-.59c.32.01.64.03.97.05-.02.17-.06.35-.09.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M153.92,238.06c-.02-.18-.03-.36-.05-.53.14,0,.28.01.42.02.2.01.4.02.61.04.1,0,.21,0,.31.02.09,0,.18.01.28.02.13,0,.26.02.39.02,0,.27,0,.42,0,.42h-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M157.29,246.7l-1.23-.09c.89-3.81,2.43-5.08,2.43-5.08-1.45,2.16-1.2,5.17-1.2,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M158.85,238.06h-1.41c0-.1.01-.2.02-.31.45.03.9.06,1.36.1.02.13.03.2.03.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M157.33,246.71c.69-3.25,2.54-4.95,2.66-5.05-1.52,2.01-2.1,5.09-2.1,5.09l-.55-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-409",
    d: "M159.54,238.06h-.64c0-.07,0-.13.01-.2.21.02.42.03.63.05,0,.1,0,.15,0,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M160.71,238.3l-.63-.09s0-.09.02-.25c.21.02.42.04.63.06,0,.09-.01.19-.02.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M162.16,238.49l-1.4-.19s.03-.1.08-.28c.39.04.8.07,1.2.11.05,0,.1,0,.15.01.3.03.61.06.91.09,0,.01,0,.03-.01.04l-.9-.12c0,.11-.01.22-.02.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M163.69,238.36l-.37-.05s0-.03,0-.05c.12.01.25.03.38.04.22.02.45.05.67.07.07,0,.15.02.23.02.1.01.2.02.31.03.12.01.25.03.37.04,0,.06-.01.1-.01.1l-.37-.05-.31-.04-.21-.03-.68-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-402",
    d: "M167.72,238.91l-1.4-.19s.02-.08.02-.12c.46.05.91.11,1.37.17,0,.09,0,.14,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "M168.39,239l-.63-.08s.02-.09.03-.14c.21.02.42.05.63.08-.02.09-.02.14-.02.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M168.53,238.88c.33.04.67.09,1,.13-.03.1-.06.2-.1.3l-1.05-.14s.06-.1.15-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M171.27,239.25c.12.02.25.04.38.06-.02.19-.03.3-.03.3l-.37-.05-.31-.04-.21-.03h0s-.68-.09-.68-.09l-.37-.05c0-.11,0-.21.01-.31.13.02.27.04.4.06.21.03.42.06.63.09.09.01.18.02.28.04.09.01.19.03.29.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M174.56,239.76c0,.16,0,.25,0,.25l-1.4-.19c.02-.09.04-.18.06-.27.45.07.89.14,1.34.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M174.65,239.77c.21.03.41.07.62.1-.02.14-.04.22-.04.22l-.63-.09c.01-.08.03-.16.05-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M175.68,239.94c.32.06.63.11.95.17-.05.18-.1.37-.17.56l-1.05-.14s.12-.21.27-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M178.32,240.41c.13.02.25.05.38.07-.04.3-.06.48-.06.48l-.37-.05-.31-.04-.21-.03-.68-.09-.37-.05c0-.19.01-.38.02-.57.14.02.28.05.42.07.2.04.39.07.59.11.1.02.21.04.31.06.09.01.18.03.27.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M181.59,241.04c0,.2,0,.32,0,.32l-1.4-.19c.03-.13.05-.26.08-.39.44.08.88.17,1.32.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M181.7,241.06c.21.04.41.08.62.13-.03.17-.05.26-.05.26l-.63-.09c.02-.1.04-.2.06-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M183.88,241.52c-.03.22-.07.45-.11.68l-.53-.13s.05-.25.12-.67c.18.04.35.07.53.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M185.14,241.79c.28.06.55.12.83.19-.05.13-.11.27-.17.41l-.76-.18c-.01.09-.03.19-.05.28l-1.19-.28s.1-.24.25-.65c.35.07.7.15,1.05.23.01,0,.02,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M187.41,242.31c.11.02.22.05.33.08-.06.28-.1.44-.1.44l-.31-.07-.26-.06-.18-.04-.58-.14-.31-.07c.02-.15.04-.29.06-.44.12.03.23.05.35.08.17.04.34.08.51.12.09.02.18.04.27.06.07.02.15.04.23.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M189.76,242.88c-.03.28-.04.44-.04.44l-1.19-.28c.04-.14.09-.29.13-.43.36.09.73.18,1.1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M190.29,243.46l-.54-.13c.04-.14.08-.28.12-.42.18.04.35.09.53.13-.08.26-.12.41-.12.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M191.38,243.29c-.06.17-.14.34-.22.52l-.89-.21s.13-.19.3-.51c.27.07.54.14.81.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M192.79,243.66c.11.03.22.06.33.09-.07.31-.11.5-.11.5l-.31-.07-.26-.06-.18-.04-.58-.14-.31-.07c.02-.19.05-.37.08-.55.12.03.24.06.36.09.16.04.33.08.49.13.09.02.19.05.28.07.07.02.15.04.22.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M195.54,244.42c-.03.27-.04.42-.04.42l-1.19-.28c.05-.15.09-.3.14-.44.36.1.72.2,1.09.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M195.66,244.46c.17.05.35.1.52.15-.07.24-.11.37-.11.37l-.54-.13c.04-.13.08-.27.12-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M197.33,244.94c-.07.2-.16.41-.26.63l-.89-.21s.17-.24.37-.65c.26.07.52.15.78.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M198.72,245.36c.11.03.22.06.33.1-.08.35-.12.56-.12.56l-.31-.07-.26-.06-.18-.04-.58-.14-.31-.07c.03-.23.06-.45.1-.67.12.03.24.07.36.11.16.04.31.09.47.14.1.03.19.06.29.09.07.02.14.04.21.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M201.46,246.21c-.03.25-.04.39-.04.39l-1.19-.28c.05-.15.09-.31.14-.46.36.11.72.23,1.08.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M201.56,246.25c.17.06.35.11.52.17-.06.21-.09.33-.09.33l-.53-.13c.04-.12.07-.25.11-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M203.76,246.98c-.06.22-.13.44-.2.67l-.45-.17s.08-.24.2-.65c.15.05.3.1.45.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M205.56,247.6c-.07.15-.16.3-.26.45l-.64-.24c-.02.08-.05.16-.07.24l-1-.38s.14-.23.33-.63c.29.1.58.2.88.3.02,0,.05.01.07.02.23.08.46.16.69.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M206.76,248.02c.09.03.19.06.28.1-.12.32-.18.51-.18.51l-.26-.1-.22-.08-.15-.06-.49-.19-.27-.1c.04-.17.09-.33.14-.49.1.04.21.07.31.11.14.05.27.1.41.15.09.03.17.06.25.09.06.02.12.04.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M208.74,248.74c-.09.35-.13.56-.13.56l-1-.38c.08-.17.16-.35.24-.51.3.11.6.22.89.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M209.09,249.48l-.45-.17c.08-.18.16-.35.24-.52.15.06.3.11.44.17-.15.33-.23.52-.23.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M210.15,249.27c-.1.2-.21.41-.34.62l-.75-.28s.2-.21.43-.58c.22.08.44.17.66.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-405",
    d: "M211.31,249.72c.09.04.19.07.28.11-.15.4-.23.65-.23.65l-.26-.1-.22-.08-.15-.06-.49-.19-.26-.1c.06-.23.13-.46.19-.67.1.04.21.08.32.12.13.05.25.1.38.15.09.04.18.07.28.11.06.02.11.04.17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M213.61,250.64c-.1.4-.15.64-.15.64l-1-.38c.09-.21.19-.41.29-.61.29.11.58.23.87.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M214.2,250.88c-.17.36-.26.58-.26.58l-.45-.17c.09-.2.18-.4.27-.59.15.06.29.12.44.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-403",
    d: "M216.31,251.76c.09.04.19.08.29.12-.18.49-.29.8-.29.8l-.27-.1-.22-.08-.15-.06-.49-.19-.27-.1c.07-.28.15-.54.23-.8-.11.24-.24.48-.4.73l-.75-.29s.27-.29.56-.78c.2.09.41.17.61.25,0,0,0,0,0,0,.11.04.22.09.33.14.11.05.23.09.35.15.1.04.2.09.31.13.05.02.1.04.15.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M218.58,252.75c-.12.45-.18.73-.18.73l-1-.38c.11-.25.23-.49.34-.72.28.12.56.25.84.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M218.74,252.83c.14.06.29.13.43.19-.19.4-.29.65-.29.65l-.45-.17c.1-.23.2-.45.31-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M220.48,253.61c-.06.15-.13.3-.2.46l-.36-.19s.07-.16.19-.44c.12.05.24.11.36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "M221.9,254.28c-.06.09-.14.19-.21.28l-.51-.26c-.02.06-.05.13-.08.19l-.8-.41s.11-.15.28-.42c.24.11.48.22.72.33,0,0,.02,0,.03.01.19.09.38.17.57.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-400",
    d: "M222.88,254.74c.07.03.15.07.22.1-.11.22-.17.35-.17.35l-.21-.11-.18-.09h0s-.12-.06-.12-.06l-.39-.2-.21-.11c.04-.11.09-.22.13-.32.08.04.16.07.24.11.11.05.23.1.34.16.06.03.12.06.19.09.05.02.1.05.15.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M224.46,255.51c-.09.25-.14.4-.14.4l-.79-.41c.07-.12.14-.23.21-.35.24.12.48.23.73.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M224.7,256.1l-.36-.18c.07-.12.14-.25.21-.36.12.06.24.12.36.18-.14.23-.21.37-.21.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M225.57,256.06c-.09.14-.2.29-.31.44l-.6-.3s.16-.14.38-.4c.18.09.35.17.53.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M226.5,256.53c.07.04.15.07.23.12-.15.3-.24.49-.24.49l-.21-.11-.17-.09-.12-.06-.39-.2-.21-.11c.07-.17.14-.34.2-.5.08.04.17.08.25.13.1.05.2.1.31.16.07.03.14.07.22.11.04.02.09.04.13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M228.34,257.49c-.12.31-.18.51-.18.51l-.8-.41c.09-.16.19-.31.28-.46.23.12.46.24.7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M228.81,257.73c-.17.29-.27.46-.27.46l-.36-.19c.09-.16.18-.31.27-.46.1.05.19.1.29.15.02,0,.04.02.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M230.54,258.52c.08.04.16.07.24.11-.24.47-.39.79-.39.79l-.21-.11-.17-.09-.12-.06-.39-.2-.21-.11c.09-.23.18-.45.28-.67-.11.19-.25.4-.41.6l-.6-.31s.26-.22.55-.62c.17.07.33.15.5.23,0,0,0,0,.01,0,.09.04.18.08.27.12.09.04.18.08.27.12s.18.08.27.13c.04.01.07.03.11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M232.39,259.38c-.23.54-.34.89-.34.89l-.8-.41c.17-.28.33-.54.49-.79.22.1.43.2.65.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M232.58,259.47c.12.06.24.11.36.17-.32.5-.5.83-.5.83l-.36-.18c.17-.29.33-.56.5-.82Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-539",
    d: "M144.34,237.5c.34-7.44,2.35-10.8,2.35-10.8-1.68,5.1-1.49,10.8-1.49,10.8h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M144.74,237.27c.02.15.03.23.03.23h-1.42c0-.08.01-.15.02-.23.41-5.94,1.92-8.07,1.92-8.07-1.12,3.1-.69,7.08-.55,8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M141.36,237.28c.02.14.04.21.04.21h-1.06c0-.07-.01-.13-.02-.2-.03-.31-.06-.61-.07-.9-.04-.51-.06-.99-.07-1.46-.11-5.36,1.3-7.9,1.39-8.05-.52,2.03-.64,4.16-.61,5.97h0c.04,2.15.3,3.85.4,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-515",
    d: "M140.74,237.5c-.24-5.24-1.88-7.61-1.88-7.61,1.19,3.59.83,7.61.83,7.61h1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "M143.41,237.5c1.03-4.89-.04-7.09-.04-7.09.63,3.35-.82,7.09-.82,7.09h.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-438",
    d: "M144.43,237.5c.32-4.43-1.42-6.33-1.42-6.33,1.21,2.99.65,6.33.65,6.33h.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M147.01,229.21c-.51,1.23-.85,2.67-1.08,4-.04.25-.08.49-.12.72-.23,1.53-.31,2.83-.34,3.33,0,.15-.01.23-.01.23h-.64c0-.08,0-.15.01-.23.1-1.71.37-3.17.68-4.35.02-.07.04-.14.06-.2.6-2.16,1.35-3.36,1.44-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M140.25,236.4c-.02.29-.06.59-.11.91-.01.06-.02.13-.04.19h-1.06s.02-.06.06-.16c.02-.06.04-.13.07-.22.25-.84.7-2.94-.3-4.86.07.06,1.03.91,1.31,2.68.07.43.1.91.07,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-507",
    d: "M141.94,237.5c.46-7.31,3.24-10.61,3.24-10.61-2.31,5.01-2.05,10.61-2.05,10.61h-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-396",
    d: "M141.92,237.28c0,.13,0,.21,0,.22h-1.21c0-.07,0-.14,0-.2,0-1.75.1-3.22.25-4.43h0c.48-3.7,1.49-5.03,1.49-5.03-.51,1.88-.62,4.42-.62,6.43,0,1.41.06,2.56.09,3.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M142.29,237.27c0,.15,0,.23,0,.23h-.68c0-.07,0-.15,0-.22.04-1.13.11-2.14.21-3.03.31-2.84.84-4.4.88-4.52-.47,2.61-.44,6.56-.42,7.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-471",
    d: "M151.27,237.66c.34-7.44,2.35-10.8,2.35-10.8-1.68,5.1-1.49,10.8-1.49,10.8h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M151.67,237.42c.02.15.04.24.04.24h-1.41c0-.1.01-.19.02-.29.42-5.9,1.92-8.01,1.92-8.01-1.12,3.09-.69,7.05-.56,8.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M147.77,237.3c.04.23.06.36.06.36h-1.06c-.01-.13-.02-.25-.03-.38-.02-.25-.04-.49-.06-.72-.04-.51-.06-.99-.07-1.46-.11-5.36,1.31-7.9,1.39-8.05-.52,2.03-.64,4.16-.61,5.97h0c.04,1.99.26,3.59.38,4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-501",
    d: "M147.17,237.66c-.24-5.24-1.88-7.61-1.88-7.61,1.19,3.59.83,7.61.83,7.61h1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-470",
    d: "M149.84,237.66c1.03-4.89-.04-7.09-.04-7.09.63,3.35-.82,7.09-.82,7.09h.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-530",
    d: "M151.36,237.66c.32-4.43-1.42-6.33-1.42-6.33,1.21,2.99.65,6.33.65,6.33h.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M153.94,229.38c-.5,1.21-.84,2.61-1.07,3.93-.02.14-.05.27-.07.4-.28,1.72-.38,3.22-.4,3.75,0,.14-.01.21-.01.21h-.64c0-.08,0-.16.01-.23.1-1.79.39-3.3.73-4.51,0-.01,0-.02.01-.04.6-2.16,1.35-3.36,1.44-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "M138.23,237.83c-.34-7.44-2.35-10.8-2.35-10.8,1.68,5.1,1.49,10.8,1.49,10.8h.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M137.86,237.37c.15-1.27.47-4.93-.58-7.84.09.12,1.44,2.18,1.88,7.58,0,.07,0,.14.02.21,0,.06,0,.11.01.17,0,.11.01.22.02.33h-1.41s.03-.17.06-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-461",
    d: "M138.14,237.83c-.32-4.43,1.42-6.33,1.42-6.33-1.21,2.99-.65,6.33-.65,6.33h-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M137.75,237.83h-.64s0-.15-.02-.43c-.07-1.27-.39-5.11-1.54-7.87,0,0,1.84,2.75,2.17,7.85.01.15.02.3.03.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M146.68,236.56c-.02.23-.04.47-.08.72-.02.12-.04.25-.07.38h-1.06s.06-.14.13-.39c.18-.62.47-1.93.21-3.33-.06-.34-.16-.68-.29-1.02-.06-.16-.14-.33-.22-.49.02.02.13.11.27.28.1.12.23.29.36.5.27.44.55,1.06.68,1.89.07.43.1.91.07,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-508",
    d: "M148.37,237.66c.46-7.31,3.24-10.61,3.24-10.61-2.31,5.01-2.05,10.61-2.05,10.61h-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M148.34,237.31c.01.21.02.33.02.35h-1.21c0-.12,0-.25,0-.37,0-1.68.1-3.09.25-4.26h0c.48-3.7,1.49-5.04,1.49-5.04-.51,1.88-.63,4.43-.62,6.44,0,1.29.06,2.36.08,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M148.72,237.32c0,.22,0,.34,0,.34h-.68c0-.12,0-.24.01-.35.04-1.07.11-2.03.2-2.87.31-2.85.84-4.42.88-4.54-.46,2.51-.44,6.28-.42,7.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M158.42,238.06c.34-7.44,2.35-10.8,2.35-10.8-1.68,5.1-1.49,10.8-1.49,10.8h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M158.82,237.86c.02.13.03.2.03.2h-1.41c0-.1.01-.2.02-.31.42-5.88,1.91-7.99,1.91-7.99-1.13,3.14-.68,7.15-.55,8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M154.9,237.59c.05.31.08.48.08.48h-1.06c-.02-.18-.03-.36-.05-.53-.02-.19-.03-.38-.04-.57-.04-.51-.06-.99-.07-1.46-.11-5.36,1.3-7.9,1.39-8.05-.52,2.03-.65,4.16-.61,5.97h0c.03,1.88.24,3.42.36,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-513",
    d: "M154.32,238.06c-.24-5.24-1.88-7.61-1.88-7.61,1.19,3.59.83,7.61.83,7.61h1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "M156.99,238.06c1.03-4.89-.04-7.09-.04-7.09.63,3.35-.82,7.09-.82,7.09h.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-423",
    d: "M158.51,238.06c.32-4.43-1.42-6.33-1.42-6.33,1.21,2.99.65,6.33.65,6.33h.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "M161.1,229.77c-.3.72-.54,1.52-.74,2.32-.08.32-.15.65-.22.97-.45,2.22-.57,4.3-.6,4.85,0,.1,0,.15,0,.15h-.64c0-.07,0-.13.01-.2.14-2.51.65-4.46,1.13-5.83.06-.17.12-.33.18-.49.46-1.17.87-1.78.87-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M153.83,236.96c-.01.18-.03.37-.06.56-.02.17-.06.35-.09.54h-1.06s.09-.22.18-.59c.21-.79.46-2.27,0-3.77-.08-.27-.18-.53-.31-.79-.02-.03-.03-.06-.04-.09,0,0,.03.02.06.05.07.07.21.21.37.43.32.43.73,1.15.89,2.2.07.43.1.91.07,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-441",
    d: "M155.52,238.06c.46-7.31,3.24-10.61,3.24-10.61-2.31,5.01-2.05,10.61-2.05,10.61h-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M155.49,237.62c.01.27.02.42.02.44h-1.21c0-.17,0-.34,0-.51,0-1.62.1-2.98.25-4.12h0c.48-3.7,1.49-5.04,1.49-5.04-.51,1.88-.62,4.42-.62,6.42,0,1.23.05,2.25.08,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M155.87,237.65c0,.27,0,.42,0,.42h-.69c0-.15,0-.31.01-.46.04-1.03.11-1.96.2-2.79.31-2.83.84-4.39.88-4.52-.45,2.46-.44,6.12-.42,7.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-509",
    d: "M167.28,238.85c1.33-7.33,3.77-10.39,3.77-10.39-2.34,4.83-2.91,10.51-2.91,10.51l-.86-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M167.71,238.77c0,.09,0,.14,0,.14l-1.4-.19s.02-.08.02-.12c1.2-5.92,3-7.85,3-7.85-1.58,3.03-1.63,7.21-1.62,8.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M164.55,233.81c-.27,2.33-.2,4.17-.19,4.57,0,.05,0,.08,0,.08l-.68-.09-.37-.05s0-.03,0-.05c.01-.37.03-.73.06-1.07.03-.5.08-.98.13-1.43h0c.63-5.5,2.45-7.8,2.45-7.8-.79,1.95-1.2,4.04-1.4,5.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-520",
    d: "M163.72,238.37c.46-5.23-.85-7.8-.85-7.8.7,3.72-.19,7.66-.19,7.66l1.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-435",
    d: "M166.36,238.73c1.67-4.71.9-7.04.9-7.04.18,3.4-1.76,6.92-1.76,6.92l.86.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-421",
    d: "M167.37,238.86c.91-4.34-.56-6.46-.56-6.46.81,3.12-.2,6.36-.2,6.36l.76.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M171.04,231c-.67,1.15-1.2,2.53-1.61,3.82-.07.24-.15.48-.21.7-.46,1.58-.72,2.92-.8,3.34-.02.09-.02.14-.02.14l-.63-.08s.02-.09.03-.14c.33-1.73.79-3.17,1.28-4.32.02-.06.05-.13.08-.19.9-2.09,1.81-3.18,1.9-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M163.38,237.19c-.06.33-.15.68-.28,1.05,0,.01,0,.03-.01.04l-.9-.12-.15-.02h0s.08-.15.17-.35c.36-.79,1.08-2.82.36-4.86.06.06.9,1.04.94,2.83h0c.01.43-.02.91-.13,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M164.9,238.53c1.43-7.18,4.63-10.08,4.63-10.08-2.96,4.66-3.45,10.24-3.45,10.24l-1.18-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M166.69,229.02c-.76,1.8-1.21,4.31-1.47,6.3-.2,1.54-.3,2.77-.32,3.11,0,.05,0,.08-.01.09l-.31-.04-.21-.03-.68-.09s0-.04,0-.06c.23-1.8.53-3.29.86-4.5.94-3.49,2.07-4.71,2.14-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M166.7,230.94c-.86,2.64-1.36,6.84-1.43,7.54,0,.06-.01.1-.01.1l-.37-.05-.31-.04s0-.06.01-.08c.19-1.16.41-2.19.63-3.08.69-2.79,1.42-4.27,1.48-4.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-429",
    d: "M174.13,239.94c1.33-7.33,3.77-10.39,3.77-10.39-2.34,4.83-2.91,10.51-2.91,10.51l-.86-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M174.56,239.76c0,.16,0,.25,0,.25l-1.4-.19c.02-.09.04-.18.06-.27,1.2-5.8,2.97-7.69,2.97-7.69-1.52,2.91-1.63,6.89-1.63,7.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M170.9,234.84c-.23,2.02-.22,3.67-.19,4.33,0,.18.01.29.01.31h0s-.68-.09-.68-.09l-.37-.05c0-.11,0-.21.01-.31.01-.28.02-.55.04-.81.03-.5.08-.98.13-1.43h0c.63-5.5,2.45-7.8,2.45-7.8-.79,1.95-1.2,4.05-1.41,5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-527",
    d: "M170.07,239.4c.46-5.23-.85-7.8-.85-7.8.7,3.72-.19,7.66-.19,7.66l1.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-533",
    d: "M172.71,239.75c1.67-4.71.9-7.04.9-7.04.18,3.4-1.76,6.92-1.76,6.92l.86.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-434",
    d: "M174.22,239.96c.91-4.34-.56-6.46-.56-6.46.81,3.12-.2,6.36-.2,6.36l.76.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M177.88,232.09c-.66,1.13-1.18,2.48-1.59,3.75-.04.13-.08.26-.12.38-.51,1.66-.8,3.12-.9,3.65-.02.14-.04.22-.04.22l-.63-.09c.01-.08.03-.16.05-.23.34-1.76.83-3.21,1.32-4.37,0-.01.01-.03.02-.04.9-2.09,1.81-3.18,1.9-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-524",
    d: "M161.19,238.36c.66-7.42-.89-11.02-.89-11.02.98,5.28.03,10.91.03,10.91l.86.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M162.2,237.79c0,.12-.01.24-.02.36h0c0,.12-.01.23-.02.34l-1.4-.19s.03-.1.08-.28c.28-1.04,1.2-4.84.52-8.01.06.12,1.14,2.33.85,7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-546",
    d: "M161.1,238.35c.27-4.43,2.25-6.08,2.25-6.08-1.6,2.8-1.49,6.18-1.49,6.18l-.76-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M160.73,238.02c0,.09-.01.19-.02.28l-.63-.09s0-.09.02-.25c.06-.69.19-2.72.04-4.9-.02-.34-.06-.69-.1-1.03-.09-.77-.22-1.54-.41-2.25.03.07.31.68.59,1.76.04.17.09.35.13.54.31,1.4.56,3.41.37,5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M169.73,238.22c-.05.25-.11.52-.2.79-.03.1-.06.2-.1.3l-1.05-.14s.06-.1.15-.29c.26-.56.76-1.86.69-3.36-.02-.35-.06-.7-.15-1.06-.04-.17-.09-.33-.15-.5.02.02.11.12.23.31.09.14.19.32.29.54.21.47.41,1.13.43,1.97h0c.01.43-.02.91-.13,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "M171.25,239.56c1.43-7.18,4.63-10.08,4.63-10.08-2.96,4.66-3.45,10.24-3.45,10.24l-1.18-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M173.05,230.05c-.75,1.79-1.21,4.29-1.47,6.28-.17,1.33-.27,2.42-.31,2.93-.02.18-.02.28-.03.3l-.31-.04-.21-.03-.68-.09c.01-.1.02-.21.04-.31.22-1.69.51-3.09.82-4.24.94-3.5,2.07-4.72,2.14-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M173.06,231.96c-.8,2.46-1.28,6.27-1.41,7.34-.02.19-.03.3-.03.3l-.37-.05-.31-.04c.02-.1.03-.2.05-.3.18-1.08.39-2.04.59-2.88.69-2.77,1.42-4.25,1.48-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-466",
    d: "M181.16,241.3c1.33-7.33,3.77-10.39,3.77-10.39-2.34,4.83-2.91,10.51-2.91,10.51l-.86-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M181.59,241.04c0,.2,0,.32,0,.32l-1.4-.19c.03-.13.05-.26.08-.39,1.2-5.71,2.94-7.57,2.94-7.57-1.49,2.85-1.62,6.71-1.63,7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M177.94,236.19c-.21,1.82-.22,3.35-.2,4.12,0,.35.02.54.02.54l-.68-.09-.37-.05c0-.19.01-.38.02-.57,0-.19.02-.37.03-.55.03-.5.07-.98.13-1.43h0c.63-5.5,2.45-7.8,2.45-7.8-.79,1.95-1.2,4.04-1.4,5.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-424",
    d: "M177.1,240.75c.46-5.23-.85-7.8-.85-7.8.7,3.72-.19,7.66-.19,7.66l1.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-525",
    d: "M179.74,241.11c1.67-4.71.9-7.04.9-7.04.18,3.4-1.76,6.92-1.76,6.92l.86.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-487",
    d: "M181.25,241.31c.91-4.34-.56-6.46-.56-6.46.81,3.12-.2,6.36-.2,6.36l.76.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M184.92,233.44c-.42.71-.78,1.52-1.09,2.33-.04.11-.08.22-.12.32-.8,2.17-1.24,4.35-1.39,5.09-.03.17-.05.26-.05.26l-.63-.09c.02-.1.04-.2.06-.3.49-2.5,1.28-4.38,1.95-5.65.02-.04.04-.08.06-.12.63-1.16,1.14-1.77,1.21-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M176.89,238.14h0c.01.43-.02.91-.13,1.43-.03.17-.07.35-.12.54-.05.18-.1.37-.17.56l-1.05-.14s.12-.21.27-.58c.31-.76.75-2.18.49-3.72-.04-.27-.11-.54-.2-.82-.01-.03-.02-.06-.03-.09,0,0,.02.03.05.06.06.08.18.24.31.47.26.47.56,1.24.59,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-510",
    d: "M178.29,240.91c1.43-7.18,4.63-10.08,4.63-10.08-2.96,4.66-3.45,10.24-3.45,10.24l-1.18-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M180.08,231.4c-.75,1.8-1.21,4.32-1.47,6.31-.15,1.16-.24,2.14-.29,2.7-.02.3-.04.48-.04.5l-.31-.04-.21-.03-.68-.09c.02-.19.05-.37.07-.55.22-1.59.5-2.91.79-4.01.94-3.49,2.07-4.71,2.14-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M180.09,233.32c-.76,2.34-1.23,5.89-1.39,7.16-.04.3-.06.48-.06.48l-.37-.05-.31-.04c.03-.17.06-.34.09-.51.17-.99.36-1.87.55-2.66.69-2.79,1.42-4.27,1.48-4.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-519",
    d: "M189.35,243.23c1.76-6.18,4.12-8.59,4.12-8.59-2.42,3.94-3.4,8.77-3.4,8.77l-.72-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M191.8,236.47c-1.44,2.2-1.9,5.28-2.03,6.41-.03.28-.04.44-.04.44l-1.19-.28c.04-.14.09-.29.13-.43,1.46-4.56,3.03-6.05,3.13-6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M189.14,233.79c-.84,1.6-1.37,3.36-1.7,4.89h0c-.34,1.56-.47,2.86-.52,3.52-.02.29-.03.45-.03.45l-.58-.14-.31-.07c.02-.15.04-.29.06-.44.02-.17.05-.34.08-.51.07-.43.15-.84.23-1.23h0c.97-4.5,2.65-6.35,2.77-6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-428",
    d: "M186.34,242.52c.84-4.45-.06-6.76-.06-6.76.28,3.25-.81,6.55-.81,6.55l.88.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-511",
    d: "M188.57,243.05c1.83-3.89,1.37-5.96,1.37-5.96-.14,2.94-2.1,5.79-2.1,5.79l.73.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-427",
    d: "M189.43,243.25c1.15-3.65.07-5.59.07-5.59.43,2.75-.71,5.44-.71,5.44l.65.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M193.24,236.81c-.67.93-1.25,2.07-1.71,3.14-.09.2-.17.39-.24.59-.43,1.06-.73,1.99-.88,2.5-.08.26-.12.41-.12.41l-.54-.13c.04-.14.08-.28.12-.42.41-1.32.89-2.41,1.37-3.29.03-.05.06-.11.09-.15.95-1.72,1.82-2.57,1.91-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M186.37,240.26h0c-.03.38-.1.78-.23,1.23-.05.16-.1.32-.17.49-.05.13-.11.27-.17.41l-.76-.18-.13-.03s.07-.1.18-.29c.02-.03.04-.06.06-.1.39-.71,1.1-2.31.66-4.04,0,0,.69.92.57,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-443",
    d: "M187.34,242.75c1.84-6.04,4.83-8.26,4.83-8.26-2.94,3.74-3.83,8.49-3.83,8.49l-1-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M189.69,234.75c-.8,1.48-1.4,3.59-1.8,5.28-.23.97-.39,1.8-.48,2.28-.05.27-.08.42-.08.44l-.26-.06-.18-.04-.58-.14c.03-.15.07-.29.1-.43.32-1.35.68-2.47,1.03-3.4h0c1.11-2.92,2.18-3.88,2.25-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M189.53,236.39c-.84,1.92-1.55,4.88-1.79,5.99-.06.28-.1.44-.1.44l-.31-.07-.26-.06c.04-.15.08-.29.12-.43.23-.83.47-1.57.7-2.23.83-2.33,1.58-3.54,1.64-3.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-491",
    d: "M195.13,244.76c1.76-6.18,4.12-8.59,4.12-8.59-2.42,3.94-3.4,8.77-3.4,8.77l-.72-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M197.58,237.99c-1.44,2.21-1.91,5.31-2.04,6.43-.03.27-.04.42-.04.42l-1.19-.28c.05-.15.09-.3.14-.44,1.45-4.55,3.03-6.03,3.13-6.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M194.5,235.21c-.84,1.61-1.37,3.37-1.7,4.9-.32,1.48-.46,2.74-.51,3.42-.03.35-.04.54-.04.54l-.58-.14-.31-.07c.02-.19.05-.37.08-.55.02-.13.04-.27.06-.4.07-.43.15-.84.23-1.23h0c.97-4.5,2.65-6.35,2.77-6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M191.7,243.94c.84-4.45-.06-6.76-.06-6.76.28,3.25-.81,6.55-.81,6.55l.88.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-516",
    d: "M193.93,244.47c1.83-3.89,1.37-5.96,1.37-5.96-.14,2.94-2.1,5.79-2.1,5.79l.73.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-502",
    d: "M195.21,244.77c1.15-3.65.07-5.59.07-5.59.43,2.75-.71,5.44-.71,5.44l.65.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M199.02,238.34c-.66.91-1.23,2.03-1.68,3.08-.05.11-.09.21-.14.32-.51,1.22-.86,2.32-1.02,2.87-.07.24-.11.37-.11.37l-.54-.13c.04-.13.08-.27.12-.4.43-1.39.95-2.53,1.44-3.44,0-.01.01-.02.02-.03.95-1.72,1.82-2.57,1.9-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-535",
    d: "M184.17,242.29c1.2-6.31.18-9.53.18-9.53.39,4.62-.9,9.36-.9,9.36l.72.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M185.1,241.78s-.01.07-.02.1c-.02.1-.03.21-.05.32-.01.09-.03.19-.05.28l-1.19-.28s.1-.24.25-.65c.43-1.23,1.25-3.97.97-6.41,0,0,.79,1.94.09,6.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-505",
    d: "M184.09,242.27c.61-3.78,2.45-5.02,2.45-5.02-1.61,2.26-1.8,5.18-1.8,5.18l-.65-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M183.88,241.52c-.03.22-.07.45-.11.68l-.53-.13s.05-.25.12-.67c.17-1.07.47-3.26.36-5.3-.01-.23-.03-.47-.06-.69-.02-.2-.05-.41-.08-.6.01.04.07.2.14.48.04.14.07.3.11.49.22,1.11.46,3.1.05,5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M191.73,241.68h0c-.03.38-.1.78-.23,1.23-.04.12-.08.25-.13.38-.06.17-.14.34-.22.52l-.89-.21s.13-.19.3-.51c.28-.54.67-1.47.73-2.54.01-.3,0-.61-.04-.92-.02-.15-.05-.3-.09-.44.02.02.09.12.17.29.06.12.14.29.2.49.14.42.25,1.01.2,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M192.7,244.18c1.84-6.04,4.83-8.26,4.83-8.26-2.94,3.74-3.83,8.49-3.83,8.49l-1-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M195.05,236.17c-.8,1.48-1.4,3.59-1.8,5.28-.22.93-.37,1.72-.46,2.21-.06.31-.09.49-.1.51l-.26-.06-.18-.04-.58-.14c.04-.18.08-.36.12-.53.32-1.3.66-2.39,1-3.29,1.11-2.93,2.18-3.88,2.25-3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M194.89,237.81c-.83,1.89-1.52,4.78-1.78,5.93-.07.31-.11.5-.11.5l-.31-.07-.26-.06c.05-.17.09-.34.14-.51.22-.8.46-1.52.68-2.16.83-2.33,1.58-3.54,1.64-3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-521",
    d: "M201.05,246.52c1.76-6.18,4.12-8.59,4.12-8.59-2.42,3.94-3.4,8.77-3.4,8.77l-.72-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M203.5,239.76c-1.46,2.23-1.92,5.37-2.04,6.46-.03.25-.04.39-.04.39l-1.19-.28c.05-.15.09-.31.14-.46,1.45-4.54,3.03-6.02,3.12-6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M200.42,236.97c-.84,1.6-1.37,3.36-1.7,4.89h0c-.31,1.42-.45,2.64-.51,3.34-.04.4-.04.63-.04.63l-.58-.14-.31-.07c.03-.23.06-.45.1-.67.02-.1.03-.19.05-.28.07-.43.15-.83.23-1.22h0c.97-4.5,2.64-6.35,2.76-6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-457",
    d: "M197.62,245.7c.84-4.45-.06-6.76-.06-6.76.28,3.25-.81,6.55-.81,6.55l.88.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-482",
    d: "M199.85,246.24c1.83-3.89,1.37-5.96,1.37-5.96-.14,2.94-2.1,5.79-2.1,5.79l.73.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-488",
    d: "M201.13,246.54c1.15-3.65.07-5.59.07-5.59.43,2.75-.71,5.44-.71,5.44l.65.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M204.94,240.1c-.25.35-.49.73-.71,1.12,0,0,0,0,0,.01-1.13,1.98-1.88,4.33-2.14,5.18-.06.21-.09.33-.09.33l-.53-.13c.04-.12.07-.25.11-.37,1.26-4.07,3.25-6.03,3.38-6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M197.65,243.45h0c-.03.37-.1.78-.23,1.22-.03.09-.06.18-.09.27-.07.2-.16.41-.26.63l-.89-.21s.17-.24.37-.65c.33-.66.73-1.75.65-2.98-.01-.23-.05-.48-.1-.72,0-.03-.01-.06-.02-.09,0,0,.01.02.04.06.05.07.13.22.22.43.18.42.38,1.11.31,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-514",
    d: "M198.62,245.94c1.84-6.04,4.83-8.26,4.83-8.26-2.94,3.74-3.83,8.49-3.83,8.49l-1-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M200.97,237.94c-.8,1.47-1.4,3.58-1.79,5.26-.21.89-.36,1.67-.46,2.16-.07.35-.1.56-.11.58l-.26-.06-.18-.04-.58-.14c.05-.22.1-.43.15-.63.31-1.26.65-2.32.98-3.19h0c1.11-2.92,2.18-3.88,2.25-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M200.81,239.58c-.81,1.86-1.5,4.69-1.77,5.88-.08.35-.12.56-.12.56l-.31-.07-.26-.06c.05-.2.1-.39.16-.58.22-.78.44-1.48.67-2.1.83-2.32,1.58-3.52,1.64-3.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-526",
    d: "M144.64,245.61c.69-4.64,2.18-6.62,2.18-6.62-1.38,3.09-1.63,6.68-1.63,6.68l-.54-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M144.91,245.64l-.89-.09c.62-3.69,1.68-4.99,1.75-5.07-1.04,2.16-.86,5.16-.86,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M142.82,242.5c-.14,1.66-.02,2.92-.02,2.92l-.43-.04-.23-.02c0-.24,0-.47.01-.69.01-.32.03-.62.06-.9.28-3.49,1.39-4.98,1.39-4.98-.46,1.25-.68,2.58-.77,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-454",
    d: "M142.39,245.38c.19-3.3-.68-4.89-.68-4.89.51,2.33.03,4.83.03,4.83l.65.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-460",
    d: "M144.06,245.55c.96-3,.43-4.45.43-4.45.18,2.14-.98,4.39-.98,4.39l.54.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-500",
    d: "M144.7,245.62c.49-2.75-.48-4.06-.48-4.06.57,1.95,0,4.01,0,4.01l.48.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M146.86,240.59c-.3.55-.54,1.18-.75,1.8-.01.03-.02.06-.03.09-.52,1.63-.74,3.21-.74,3.21l-.4-.04c.49-3.25,1.83-4.95,1.91-5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M142.2,243.76c.01.27,0,.57-.06.9-.04.21-.09.44-.16.67l-.67-.07s.88-1.66.23-3.29c0,0,.59.61.65,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-493",
    d: "M143.14,245.46c.76-4.55,2.72-6.44,2.72-6.44-1.78,2.99-1.97,6.52-1.97,6.52l-.75-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M144.08,239.43c-.44,1.14-.68,2.73-.8,3.98-.11,1.13-.14,2-.15,2.04l-.2-.02h-.13s-.43-.06-.43-.06c.11-1.15.27-2.1.46-2.88.52-2.2,1.2-3.01,1.26-3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M144.12,240.64c-.54,1.84-.76,4.84-.76,4.84l-.23-.02-.2-.02c.1-.76.22-1.44.35-2.02.38-1.76.81-2.7.85-2.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M150.72,245.96c.96-4.64,3.02-6.62,3.02-6.62-1.92,3.09-2.27,6.68-2.27,6.68l-.75-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M151.1,245.98l-1.23-.09c.89-3.81,2.43-5.08,2.43-5.08-1.45,2.16-1.2,5.17-1.2,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M147.76,242.81c-.2,1.66-.03,2.92-.03,2.92l-.6-.05-.32-.02c0-.25,0-.48.02-.71.01-.31.04-.61.07-.89.4-3.48,1.94-4.97,1.94-4.97-.64,1.24-.94,2.58-1.07,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-465",
    d: "M147.15,245.33c.27-3.3-.95-4.89-.95-4.89.71,2.33.04,4.83.04,4.83l.91.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-495",
    d: "M149.47,245.86c1.34-3,.6-4.45.6-4.45.25,2.14-1.36,4.39-1.36,4.39l.75.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-489",
    d: "M150.8,245.96c.68-2.75-.67-4.06-.67-4.06.79,1.95,0,4.01,0,4.01l.67.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M153.79,240.94c-.55.72-.97,1.59-1.29,2.4-.03.08-.06.16-.09.24-.51,1.33-.72,2.45-.72,2.45l-.55-.04c.25-1.18.65-2.16,1.07-2.92,0,0,0-.02.01-.02.73-1.33,1.5-2.04,1.57-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-531",
    d: "M138.78,244.84c.5-6.23-1.43-9.21-1.43-9.21,1.33,4.4.43,9.13.43,9.13l1,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M140.2,245.27l-1.23-.09s1.1-2.91.3-5.23c0,0,1.15,1.46.94,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-418",
    d: "M138.68,244.83c.16-3.72,2.4-5.15,2.4-5.15-1.76,2.38-1.51,5.21-1.51,5.21l-.89-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M138.22,244.8l-.74-.06s.4-4.13-.81-7.05c0,0,1.9,2.6,1.55,7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M146.82,244.95c-.05.22-.12.45-.23.7l-.92-.07s1.13-1.53.42-3.1c-.03-.06-.06-.13-.09-.19,0,0,.05.04.12.11.23.22.72.78.78,1.67.02.27,0,.56-.07.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-503",
    d: "M148.19,245.77c1.06-4.55,3.78-6.44,3.78-6.44-2.47,2.99-2.74,6.52-2.74,6.52l-1.04-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M149.51,239.74c-.62,1.15-.95,2.74-1.12,4-.16,1.12-.19,1.98-.2,2.02l-.27-.02h-.18s-.6-.06-.6-.06c.15-1.15.38-2.1.63-2.88.75-2.3,1.75-3.07,1.75-3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M149.56,240.95c-.75,1.84-1.06,4.84-1.06,4.84l-.33-.02-.27-.02c.14-.75.3-1.42.47-2,.53-1.77,1.13-2.72,1.18-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-425",
    d: "M156.91,246.68c.96-4.64,3.02-6.62,3.02-6.62-1.92,3.09-2.27,6.68-2.27,6.68l-.75-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "M157.29,246.7l-1.23-.09c.89-3.81,2.43-5.08,2.43-5.08-1.45,2.16-1.2,5.17-1.2,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M153.95,243.53c-.19,1.61-.04,2.85-.03,2.92h0s-.92-.07-.92-.07c0-.24,0-.48.02-.7.01-.32.04-.62.07-.91,0,0,0,0,0,0,.41-3.47,1.94-4.96,1.94-4.96-.64,1.25-.94,2.58-1.08,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-473",
    d: "M153.34,246.41c.27-3.3-.95-4.89-.95-4.89.71,2.33.04,4.83.04,4.83l.91.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-469",
    d: "M155.66,246.58c1.34-3,.6-4.45.6-4.45.25,2.14-1.36,4.39-1.36,4.39l.75.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-537",
    d: "M156.99,246.68c.68-2.75-.67-4.06-.67-4.06.79,1.95,0,4.01,0,4.01l.67.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M159.99,241.66c-1.52,2.01-2.1,5.09-2.1,5.09l-.55-.04c.69-3.25,2.54-4.95,2.66-5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M153.01,245.68c-.05.22-.12.44-.23.69l-.92-.07s.95-1.3.55-2.72c-.05-.17-.11-.34-.2-.51,0-.02-.02-.04-.03-.06,0,0,.02.01.04.04.06.05.17.15.28.29.24.29.53.77.58,1.43,0,0,0,0,0,0,.02.27,0,.57-.07.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-451",
    d: "M154.38,246.49c1.06-4.55,3.78-6.44,3.78-6.44-2.47,2.99-2.74,6.52-2.74,6.52l-1.04-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M155.7,240.46c-.62,1.15-.95,2.75-1.12,4.01h0c-.15,1.12-.19,1.97-.2,2.01l-.27-.02-.19-.02-.6-.04c.15-1.15.38-2.1.63-2.88.75-2.29,1.75-3.07,1.75-3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M155.75,241.67c-.75,1.84-1.06,4.84-1.06,4.84l-.33-.02-.27-.02c.14-.75.3-1.41.47-1.99h0c.53-1.78,1.13-2.74,1.18-2.81Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-518",
    d: "M224.07,255.78c2.32-4.08,4.42-5.38,4.42-5.38-2.4,2.38-3.93,5.63-3.93,5.63l-.48-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M226.98,251.4c-1.35,1.26-2.21,3.26-2.53,4.1-.09.25-.14.4-.14.4l-.79-.41c.07-.12.14-.23.21-.35,1.81-2.93,3.17-3.7,3.25-3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M225.56,249.03c-.88.99-1.56,2.15-2.06,3.18-.49,1.01-.81,1.9-.97,2.37-.07.21-.11.33-.11.35h0s-.39-.2-.39-.2l-.21-.11c.04-.11.09-.22.13-.32.05-.12.1-.23.15-.35.12-.28.24-.54.36-.79,1.52-3.15,3.1-4.14,3.1-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-415",
    d: "M222.06,254.74c1.37-3.01,1.13-4.81,1.13-4.81-.36,2.36-1.71,4.51-1.71,4.51l.59.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-499",
    d: "M223.55,255.51c1.98-2.45,2.01-3.99,2.01-3.99-.61,2.06-2.49,3.74-2.49,3.74l.49.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-467",
    d: "M224.12,255.8c1.45-2.39,1.02-3.96,1.02-3.96-.17,2.03-1.45,3.74-1.45,3.74l.43.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M227.95,251.9c-.64.54-1.25,1.25-1.76,1.93-.1.12-.19.25-.28.37-.44.62-.8,1.18-1,1.53-.14.23-.21.37-.21.37l-.36-.18c.07-.12.14-.25.21-.36.5-.82,1.02-1.48,1.49-2.01h0s.06-.07.09-.1c.97-1.05,1.74-1.51,1.81-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M222.47,253.17c-.08.25-.2.51-.36.79-.06.11-.13.21-.2.32-.06.09-.14.19-.21.28l-.51-.26-.09-.04s.07-.06.18-.18c.02-.02.04-.04.06-.06.4-.44,1.17-1.45,1.16-2.75,0,0,.33.78-.04,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-433",
    d: "M222.73,255.09c2.36-3.97,4.86-5.02,4.86-5.02-2.73,2.15-4.19,5.36-4.19,5.36l-.67-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M225.78,249.81c-.83.91-1.62,2.3-2.19,3.43-.31.62-.57,1.17-.71,1.5-.09.2-.15.33-.15.34l-.18-.09h0s-.12-.06-.12-.06h0s-.39-.2-.39-.2c.06-.11.11-.22.16-.32.46-.89.9-1.62,1.31-2.21,1.29-1.88,2.22-2.37,2.27-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M225.39,250.95c-.91,1.19-1.9,3.11-2.29,3.89-.11.22-.17.35-.17.35l-.21-.11-.18-.09h0c.06-.11.12-.22.18-.33.3-.54.59-1.01.86-1.42.99-1.51,1.74-2.23,1.8-2.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-517",
    d: "M227.91,257.87c2.32-4.08,4.42-5.38,4.42-5.38-2.4,2.38-3.93,5.63-3.93,5.63l-.48-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M230.82,253.49c-1.29,1.21-2.13,3.1-2.48,4-.12.31-.18.51-.18.51l-.8-.41c.09-.16.19-.31.28-.46,1.77-2.84,3.09-3.59,3.18-3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M229.12,250.97c-.88,1-1.57,2.16-2.06,3.19-.44.9-.74,1.7-.91,2.19-.11.33-.17.52-.17.52l-.39-.2-.21-.11c.07-.17.14-.34.2-.5.02-.06.04-.11.07-.16.12-.28.24-.55.36-.8,1.52-3.15,3.09-4.14,3.09-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M225.62,256.69c1.37-3.01,1.13-4.81,1.13-4.81-.36,2.36-1.71,4.51-1.71,4.51l.59.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-464",
    d: "M227.11,257.45c1.98-2.45,2.01-3.99,2.01-3.99-.61,2.06-2.49,3.74-2.49,3.74l.49.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-494",
    d: "M227.96,257.89c1.45-2.39,1.02-3.96,1.02-3.96-.17,2.03-1.45,3.74-1.45,3.74l.43.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M231.79,253.99c-.63.54-1.22,1.23-1.73,1.9-.05.07-.1.14-.15.2-.47.64-.86,1.24-1.1,1.64-.17.29-.27.46-.27.46l-.36-.19c.09-.16.18-.31.27-.46.51-.82,1.03-1.48,1.5-1.99,0,0,.01-.01.02-.02.97-1.05,1.74-1.51,1.81-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-541",
    d: "M220.55,254.21c1.94-4.27,1.78-6.74,1.78-6.74-.52,3.35-2.26,6.49-2.26,6.49l.48.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-401",
    d: "M221.31,254s-.02.05-.03.08c-.03.07-.06.15-.09.22-.02.06-.05.13-.08.19l-.8-.41s.11-.15.28-.42c.52-.79,1.58-2.6,1.8-4.38,0,0,.22,1.51-1.08,4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-504",
    d: "M220.5,254.18c1.09-2.58,2.61-3.14,2.61-3.14-1.54,1.33-2.18,3.36-2.18,3.36l-.43-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M220.48,253.61c-.06.15-.13.3-.2.46l-.36-.19s.07-.16.19-.44c.34-.8,1.04-2.59,1.26-4.23.01-.1.02-.19.03-.29,0-.05.01-.1.01-.15,0,0,0,.04,0,.13,0,.06,0,.13,0,.23,0,.69-.09,2.34-.97,4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M226.03,255.11c-.08.25-.2.52-.36.8-.03.05-.06.1-.09.15-.09.14-.2.29-.31.44l-.6-.3s.16-.14.38-.4c.29-.35.68-.9.88-1.59.06-.21.11-.43.13-.65h0c.01-.11.02-.22.02-.34,0,0,.04.09.07.24.02.1.04.23.06.38.02.33,0,.77-.17,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-484",
    d: "M226.29,257.03c2.36-3.97,4.86-5.02,4.86-5.02-2.73,2.15-4.19,5.36-4.19,5.36l-.67-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M229.34,251.76c-.83.91-1.62,2.31-2.19,3.44-.27.53-.49,1.01-.65,1.34-.13.29-.21.48-.22.49l-.17-.09-.12-.06-.39-.2c.08-.17.17-.32.25-.48.43-.81.84-1.48,1.21-2.03,1.29-1.89,2.22-2.38,2.28-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M228.95,252.9c-.86,1.12-1.79,2.9-2.22,3.75-.15.3-.24.49-.24.49l-.21-.11-.17-.09c.09-.16.18-.32.26-.47.27-.47.53-.9.78-1.27.99-1.51,1.74-2.24,1.8-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-523",
    d: "M231.81,260.15c2.32-4.08,4.42-5.38,4.42-5.38-2.4,2.38-3.93,5.63-3.93,5.63l-.48-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-406",
    d: "M234.72,255.77c-1.13,1.06-1.91,2.63-2.32,3.61-.23.54-.34.89-.34.89l-.8-.41c.17-.28.33-.54.49-.79,1.66-2.57,2.89-3.26,2.97-3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M233.02,253.26c-.88.99-1.56,2.16-2.06,3.19-.36.74-.62,1.41-.8,1.9-.18.51-.27.82-.27.82l-.39-.2-.21-.11c.09-.23.18-.45.28-.67.01-.03.02-.06.04-.09.11-.25.22-.49.33-.71h0c1.52-3.14,3.09-4.12,3.09-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M229.51,258.97c1.37-3.01,1.13-4.81,1.13-4.81-.36,2.36-1.71,4.51-1.71,4.51l.59.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-411",
    d: "M231.01,259.74c1.98-2.45,2.01-3.99,2.01-3.99-.61,2.06-2.49,3.74-2.49,3.74l.49.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "M231.86,260.18c1.45-2.39,1.02-3.96,1.02-3.96-.17,2.03-1.45,3.74-1.45,3.74l.43.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M235.68,256.27c-1.13.96-2.16,2.45-2.74,3.37-.32.5-.5.83-.5.83l-.36-.18c.17-.29.33-.56.5-.82,1.49-2.25,3-3.14,3.1-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M229.93,257.38h0c-.07.23-.18.47-.31.72-.02.03-.03.06-.05.09-.11.19-.25.4-.41.6l-.6-.31s.26-.22.55-.62c.32-.42.67-1.03.8-1.77.03-.17.05-.35.05-.53v-.06s0,.01.02.04c.02.06.06.18.08.35.06.33.08.86-.13,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-419",
    d: "M230.18,259.31c2.36-3.97,4.86-5.02,4.86-5.02-2.73,2.15-4.19,5.36-4.19,5.36l-.67-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M233.24,254.04c-.83.91-1.61,2.3-2.19,3.42-.2.4-.38.76-.51,1.06-.22.46-.35.77-.36.79l-.17-.09-.12-.06-.39-.2c.13-.26.26-.51.38-.74.38-.7.74-1.28,1.08-1.77,1.29-1.89,2.22-2.38,2.28-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M232.84,255.18c-.77,1-1.59,2.53-2.06,3.45-.24.47-.39.79-.39.79l-.21-.11-.17-.09c.14-.27.28-.51.43-.75.22-.37.43-.7.62-1.01.99-1.5,1.73-2.23,1.79-2.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-547",
    d: "M208.3,249.18c2.23-5.17,4.55-7,4.55-7-2.55,3.15-3.94,7.23-3.94,7.23l-.61-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M211.2,243.58c-1.42,1.65-2.17,4.08-2.46,5.16-.09.35-.13.56-.13.56l-1-.38c.08-.17.16-.35.24-.51,1.81-3.8,3.35-4.84,3.35-4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M209.18,240.95c-.91,1.3-1.57,2.77-2.03,4.05,0,0,0,0,0,0-.43,1.21-.69,2.27-.82,2.86-.07.33-.1.52-.1.52l-.49-.19-.27-.1c.04-.17.09-.33.14-.49.03-.1.06-.2.09-.3.11-.37.23-.72.35-1.05,1.35-3.79,3.01-5.22,3.13-5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-463",
    d: "M205.76,248.22c1.23-3.77.71-5.88.71-5.88-.12,2.86-1.45,5.6-1.45,5.6l.74.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-452",
    d: "M207.64,248.93c2.03-3.18,1.87-5.02,1.87-5.02-.45,2.54-2.48,4.79-2.48,4.79l.61.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-549",
    d: "M208.36,249.21c1.41-3.04.69-4.85.69-4.85.06,2.44-1.23,4.64-1.23,4.64l.54.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M212.41,244.05c-.69.73-1.32,1.66-1.84,2.54-.1.16-.19.32-.28.48-.43.76-.76,1.45-.97,1.9-.15.33-.23.52-.23.52l-.45-.17c.08-.18.16-.35.24-.52.48-1.02,1-1.86,1.48-2.53.03-.04.06-.09.09-.13,1.02-1.38,1.87-2.03,1.96-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M206.05,246.26c-.07.32-.18.68-.35,1.05-.04.09-.09.19-.14.29-.07.15-.16.3-.26.45l-.64-.24-.11-.04s.07-.08.18-.23c.04-.05.08-.11.13-.18.43-.61,1.14-1.87.96-3.34,0,0,.5.87.22,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-453",
    d: "M206.6,248.54c2.28-5.04,5.13-6.63,5.13-6.63-2.98,2.92-4.29,6.95-4.29,6.95l-.84-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M209.55,241.85c-.86,1.19-1.63,2.96-2.16,4.38-.27.73-.49,1.38-.62,1.79-.1.31-.16.49-.17.51l-.22-.08-.15-.06-.49-.19c.06-.17.12-.33.18-.49.42-1.08.84-1.98,1.23-2.72,0,0,0,0,0,0,1.29-2.4,2.33-3.11,2.39-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.23,243.26c-.91,1.5-1.81,3.84-2.18,4.86-.12.32-.18.51-.18.51l-.26-.1-.22-.08c.07-.17.14-.33.21-.49.27-.64.55-1.22.8-1.73.98-1.93,1.78-2.9,1.84-2.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-522",
    d: "M213.15,251.16c2.23-5.17,4.55-7,4.55-7-2.55,3.15-3.94,7.23-3.94,7.23l-.61-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M216.05,245.55c-1.38,1.61-2.13,3.96-2.43,5.08-.1.4-.15.64-.15.64l-1-.38c.09-.21.19-.41.29-.61,1.79-3.72,3.3-4.74,3.3-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M213.68,242.79c-.91,1.3-1.57,2.76-2.03,4.05,0,0,0,0,0,0-.4,1.11-.65,2.08-.79,2.7-.1.43-.14.69-.14.69l-.49-.19-.26-.1c.06-.23.13-.46.19-.67.01-.04.02-.09.04-.13t0,0c.11-.36.22-.7.34-1.03,0,0,0,0,0,0,1.35-3.8,3.01-5.22,3.13-5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-538",
    d: "M210.26,250.06c1.23-3.77.71-5.88.71-5.88-.12,2.86-1.45,5.6-1.45,5.6l.74.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-498",
    d: "M212.14,250.78c2.03-3.18,1.87-5.02,1.87-5.02-.45,2.54-2.48,4.79-2.48,4.79l.61.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-552",
    d: "M213.22,251.19c1.41-3.04.69-4.85.69-4.85.06,2.44-1.23,4.64-1.23,4.64l.54.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M217.26,246.02c-.68.72-1.3,1.62-1.81,2.49-.06.09-.1.17-.15.26-.48.83-.86,1.61-1.09,2.11-.17.36-.26.58-.26.58l-.45-.17c.09-.2.18-.4.27-.59.5-1.04,1.03-1.89,1.52-2.56,0,0,.01-.02.02-.02,1.02-1.38,1.88-2.03,1.96-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-449",
    d: "M203.9,247.78c1.75-5.35,1.23-8.27,1.23-8.27-.18,4.06-1.84,8.03-1.84,8.03l.61.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M204.8,247.33c-.02.07-.04.13-.06.2-.02.09-.05.18-.08.27-.02.08-.05.16-.07.24l-1-.38s.14-.23.33-.63c.52-1.06,1.49-3.28,1.52-5.37,0,0,.46,1.74-.65,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-456",
    d: "M203.83,247.75c.96-3.22,2.7-4.09,2.7-4.09-1.66,1.78-2.15,4.3-2.15,4.3l-.54-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M203.76,246.98c-.06.22-.13.44-.2.67l-.45-.17s.08-.24.2-.65c.34-1.14.97-3.57.91-5.59v-.04s0,.01,0,.03c.06.28.46,2.49-.47,5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M210.55,248.1s0,0,0,0c-.07.32-.17.66-.34,1.03t0,0s-.04.08-.06.12c-.1.2-.21.41-.34.62l-.75-.28s.2-.21.43-.58c.3-.45.66-1.14.81-1.96.04-.25.07-.52.07-.8,0-.13-.01-.27-.03-.41,0,0,.06.1.12.28.04.12.08.27.12.45.07.38.1.9-.02,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-426",
    d: "M211.1,250.38c2.28-5.04,5.13-6.63,5.13-6.63-2.98,2.92-4.29,6.95-4.29,6.95l-.84-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M214.04,243.69c-.86,1.19-1.63,2.96-2.16,4.38-.25.65-.44,1.23-.58,1.65-.13.39-.2.64-.22.66l-.22-.08-.15-.06-.49-.19c.08-.22.17-.44.25-.65.4-1.01.79-1.85,1.17-2.55,0,0,0,0,0,0,1.29-2.4,2.33-3.11,2.39-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M213.73,245.1c-.87,1.44-1.73,3.64-2.13,4.73-.15.4-.23.65-.23.65l-.26-.1-.22-.08c.09-.22.18-.43.27-.64.25-.59.51-1.11.74-1.58.98-1.93,1.78-2.9,1.84-2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-448",
    d: "M218.1,253.37c2.23-5.17,4.55-7,4.55-7-2.55,3.15-3.94,7.23-3.94,7.23l-.61-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M220.99,247.76c-1.35,1.56-2.1,3.84-2.41,4.99-.12.45-.18.73-.18.73l-1-.38c.11-.25.23-.49.34-.72,1.76-3.63,3.25-4.62,3.25-4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M218.62,245c-.91,1.3-1.57,2.77-2.03,4.06,0,0,0,0,0,0-.36,1-.6,1.89-.74,2.51-.13.54-.18.87-.18.87l-.49-.19-.27-.1c.07-.28.15-.54.23-.8,0-.03.02-.05.02-.08.1-.34.21-.66.32-.97,1.35-3.8,3.01-5.22,3.13-5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M215.2,252.27c1.23-3.77.71-5.88.71-5.88-.12,2.86-1.45,5.6-1.45,5.6l.74.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M217.09,252.98c2.03-3.18,1.87-5.02,1.87-5.02-.45,2.54-2.48,4.79-2.48,4.79l.61.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-437",
    d: "M218.16,253.39c1.41-3.04.69-4.85.69-4.85.06,2.44-1.23,4.64-1.23,4.64l.54.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M222.21,248.23c-.26.28-.52.59-.76.91-.02.03-.04.06-.06.08-1,1.35-1.8,2.93-2.21,3.8-.19.4-.29.65-.29.65l-.45-.17c.1-.23.2-.45.31-.67.93-1.93,1.98-3.19,2.67-3.89,0,0,.02-.01.02-.02.43-.43.72-.65.77-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M215.49,250.31c-.06.3-.16.63-.31.98-.01.02-.02.05-.03.07-.11.24-.24.48-.4.73l-.75-.29s.27-.29.56-.78c.33-.54.68-1.34.74-2.25.01-.21.01-.42-.01-.64,0-.02,0-.05,0-.08,0,0,.01.02.02.05.03.07.09.2.15.4.11.39.2,1.01.04,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-431",
    d: "M216.05,252.59c2.28-5.04,5.13-6.63,5.13-6.63-2.98,2.92-4.29,6.95-4.29,6.95l-.84-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M218.99,245.89c-.86,1.19-1.63,2.96-2.16,4.38-.22.57-.39,1.09-.52,1.48-.16.49-.26.8-.27.82l-.22-.08-.15-.06-.49-.19c.11-.29.22-.57.32-.83.37-.93.74-1.71,1.09-2.36,0,0,0,0,0,0,1.29-2.41,2.33-3.12,2.39-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M218.67,247.31c-.83,1.37-1.65,3.45-2.08,4.58-.18.49-.29.8-.29.8l-.27-.1-.22-.08c.11-.28.23-.55.34-.8.23-.52.46-.99.67-1.42.98-1.93,1.78-2.9,1.84-2.97Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M147.76,242.81c-.2,1.66-.03,2.92-.03,2.92l-.6-.05-.32-.02c0-.25,0-.48.02-.71.01-.31.04-.61.07-.89.4-3.48,1.94-4.97,1.94-4.97-.64,1.24-.94,2.58-1.07,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-462",
    d: "M147.15,245.33c.27-3.3-.95-4.89-.95-4.89.71,2.33.04,4.83.04,4.83l.91.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-479",
    d: "M149.47,245.86c1.34-3,.6-4.45.6-4.45.25,2.14-1.36,4.39-1.36,4.39l.75.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-477",
    d: "M150.8,245.96c.68-2.75-.67-4.06-.67-4.06.79,1.95,0,4.01,0,4.01l.67.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M153.79,240.94c-.55.72-.97,1.59-1.29,2.4-.03.08-.06.16-.09.24-.51,1.33-.72,2.45-.72,2.45l-.55-.04c.25-1.18.65-2.16,1.07-2.92,0,0,0-.02.01-.02.73-1.33,1.5-2.04,1.57-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M146.82,244.95c-.05.22-.12.45-.23.7l-.92-.07s1.13-1.53.42-3.1c-.03-.06-.06-.13-.09-.19,0,0,.05.04.12.11.23.22.72.78.78,1.67.02.27,0,.56-.07.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-536",
    d: "M148.19,245.77c1.06-4.55,3.78-6.44,3.78-6.44-2.47,2.99-2.74,6.52-2.74,6.52l-1.04-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M149.51,239.74c-.62,1.15-.95,2.74-1.12,4-.16,1.12-.19,1.98-.2,2.02l-.27-.02h-.18s-.6-.06-.6-.06c.15-1.15.38-2.1.63-2.88.75-2.3,1.75-3.07,1.75-3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M149.56,240.95c-.75,1.84-1.06,4.84-1.06,4.84l-.33-.02-.27-.02c.14-.75.3-1.42.47-2,.53-1.77,1.13-2.72,1.18-2.79Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M167.86,285.84c22.02,18.78,50.49,30.11,81.59,30.11s60.2-11.58,82.32-30.73c-28.48-2.24-85.57-4.51-119.77-5.25-19.72-.43-34.34,2.63-44.15,5.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-420"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M440.56,320.07c0,20.84-84.75,2.61-196.12,2.61s-70.83,10.03-83.21-6.73c-22.42-30.38,23.82-34.78,31.45-35.29.65-.04,10.65-.68,11.31-.68,114.1.84,236.57,19.99,236.57,40.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M295.46,309.08c-.93-4.85-3.06-9.47-6.14-13.33,3.6,3.2,6.3,7.04,7.33,13.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M290.91,297.55c.37.45.7.93,1.01,1.42.15.25.32.49.46.74l.22.37c.07.13.14.25.21.38.56,1.02,1.06,2.07,1.49,3.15.11.27.21.54.31.81l.15.41c.05.14.09.28.14.41l.27.83.23.84c.17.56.28,1.13.41,1.69l.05.21c.01.07.03.14.04.21l.08.43.16.86-.13-.86-.06-.43c-.01-.07-.02-.14-.03-.22l-.04-.21c-.12-.57-.22-1.14-.38-1.71-.07-.28-.14-.56-.22-.84l-.26-.83c-.05-.14-.08-.28-.13-.42l-.15-.41-.15-.41c-.05-.14-.1-.27-.16-.41l-.34-.81c-.12-.27-.25-.53-.37-.79-.12-.27-.26-.52-.39-.78-.07-.13-.13-.26-.2-.39l-.22-.38c-.58-1.01-1.22-1.99-1.98-2.87Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M290.09,291.58c-.22-.25-.82-.34-.83-.31-.06.22.1,1.01,1.01.85.02,0,.04-.03.04-.05,0-.13-.06-.29-.23-.49Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M290.2,291.73c-.03.09.06.19,0,.27-.03.05-.11.05-.17.04-.17-.04-.3-.17-.43-.29-.11-.11-.23-.22-.28-.37-.01-.04-.03-.09-.07-.11,0,0,0,0,0,0-.06.22.1,1.01,1.01.85.02,0,.04-.03.04-.05,0-.09-.03-.21-.12-.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M290.04,291.63c-.03-.06-.09-.09-.15-.12-.1-.05-.22-.1-.33-.1,0,.02.03.04.05.05.13.07.25.15.36.25.03.02.06.05.09.07,0,0,.02,0,.03,0,.01,0,.01-.03,0-.04,0-.03-.02-.05-.04-.07"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M290.4,292.4c-.38-.15-1.08.1-1.08.14.06.27.69,1.04,1.59.35.02-.02.03-.05.01-.08-.08-.13-.23-.28-.53-.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M290.61,292.51c.02.11.17.18.16.29,0,.08-.09.12-.16.14-.21.05-.43,0-.63-.07-.18-.05-.38-.11-.51-.25-.04-.04-.08-.08-.14-.07,0,0,0,0,0,0,.06.27.69,1.04,1.59.35.02-.02.03-.05.01-.08-.06-.1-.15-.2-.32-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M290.37,292.49c-.06-.05-.15-.05-.23-.05-.14,0-.29.01-.42.08.02.02.06.02.09.02.18,0,.36.02.53.06.04.01.09.02.13.02.01,0,.03,0,.04-.01.01-.02,0-.04-.02-.05-.03-.02-.05-.04-.08-.06"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M291.09,293.3c-.45-.18-1.3.12-1.29.16.08.33.83,1.25,1.9.41.03-.02.04-.06.02-.1-.09-.16-.27-.34-.63-.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M291.34,293.42c.02.13.21.21.19.34,0,.09-.1.15-.19.17-.25.06-.51-.01-.76-.09-.22-.07-.45-.14-.62-.29-.05-.04-.1-.1-.16-.09,0,0,0,0,0,0,.08.33.83,1.25,1.9.41.03-.02.04-.06.02-.1-.07-.12-.19-.25-.38-.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.05,293.4c-.08-.06-.18-.06-.28-.06-.17,0-.35.01-.5.1.03.02.07.03.1.03.21,0,.43.03.64.07.05.01.11.03.16.03.02,0,.03,0,.04-.02.01-.02,0-.04-.02-.06-.03-.03-.06-.05-.1-.07"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M291.79,294.49c-.52-.21-1.47.14-1.46.19.09.37.94,1.42,2.16.47.03-.03.04-.07.02-.11-.11-.18-.31-.38-.72-.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M292.07,294.63c.03.15.23.24.22.39,0,.1-.12.16-.22.19-.28.07-.58-.01-.86-.1-.25-.07-.51-.15-.7-.33-.05-.05-.11-.11-.18-.1,0,0,0,0,0,0,.09.37.94,1.42,2.16.47.03-.03.04-.07.02-.11-.08-.13-.21-.28-.44-.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-410",
    d: "M291.75,294.61c-.09-.06-.2-.07-.31-.07-.19,0-.4.02-.57.11.03.03.08.03.12.03.24.01.49.03.72.08.06.01.12.03.18.03.02,0,.04,0,.05-.02.01-.02,0-.05-.03-.07-.03-.03-.07-.06-.11-.08"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M292.74,296c-.5-.29-1.54-.06-1.53,0,.04.4.77,1.59,2.16.78.04-.02.05-.07.04-.11-.09-.2-.27-.44-.66-.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M293.01,296.18c0,.16.21.28.17.43-.02.1-.15.15-.25.17-.3.03-.6-.09-.87-.22-.25-.11-.51-.23-.68-.44-.05-.06-.1-.13-.18-.13,0,0,0,0,0,0,.04.4.77,1.59,2.16.78.04-.02.05-.07.04-.11-.06-.15-.18-.32-.39-.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M292.68,296.11c-.08-.08-.2-.1-.31-.11-.2-.03-.41-.04-.6.04.03.03.07.04.12.05.25.04.5.1.73.19.06.02.12.05.18.06.02,0,.04,0,.05-.01.02-.02,0-.05-.02-.07-.03-.04-.07-.07-.1-.09"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M293.48,297.73c-.51-.34-1.62-.19-1.62-.14,0,.42.68,1.74,2.21,1,.04-.02.06-.07.05-.11-.07-.22-.24-.48-.64-.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M293.75,297.94c0,.17.2.31.15.47-.03.11-.17.15-.28.15-.32.01-.62-.15-.9-.3-.25-.14-.51-.28-.67-.52-.05-.07-.1-.15-.17-.15,0,0,0,0,0,0,0,.42.68,1.74,2.21,1,.04-.02.06-.07.05-.11-.05-.16-.16-.35-.37-.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M293.4,297.84c-.08-.09-.2-.12-.32-.14-.21-.04-.43-.07-.63,0,.03.04.07.05.12.06.26.07.52.14.76.26.06.03.12.06.19.07.02,0,.04,0,.06,0,.02-.02,0-.05-.01-.08-.03-.04-.06-.08-.1-.11"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M293.98,299.52c-.56-.41-1.83-.28-1.83-.22,0,.48.71,2,2.47,1.22.05-.02.07-.08.06-.12-.08-.25-.26-.56-.7-.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M294.28,299.77c-.01.19.21.36.15.54-.04.12-.19.16-.32.16-.36,0-.7-.19-1.01-.38-.28-.17-.57-.34-.75-.62-.05-.08-.1-.17-.19-.18,0,0,0,0,0,0,0,.48.71,2,2.47,1.22.05-.02.07-.08.06-.12-.06-.19-.17-.4-.4-.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M293.89,299.65c-.09-.1-.23-.14-.36-.18-.24-.06-.49-.1-.72-.04.03.04.08.06.13.07.29.09.58.18.85.32.07.04.14.07.21.09.02,0,.05,0,.06,0,.02-.02,0-.06-.01-.09-.03-.05-.07-.09-.11-.13"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M294.35,301.46c-.58-.49-1.98-.46-1.99-.39-.05.52.61,2.26,2.61,1.55.05-.02.09-.08.07-.13-.06-.28-.24-.63-.7-1.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M294.65,301.76c-.03.21.2.41.12.61-.06.13-.23.16-.37.15-.4-.03-.75-.27-1.08-.5-.29-.21-.6-.42-.77-.74-.05-.09-.1-.19-.2-.21,0,0,0,0,0,0-.05.52.61,2.26,2.61,1.55.05-.02.09-.08.07-.13-.05-.21-.15-.45-.39-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M294.24,301.59c-.09-.12-.24-.18-.38-.22-.25-.08-.53-.15-.79-.1.03.05.09.07.14.09.31.12.62.25.91.42.07.04.14.09.22.12.02,0,.05.01.07,0,.03-.02.01-.07,0-.1-.03-.05-.07-.1-.11-.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M295.13,300.98c.22-.73,1.42-1.45,1.46-1.4.32.41.7,2.23-1.36,2.71-.06.01-.11-.02-.13-.07-.1-.27-.14-.66.03-1.24Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M295.04,301.39c.14.16.05.46.23.57.12.08.28.01.39-.07.32-.24.49-.63.64-1,.14-.33.27-.68.25-1.04,0-.1-.02-.22.05-.28,0,0,0,0,0,0,.32.41.7,2.23-1.36,2.71-.06.01-.11-.02-.13-.07-.07-.2-.12-.47-.06-.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M295.29,301.02c0-.15.1-.28.2-.39.17-.21.36-.41.61-.51,0,.06-.03.11-.07.15-.2.27-.39.55-.53.85-.04.08-.07.15-.13.22-.02.02-.04.04-.06.04-.04,0-.05-.05-.05-.09,0-.06,0-.12.01-.18"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M294.66,299.1c.21-.68,1.32-1.35,1.36-1.31.3.38.66,2.07-1.27,2.53-.05.01-.11-.02-.12-.07-.09-.25-.13-.62.03-1.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M294.57,299.49c.13.15.05.42.21.53.11.07.26.01.36-.07.3-.22.45-.59.59-.93.13-.31.26-.63.23-.96,0-.09-.02-.2.05-.26,0,0,0,0,0,0,.3.38.66,2.07-1.27,2.53-.05.01-.11-.02-.12-.07-.07-.19-.11-.43-.06-.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M294.81,299.15c0-.14.1-.26.18-.37.16-.19.34-.38.57-.47,0,.05-.03.1-.06.14-.18.25-.36.51-.5.79-.03.07-.07.14-.12.21-.01.02-.03.04-.06.03-.03,0-.04-.05-.05-.08,0-.06,0-.12.01-.17"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M294.08,297.37c.13-.6,1.05-1.24,1.08-1.2.28.31.69,1.73-.92,2.24-.04.01-.09,0-.11-.05-.1-.21-.15-.52-.05-.99Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M294.03,297.71c.12.12.07.36.22.44.1.06.22,0,.31-.08.24-.21.35-.53.45-.84.09-.27.18-.56.13-.84-.01-.08-.03-.17.02-.23,0,0,0,0,0,0,.28.31.69,1.73-.92,2.24-.04.01-.09,0-.11-.05-.07-.16-.12-.36-.1-.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M294.21,297.4c0-.12.07-.23.13-.32.12-.17.26-.35.46-.44,0,.04-.02.09-.04.13-.14.23-.28.46-.38.71-.03.06-.05.13-.09.18-.01.02-.03.03-.05.03-.03,0-.04-.04-.04-.07,0-.05,0-.1,0-.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M293.37,295.57c.13-.6,1.05-1.24,1.08-1.2.28.31.69,1.73-.92,2.24-.04.01-.09,0-.11-.05-.1-.21-.15-.52-.05-.99Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M293.32,295.91c.12.12.07.36.22.44.1.06.22,0,.31-.08.24-.21.35-.53.45-.84.09-.27.18-.56.13-.84-.01-.08-.03-.17.02-.23,0,0,0,0,0,0,.28.31.69,1.73-.92,2.24-.04.01-.09,0-.11-.05-.07-.16-.12-.36-.1-.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M293.5,295.6c0-.12.07-.23.13-.32.12-.17.26-.35.46-.44,0,.04-.02.09-.04.13-.14.23-.28.46-.38.71-.03.06-.05.13-.09.18-.01.02-.03.03-.05.03-.03,0-.04-.04-.04-.07,0-.05,0-.1,0-.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M292.26,294.01c0-.59.74-1.37.78-1.34.33.24.99,1.49-.43,2.29-.04.02-.09.01-.11-.02-.13-.18-.25-.46-.24-.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M292.28,294.34c.13.09.14.33.29.37.1.03.21-.05.27-.14.18-.25.22-.57.26-.87.03-.27.06-.56-.04-.82-.03-.07-.06-.16-.02-.22,0,0,0,0,0,0,.33.24.99,1.49-.43,2.29-.04.02-.09.01-.11-.02-.1-.13-.18-.32-.22-.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M292.39,294.02c-.03-.11.02-.23.06-.33.08-.19.18-.38.34-.5.01.04,0,.09-.02.13-.09.24-.17.48-.21.74-.01.06-.02.13-.05.19,0,.02-.02.04-.04.04-.03,0-.05-.03-.05-.05-.01-.05-.02-.09-.03-.14"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M291.41,292.87c-.03-.55.6-1.33.64-1.3.32.2,1.02,1.33-.25,2.16-.03.02-.08.02-.11-.02-.14-.16-.26-.41-.28-.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M291.44,293.17c.13.07.15.29.29.33.1.02.19-.06.25-.14.16-.24.17-.54.18-.83.01-.26.02-.52-.09-.76-.03-.06-.07-.14-.04-.2,0,0,0,0,0,0,.32.2,1.02,1.33-.25,2.16-.03.02-.08.02-.11-.02-.1-.12-.19-.28-.24-.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-407",
    d: "M291.53,292.86c-.03-.1,0-.21.04-.31.06-.18.14-.36.29-.49.01.04,0,.08,0,.12-.07.23-.13.46-.15.7,0,.06-.01.12-.03.18,0,.02-.01.03-.03.04-.03,0-.04-.02-.05-.05-.02-.04-.03-.08-.04-.13"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M290.64,292.13c-.04-.4.39-1,.42-.98.24.13.81.93-.1,1.6-.02.02-.06.01-.08,0-.11-.11-.21-.29-.24-.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M290.68,292.35c.1.05.12.21.23.23.07.01.14-.05.18-.12.1-.18.1-.41.1-.62,0-.19,0-.39-.1-.55-.02-.05-.06-.1-.03-.15,0,0,0,0,0,0,.24.13.81.93-.1,1.6-.02.02-.06.01-.08,0-.08-.08-.15-.2-.2-.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M290.72,292.12c-.03-.07,0-.16.01-.23.04-.14.09-.27.19-.37.01.03,0,.06,0,.09-.04.17-.08.35-.08.52,0,.04,0,.09-.01.13,0,.01,0,.03-.02.03-.02,0-.03-.01-.04-.03-.01-.03-.02-.06-.03-.09"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M290.17,291.93c.66.61,1.23,1.31,1.75,2.03.63.89,1.18,1.83,1.63,2.82.52,1.14.94,2.32,1.23,3.54.33,1.38.51,2.79.54,4.2.03,1.61-.12,3.22-.47,4.79-.05.21-.1.42-.15.62-.02.07-.12.04-.1-.03.32-1.6.52-3.22.53-4.85,0-1.42-.13-2.84-.42-4.23-.25-1.23-.63-2.44-1.12-3.59-.43-1.01-.95-1.99-1.56-2.91-.51-.76-1.08-1.48-1.71-2.13-.07-.07-.14-.14-.21-.21-.04-.04.02-.09.05-.05h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M306.38,290.61c-.2-.18-.69-.17-.7-.15-.02.18.2.79.91.56.02,0,.03-.03.03-.05-.02-.1-.08-.22-.24-.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M306.49,290.71c-.01.07.07.15.04.21-.02.05-.08.06-.13.05-.14-.01-.26-.1-.38-.18-.1-.07-.21-.15-.27-.26-.02-.03-.03-.07-.07-.08,0,0,0,0,0,0-.02.18.2.79.91.56.02,0,.03-.03.03-.05-.01-.07-.05-.16-.13-.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M306.34,290.65s-.08-.06-.13-.08c-.09-.03-.18-.06-.28-.04.01.02.03.03.05.03.11.04.22.09.32.15.03.02.05.03.08.04,0,0,.02,0,.02,0,0,0,0-.02,0-.03-.01-.02-.02-.04-.04-.05"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M306.72,291.23c-.32-.08-.85.21-.84.24.08.21.68.75,1.3.08.02-.02.02-.05,0-.06-.08-.1-.22-.2-.47-.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M306.9,291.28c.03.09.16.12.16.21,0,.06-.06.11-.11.13-.16.07-.34.04-.51.02-.15-.02-.31-.05-.44-.13-.04-.02-.08-.06-.12-.04,0,0,0,0,0,0,.08.21.68.75,1.3.08.02-.02.02-.05,0-.06-.06-.07-.15-.14-.29-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M306.71,291.3c-.06-.03-.13-.02-.19-.01-.11.02-.23.04-.32.12.02.01.05.01.07,0,.14-.02.29-.03.43-.01.04,0,.07,0,.11,0,.01,0,.02,0,.03-.01,0-.01,0-.03-.02-.04-.02-.01-.05-.03-.07-.04"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M307.38,291.86c-.38-.09-1.02.25-1.01.29.1.25.81.89,1.56.1.02-.02.02-.06,0-.08-.09-.12-.26-.24-.56-.31Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M307.59,291.92c.04.1.19.14.2.25,0,.07-.07.13-.13.16-.19.08-.41.05-.61.02-.18-.03-.37-.05-.53-.16-.04-.03-.09-.07-.14-.05,0,0,0,0,0,0,.1.25.81.89,1.56.1.02-.02.02-.06,0-.08-.07-.09-.18-.17-.35-.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M307.36,291.94c-.07-.04-.15-.03-.23-.01-.14.02-.28.05-.39.14.02.02.06.01.09,0,.17-.02.34-.03.52-.02.04,0,.09,0,.13,0,.01,0,.03,0,.03-.02,0-.02,0-.03-.03-.04-.03-.02-.06-.03-.09-.04"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M308.08,292.72c-.44-.1-1.15.29-1.14.32.11.29.92,1.01,1.77.11.02-.02.02-.06,0-.09-.11-.13-.29-.27-.64-.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M308.32,292.8c.04.12.22.16.22.28,0,.08-.07.15-.15.18-.22.09-.46.06-.69.03-.21-.03-.42-.06-.6-.18-.05-.03-.1-.07-.16-.06,0,0,0,0,0,0,.11.29.92,1.01,1.77.11.02-.02.02-.06,0-.09-.08-.1-.2-.2-.4-.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M308.06,292.82c-.08-.04-.17-.03-.26-.02-.15.02-.31.06-.44.16.03.02.06.01.1.01.19-.02.39-.04.58-.02.05,0,.1,0,.15,0,.01,0,.03,0,.04-.02,0-.02-.01-.04-.03-.05-.03-.02-.06-.04-.1-.05"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M309.02,293.81c-.44-.17-1.23.14-1.22.18.08.31.81,1.17,1.82.36.03-.02.03-.06.02-.09-.09-.15-.26-.32-.61-.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M309.25,293.92c.03.12.2.2.19.32,0,.09-.1.14-.18.16-.24.06-.49,0-.72-.07-.21-.06-.43-.12-.59-.27-.04-.04-.1-.09-.16-.08,0,0,0,0,0,0,.08.31.81,1.17,1.82.36.03-.02.03-.06.02-.09-.07-.11-.18-.23-.37-.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M308.98,293.9c-.07-.05-.17-.05-.26-.05-.16,0-.33.02-.47.1.03.02.06.02.1.02.2,0,.41.02.61.06.05.01.1.02.15.02.01,0,.03,0,.04-.02.01-.02,0-.04-.02-.06-.03-.02-.06-.05-.09-.06"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M309.81,295.1c-.44-.21-1.31.04-1.3.09.06.33.75,1.3,1.88.53.03-.02.04-.06.02-.09-.09-.17-.25-.36-.6-.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M310.05,295.23c.02.13.19.22.17.36-.01.09-.11.14-.2.16-.25.05-.51-.04-.75-.13-.22-.08-.44-.16-.6-.33-.04-.05-.09-.1-.16-.1,0,0,0,0,0,0,.06.33.75,1.3,1.88.53.03-.02.04-.06.02-.09-.06-.12-.17-.26-.36-.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M309.77,295.19c-.07-.06-.18-.07-.27-.08-.17,0-.35,0-.51.07.03.03.07.03.1.03.21.02.43.05.63.11.05.02.1.03.16.04.02,0,.03,0,.04-.01.01-.02,0-.04-.02-.06-.03-.03-.06-.05-.09-.07"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M310.43,296.46c-.5-.26-1.49,0-1.48.05.05.38.8,1.51,2.12.68.04-.02.05-.07.03-.11-.09-.19-.27-.41-.66-.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M310.7,296.62c.01.15.21.26.18.41-.02.1-.13.15-.24.17-.29.04-.58-.07-.85-.18-.24-.1-.5-.2-.67-.4-.05-.06-.1-.12-.17-.12,0,0,0,0,0,0,.05.38.8,1.51,2.12.68.04-.02.05-.07.03-.11-.07-.14-.18-.3-.4-.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M310.38,296.57c-.08-.07-.2-.09-.31-.1-.2-.02-.4-.02-.58.06.03.03.07.04.11.04.24.03.48.08.72.15.06.02.12.04.18.05.02,0,.04,0,.05-.01.02-.02,0-.05-.02-.07-.03-.03-.07-.06-.1-.09"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M310.95,297.96c-.52-.32-1.63-.12-1.63-.07.02.42.76,1.72,2.26.92.04-.02.06-.07.04-.11-.08-.22-.27-.48-.68-.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M311.23,298.16c0,.17.21.3.17.47-.03.11-.16.16-.27.17-.32.02-.63-.12-.92-.27-.26-.13-.53-.26-.7-.5-.05-.06-.1-.14-.18-.15,0,0,0,0,0,0,.02.42.76,1.72,2.26.92.04-.02.06-.07.04-.11-.06-.16-.18-.34-.4-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M310.88,298.07c-.08-.09-.21-.11-.33-.13-.21-.03-.44-.06-.64.02.03.03.08.05.12.06.26.06.52.12.77.23.06.03.13.06.19.07.02,0,.04,0,.06-.01.02-.02,0-.06-.02-.08-.03-.04-.07-.07-.11-.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M311.52,297.48c.09-.61.95-1.33.99-1.29.31.29.83,1.69-.76,2.32-.04.02-.09,0-.11-.04-.11-.2-.19-.51-.12-.99Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M311.5,297.82c.13.11.1.36.25.43.1.05.22-.02.3-.1.23-.23.31-.56.39-.87.07-.28.14-.57.07-.85-.02-.08-.04-.17,0-.23,0,0,0,0,0,0,.31.29.83,1.69-.76,2.32-.04.02-.09,0-.11-.04-.08-.15-.15-.36-.15-.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M311.66,297.5c-.01-.12.05-.23.11-.34.11-.18.24-.37.42-.48,0,.04-.01.09-.04.13-.12.24-.24.48-.32.74-.02.07-.04.13-.07.19,0,.02-.02.04-.04.04-.03,0-.04-.03-.05-.06,0-.05-.01-.1-.01-.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M310.92,296.04c.08-.57.89-1.24.92-1.2.29.27.77,1.57-.7,2.16-.04.02-.09,0-.11-.04-.11-.19-.18-.47-.11-.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M310.89,296.36c.12.1.09.33.23.4.1.04.21-.02.28-.1.21-.21.29-.52.36-.81.06-.26.13-.53.07-.8-.02-.07-.04-.16,0-.22,0,0,0,0,0,0,.29.27.77,1.57-.7,2.16-.04.02-.09,0-.11-.04-.08-.14-.14-.33-.14-.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M311.04,296.06c-.01-.11.04-.22.1-.31.1-.17.22-.34.39-.44,0,.04-.01.08-.03.12-.12.22-.23.45-.3.69-.02.06-.04.12-.07.18,0,.02-.02.03-.04.03-.03,0-.04-.03-.05-.06,0-.05-.01-.09-.01-.14"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M310.25,294.73c.04-.49.68-1.12.72-1.09.26.21.76,1.3-.47,1.9-.03.02-.07,0-.09-.03-.1-.16-.18-.39-.16-.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M310.25,295.01c.11.08.1.28.23.33.09.03.18-.03.24-.1.17-.2.21-.46.26-.72.04-.23.08-.47,0-.69-.02-.06-.04-.13,0-.19,0,0,0,0,0,0,.26.21.76,1.3-.47,1.9-.03.02-.07,0-.09-.03-.08-.11-.14-.28-.16-.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M310.36,294.74c-.02-.09.02-.19.07-.27.08-.15.17-.31.31-.41,0,.04,0,.07-.02.11-.09.2-.17.4-.21.61-.01.05-.02.11-.05.16,0,.01-.02.03-.03.03-.02,0-.04-.02-.04-.05-.01-.04-.02-.08-.02-.12"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M309.47,293.39c.04-.49.68-1.12.72-1.09.26.21.76,1.3-.47,1.9-.03.02-.07,0-.09-.03-.1-.16-.18-.39-.16-.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M309.47,293.66c.11.08.1.28.23.33.09.03.18-.03.24-.1.17-.2.21-.46.26-.72.04-.23.08-.47,0-.69-.02-.06-.04-.13,0-.19,0,0,0,0,0,0,.26.21.76,1.3-.47,1.9-.03.02-.07,0-.09-.03-.08-.11-.14-.28-.16-.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M309.57,293.4c-.02-.09.02-.19.07-.27.08-.15.17-.31.31-.41,0,.04,0,.07-.02.11-.09.2-.17.4-.21.61-.01.05-.02.11-.05.16,0,.01-.02.03-.03.03-.02,0-.04-.02-.04-.05-.01-.04-.02-.08-.02-.12"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M308.4,292.28c-.06-.47.42-1.18.46-1.16.29.15.97,1.07-.07,1.87-.03.02-.07.02-.09,0-.13-.13-.25-.33-.3-.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M308.45,292.54c.12.05.15.24.28.26.09.01.16-.06.2-.14.12-.22.11-.48.1-.73,0-.22-.02-.45-.13-.64-.03-.05-.07-.12-.05-.17,0,0,0,0,0,0,.29.15.97,1.07-.07,1.87-.03.02-.07.02-.09,0-.09-.09-.18-.23-.25-.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M308.5,292.27c-.03-.09-.01-.18,0-.27.04-.16.1-.32.21-.44.02.03,0,.07,0,.1-.04.2-.08.41-.08.61,0,.05,0,.11-.01.16,0,.01-.01.03-.02.04-.02,0-.04-.02-.05-.04-.02-.03-.03-.07-.04-.11"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M307.58,291.48c-.09-.43.32-1.13.35-1.11.28.12.97.93.06,1.75-.02.02-.06.02-.09,0-.13-.11-.25-.3-.33-.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M307.65,291.71c.11.04.15.22.27.23.08,0,.15-.07.18-.14.09-.21.07-.45.05-.68-.02-.21-.05-.42-.16-.59-.03-.05-.07-.1-.05-.16,0,0,0,0,0,0,.28.12.97.93.06,1.75-.02.02-.06.02-.09,0-.09-.08-.19-.2-.26-.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M307.67,291.46c-.04-.08-.02-.17,0-.25.03-.15.07-.31.17-.43.02.03.01.06,0,.1-.03.19-.05.38-.04.57,0,.05,0,.1,0,.15,0,.01,0,.03-.02.03-.02,0-.04-.01-.05-.03-.02-.03-.03-.06-.04-.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M306.88,290.98c-.08-.31.19-.84.21-.83.21.08.75.65.12,1.28-.02.02-.04.02-.06,0-.1-.08-.2-.21-.27-.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M306.94,291.15c.08.03.12.15.21.16.06,0,.1-.06.13-.11.06-.16.03-.34,0-.5-.03-.15-.05-.31-.14-.43-.03-.03-.06-.07-.05-.11,0,0,0,0,0,0,.21.08.75.65.12,1.28-.02.02-.04.02-.06,0-.07-.06-.15-.14-.21-.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "M306.95,290.96c-.03-.06-.02-.12-.02-.19.01-.11.04-.23.11-.32.01.02.01.05,0,.07-.01.14-.02.28,0,.42,0,.04,0,.07,0,.11,0,.01,0,.02-.01.03-.01,0-.03,0-.04-.02-.01-.02-.03-.05-.04-.07"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M306.49,290.87c.6.4,1.14.89,1.65,1.41.61.63,1.16,1.31,1.64,2.04.56.84,1.03,1.74,1.41,2.67.43,1.06.74,2.16.94,3.29.22,1.27.29,2.57.2,3.86-.01.17-.03.35-.05.52,0,.07-.11.07-.11,0,.05-1.3.02-2.61-.16-3.9-.16-1.13-.44-2.25-.84-3.32-.35-.95-.79-1.87-1.32-2.73-.46-.75-.99-1.47-1.58-2.12-.5-.55-1.04-1.05-1.62-1.5-.06-.05-.13-.1-.19-.14-.04-.03,0-.1.04-.07h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M310.52,306c-.8-7.94-6.17-12.76-8.53-14.13,2.01.57,10.22,4.9,10.28,14.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M303.4,292.63c1.12.75,2.16,1.61,3.09,2.57.93.96,1.76,2.02,2.41,3.18.66,1.16,1.17,2.41,1.56,3.69.39,1.28.65,2.6.79,3.94-.05-1.35-.25-2.69-.61-3.99-.36-1.3-.87-2.57-1.53-3.75-.67-1.18-1.52-2.26-2.49-3.2-.97-.94-2.06-1.76-3.22-2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M303.61,309.18s0-.01,0-.01,0,.01,0,.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M302.15,310.44c-.4-4.92-2.03-9.74-4.69-13.9,3.24,3.57,5.52,7.67,5.88,13.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M298.85,298.49c.31.49.59,1,.86,1.52.13.26.26.52.38.78l.18.4c.06.13.11.27.17.4.44,1.07.84,2.17,1.14,3.29.09.28.15.56.22.84l.11.42c.04.14.06.28.09.43l.18.85.14.86c.11.57.16,1.15.23,1.73l.03.22c0,.07.01.14.02.22l.03.43.06.87-.03-.87-.02-.44c0-.07,0-.15-.01-.22l-.02-.22c-.06-.58-.1-1.16-.2-1.74-.04-.29-.08-.58-.13-.86l-.17-.86c-.03-.14-.05-.29-.09-.43l-.11-.42-.11-.42c-.03-.14-.07-.28-.11-.42l-.25-.84c-.09-.28-.19-.55-.28-.83-.09-.28-.2-.55-.31-.82-.05-.14-.1-.27-.16-.41l-.17-.4c-.47-1.07-1-2.11-1.67-3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M304.23,308.54c-2.75-5.09-9.88-7.3-12.61-7.45,2.04-.41,11.33-.29,15.73,8.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M307.16,308.73c.39-9.02,5.62-12.47,5.62-12.47,0,0-3.8,4.35-4.02,12.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M302.41,309.68s0-.01,0-.01,0,.01,0,.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M293.22,301.12c1.34.16,2.65.45,3.92.88,1.27.43,2.49.99,3.6,1.74,1.11.74,2.14,1.61,3.07,2.57.93.97,1.77,2.02,2.5,3.15-.65-1.18-1.45-2.28-2.36-3.27-.91-1-1.94-1.89-3.07-2.64-1.13-.75-2.38-1.32-3.67-1.71-1.29-.4-2.63-.63-3.98-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M292.26,308.72c-2.75-5.09-9.88-7.3-12.61-7.45,2.04-.41,11.33-.29,15.73,8.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M281.26,301.3c1.34.16,2.65.45,3.92.88,1.27.43,2.49.99,3.6,1.74,1.11.74,2.14,1.61,3.07,2.57.93.97,1.77,2.02,2.5,3.15-.65-1.18-1.45-2.28-2.36-3.27-.91-1-1.94-1.89-3.07-2.64-1.13-.75-2.38-1.32-3.67-1.71-1.29-.4-2.63-.63-3.98-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M299.61,307.94c-.67-4.54-2.46-8.91-5.18-12.61,3.22,3.11,5.57,6.78,6.29,12.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M295.84,297.06c.32.44.61.89.88,1.36.13.23.27.47.4.71l.19.36c.06.12.12.24.18.36.48.97.9,1.96,1.25,2.98.1.25.17.51.26.77l.12.38c.04.13.07.26.11.39l.22.78.18.79c.13.52.21,1.06.32,1.59l.04.2c.01.07.02.13.03.2l.06.4.11.8-.08-.81-.04-.4c0-.07-.01-.13-.02-.2l-.03-.2c-.09-.53-.16-1.07-.28-1.6-.06-.26-.11-.53-.17-.79l-.21-.78c-.04-.13-.07-.26-.11-.39l-.12-.39c-.08-.26-.16-.52-.25-.77l-.28-.76c-.1-.25-.21-.5-.31-.75-.1-.25-.22-.49-.33-.74-.06-.12-.11-.25-.17-.37l-.19-.36c-.5-.96-1.06-1.89-1.73-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M311.51,297.65c-.33.36-.59.78-.85,1.19-.13.21-.24.42-.36.64-.11.22-.22.44-.33.65-.43.88-.77,1.8-1.07,2.73-.3.93-.54,1.88-.74,2.83-.1.48-.18.96-.26,1.44-.06.48-.13.97-.19,1.45.11-.48.2-.95.3-1.43l.33-1.42.18-.71.09-.35.1-.35.2-.7c.07-.23.15-.46.22-.69.3-.92.62-1.84,1.01-2.72l.3-.66c.11-.22.21-.44.33-.65.22-.43.47-.85.75-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M304.81,307.52c-2.04-8.79,2.08-13.51,2.08-13.51,0,0-2.5,5.21-.46,13.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M306.03,295.68c-.22.44-.37.91-.5,1.38-.07.23-.12.47-.18.71-.05.24-.1.48-.14.72-.18.96-.26,1.94-.3,2.92-.05.98-.01,1.96.04,2.93.03.49.09.97.13,1.46.07.48.13.97.21,1.45-.02-.49-.06-.97-.09-1.46l-.06-1.46v-.73s-.02-.36-.02-.36v-.36s0-.73,0-.73c0-.24.02-.48.03-.73.04-.97.11-1.94.25-2.9l.11-.72c.05-.24.08-.48.14-.71.1-.48.22-.95.39-1.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M298.14,292.6c-.28-.17-.88-.06-.88-.03.01.23.42.93,1.23.49.02-.01.03-.04.02-.06-.05-.12-.15-.26-.37-.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M298.29,292.71c0,.09.12.16.09.25-.02.06-.09.09-.15.09-.17.01-.34-.07-.5-.14-.14-.07-.29-.14-.38-.27-.03-.03-.06-.08-.1-.08,0,0,0,0,0,0,.01.23.42.93,1.23.49.02-.01.03-.04.02-.06-.03-.09-.1-.19-.22-.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M298.1,292.66s-.11-.06-.18-.07c-.12-.02-.24-.03-.35.01.02.02.04.02.07.03.14.03.28.07.42.12.03.01.07.03.1.04.01,0,.02,0,.03,0,.01-.01,0-.03,0-.04-.02-.02-.04-.04-.06-.06"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M298.69,293.29c-.41-.03-1,.44-.98.47.15.24.98.77,1.62-.17.02-.03.01-.06-.01-.08-.12-.1-.3-.2-.63-.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M298.91,293.32c.05.1.22.11.24.22.02.07-.05.14-.11.18-.18.11-.41.12-.62.13-.19,0-.39,0-.57-.07-.05-.02-.1-.05-.15-.03,0,0,0,0,0,0,.15.24.98.77,1.62-.17.02-.03.01-.06-.01-.08-.09-.08-.21-.15-.4-.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M298.68,293.38c-.08-.02-.16,0-.23.02-.14.05-.27.1-.37.21.03.01.06,0,.09,0,.17-.05.35-.09.52-.11.05,0,.09,0,.13-.02.01,0,.03-.01.03-.02,0-.02-.02-.03-.03-.04-.03-.01-.06-.02-.1-.03"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M299.62,293.92c-.49-.03-1.19.52-1.17.56.17.29,1.18.93,1.94-.2.02-.03.01-.07-.01-.1-.14-.12-.37-.24-.75-.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M299.89,293.96c.06.12.26.13.29.27.02.09-.05.17-.13.22-.22.14-.49.15-.75.16-.23,0-.47.01-.68-.09-.06-.03-.13-.06-.18-.03,0,0,0,0,0,0,.17.29,1.18.93,1.94-.2.02-.03.01-.07-.01-.1-.1-.09-.25-.17-.48-.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "M299.62,294.03c-.09-.03-.19,0-.28.03-.16.06-.33.12-.44.25.03.01.07,0,.11,0,.21-.06.41-.11.63-.13.05,0,.11,0,.16-.03.01,0,.03-.01.04-.03,0-.02-.02-.04-.04-.05-.04-.02-.07-.03-.11-.03"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M300.66,294.83c-.56-.04-1.35.59-1.33.64.2.33,1.34,1.05,2.2-.23.02-.03.02-.08-.01-.11-.16-.14-.41-.27-.85-.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M300.97,294.88c.07.13.3.15.33.3.02.1-.06.19-.15.25-.25.16-.55.17-.85.18-.26,0-.53.01-.77-.1-.07-.03-.14-.07-.21-.04,0,0,0,0,0,0,.2.33,1.34,1.05,2.2-.23.02-.03.02-.08-.01-.11-.12-.1-.29-.2-.54-.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M300.65,294.96c-.1-.03-.21,0-.32.03-.18.06-.37.14-.5.28.04.02.08,0,.12,0,.23-.07.47-.12.71-.15.06,0,.12,0,.18-.03.02,0,.04-.01.04-.03,0-.03-.02-.05-.05-.06-.04-.02-.09-.03-.13-.04"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M302.03,295.96c-.57-.11-1.48.43-1.46.47.16.36,1.24,1.27,2.3.06.03-.03.03-.08,0-.11-.15-.17-.39-.33-.84-.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M302.35,296.05c.06.15.29.2.3.36,0,.11-.09.19-.19.24-.28.13-.6.1-.9.07-.27-.03-.55-.06-.78-.21-.06-.04-.14-.09-.21-.07,0,0,0,0,0,0,.16.36,1.24,1.27,2.3.06.03-.03.03-.08,0-.11-.11-.12-.27-.24-.53-.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M302.01,296.09c-.1-.05-.22-.03-.33,0-.2.04-.4.09-.56.23.04.02.08.02.13,0,.25-.04.5-.06.76-.05.06,0,.13,0,.19,0,.02,0,.04-.01.05-.03.01-.03-.02-.05-.04-.06-.04-.02-.08-.04-.13-.06"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M303.28,297.38c-.59-.17-1.59.33-1.58.38.14.4,1.2,1.44,2.42.26.03-.03.04-.08,0-.12-.14-.19-.38-.38-.85-.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M303.6,297.49c.05.16.28.23.29.4,0,.11-.11.19-.22.23-.3.11-.63.05-.95,0-.28-.05-.58-.11-.8-.28-.06-.05-.14-.11-.21-.09,0,0,0,0,0,0,.14.4,1.2,1.44,2.42.26.03-.03.04-.08,0-.12-.1-.14-.26-.28-.53-.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M303.24,297.51c-.1-.06-.23-.05-.35-.04-.21.02-.43.07-.61.19.04.03.09.02.13.02.27-.02.54-.03.8,0,.07,0,.14.02.2.01.02,0,.04,0,.05-.03.01-.03-.01-.05-.04-.07-.04-.03-.08-.05-.13-.07"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M304.32,298.92c-.66-.21-1.82.31-1.8.37.14.46,1.3,1.68,2.73.39.04-.03.04-.09.02-.14-.15-.22-.42-.45-.94-.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M304.69,299.06c.05.18.31.28.31.47,0,.13-.13.22-.26.26-.35.11-.72.04-1.08-.04-.32-.07-.65-.15-.9-.35-.07-.06-.15-.13-.24-.11,0,0,0,0,0,0,.14.46,1.3,1.68,2.73.39.04-.03.04-.09.02-.14-.11-.16-.29-.33-.58-.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M304.28,299.07c-.12-.07-.26-.07-.4-.06-.24.02-.49.06-.7.19.04.03.1.03.15.03.3,0,.61,0,.91.04.08.01.15.03.23.02.02,0,.05,0,.06-.03.02-.03-.01-.06-.04-.08-.05-.03-.09-.06-.15-.09"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M305.28,300.65c-.71-.29-2.02.19-2.01.25.12.51,1.29,1.95,2.97.65.04-.03.06-.1.03-.15-.15-.25-.43-.53-.98-.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M305.66,300.83c.04.21.32.33.3.54-.01.14-.16.23-.3.26-.39.1-.8-.02-1.18-.13-.34-.1-.7-.21-.96-.46-.07-.07-.16-.15-.25-.14,0,0,0,0,0,0,.12.51,1.29,1.95,2.97.65.04-.03.06-.1.03-.15-.11-.18-.29-.38-.6-.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M305.21,300.8c-.12-.09-.28-.09-.43-.09-.27,0-.55.02-.78.15.04.04.1.04.16.04.33.02.67.04.99.12.08.02.17.04.25.04.02,0,.05,0,.07-.02.02-.03,0-.07-.04-.09-.05-.04-.1-.08-.15-.11"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M305.87,299.94c-.02-.76.89-1.83.95-1.79.44.29,1.37,1.89-.44,3-.05.03-.11.02-.15-.03-.18-.23-.34-.58-.36-1.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M305.91,300.36c.18.11.19.42.4.47.14.04.27-.07.35-.19.23-.33.26-.75.29-1.15.02-.36.05-.73-.09-1.06-.04-.09-.09-.2-.04-.29,0,0,0,0,0,0,.44.29,1.37,1.89-.44,3-.05.03-.11.02-.15-.03-.13-.17-.26-.41-.32-.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M306.04,299.93c-.04-.14.01-.3.06-.43.1-.25.21-.5.42-.67.02.05,0,.11-.02.17-.1.32-.2.64-.24.97-.01.08-.02.17-.05.25,0,.02-.02.05-.05.05-.04,0-.06-.03-.07-.07-.02-.06-.04-.12-.05-.18"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M304.83,298.31c-.02-.71.83-1.7.88-1.67.41.27,1.27,1.76-.41,2.8-.05.03-.11.02-.14-.02-.17-.21-.32-.54-.33-1.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M304.87,298.7c.17.1.18.39.37.44.13.03.25-.07.33-.18.21-.31.24-.7.27-1.07.02-.33.04-.68-.09-.99-.04-.09-.08-.19-.04-.27,0,0,0,0,0,0,.41.27,1.27,1.76-.41,2.8-.05.03-.11.02-.14-.02-.12-.16-.24-.38-.3-.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M304.99,298.3c-.04-.13,0-.27.06-.4.09-.23.2-.47.39-.63.02.05,0,.1-.02.15-.1.3-.18.6-.23.9-.01.08-.02.16-.05.23,0,.02-.02.04-.04.05-.03,0-.06-.03-.07-.06-.02-.05-.03-.11-.04-.17"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M303.74,296.84c-.06-.61.6-1.51.65-1.48.37.21,1.2,1.43-.17,2.42-.04.03-.09.02-.12-.01-.16-.17-.31-.44-.36-.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M303.8,297.18c.15.08.18.32.34.35.11.02.21-.07.27-.17.16-.28.17-.61.16-.93,0-.29,0-.59-.14-.84-.04-.07-.08-.15-.05-.23,0,0,0,0,0,0,.37.21,1.2,1.43-.17,2.42-.04.03-.09.02-.12-.01-.12-.12-.23-.31-.3-.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M303.87,296.83c-.04-.11,0-.24.03-.35.06-.2.14-.41.29-.56.02.04,0,.09,0,.13-.06.26-.12.52-.14.79,0,.07,0,.14-.02.2,0,.02-.01.04-.03.05-.03,0-.05-.02-.06-.05-.02-.05-.04-.09-.05-.14"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M302.5,295.36c-.06-.61.6-1.51.65-1.48.37.21,1.2,1.43-.17,2.42-.04.03-.09.02-.12-.01-.16-.17-.31-.44-.36-.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M302.55,295.7c.15.08.18.32.34.35.11.02.21-.07.27-.17.16-.28.17-.61.16-.93,0-.29,0-.59-.14-.84-.04-.07-.08-.15-.05-.23,0,0,0,0,0,0,.37.21,1.2,1.43-.17,2.42-.04.03-.09.02-.12-.01-.12-.12-.23-.31-.3-.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M302.63,295.35c-.04-.11,0-.24.03-.35.06-.2.14-.41.29-.56.02.04,0,.09,0,.13-.06.26-.12.52-.14.79,0,.07,0,.14-.02.2,0,.02-.01.04-.03.05-.03,0-.05-.02-.06-.05-.02-.05-.04-.09-.05-.14"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M300.96,294.23c-.18-.56.27-1.54.32-1.52.38.12,1.41,1.11.31,2.31-.03.03-.08.04-.12.01-.18-.13-.38-.36-.52-.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M301.08,294.54c.15.04.23.27.39.26.11,0,.18-.11.22-.21.1-.29.03-.61-.03-.91-.06-.27-.12-.55-.29-.76-.05-.06-.11-.13-.09-.2,0,0,0,0,0,0,.38.12,1.41,1.11.31,2.31-.03.03-.08.04-.12.01-.13-.09-.28-.24-.4-.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M301.08,294.19c-.06-.1-.05-.22-.04-.33.02-.2.05-.42.17-.59.03.04.02.08.02.13,0,.26-.01.51.03.77,0,.06.02.13.02.19,0,.02,0,.04-.02.05-.02.01-.05-.01-.07-.03-.03-.04-.05-.08-.07-.12"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M299.79,293.41c-.2-.51.15-1.45.2-1.44.37.09,1.39.94.44,2.13-.03.03-.07.04-.11.02-.18-.11-.37-.31-.53-.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M299.92,293.69c.15.03.23.23.38.22.1,0,.16-.12.19-.21.07-.28,0-.57-.09-.85-.07-.25-.15-.5-.32-.69-.05-.05-.11-.11-.1-.18,0,0,0,0,0,0,.37.09,1.39.94.44,2.13-.03.03-.07.04-.11.02-.13-.08-.27-.21-.4-.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M299.9,293.37c-.06-.09-.07-.2-.06-.31,0-.19.02-.39.12-.56.03.03.03.07.03.12,0,.24.02.48.08.71.01.06.03.12.03.18,0,.02,0,.04-.02.05-.02.01-.05,0-.07-.03-.03-.03-.05-.07-.07-.11"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M298.82,292.95c-.17-.37.05-1.07.09-1.07.27.05,1.06.63.41,1.55-.02.02-.05.03-.08.02-.14-.07-.29-.21-.42-.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M298.93,293.15c.11.02.18.16.29.15.07-.01.12-.09.13-.17.04-.21-.03-.42-.1-.62-.06-.18-.13-.36-.27-.5-.04-.04-.08-.08-.08-.13,0,0,0,0,0,0,.27.05,1.06.63.41,1.55-.02.02-.05.03-.08.02-.1-.05-.21-.14-.31-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M298.9,292.91c-.05-.06-.06-.15-.06-.22,0-.14,0-.29.06-.41.02.02.02.05.03.08.02.18.04.35.08.52.01.04.03.09.03.13,0,.01,0,.03-.01.04-.02.01-.04,0-.05-.02-.02-.02-.04-.05-.06-.08"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M298.32,292.91c.82.37,1.59.85,2.31,1.39.87.64,1.69,1.37,2.43,2.16.86.92,1.62,1.92,2.28,2.98.74,1.2,1.35,2.48,1.82,3.81.54,1.52.9,3.1,1.06,4.7.02.21.04.42.05.63,0,.07-.1.07-.11,0-.2-1.61-.51-3.21-1.01-4.76-.44-1.35-1.02-2.66-1.73-3.89-.63-1.09-1.36-2.12-2.2-3.07-.73-.82-1.53-1.59-2.39-2.26-.72-.56-1.49-1.07-2.3-1.49-.09-.05-.17-.09-.26-.13-.05-.02,0-.09.04-.07h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M286.32,298.1c-.24-.17-.77-.1-.77-.08,0,.2.31.83,1.05.49.02,0,.03-.03.02-.05-.03-.11-.11-.23-.3-.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M286.45,298.2c0,.08.09.15.07.23-.02.05-.08.07-.13.07-.15,0-.29-.08-.43-.15-.12-.07-.24-.14-.32-.25-.02-.03-.04-.07-.08-.07,0,0,0,0,0,0,0,.2.31.83,1.05.49.02,0,.03-.03.02-.05-.02-.08-.07-.17-.17-.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M286.28,298.15s-.1-.06-.15-.07c-.1-.02-.2-.04-.3,0,.01.02.04.02.06.03.12.03.24.07.36.13.03.01.06.03.09.04,0,0,.02,0,.03,0,0,0,0-.03,0-.04-.01-.02-.03-.04-.05-.05"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M286.76,298.73c-.35-.04-.89.33-.88.35.11.22.82.73,1.42-.06.02-.02.01-.05,0-.07-.1-.1-.26-.19-.53-.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M286.96,298.77c.04.09.18.11.2.21.01.07-.05.12-.11.15-.16.09-.36.09-.55.08-.17,0-.34-.01-.49-.09-.04-.02-.09-.05-.13-.03,0,0,0,0,0,0,.11.22.82.73,1.42-.06.02-.02.01-.05,0-.07-.07-.07-.18-.14-.34-.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M286.75,298.81c-.06-.03-.14,0-.21,0-.12.03-.24.08-.33.16.02.01.05,0,.08,0,.15-.03.31-.06.46-.07.04,0,.08,0,.12-.01.01,0,.02,0,.03-.02,0-.02-.01-.03-.03-.04-.03-.01-.05-.02-.08-.03"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M287.55,299.33c-.43-.05-1.07.39-1.05.42.14.26.98.87,1.7-.07.02-.03.02-.06,0-.08-.12-.11-.31-.22-.64-.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M287.78,299.38c.05.11.22.13.24.25.01.08-.06.15-.13.18-.2.11-.43.1-.66.1-.2,0-.41-.02-.59-.11-.05-.03-.11-.06-.16-.04,0,0,0,0,0,0,.14.26.98.87,1.7-.07.02-.03.02-.06,0-.08-.09-.08-.21-.17-.41-.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M287.53,299.43c-.08-.03-.17-.01-.25.01-.14.04-.29.09-.4.19.03.01.06,0,.09,0,.18-.04.37-.07.55-.08.05,0,.1,0,.14-.01.01,0,.03,0,.03-.02,0-.02-.01-.04-.03-.04-.03-.02-.06-.03-.1-.04"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M288.4,300.18c-.48-.06-1.21.44-1.19.48.16.3,1.11.99,1.93-.08.02-.03.02-.07,0-.1-.13-.13-.35-.25-.73-.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M288.67,300.24c.06.12.25.15.27.28.01.09-.06.17-.14.21-.22.12-.49.12-.75.11-.23,0-.47-.02-.66-.13-.06-.03-.12-.07-.18-.05,0,0,0,0,0,0,.16.3,1.11.99,1.93-.08.02-.03.02-.07,0-.1-.1-.1-.24-.19-.46-.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M288.39,300.29c-.09-.03-.19-.01-.28.01-.16.04-.33.1-.45.22.03.02.07,0,.11,0,.21-.04.42-.08.63-.09.05,0,.11,0,.16-.02.02,0,.03-.01.04-.03,0-.02-.02-.04-.04-.05-.04-.02-.07-.03-.11-.04"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M289.54,301.24c-.49-.13-1.31.29-1.3.33.12.33,1.01,1.17,2,.18.03-.03.03-.07,0-.1-.12-.15-.32-.31-.71-.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M289.81,301.34c.04.13.24.19.24.33,0,.09-.09.16-.18.2-.25.1-.52.05-.79,0-.23-.04-.48-.08-.67-.22-.05-.04-.11-.09-.18-.07,0,0,0,0,0,0,.12.33,1.01,1.17,2,.18.03-.03.03-.07,0-.1-.09-.11-.22-.23-.44-.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M289.51,301.35c-.09-.05-.19-.04-.29-.03-.18.02-.36.06-.5.17.03.02.07.02.11.02.22-.02.44-.03.66,0,.06,0,.11.01.17,0,.02,0,.03,0,.04-.02.01-.02-.01-.04-.03-.06-.03-.02-.07-.04-.11-.06"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M290.55,302.55c-.5-.18-1.41.2-1.4.24.1.35.96,1.32,2.09.35.03-.03.04-.07.01-.1-.11-.17-.31-.35-.71-.49Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M290.82,302.66c.03.14.24.22.23.37,0,.1-.11.16-.2.19-.27.08-.56.01-.83-.05-.24-.06-.5-.13-.69-.29-.05-.05-.11-.1-.18-.09,0,0,0,0,0,0,.1.35.96,1.32,2.09.35.03-.03.04-.07.01-.1-.08-.13-.21-.26-.44-.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M290.51,302.66c-.09-.06-.2-.06-.3-.05-.19.01-.38.03-.54.13.03.02.07.02.11.02.23,0,.47,0,.7.05.06.01.12.02.18.02.02,0,.04,0,.05-.02.01-.02,0-.05-.03-.06-.03-.03-.07-.05-.11-.07"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M291.37,303.95c-.57-.22-1.61.17-1.59.22.1.41,1.04,1.54,2.36.48.04-.03.04-.08.02-.12-.12-.2-.34-.41-.79-.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M291.68,304.09c.03.16.26.26.24.42,0,.11-.13.18-.24.21-.31.08-.63,0-.94-.09-.27-.08-.56-.16-.77-.36-.06-.05-.13-.12-.2-.11,0,0,0,0,0,0,.1.41,1.04,1.54,2.36.48.04-.03.04-.08.02-.12-.09-.15-.23-.3-.48-.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M291.32,304.07c-.1-.07-.22-.07-.34-.07-.21,0-.43.02-.62.13.03.03.08.03.13.03.27,0,.53.03.79.08.07.01.13.03.2.03.02,0,.04,0,.05-.02.02-.02,0-.05-.03-.07-.04-.03-.08-.06-.12-.08"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M292.11,305.5c-.6-.29-1.77.06-1.77.11.07.45,1.02,1.77,2.55.72.04-.03.05-.08.03-.13-.12-.23-.34-.48-.82-.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M292.43,305.69c.02.18.26.3.23.48-.02.12-.16.19-.28.21-.34.06-.69-.06-1.02-.18-.29-.11-.6-.22-.81-.45-.06-.06-.13-.14-.21-.14,0,0,0,0,0,0,.07.45,1.02,1.77,2.55.72.04-.03.05-.08.03-.13-.08-.17-.23-.35-.49-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M292.05,305.63c-.1-.08-.24-.1-.37-.1-.23-.01-.48-.01-.69.09.04.03.09.04.14.05.29.03.58.07.86.15.07.02.14.05.22.05.02,0,.05,0,.06-.02.02-.03,0-.06-.03-.08-.04-.04-.08-.07-.13-.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M292.67,304.92c.03-.67.88-1.54.92-1.51.37.28,1.09,1.73-.55,2.59-.04.02-.1,0-.13-.03-.15-.21-.27-.53-.25-1.05Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M292.68,305.29c.15.1.15.37.32.43.12.04.24-.05.32-.15.22-.28.27-.64.32-.99.04-.31.08-.63-.02-.93-.03-.08-.07-.18-.02-.25,0,0,0,0,0,0,.37.28,1.09,1.73-.55,2.59-.04.02-.1,0-.13-.03-.11-.15-.2-.37-.24-.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "M292.81,304.92c-.03-.13.03-.26.08-.38.1-.21.21-.43.4-.56.01.05,0,.1-.02.14-.11.27-.21.55-.26.83-.01.07-.03.15-.06.21,0,.02-.02.04-.04.04-.03,0-.05-.03-.06-.06-.02-.05-.03-.11-.03-.16"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M291.85,303.44c.02-.62.82-1.44.86-1.41.34.26,1.02,1.61-.51,2.42-.04.02-.09,0-.12-.03-.14-.19-.25-.49-.23-.98Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M291.86,303.79c.14.1.14.35.3.4.11.04.22-.05.29-.14.2-.26.25-.6.29-.92.04-.29.08-.59-.02-.87-.03-.08-.06-.17-.02-.23,0,0,0,0,0,0,.34.26,1.02,1.61-.51,2.42-.04.02-.09,0-.12-.03-.1-.14-.19-.34-.22-.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M291.99,303.44c-.02-.12.02-.24.07-.35.09-.2.2-.4.37-.53.01.04,0,.09-.02.13-.1.25-.19.51-.25.78-.01.07-.02.14-.05.2,0,.02-.02.04-.04.04-.03,0-.05-.03-.06-.06-.01-.05-.02-.1-.03-.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M290.98,302.1c-.02-.53.61-1.28.65-1.26.31.2.97,1.31-.28,2.1-.03.02-.08.01-.1-.02-.13-.16-.24-.4-.26-.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M291.01,302.4c.13.07.14.29.28.33.1.02.19-.05.24-.14.16-.23.18-.53.19-.81.01-.25.03-.51-.07-.74-.03-.06-.06-.14-.03-.2,0,0,0,0,0,0,.31.2.97,1.31-.28,2.1-.03.02-.08.01-.1-.02-.09-.12-.18-.28-.23-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M291.09,302.1c-.03-.1,0-.21.04-.3.06-.18.14-.35.29-.47.01.04,0,.08,0,.12-.07.22-.13.45-.16.68,0,.06-.01.12-.03.17,0,.02-.02.03-.03.04-.02,0-.04-.02-.05-.05-.02-.04-.03-.08-.03-.13"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M289.97,300.74c-.02-.53.61-1.28.65-1.26.31.2.97,1.31-.28,2.1-.03.02-.08.01-.1-.02-.13-.16-.24-.4-.26-.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M290.01,301.04c.13.07.14.29.28.33.1.02.19-.05.24-.14.16-.23.18-.53.19-.81.01-.25.03-.51-.07-.74-.03-.06-.06-.14-.03-.2,0,0,0,0,0,0,.31.2.97,1.31-.28,2.1-.03.02-.08.01-.1-.02-.09-.12-.18-.28-.23-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M290.09,300.74c-.03-.1,0-.21.04-.3.07-.18.14-.35.29-.47.01.04,0,.08,0,.12-.07.22-.13.45-.16.68,0,.06-.01.12-.03.17,0,.02-.02.03-.03.04-.02,0-.04-.02-.05-.05-.02-.04-.03-.08-.03-.13"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M288.7,299.67c-.12-.5.32-1.32.36-1.31.33.13,1.17,1.04.15,2.03-.03.03-.07.03-.1,0-.15-.12-.31-.33-.41-.72Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M288.78,299.95c.13.04.19.24.33.25.09,0,.17-.09.2-.18.1-.25.06-.53.02-.8-.04-.24-.07-.49-.21-.68-.04-.05-.09-.12-.07-.18,0,0,0,0,0,0,.33.13,1.17,1.04.15,2.03-.03.03-.07.03-.1,0-.11-.09-.23-.23-.32-.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M288.81,299.65c-.05-.09-.04-.19-.02-.29.03-.18.07-.36.18-.5.02.03.02.07.01.11-.02.22-.04.45-.02.67,0,.06.01.11,0,.17,0,.02,0,.03-.02.04-.02,0-.04-.01-.06-.03-.02-.03-.04-.07-.06-.11"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M287.72,298.9c-.15-.46.21-1.25.25-1.24.31.1,1.16.89.27,1.88-.02.03-.06.03-.09.01-.15-.1-.31-.29-.42-.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M287.82,299.15c.13.03.19.22.32.21.09,0,.15-.09.18-.18.08-.24.02-.5-.03-.74-.05-.22-.1-.45-.24-.62-.04-.05-.09-.1-.08-.16,0,0,0,0,0,0,.31.1,1.16.89.27,1.88-.02.03-.06.03-.09.01-.11-.08-.23-.2-.33-.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M287.82,298.87c-.05-.08-.05-.18-.04-.27.01-.17.04-.34.13-.48.02.03.02.07.02.1,0,.21,0,.42.03.62,0,.05.02.11.01.16,0,.02,0,.03-.02.04-.02.01-.04,0-.06-.03-.02-.03-.04-.06-.06-.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M286.9,298.44c-.13-.33.1-.93.13-.92.24.06.89.61.27,1.37-.02.02-.05.03-.07.01-.11-.07-.24-.2-.34-.46Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M286.98,298.62c.09.02.15.15.25.14.07,0,.11-.07.12-.14.05-.18,0-.37-.05-.55-.04-.16-.09-.32-.2-.45-.03-.03-.07-.07-.06-.12,0,0,0,0,0,0,.24.06.89.61.27,1.37-.02.02-.05.03-.07.01-.08-.05-.17-.14-.26-.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M286.97,298.41c-.04-.06-.04-.13-.04-.2,0-.12.01-.25.08-.36.02.02.02.05.02.07,0,.15.01.31.05.46,0,.04.02.08.02.12,0,.01,0,.02-.01.03-.01,0-.03,0-.04-.02-.02-.02-.03-.05-.05-.07"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M286.47,298.37c.69.37,1.34.83,1.94,1.33.73.61,1.4,1.28,2,2.01.7.85,1.31,1.76,1.83,2.73.58,1.09,1.05,2.24,1.38,3.42.39,1.35.62,2.76.67,4.16,0,.19,0,.37.01.56,0,.07-.1.07-.11,0-.09-1.42-.28-2.82-.63-4.2-.31-1.2-.74-2.37-1.29-3.49-.49-.98-1.07-1.92-1.75-2.79-.59-.76-1.24-1.47-1.96-2.1-.6-.53-1.24-1.01-1.92-1.43-.07-.04-.15-.09-.22-.13-.04-.03,0-.09.04-.07h0Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.06,265.47c-.36-.06-.72-.02-1.08-.04-.31-.02-.32-.03-.26-.32.32-1.42.87-2.76,1.35-4.12.35-.98.65-1.97.81-2.99.09-.61.02-1.2-.13-1.8-.06-.27-.14-.54-.22-.84-.11.08-.15.18-.2.27-.56,1.04-1.07,2.1-1.66,3.12-.97,1.68-1.93,3.35-2.82,5.07-.06.12-.14.18-.28.18-.81-.02-1.63-.03-2.44-.04-.15,0-.23-.05-.18-.22.08-.29.15-.59.22-.88.08-.31.23-.58.5-.76.77-.5,1.26-1.21,1.68-2.01.51-.94,1.12-1.83,1.51-2.84.58-1.49.99-3.03,1.36-4.59.05-.22-.06-.23-.21-.23-.67,0-1.34.05-1.99.19-.49.1-.98.22-1.49.26-.4.04-.79-.02-1.16-.17-.63-.25-1.26-.53-1.92-.73-.54-.16-1.09-.19-1.64-.24-.7-.06-1.4-.16-2.09-.28-.15-.03-.22,0-.25.16-.24,1.09-.43,2.19-.4,3.31.01.71-.05,1.4-.22,2.09-.17.72-.21,1.47-.44,2.17-.28.85-.27,1.73-.43,2.59-.12.68-.29,1.35-.48,2.01-.04.14-.11.27-.16.4-.14.32-.35.47-.72.45-.52-.03-1.04-.02-1.55,0-.18,0-.27-.06-.26-.25.01-.14,0-.27,0-.41.02-.21.08-.4.32-.45.07-.02.11-.07.14-.13.28-.58.56-1.17.85-1.75.28-.56.37-1.16.37-1.78.02-1.71-.09-3.42-.09-5.14,0-.55-.13-1.08-.26-1.61,0-.03-.03-.06-.05-.11-.38.44-.69.91-.97,1.39-.26.43-.48.88-.68,1.35-.27.64-.71,1.17-1.17,1.67-.6.65-1.24,1.28-1.68,2.07-.49.87-.87,1.78-1.28,2.69-.38.85-.81,1.67-1.4,2.4-.29.36-.64.55-1.07.62-.57.09-1.15.04-1.72.05-.13,0-.14-.07-.11-.17.09-.28.2-.54.34-.79.29-.52.68-.96,1.09-1.39.41-.43.85-.84,1.25-1.29.13-.14.13-.21-.05-.29-.38-.17-.75-.37-1.13-.54-.18-.08-.23-.2-.24-.38-.06-1.17.03-2.34,0-3.52,0-.21-.06-.38-.22-.51-.2-.17-.39-.34-.6-.5-.34-.26-.53-.59-.63-1-.18-.78-.29-1.59-.61-2.33-.28-.66-.59-1.31-.87-1.98-1.05-2.52-2.42-4.87-3.8-7.21-.35-.6-.78-1.14-1.27-1.62-.24-.23-.45-.49-.71-.69-.46-.36-.56-.86-.59-1.4-.04-.85.23-1.63.55-2.4.08-.18.15-.35.25-.58-.49.26-.89.55-1.27.87-.72.62-1.43,1.25-1.95,2.06-.25.39-.45.8-.64,1.22-.31.69-.63,1.37-.94,2.06-.21.47-.29.95-.3,1.47-.04,1.54-.02,3.08.02,4.62.03,1.37.1,2.73.21,4.09.03.38.15.75.27,1.11.04.13.08.26.13.39.37.88.36,1.76,0,2.64-.07.17-.05.31.05.48.67,1.12,1.03,2.34,1.07,3.64,0,.02,0,.04,0,.06.05.63.08.55-.51.73-.88.28-1.78.32-2.69.25-.48-.03-.96-.07-1.44-.1-.16,0-.24-.06-.25-.22-.06-.66-.14-1.31-.18-1.97-.04-.64.06-1.25.28-1.84.23-.62.22-1.22-.03-1.83-.33-.8-.33-1.64-.27-2.48.04-.44.03-.89.05-1.34.04-1.41.11-2.82.09-4.23-.02-1.58-.11-3.14-.32-4.71-.11-.8-.17-1.62-.37-2.41-.12-.5-.29-.98-.49-1.45-.42-.94-.36-1.91-.18-2.9.13-.73.45-1.32,1.06-1.75.26-.18.48-.41.72-.62,1.04-.95,1.61-2.13,1.79-3.52.18-1.41.07-2.83.09-4.25,0-.49-.07-.97-.18-1.45-.03-.14-.1-.24-.25-.29-2.06-.69-3.64-2.02-4.91-3.74-1.27-1.72-1.92-3.67-2.13-5.78-.22-2.13,0-4.23.45-6.32.21-.99.47-1.96.9-2.87.65-1.37,1.53-2.58,2.52-3.72.8-.92,1.69-1.76,2.79-2.32.94-.49,1.95-.82,2.96-1.13,1.27-.38,2.55-.7,3.84-.99.67-.15,1.36-.2,2.05-.23,1.48-.05,2.96.03,4.43.22.84.11,1.67.29,2.51.4.83.11,1.66.19,2.49.24,1.06.07,2.11.03,3.17.09,1.29.07,2.58.23,3.83.58.3.08.6.08.9.09.82.04,1.63.15,2.44.28.66.1,1.33.15,1.99.24.98.13,1.96.33,2.94.46,1.85.25,3.7.25,5.53-.16.55-.12,1.11-.23,1.67-.34.38-.08.74-.23,1.09-.4.36-.17.71-.35,1.06-.53.68-.36,1.4-.46,2.15-.42,1.33.06,2.6.38,3.83.86.97.38,1.67,1.08,2.29,1.88.67.87,1.25,1.8,1.92,2.66.86,1.1,1.76,2.17,2.65,3.24.95,1.13,1.69,2.38,2.22,3.75.6,1.53,1.19,3.06,1.47,4.69.18,1.09.31,2.19.27,3.3-.02.65-.09,1.29-.22,1.92-.04.18,0,.28.16.37.33.19.32.19.58-.09.89-.95.95-2.06.65-3.25-.19-.77-.52-1.49-.77-2.24-.19-.56-.33-1.12-.35-1.71-.02-.42.05-.83.18-1.23,0-.02.03-.04.05-.06.09.05.1.13.13.2.5,1.43,1.27,2.7,2.29,3.83.68.76,1,1.66,1.13,2.65.09.65.18,1.3.24,1.95.06.67-.15,1.29-.45,1.88-.38.76-.96,1.34-1.66,1.81-.23.15-.22.17-.05.38.39.46.77.93,1.16,1.39.54.63.86,1.35,1.06,2.15.11.46.26.91.28,1.39v.6c-.03.26-.06.51-.1.77-.21,1.35-.72,2.62-1.13,3.91-.02.05-.02.11-.08.11-.05,0-.07-.06-.1-.11-.04-.07-.08-.15-.13-.22-.05-.07-.07-.16-.19-.24.19.65.33,1.26.38,1.88.08.88,0,1.75-.22,2.61-.03.13-.09.16-.21.1-.17-.08-.34-.16-.51-.24-.44-.19-.75-.5-.98-.93-.34-.66-.64-1.34-.99-1.99-.33-.63-.71-1.22-1.24-1.7-.14-.13-.26-.14-.42-.04-.99.62-1.86,1.36-2.32,2.48-.39.95-.99,1.75-1.74,2.44-.28.26-.56.54-.8.85-.33.43-.54.89-.49,1.45.04.42.09.83.16,1.24.14.87.28,1.75.04,2.63-.01.04-.01.08,0,.13.26.61.43,1.25.57,1.9.52,2.34,1.28,4.58,2.47,6.67.24.43.42.89.56,1.36.06.2.16.39.29.55.2.26.46.48.68.72.26.28.52.59.54.99.03.8-.08,1.59-.56,2.27-.25.35-.56.6-1.01.67-.41.06-.83.11-1.24.06-.44-.05-.77-.21-1-.63-.36-.66-.63-1.34-.81-2.06-.06-.25-.02-.49.06-.72.08-.22.16-.45.24-.67.07-.21.03-.4-.11-.57-.5-.62-.79-1.33-.99-2.09q-.13-.51-.66-.4c-.57.12-1.14.17-1.69-.07-1.47-.66-2.32-2.24-2.06-3.84.15-.94.42-1.83.77-2.71.05-.13.06-.24,0-.37-.5-1.01-1.01-2.02-1.56-3.01-.13-.24-.27-.48-.41-.72-.04.08-.04.15-.04.22,0,.68,0,1.35,0,2.03,0,.99-.28,1.88-.9,2.66-.27.34-.54.69-.82,1.03-.47.59-.92,1.18-1.2,1.88-.18.44-.15.85.08,1.26.13.23.26.46.39.69.33.56.32,1.12,0,1.68-.14.24-.27.49-.4.74-.14.28-.21.57-.21.89,0,.91.25,1.77.55,2.62.32.89.69,1.75.89,2.68.03.14,0,.23-.1.32-.18.14-.35.3-.53.45-.53.43-1.11.77-1.8.87-.4.06-.79.05-1.13-.23-.14-.11-.3-.2-.45-.3-.07-.05-.14-.07-.21,0-.39.41-.79.81-.79,1.43,0,.17,0,.35-.02.52-.02.18,0,.36-.09.52h-.22ZM216.16,221.07c-.07-.52-.1-1-.12-1.48-.02-.44-.06-.88-.1-1.31-.06-.68-.29-1.32-.45-1.97-.49-1.88-.94-3.77-1.63-5.59-.48-1.28-1.09-2.47-2.1-3.43-.68-.64-1.28-1.36-1.86-2.1-1-1.29-1.97-2.61-3.05-3.84-.43-.49-.88-.96-1.55-1.11-1.2-.27-2.39-.56-3.62-.68-.57-.06-1.09.03-1.56.35-.54.37-.96.87-1.36,1.37-.12.15-.25.21-.44.2-1.09-.04-2.17.04-3.24.28-.35.08-.71.09-1.07.05-1.34-.15-2.68-.36-4.01-.58-1.63-.26-3.27-.47-4.92-.62-1.18-.11-2.36-.23-3.52-.47-.76-.16-1.51-.25-2.29-.23-.42.01-.85-.02-1.27-.05-1.12-.08-2.24-.16-3.35-.25-.55-.04-1.11-.07-1.65-.16-1.55-.25-3.1-.49-4.66-.56-1.71-.08-3.4.02-5.08.41-1.66.39-3.32.78-4.89,1.47-1.12.5-2.19,1.08-3.09,1.95-1.26,1.21-2.2,2.64-2.9,4.23-.82,1.89-1.39,3.83-1.35,5.92.02,1,0,2,.12,2.99.19,1.6.81,3.06,1.59,4.44,1.01,1.79,2.56,2.97,4.45,3.71.52.21,1.05.4,1.62.43.96.06,1.91.07,2.87.04.69-.03,1.39-.06,2.08-.2,2.63-.56,5.24-1.21,7.76-2.18,1.82-.7,3.68-1.29,5.59-1.69.42-.09.84-.18,1.28-.12.61.07,1.19.27,1.78.41.18.04.36.1.59.1-.25-.3-.49-.57-.77-.8-.19-.15-.39-.23-.63-.25-.74-.07-1.47-.01-2.19.13-1.04.21-2.04.54-3.05.86-2.05.66-4.09,1.37-6.16,2-2.02.61-4.07,1-6.19.99-1.04,0-2.09.02-3.13-.09-.74-.08-1.46-.25-2.12-.62-.96-.53-1.68-1.31-2.34-2.17-1.49-1.92-2.3-4.08-2.25-6.54.02-.74,0-1.48.03-2.22.06-1.24.25-2.46.7-3.63.74-1.91,1.91-3.49,3.66-4.59.72-.45,1.52-.73,2.29-1.05,1.02-.43,2.07-.79,3.17-.99.1-.02.2-.05.31-.03-.03.1-.1.12-.16.16-.34.25-.67.49-1.01.74-.77.56-1.55,1.11-2.15,1.85-.76.93-1.42,1.92-1.95,2.99-.44.89-.76,1.82-.8,2.82-.04,1.19-.09,2.39-.02,3.58.06.94.16,1.86.43,2.76.57,1.92,1.16,3.84,1.58,5.81.03.14.09.2.24.23,1.53.27,3.08.28,4.62.2.44-.02.89-.03,1.33-.11,1.13-.19,2.23-.5,3.33-.82,2.13-.62,4.23-1.37,6.35-2.02,1.07-.33,2.15-.66,3.26-.82.54-.08,1.09-.1,1.63-.18.79-.1,1.54-.37,2.31-.55.33-.08.65-.08.98,0,.94.24,1.77.67,2.45,1.38.47.5.99.94,1.56,1.32.37.26.72.55,1.05.86.06.05.16.1.14.18-.02.08-.13.07-.2.09-.31.07-.63.14-.99.22.24.16.44.29.63.42.04.03.12.05.1.12-.02.07-.09.05-.15.06-.45.07-.9.14-1.34.2-1.05.14-2.1.21-3.16.07-.87-.12-1.63-.45-2.23-1.11-.28-.3-.58-.58-.84-.9-.3-.38-.68-.45-1.1-.35-1.1.24-2.2.46-3.26.83-2.69.94-5.39,1.83-8.14,2.59-1.78.49-3.58.8-5.43.75-.52-.01-1.05-.01-1.58,0-.35,0-.68.1-.99.26-.17.08-.2.16-.08.33.28.4.47.82.44,1.33-.06.93-.04,1.85-.11,2.78-.09,1.17-.27,2.31-.61,3.43-.19.63-.53,1.16-1.05,1.57-.27.22-.54.43-.82.63-.32.24-.64.49-.92.79-.22.23-.36.49-.42.81-.11.57-.07,1.13.04,1.69.12.67.33,1.31.49,1.97.39,1.59.52,3.22.55,4.85.03,1.55.07,3.1.19,4.65.09,1.19.01,2.38-.12,3.57-.04.4-.15.79-.05,1.2.09.36.24.69.4,1.02.53,1.18.54,1.19-.02,2.3-.35.69-.41,1.4-.36,2.14.02.25.04.5.18.72.08.11.15.22.31.24.6.08,1.19.03,1.79.04.1,0,.14-.04.12-.15-.19-.97-.53-1.84-1.44-2.37-.12-.07-.25-.14-.36-.27.06,0,.09-.01.11,0,.56.14,1.12.28,1.67.42.11.03.16.1.2.2.1.27.2.54.32.8.09.21.18.42.35.65.01-.85-.16-1.59-.56-2.28-.23-.4-.33-.83-.35-1.28-.01-.33.03-.66.06-.99.04-.57.06-1.13-.11-1.69-.21-.68-.29-1.39-.34-2.1-.05-.65-.05-1.31-.14-1.96-.19-1.33-.23-2.66-.24-4,0-.85,0-1.7,0-2.55,0-.17,0-.34.03-.52.11-.69.41-1.3.73-1.9.47-.86.89-1.74,1.2-2.67.09-.27.22-.53.36-.78.1-.18.22-.34.38-.46,1.36-.98,2.69-2,4.07-2.95,2.06-1.42,3.8-3.14,5.2-5.21.24-.36.3-.73.22-1.13-.06-.33-.15-.66-.21-.99-.04-.24-.1-.48-.05-.75.04.03.05.04.06.05.07.12.14.23.21.35.48.88,1.05,1.65,1.91,2.21,1.5.98,3.11,1.68,4.82,2.16,1.97.55,3.95,1,6.02,1.02,2.29.02,4.57-.03,6.83-.47,1.1-.21,2.21-.29,3.33-.19.09,0,.18,0,.28.09-.75.34-1.52.58-2.18,1.06.92-.02,1.81.13,2.71.23.51.06.95.22,1.32.57.06.06.12.14.23.16.04-.3-.04-.59-.02-.87.02-.24-.1-.3-.3-.31-.27-.01-.55-.03-.82-.06-.1,0-.21-.01-.19-.17.03-.34.05-.69.08-1.03.04-.39.24-.72.36-1.08.22-.69.46-1.38.7-2.07.04-.11.08-.22.17-.3.5-.43.99-.87,1.63-1.12.88-.34,1.7-.81,2.45-1.4.51-.4,1.05-.76,1.65-1.02.82-.35,1.68-.41,2.55-.47.16-.01.22-.04.16-.21-.11-.33-.19-.66-.29-.99-.31-1.07-.6-2.14-.54-3.26.05-1.05.35-2.02,1.03-2.85.64-.79,1.44-1.38,2.3-1.9.88-.54,1.77-1.05,2.53-1.76.31-.29.63-.56.96-.84.05-.04.1-.11.16-.08.07.03.04.11.04.18.04.95-.35,1.73-.92,2.45-.5.62-1.08,1.15-1.62,1.74-.48.53-.87,1.13-1.11,1.81-.1.27-.12.54-.08.83.08.55.34,1.02.57,1.51.07.15.15.16.29.1.33-.16.67-.29,1.03-.38.64-.16,1.24-.09,1.77.34.22.18.44.34.67.51.3.22.62.39.99.45.18.03.26-.03.24-.21-.02-.19-.03-.39-.04-.58-.04-.57-.07-1.13-.12-1.7-.06-.73-.09-1.45.03-2.17.08-.51.23-1.01.31-1.52.15-.95.04-1.9.03-2.84,0-.84.05-1.67.37-2.46.03-.07.03-.16.13-.19.02.05.04.1.05.14.11.65.19,1.3.22,1.95.06,1.51-.05,3.02-.28,4.51-.22,1.46-.22,2.92-.24,4.39,0,.15.06.17.18.13.25-.08.51-.15.77-.23.74-.2,1.48-.3,2.24-.16.33.06.62.22.96.39ZM179.58,245.99c.22.54.33,1.1.3,1.68-.04.69-.2,1.37-.46,2.01-.73,1.81-1.37,3.65-2.04,5.48-.39,1.06-.75,2.13-1.05,3.22-.02.06-.08.14.03.19.07.03.1-.04.13-.09,1.03-1.5,2.18-2.91,3.02-4.54.79-1.52,1.91-2.82,2.95-4.17.43-.56,1-.87,1.65-1.07.13-.04.19-.02.16.13-.08.38-.14.76-.21,1.14-.02.11-.02.21.1.27.65.34,1.32.6,2.07.58.35,0,.7,0,1.05.06.79.13,1.55.38,2.32.56.75.18,1.51.31,2.28.17,1.33-.25,2.67-.37,4.03-.36q.57,0,.75.55s0,.01,0,.02c.33,1.11.88,2.12,1.48,3.11.47.78.61,1.63.48,2.53-.13.93-.37,1.83-.66,2.72-.27.84-.55,1.68-.73,2.55-.01.07-.06.16.02.2.09.04.11-.07.15-.12.21-.3.36-.64.45-1,.3-1.18.73-2.32,1.11-3.47.38-1.17.84-2.3,1.6-3.28.13-.16.22-.35.33-.53.09-.15.11-.3.07-.47-.1-.46-.3-.89-.47-1.32-.35-.88-.23-1.71.22-2.52.36-.65.85-1.19,1.31-1.77.46-.58.87-1.18,1.04-1.92.21-.97.33-1.94.23-2.93-.08-.78-.29-1.51-.64-2.2-.09-.18-.2-.2-.36-.11-.15.09-.29.19-.41.31-.13.13-.26.25-.39.38-.35.34-.75.51-1.25.46-.81-.08-1.55-.35-2.2-.86-.15-.12-.18-.29-.2-.46-.02-.19-.04-.39-.04-.58,0-.19-.06-.2-.22-.15-.6.19-1.18.45-1.77.69-1,.41-2.01.49-3.05.15-.64-.21-1.28-.43-1.91-.68-1.34-.54-2.72-.85-4.16-.79-.88.03-1.75.04-2.62-.1-.75-.12-1.48-.33-2.09-.8-.45-.34-.75-.81-1.04-1.28-.39-.64-.8-1.26-1.4-1.74-.3-.24-.56-.56-.7-.92-.12-.31-.33-.43-.61-.51-.32-.09-.65-.14-.98-.15-.75-.02-1.51-.02-2.26.04-.15.01-.29.04-.34.21-.02.07-.08.12-.16.13-.23.04-.45.07-.68.06-.56-.03-1.09-.21-1.63-.3-.38-.07-.68.04-.9.35-.19.26-.3.55-.45.83-.06.12-.05.19.08.25.44.22.87.45,1.3.68.32.17.58.4.8.68.24.3.47.6.7.9.42.54.99.92,1.48,1.38.38.35.66.75.79,1.28.18.79.3,1.6.68,2.33.27.52.52,1.04.79,1.56.52.96.89,2,1.29,3.01.03.07.02.16.13.19.31-.59.47-1.24.71-1.86ZM203.72,235.21s-.02.02-.03.02c.05.27.09.54.14.81q.07.38.46.45t.27.4c-.03.1-.06.19-.07.29-.03.17-.13.21-.28.17-.35-.07-.7-.14-1.06-.21-.05-.01-.12-.06-.16-.01-.05.06,0,.12.03.18.17.38.43.7.65,1.04.24.37.43.75.47,1.19.01.13.07.17.19.16.28-.02.56-.02.84-.05.57-.07.95-.36,1.1-.94.14-.52.24-1.05.36-1.58.16-.76.38-1.49.84-2.13.03-.04.06-.13.12-.11.08.02.05.11.05.17,0,.35.01.71,0,1.06,0,.18.07.25.23.25.21,0,.42,0,.63.02.23.03.42-.02.59-.18.39-.34.87-.45,1.35-.58.07-.02.19-.05.15.08-.09.36-.09.73-.21,1.08-.08.23-.23.37-.47.43-.38.1-.77.17-1.16.22-.26.04-.27.03-.2-.24.05-.21.1-.41.15-.62-.23.13-.4.31-.55.49-.64.8-.96,1.74-1.17,2.73-.04.17,0,.28.13.39.43.39.86.79,1.27,1.2.14.14.2.14.32-.02.92-1.28,1.59-2.67,1.88-4.22.01-.07,0-.15.1-.19.06.64.13,1.27.19,1.91.03,0,.05,0,.06-.01.51-.56.92-1.19,1.26-1.88.06-.12,0-.17-.1-.21-.22-.1-.44-.2-.66-.31-.06-.03-.16-.04-.15-.13,0-.07.09-.08.15-.11.44-.21.9-.39,1.32-.64.97-.57,1.62-1.37,1.77-2.51.13-.94.28-1.88.53-2.79.12-.42.12-.84,0-1.26-.15-.56-.28-1.11-.42-1.67-.02-.07-.05-.13.02-.26.03.05.04.08.06.11.28.41.57.81.81,1.25.25.46.39.94.31,1.47-.09.6-.22,1.2-.27,1.81-.05.59-.02,1.17.25,1.71.69,1.37,1.45,2.7,2.05,4.11.18.42.47.77.92.96.14.06.19.04.2-.12.02-.55.05-1.09.07-1.64.03-.67.1-1.34.27-1.98.25-.99.49-1.98.57-3,.12-1.5-.09-2.92-.97-4.2-.62-.89-1.19-1.81-1.7-2.78-.09-.17-.06-.24.12-.31.63-.23,1.15-.62,1.57-1.14.79-.98,1.08-2.11.92-3.35-.09-.7-.41-1.32-.81-1.92-.05.1-.04.18-.03.25,0,.55,0,1.11-.03,1.66-.03.45-.07.89-.3,1.29-.13.23-.26.47-.38.7-.31.58-.63,1.16-.66,1.85,0,.04,0,.1-.05.11-.06.02-.09-.04-.12-.08-.28-.31-.56-.62-.84-.93-.69-.78-1.55-1.2-2.61-1.14-.76.05-1.46.3-2.13.64-.77.39-1.49.87-2.22,1.34-.06.04-.12.11-.22.09.07-.28.22-.51.37-.75.13-.2.26-.4.32-.63.03-.12.02-.22-.07-.32-.7-.77-2.18-.85-2.97-.18-.37.32-.67.69-.95,1.09-.5.72-1.03,1.41-1.69,1.98-.24.21-.46.44-.7.64-.52.44-.51,1.05-.55,1.7.54-.31,1.04-.6,1.56-.9,0,.13-.08.18-.13.24-.91,1.14-1.72,2.34-2.3,3.69-.27.62-.53,1.25-.83,1.85-.4.79-.85,1.57-1.65,2.06.47-.08.92.03,1.37.18.73.24,1.47.41,2.25.25.06-.01.12-.01.14.06.04.15.17.15.28.15.29.02.57.04.86.05.34.01.34.01.34.34-.01.58.11.46-.52.55-.19.03-.31-.03-.42-.19-.12-.18-.26-.34-.39-.51ZM176.01,256.53c.13-.34.24-.67.38-.98.73-1.68,1.25-3.43,1.84-5.15.24-.7.24-1.37-.1-2.04-.21-.42-.37-.86-.42-1.33-.03-.29-.12-.54-.26-.79-.5-.86-1.05-1.69-1.47-2.59-.04-.09-.16-.08-.18-.21-.06-.35-.15-.69-.21-1.03-.12-.63-.23-1.27-.47-1.88-.13-.32-.32-.56-.64-.73-.78-.42-1.44-.97-1.92-1.75-.54-.9-1.44-1.29-2.44-1.45-.11-.02-.19.02-.23.14-.29.83-.4,1.7-.3,2.57.12,1.02.32,2.03.45,3.04.21,1.65.58,3.26,1.09,4.85.52,1.61,1.09,3.2,1.97,4.66.66,1.1,1.38,2.15,1.93,3.31.24.5.58.94.98,1.36ZM194.39,240.2c.69.06,1.3-.11,1.89-.35.1-.04.16-.09.15-.22-.08-.68-.21-1.35-.34-2.02-.21-1.05-.72-2.02-.86-3.09-.01-.09-.07-.13-.17-.09-.96.33-1.89.15-2.8-.21-.6-.23-1.16-.54-1.72-.85-.1-.05-.2-.1-.32-.11-.64,0-1.28.01-1.91.12-.84.15-1.68.26-2.53.26-1.22,0-2.43.02-3.65-.02-1.13-.04-2.23-.21-3.32-.48-.99-.24-1.95-.55-2.9-.9-.17-.06-.28-.04-.38.11-.19.27-.4.51-.55.8-.03.05-.09.1-.04.15.04.05.11,0,.16,0,.38-.06.73-.23,1.11-.3.45-.08.9-.13,1.34.02.07.02.16.03.17.11,0,.11.08.12.15.15.89.36,1.76.78,2.61,1.24.78.43,1.56.87,2.25,1.45.05.04.14.08.11.16-.03.07-.11.05-.17.06-.43.06-.85.12-1.28.17-.15.02-.17.06-.11.19.21.39.42.79.67,1.16.13.19.28.35.48.46.77.42,1.58.74,2.47.76.7.02,1.4,0,2.09,0,.36,0,.72-.01,1.08.02.85.08,1.67.29,2.49.52,1.28.36,2.56.75,3.86.71ZM165.32,235.65c-.09.05-.09.12-.11.18-.31.79-.65,1.57-1.09,2.3-.27.44-.34.91-.36,1.42-.02.48.13.78.55,1.01.74.41,1.28,1.02,1.68,1.78.75,1.42,1.46,2.87,2.29,4.26.92,1.55,1.59,3.22,2.37,4.84.38.79.71,1.61.8,2.49.06.61.35,1.06.77,1.47.17.17.33.34.5.5.17.16.24.36.27.59.07.6.03,1.19.04,1.79,0,.42-.01.85.04,1.27.07.54.55.93,1.09.86.13-.02.24-.07.32-.19.2-.31.35-.64.38-1.02.02-.31.17-.55.43-.71.11-.07.2-.16.23-.28.11-.42.13-.83-.16-1.19-.38-.48-.76-.96-1.1-1.47-1.67-2.54-2.85-5.32-3.89-8.16-.69-1.91-1.16-3.88-1.55-5.87-.12-.58-.24-1.17-.3-1.76-.06-.59-.06-1.19-.02-1.79.03-.41.04-.82.06-1.23,0-.19-.06-.19-.19-.1-.28.18-.56.35-.84.53-.15.11-.25.09-.38-.04-.4-.4-.87-.66-1.45-.67-.12,0-.18-.06-.2-.18-.05-.21-.1-.43-.16-.65ZM157.94,204.17c-.36.03-.63.12-.87.29-1.88,1.29-3.27,2.95-3.9,5.18-.21.77-.46,1.53-.53,2.33-.08.91-.03,1.82,0,2.74,0,.22.02.45.05.67.34,2,1.11,3.81,2.42,5.38.42.5.85.98,1.41,1.33.05.03.1.09.15.06.07-.04.04-.12.03-.18-.05-.41-.09-.81-.19-1.21-.43-1.67-.95-3.31-1.31-5-.31-1.46-.56-2.91-.35-4.42.18-1.33.53-2.62.99-3.87.34-.94.94-1.73,1.53-2.52.18-.24.36-.48.57-.77ZM208.7,242.61c-.02.17-.04.27-.05.38-.1.78-.17,1.56-.35,2.32-.14.59-.37,1.15-.55,1.73-.18.59-.17,1.14.22,1.66.21.27.37.58.55.88,1,1.7,1.77,3.49,2.13,5.43.05.26.15.49.31.7.19.25.39.49.59.74.08.1.13.21.1.34-.03.18-.06.37-.1.55-.07.3-.18.6-.22.9-.11.81.31,1.45.75,2.07.04.06.12.08.19.08.4,0,.81,0,1.21,0,.16,0,.22-.08.18-.24-.08-.34-.15-.67-.23-1.01-.09-.37-.3-.65-.61-.85-.33-.22-.66-.44-.99-.66-.07-.05-.15-.08-.18-.2.46,0,.9,0,1.35,0,.17,0,.28.06.35.22.21.44.43.88.74,1.26.13.17.27.35.48.47-.03-.2-.06-.38-.09-.56-.09-.55-.38-.99-.77-1.37-.48-.47-.83-1-1.04-1.64-.18-.57-.44-1.12-.68-1.68-.58-1.33-1.2-2.64-1.7-4.01-.32-.88-.51-1.76-.42-2.7.03-.31.05-.63.09-.94,0-.06.02-.18,0-.17-.18.02-.14-.14-.17-.22-.25-.65-.38-1.34-.55-2.02-.12-.49-.25-.97-.53-1.47ZM167.51,236.24c.19-.18.35-.32.5-.49.11-.11.22-.15.37-.12.54.08,1.08.13,1.63.12.34,0,.33,0,.29-.34-.05-.58,0-1.15.34-1.65.16-.23.36-.44.67-.46.23-.02.44.06.64.16.23.11.44.24.67.34.12.06.25.1.37.01.69-.48,1.2-1.09,1.43-1.91.04-.13-.01-.18-.13-.21-.51-.14-1-.36-1.47-.62-.5-.28-1-.57-1.49-.87-.2-.12-.34-.15-.49.06-.1.15-.24.26-.36.4-.75.84-1.52,1.65-2.38,2.37-.56.47-1.13.94-1.63,1.47-.28.29-.33.66-.37,1.05.35-.2.67-.39.99-.57.25-.14.29-.12.32.18.03.35.06.7.1,1.07ZM196.4,231.41c-.4-.02-.92.07-1.45.05-.09,0-.14.03-.18.12-.09.21-.08.27.15.31.31.05.44.23.54.52.72,2.15,1.32,4.33,1.71,6.57.09.5.09.49.59.41.19-.03.22-.1.18-.27-.19-.77-.23-1.56-.22-2.36,0-.53.07-1.06.06-1.59-.02-.73.32-1.22.95-1.52.3-.15.61-.28.92-.44.24-.12.47-.26.61-.5.23-.36.4-.75.58-1.13.07-.15,0-.18-.13-.16-.41.08-.83.07-1.25.08-.98.02-1.95-.09-3.06-.1ZM196.16,252.88c-.06.04-.06.09-.08.14-.82,2.91-1.94,5.68-3.56,8.25-.36.57-.75,1.12-1.32,1.52-.03.02-.06.04-.08.07-.04.05-.07.12-.05.18.03.07.1.04.15.04.31-.03.62-.05.93-.04.13,0,.22-.04.29-.14.16-.23.34-.45.5-.68.85-1.27,1.55-2.62,2.29-3.95.61-1.09,1.14-2.22,1.57-3.4.03-.08.07-.15.05-.25-.16-.61-.42-1.17-.7-1.73ZM181.01,263.66c.21.07.37.02.48-.16.27-.45.52-.93.63-1.43.16-.72.3-1.44.46-2.17.2-.89.32-1.8.57-2.67.14-.48.19-.96.16-1.44-.04-.64,0-1.28,0-1.92.01-.67.06-1.33.12-2,.04-.41.06-.82.09-1.22,0-.09.02-.21-.14-.15-.61.24-1.07.64-1.2,1.31-.1.53-.06,1.07-.04,1.61.03.91.11,1.82.05,2.74-.04.67.01,1.34.04,2,.04.88.04,1.76-.13,2.62-.21,1.01-.55,1.98-1.1,2.88ZM201.4,228.18s-.02-.03-.04-.05c-.07.02-.15.05-.22.07-.69.24-1.38.46-2.09.6-.45.08-.91.11-1.36.24-.82.25-1.57.63-2.33,1.03-.06.03-.11.07-.13.13-.1.32-.21.64-.31.96.07.02.09-.03.12-.05.63-.55,1.38-.67,2.18-.64.8.03,1.6.17,2.41.15.37-.01.71-.08,1.04-.24.44-.21.79-.52,1.08-.97-.59.18-1.1.43-1.66.61.46-.6.95-1.17,1.3-1.83ZM206.12,251.83c0-.19,0-.35,0-.52-.01-.69.01-1.38.24-2.04.44-1.31.87-2.62,1.3-3.93.27-.81.43-1.64.32-2.5-.1-.83-.43-1.53-1.09-2.06-.3-.24-.64-.32-1.01-.12-.05.03-.13.04-.13.1,0,.08.09.08.14.11.22.11.44.21.66.32.35.17.6.44.75.8.12.31.23.63.36.95.07.18.02.23-.16.22-.7-.01-1.41.02-2.11-.04-.24-.02-.26,0-.16.23.31.65.62,1.3.94,1.94.23.46.23.46.74.36.29-.06.3-.04.21.25-.37,1.13-.76,2.26-1,3.43-.14.67-.26,1.34-.24,2.03,0,.18.05.33.24.47ZM206.43,215.92c-.39.19-.73.45-1.04.73-1.06.95-1.6,2.1-1.4,3.55.13.9.43,1.75.78,2.59.06.14.11.11.19.02.32-.35.63-.71.93-1.08.09-.11.08-.19.02-.31-.16-.3-.32-.6-.46-.9-.2-.43-.35-.86-.37-1.34-.03-.74.19-1.4.55-2.03.24-.42.54-.81.8-1.23ZM200.18,241.81c.59.03,1.06-.32,1.35-.95.21-.45.27-.94.35-1.42.02-.13-.03-.19-.17-.18-.48.06-.95.12-1.44.13-.13,0-.19.09-.23.2-.1.25-.2.51-.3.76-.18.44-.1.44-.53.19q-.47-.28-.8.14c-.05.07-.1.14-.16.2-.07.08-.05.14.03.2.52.4,1.08.71,1.89.72ZM207.96,252.11s0,.01,0,.02c.26,0,.52-.02.78,0,.15.01.16-.03.13-.15-.31-1.08-.89-2-1.66-2.81-.08-.09-.13-.1-.17.04-.06.25-.14.5-.19.75-.14.66-.17,1.32.11,1.97.06.13.13.19.27.18.24,0,.49,0,.73,0ZM202.63,225.21c-.06,0-.09,0-.12,0-.99.26-1.89.69-2.68,1.34-.31.26-.65.48-1.01.66-.57.29-1.18.5-1.76.76-.52.23-1.03.48-1.46.86-.21.19-.32.52-.27.83.09-.1.17-.2.26-.3.46-.51.97-.94,1.63-1.18,1.51-.54,2.97-1.2,4.42-1.88.48-.23.76-.61.99-1.09ZM198.66,261.27c0,.3.02.55.08.8.04.18.14.27.31.31.34.09.68.1,1.02.1.18,0,.27-.02.22-.23-.04-.15-.03-.31-.06-.47-.14-.73-.46-1.34-1.07-1.78-.11-.08-.17-.08-.22.05-.17.41-.31.82-.28,1.22ZM203.39,241.48c1.02.81,2.16,1.02,3.42,1-.32-.44-.64-.81-.96-1.18-.12-.14-.21-.35-.38-.4-.17-.05-.35.1-.52.16-.5.17-1,.3-1.56.42ZM200.2,257.41s-.04.01-.05.02c-.44.69-.73,1.45-1.04,2.2-.04.1.02.12.11.12.29.01.59.03.88.04.44,0,.44,0,.57.43.01.05.03.1.04.15.1.37.14.76.29,1.12.07.16.13.32.32.42,0-.26-.05-.49-.09-.73-.09-.61-.19-1.23-.52-1.76-.25-.4-.34-.83-.39-1.28-.03-.25-.04-.5-.12-.74ZM172.27,264.38c.39-.03.77.02,1.04-.33.34-.42.71-.83,1.06-1.25.07-.08.16-.18,0-.27-.12-.07-.22-.24-.4-.05-.49.54-.99,1.06-1.49,1.59-.08.08-.16.16-.23.3ZM200.97,236.68h0c0-.12,0-.24,0-.37,0-.08-.03-.14-.12-.15-.38-.06-.76-.13-1.15-.14-.14,0-.14.05-.08.15.09.16.18.31.26.47.13.28.35.41.65.46.45.07.45.08.45-.37,0-.02,0-.04,0-.06ZM174.9,261.65c.3-.67.59-1.32.9-1.96.11-.23.05-.4-.05-.6-.08.08-.1.18-.13.26-.21.51-.4,1.03-.63,1.54-.11.25-.17.48-.09.77ZM199.06,234.65c-.17.1-.34.1-.35.32-.06,1.04-.12,2.08-.09,3.12,0,.29.08.34.37.26-.44-.85-.42-2.69.07-3.7ZM204,240.52c-.45-.3-.91-.46-1.44-.43.22.39.87.58,1.44.43ZM196.83,264.37c0-.12.04-.32-.1-.37-.14-.04-.24.14-.34.25,0,.01-.02.02-.02.04-.17.24-.15.3.14.36q.32.07.32-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.43,208.53c-.28-.23-.57-.46-.84-.7-1.4-1.24-2.8-2.48-4.19-3.73-.45-.4-.81-.87-1.11-1.4-.03-.06-.09-.12-.08-.23,1.02.46,1.77,1.28,2.66,1.89-.1-.29-.29-.52-.49-.74-.44-.48-.97-.83-1.47-1.23-.04-.04-.09-.07-.14-.11-.08-.08-.27-.13-.23-.25.03-.1.22-.07.33-.08.8-.05,1.43.29,1.97.85.35.36.64.77.81,1.24.45,1.21,1.16,2.28,1.94,3.3.29.38.58.77.87,1.15-.01.02-.03.03-.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.45,237.52c.12,0,.23.04.31.13.08.1.17.21.08.32-.09.1-.21.23-.39.18-.14-.05-.28-.1-.43-.15-.15-.04-.17-.12-.07-.23.13-.16.29-.25.5-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.49,238.58c.08.01.08.1.1.16.13.49.28.97.5,1.42.27.59.63,1.11,1.19,1.48.06.04.12.12.19.07.06-.05.01-.13,0-.2-.09-.34-.25-.64-.4-.95-.19-.4-.36-.8-.35-1.25,0-.15.02-.29.06-.43.02-.06.01-.15.09-.15.06,0,.09.06.13.11.23.3.43.61.61.94.45.85.74,1.76,1.07,2.66.17.46.35.91.57,1.35.03.05.09.12.03.18-.05.05-.11,0-.16-.01-.59-.14-1.1-.45-1.55-.85-.61-.54-1.12-1.17-1.64-1.8-.27-.32-.41-.71-.52-1.1-.11-.37-.2-.73-.3-1.1-.04-.14.26-.51.41-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.87,236.45c-.03.19-.08.45-.13.71-.03.14-.14.13-.24.13-.1,0-.23.02-.26-.13-.02-.09-.03-.18-.06-.27-.05-.19-.13-.35-.38-.34-.09,0-.12-.05-.15-.13-.12-.41,0-.72.36-.93.2-.12.35-.07.5.07.2.19.34.53.34.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.53,237.9c-.17-.27-.34-.53-.5-.8-.52-.88-.92-1.8-1.19-2.79-.03-.12-.03-.23.02-.35.67-1.48.68-3,.14-4.51-.25-.71-.4-1.42-.4-2.17,0-.23-.02-.46-.02-.69,0-.2.04-.22.22-.13.32.17.54.43.69.75.45.93.85,1.89,1.02,2.92.11.68,0,1.34-.12,2.01-.17.98-.19,1.97-.13,2.97.05.87.17,1.73.31,2.59.01.06,0,.13.01.19-.02,0-.04.02-.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.56,229.03c-.17,0-.34.01-.5.02-.1,0-.14-.03-.09-.13.28-.54.45-1.12.77-1.64.25-.4.61-.52,1.06-.53.53-.01.99.11,1.4.46.15.13.19.27.09.43-.45.7-.99,1.28-1.89,1.34-.28.02-.56.06-.83.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.88,229.65c.13-.07.26-.15.39-.22.5-.26,1.01-.52,1.51-.77.05-.02.1-.08.15-.02.04.04,0,.1-.02.14-.1.29-.21.58-.32.87-.03.08-.06.17-.17.17-.51,0-1.02-.07-1.53-.1,0-.02-.01-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.02,227.73c-.05-.79.34-1.54.9-1.79.11-.05.26-.16.35-.08.09.08-.03.22-.08.33-.25.61-.62,1.12-1.17,1.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M181.14,252.89s-.06,0-.09-.01c.04.01.05.01.09.02,0,0,0,0,0,0ZM205.97,247.07s0,0,0-.01c.07.13.08.28.02.41.06-.15.06-.26-.02-.4ZM208.66,242.46s-.03,0-.04,0c.01,0,.02,0,.04,0,0,0,0,0,0,0ZM209.92,246.15h0s.03,0,.04,0c-.01,0-.02,0-.04,0ZM211.47,260.92s.08.08.13.11c-.05-.03-.09-.07-.13-.11ZM216.31,220.92s0,0,0,0c-.03.16,0,.25.15.32,0,0,0,0,0,0-.12-.06-.19-.2-.16-.33ZM216.86,212.68s-.01,0-.02,0c0,0,.01,0,.02,0,0,0,0,0,0,0ZM219.65,235.71c-.15-.25-.29-.48-.41-.72-.01-.02-.02-.05-.02-.08,0-.05,0-.1.02-.15.18-.85.41-1.69.53-2.55.22-1.52.13-3.02-.69-4.39-.4-.66-.84-1.29-1.24-1.95-.27-.45-.52-.91-.79-1.38,1.55-.6,2.43-1.73,2.7-3.33.21-1.22-.15-2.31-.9-3.35,0,.26,0,.46,0,.66-.03.67-.04,1.35-.09,2.02-.01.2-.11.4-.19.59-.13.27-.27.54-.42.8-.33.6-.64,1.21-.66,1.98-.1-.11-.16-.18-.22-.24-.41-.43-.81-.88-1.24-1.28-.68-.63-1.51-.76-2.39-.65-.98.11-1.83.56-2.66,1.06-.49.29-.96.61-1.44.91-.05.03-.09.05-.18.05.13-.24.26-.47.39-.71.1-.2.22-.39.3-.59.07-.17.02-.31-.12-.44-.82-.72-2.28-.86-3.13.06-.33.36-.65.75-.93,1.16-.5.72-1.07,1.37-1.74,1.93-.19.16-.36.35-.54.52-.26.24-.39.54-.42.89-.02.25-.06.5-.09.8.53-.31,1.03-.6,1.57-.91-.04.07-.05.1-.06.12-1.27,1.51-2.18,3.24-2.92,5.06-.35.85-.8,1.64-1.47,2.29-.14.13-.31.22-.46.33,0,0,.01.02.02.02.67-.1,1.28.17,1.91.34.57.16,1.15.25,1.74.09.03,0,.06,0,.1,0,.01.19.14.21.3.22.39.02.78.05,1.19.08v.75c-.23.02-.45.05-.68.07-.05,0-.11-.06-.15-.1-.18-.22-.35-.45-.57-.71.08.49.15.93.23,1.37.25.04.49.09.75.14-.07.27-.13.52-.21.79-.5-.1-.99-.19-1.54-.3.14.26.24.47.36.67.13.22.29.43.43.65.27.4.45.83.46,1.39.47-.06.93-.08,1.37-.17.38-.07.64-.34.74-.71.18-.68.33-1.37.49-2.05.15-.64.36-1.24.74-1.78.03-.04.07-.09.15-.12v1.45c.38.02.73.04,1.1.06-.03.04-.03.07-.05.08-.96.86-1.41,1.98-1.68,3.21-.02.08-.02.14-.02.21,0,0,0,.01,0,.02,0,.01,0,.03,0,.04,0,0,0,.01,0,.02,0,.02,0,.03.01.04,0,0,0,.01,0,.02,0,0,0,.01,0,.02.02.03.04.07.07.1,0,0,.01.01.02.02.01.01.03.03.04.04,0,0,0,0,.01.01.01.01.02.02.04.03.43.38.83.79,1.25,1.18.04.04.09.08.14.12,1.03-1.37,1.76-2.86,2.1-4.54.06.63.12,1.25.18,1.89.36-.24,1.19-1.48,1.41-2.11-.33-.15-.66-.31-1.02-.48.06-.04.11-.07.15-.09.31-.15.63-.29.94-.43.55-.26,1.04-.61,1.45-1.06.45-.5.65-1.1.76-1.75.16-.93.34-1.86.54-2.79.1-.48.06-.94-.07-1.4-.15-.54-.28-1.08-.4-1.63.47.68,1.06,1.31,1.15,2.17.04.43-.05.87-.11,1.3-.1.7-.24,1.4-.1,2.1.07.33.19.65.33.95.49.98,1,1.96,1.5,2.94.21.42.39.85.62,1.25.2.36.52.61.94.7,0-.05,0-.11.01-.17,0-.03,0-.06,0-.09,0-.05,0-.11.01-.16,0-.02,0-.04,0-.05.06-.97.13-1.94.19-2.9.03,0,.06,0,.09,0,.48,1.52.56,3.05.11,4.63.41-1.44.72-2.74.37-4.13,0,.02-.02.03-.04.06ZM210.21,225.74c-.25.73-.63,1.35-1.26,1.84.04-1.06.47-1.69,1.26-1.84ZM210.32,236.61c-.06.27-.21.46-.51.51-.44.08-.88.17-1.37.26.09-.36.17-.67.25-.97.02-.05.09-.09.14-.13.48-.41,1.05-.62,1.69-.74-.07.37-.13.72-.2,1.07ZM211.43,229.71c-.53-.04-1.05-.08-1.58-.11,0-.02,0-.04,0-.05.66-.34,1.32-.67,2.02-1.03-.15.42-.29.8-.44,1.2ZM212.12,227.63c-.45.61-.94,1.18-1.77,1.23-.49.03-.97.05-1.52.08.31-.63.6-1.22.9-1.8.14-.27.38-.4.7-.44.58-.06,1.12,0,1.59.37.24.19.29.31.11.56ZM218.42,237.75c-.24-.4-.49-.8-.72-1.21-.4-.75-.73-1.53-.93-2.36-.02-.1-.02-.22.02-.31.68-1.51.69-3.04.13-4.58-.35-.97-.42-1.96-.39-2.99.3.12.55.3.69.56.69,1.29,1.27,2.62,1.19,4.13-.03.51-.15,1.01-.22,1.51-.15,1.19-.11,2.38.03,3.57.07.55.15,1.11.23,1.66-.01,0-.03.01-.04.02ZM220.71,229.08c.42,1.35.2,2.66-.18,3.97.18-.6.35-1.16.44-1.74v-1.25c-.05-.31-.13-.63-.26-.98ZM208.29,241.31c-.27-.36-.59-.68-.96-.94-.08-.06-.16-.11-.21-.16.43.38.83.79,1.25,1.18-.02-.02-.05-.05-.07-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M214.47,259.34c-.17-.13-.33-.28-.44-.45-.28-.44-.54-.9-.8-1.35-.02-.04-.05-.08-.08-.1,0,0,0,0-.01-.01-.02-.02-.04-.03-.06-.03,0,0,0,0-.01,0-.03,0-.06-.01-.1-.01-.03,0-.08,0-.12.01-.34.05-.69.04-1.03-.03-.02,0-.04,0-.05,0-.05,0-.1.01-.2.02.42.28.8.53,1.17.79.17.12.37.26.47.44.28.52.35,1.11.45,1.72-.49,0-.95,0-1.4,0-.17,0-.28-.06-.35-.2-.21-.42-.44-.84-.62-1.27-.08-.2-.08-.45-.05-.67.07-.41.19-.81.28-1.22.07-.29.03-.55-.19-.77-.18-.18-.34-.37-.47-.59-.13-.21-.23-.45-.29-.68-.2-.69-.34-1.4-.56-2.08-.52-1.56-1.29-2.99-2.19-4.36-.17-.27-.3-.55-.27-.87.02-.25.06-.5.15-.74.43-1.16.71-2.35.82-3.58.02-.27.07-.54.1-.82,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,.04,0,.09.23.19.46.27.69,0,.02.01.04.02.05.01.04.02.07.03.11.21.76.4,1.53.6,2.29.05.19.13.38.19.57,0-.01,0-.02.01-.04,0,.06.01.11,0,.17,0,.08.08.18.07.26-.15,1.16-.11,2.3.34,3.39.28.68.54,1.38.83,2.06.58,1.39,1.16,2.77,1.75,4.15.13.29.33.55.52.81.18.24.4.45.6.68.42.47.51,1.06.55,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M216.01,220.22c-.06-.73-.06-1.47-.17-2.19-.12-.74-.33-1.47-.52-2.2-.45-1.78-.9-3.57-1.55-5.29-.46-1.19-1-2.33-1.93-3.23-1.01-.97-1.86-2.08-2.72-3.18-.8-1.02-1.61-2.03-2.43-3.03-.35-.43-.76-.83-1.33-.95-1.22-.26-2.45-.49-3.67-.72-.83-.15-1.53.14-2.11.72-.3.3-.59.63-.86.96-.14.17-.28.23-.5.24-.81.02-1.62.04-2.42.14-.71.1-1.42.25-2.14.15-1.19-.16-2.38-.36-3.58-.52-1.52-.21-3.05-.39-4.57-.59-1.3-.17-2.61-.33-3.91-.51-.42-.06-.83-.24-1.24-.24-1.67,0-3.33-.11-4.99-.24-.77-.06-1.55-.11-2.32-.21-1.41-.17-2.82-.4-4.23-.53-1.83-.17-3.66-.06-5.46.35-1.67.38-3.33.79-4.92,1.46-1.89.8-3.47,1.99-4.63,3.7-1.66,2.46-2.71,5.14-2.77,8.15-.02,1.15.03,2.3.14,3.45.14,1.39.75,2.64,1.33,3.9,1.07,2.32,4.22,4.69,7.28,4.62,1.42-.03,2.84.04,4.24-.27,2.4-.53,4.78-1.1,7.08-1.97,1.79-.68,3.61-1.29,5.48-1.72.71-.16,1.41-.36,2.15-.19.47.11.93.24,1.4.35.21.05.43.09.64.14.01-.02.03-.05.04-.07-.31-.29-.61-.6-.94-.87-.15-.12-.38-.2-.58-.2-.67,0-1.35-.02-1.99.12-1.04.22-2.07.53-3.09.84-2.2.69-4.38,1.42-6.58,2.11-1.09.34-2.19.64-3.33.75-1.83.19-3.67.22-5.51.09-1.31-.09-2.45-.57-3.41-1.48-.65-.61-1.19-1.31-1.69-2.04-.92-1.37-1.55-2.85-1.64-4.5-.07-1.29-.04-2.59-.01-3.88.03-1.11.26-2.2.66-3.24.81-2.08,2.08-3.78,4.09-4.83,1.23-.64,2.54-1.15,3.88-1.53.45-.13.9-.22,1.35-.33,0,.02.01.05.02.07-.21.15-.42.3-.62.46-.77.61-1.59,1.16-2.28,1.84-1.05,1.03-1.81,2.3-2.44,3.63-.41.85-.67,1.75-.69,2.7-.02.97-.04,1.94-.03,2.91,0,1.05.1,2.1.39,3.12.58,2.02,1.21,4.03,1.66,6.09.01.06.11.15.18.16.67.09,1.34.2,2.01.23,2.01.09,4.01.04,5.95-.56,2.08-.64,4.16-1.3,6.25-1.93,1.35-.41,2.71-.81,4.08-1.16.59-.15,1.23-.14,1.83-.25.82-.15,1.64-.36,2.46-.53.3-.06.62-.16.91-.12.95.14,1.81.5,2.51,1.18.64.62,1.28,1.22,2.02,1.71.19.13.36.28.54.43.16.14.32.28.51.45-.45.1-.85.19-1.29.29.29.19.54.36.84.56-.47.07-.89.13-1.31.19-1.1.15-2.2.26-3.3.11-.83-.11-1.58-.37-2.17-.99-.35-.36-.7-.73-1.03-1.1-.24-.27-.53-.38-.87-.3-.92.2-1.84.39-2.74.65-2.43.71-4.79,1.62-7.22,2.34-2.64.78-5.28,1.38-8.05,1.18-.24-.02-.49,0-.73.04-.37.04-.71.16-1.02.4.09.14.17.27.25.41.18.3.31.62.29.98-.01.29,0,.59-.02.88-.04,1.55-.09,3.11-.47,4.63-.15.6-.28,1.21-.64,1.73-.33.47-.78.8-1.22,1.14-.37.29-.73.58-1.08.89-.3.27-.45.62-.5,1.02-.1.68,0,1.35.16,2.01.21.87.45,1.74.61,2.62.3,1.58.31,3.19.36,4.79.03,1.04.08,2.07.14,3.1.08,1.32.09,2.64-.1,3.94-.13.85-.08,1.64.35,2.4.13.24.21.5.31.76.1.24.09.49,0,.74-.14.34-.28.68-.44,1-.36.75-.3,1.54-.19,2.33.02.16.14.31.23.45.03.05.11.1.18.1.66.04,1.31.06,2,.09-.17-1.25-.65-2.25-1.79-2.82.6.12,1.18.27,1.75.42.06.02.12.11.15.18.2.46.4.92.6,1.38.02.05.06.09.12.17,0-.88-.15-1.68-.57-2.41-.2-.34-.32-.71-.32-1.1,0-.33,0-.66.03-.99.06-.67.06-1.32-.13-1.99-.15-.53-.22-1.08-.28-1.63-.08-.79-.12-1.58-.18-2.37-.07-.89-.17-1.78-.21-2.67-.04-1.11,0-2.23-.05-3.35-.04-.9.16-1.73.58-2.51.56-1.04,1.09-2.09,1.46-3.21.05-.16.13-.3.2-.45.14-.29.34-.52.6-.71,1.55-1.11,3.08-2.24,4.62-3.36,1.82-1.32,3.32-2.94,4.56-4.81.16-.25.23-.51.19-.8-.04-.3-.12-.59-.17-.89-.06-.34-.11-.68-.16-1.02.02,0,.04,0,.06-.01.06.1.11.2.17.3.22.36.42.72.65,1.06.51.78,1.29,1.24,2.07,1.69,2.34,1.38,4.94,2.03,7.58,2.51,1.41.25,2.85.22,4.28.22,1.26,0,2.51-.08,3.75-.29,1.14-.19,2.28-.4,3.44-.41.23,0,.46,0,.69.01.23,0,.46.03.69.04-.74.37-1.51.61-2.15,1.07.88.09,1.75.19,2.63.26.6.05,1.12.25,1.53.69.04.05.1.08.18.15-.02-.45-.05-.86-.07-1.28-.44-.04-.87-.08-1.3-.12.06-.65.06-1.26.31-1.86.32-.78.55-1.6.83-2.4.04-.11.08-.23.16-.3.49-.41.95-.86,1.56-1.09.96-.37,1.85-.89,2.66-1.54.14-.11.29-.21.44-.32.75-.52,1.57-.86,2.48-.96.45-.05.9-.09,1.35-.13-.21-.75-.43-1.49-.62-2.24-.23-.9-.34-1.81-.22-2.74.18-1.39.87-2.47,1.96-3.3.67-.51,1.4-.96,2.11-1.41.64-.41,1.25-.84,1.81-1.36.29-.28.6-.53.91-.79.03-.03.08-.04.13-.07.06.95-.25,1.77-.82,2.48-.37.46-.79.87-1.18,1.31-.41.47-.83.92-1.18,1.43-.35.52-.65,1.1-.55,1.77.09.62.4,1.16.68,1.72.22-.09.42-.2.63-.27.31-.1.62-.2.93-.26.54-.1,1.01.07,1.45.4.34.26.68.51,1.03.74.26.17.56.25.9.2-.06-.88-.1-1.74-.18-2.6-.08-.82-.09-1.64.11-2.45.29-1.14.35-2.3.28-3.47-.03-.55,0-1.11.03-1.66.03-.52.18-1.01.41-1.53.03.12.04.2.06.28.31,1.84.24,3.68.03,5.53-.1.87-.23,1.74-.28,2.61-.06.88-.04,1.77-.06,2.65,0,.04.01.08.01.08.71-.15,1.41-.33,2.12-.43.72-.1,1.42.04,2.07.47-.03-.3-.06-.55-.08-.8ZM156.83,237.85c-.1.09-.24.18-.36.17-.19-.02-.36-.12-.57-.19.11-.23.27-.36.49-.38.12,0,.27.05.36.12.07.05.12.25.08.28ZM204.16,208.23c-1.12-.99-2.24-1.97-3.36-2.96-.49-.43-.99-.86-1.47-1.3-.48-.44-.86-.96-1.19-1.58,1.06.49,1.82,1.33,2.73,1.95-.22-.56-.62-.96-1.06-1.33-.44-.36-.89-.7-1.37-1.08.47-.11.88-.09,1.29.07.73.28,1.22.82,1.61,1.47.09.15.18.31.24.48.45,1.24,1.19,2.31,1.97,3.35.26.34.51.67.75,1.04-.05-.03-.1-.06-.14-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M203.22,243.49c-.08-.86-.32-1.67-.79-2.47-.21.14-.41.26-.59.41-.21.17-.39.36-.59.54-.22.19-.47.34-.77.34-.94.02-1.77-.28-2.5-.86-.08-.06-.14-.17-.15-.27-.05-.32-.07-.64-.1-.97-.07.02-.14.03-.2.05-.59.23-1.19.45-1.78.69-.99.41-1.99.51-3.01.16-.8-.28-1.6-.57-2.4-.85-.8-.28-1.6-.53-2.45-.58-.78-.04-1.56-.03-2.35-.04-.77,0-1.53-.05-2.27-.28-.73-.23-1.41-.53-1.87-1.18-.25-.36-.49-.72-.73-1.09-.3-.47-.64-.89-1.06-1.27-.31-.29-.61-.63-.79-1.01-.15-.31-.35-.45-.64-.52-.3-.07-.6-.14-.91-.14-.8,0-1.59.02-2.39.04-.08,0-.22.05-.24.1-.07.27-.29.26-.49.28-.6.06-1.16-.11-1.73-.24-.45-.1-.9-.16-1.19.31-.21.32-.37.67-.56,1.01.46.24.88.47,1.31.68.47.23.84.56,1.15.99.41.58.87,1.11,1.42,1.56.28.23.57.47.81.74.2.22.37.48.48.76.13.34.22.71.27,1.08.09.64.32,1.24.61,1.8.76,1.45,1.46,2.92,2.01,4.46.01.03.03.06.05.1.02,0,.04,0,.06,0,.23-.64.46-1.28.71-1.98.08.39.18.72.22,1.06.1.81-.05,1.6-.32,2.36-.69,1.89-1.41,3.78-2.1,5.67-.42,1.15-.79,2.32-1.18,3.49.09.04.14.07.19.09.05-.07.09-.13.13-.19.61-.84,1.25-1.67,1.82-2.53.48-.72.87-1.5,1.31-2.24.86-1.44,1.9-2.75,2.94-4.06.41-.52,1-.75,1.65-.93-.09.45-.17.86-.24,1.27-.02.1-.1.22.06.3.66.34,1.34.61,2.1.6.35,0,.71,0,1.05.07.72.14,1.43.33,2.14.5.66.16,1.33.33,2.01.27.9-.08,1.8-.25,2.7-.33.78-.07,1.57-.06,2.35-.09.1.33.19.59.27.86.32,1.01.85,1.91,1.37,2.81.25.43.45.88.51,1.38.08.66,0,1.32-.16,1.96-.27,1.04-.6,2.07-.89,3.11-.15.52-.28,1.04-.42,1.56.02.02.05.03.07.05.05-.04.13-.07.16-.12.15-.28.32-.56.42-.86.37-1.13.72-2.26,1.08-3.39.41-1.29.91-2.55,1.75-3.64.11-.15.21-.31.28-.48.05-.13.09-.3.05-.43-.12-.42-.25-.84-.42-1.24-.39-.93-.31-1.82.21-2.65.34-.54.74-1.04,1.13-1.55.45-.58.92-1.15,1.12-1.87.28-1.04.4-2.09.29-3.17ZM174.79,236.59c-.02.13-.06.25-.07.38-.02.15-.08.21-.24.2-.15,0-.26-.03-.25-.21,0-.05-.02-.1-.03-.15-.08-.33-.16-.4-.52-.41-.02-.14-.04-.27-.04-.4,0-.43.16-.52.5-.64.1-.03.28.06.37.14.29.3.34.68.27,1.08ZM178.34,242.79c-.5-.51-.98-1.06-1.44-1.6-.35-.42-.49-.95-.63-1.48-.06-.23-.11-.46-.18-.69-.05-.15-.03-.24.1-.33.09-.06.18-.14.29-.24.38,1.27.73,2.54,2.04,3.29-.03-.16-.04-.28-.08-.38-.15-.37-.3-.73-.47-1.09-.23-.5-.37-1.01-.19-1.57,0-.03.02-.05.06-.14.25.4.52.74.7,1.13.31.67.58,1.36.85,2.05.28.7.55,1.4.83,2.11-.74-.14-1.36-.53-1.88-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M165.33,235.51c.05.2.1.43.16.67.02.07.09.16.14.17.67.01,1.18.35,1.63.8,0,0,.01,0,.04.03.39-.25.8-.5,1.22-.77,0,.26,0,.5,0,.74-.04.94-.13,1.89.03,2.82.57,3.37,1.41,6.66,2.78,9.81.78,1.79,1.57,3.58,2.64,5.23.43.67.92,1.3,1.39,1.94.25.34.29.97.08,1.31-.03.05-.08.11-.13.14-.3.17-.45.43-.47.77-.03.39-.19.72-.41,1.03-.13.19-.34.17-.53.15-.39-.05-.86-.26-.88-.89-.02-.78-.03-1.57-.04-2.35,0-.25,0-.51-.05-.75-.03-.17-.12-.35-.23-.49-.13-.17-.29-.32-.45-.46-.48-.43-.8-.93-.86-1.6-.07-.81-.38-1.57-.72-2.3-1.03-2.28-2.11-4.53-3.38-6.69-.53-.9-.98-1.85-1.47-2.77-.31-.6-.78-1.06-1.34-1.43-.04-.02-.07-.05-.11-.07-.21-.14-.49-.24-.59-.44-.11-.2-.05-.49-.05-.74,0-.43.09-.82.3-1.21.46-.86.87-1.74,1.29-2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M170.33,235.69c-.55-.03-1.06-.06-1.57-.09-.16-.01-.31-.05-.47-.06-.08,0-.18.04-.24.09-.19.18-.36.37-.56.59-.05-.5-.09-.95-.15-1.47-.44.26-.85.49-1.29.74.06-.42.08-.84.41-1.14.52-.48,1.04-.97,1.59-1.42.99-.84,1.86-1.8,2.73-2.75.08-.08.16-.17.24-.27,1.11.64,2.17,1.36,3.43,1.7-.2.93-.75,1.61-1.51,2.12-.06.04-.2.02-.28,0-.15-.05-.3-.14-.44-.21-.15-.08-.3-.17-.46-.23-.46-.18-.78-.08-1.07.31-.37.48-.41,1.04-.39,1.61,0,.14.02.27.03.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M197.93,239.27c-.24.04-.48.08-.74.13-.08-.41-.15-.81-.23-1.21-.4-2.08-.97-4.11-1.67-6.1-.03-.08-.12-.16-.2-.19-.15-.07-.31-.1-.46-.15.06-.4.06-.38.41-.41,1.23-.09,2.45,0,3.68.04.71.02,1.42-.03,2.14-.04-.13.28-.29.59-.43.91-.2.46-.54.77-.99.97-.3.13-.6.27-.89.43-.53.28-.82.72-.82,1.34,0,.98-.02,1.97,0,2.95.01.44.12.88.19,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M190.94,262.93c.09-.1.17-.23.28-.31.52-.39.89-.91,1.23-1.46,1.61-2.57,2.73-5.34,3.55-8.25.02-.07.04-.14.06-.24.31.61.59,1.21.75,1.86.02.07-.02.17-.05.25-.47,1.28-1.05,2.51-1.73,3.69-.7,1.22-1.4,2.43-2.12,3.64-.17.28-.34.62-.6.77-.25.15-.62.09-.94.11-.13,0-.26,0-.39,0-.02-.02-.03-.04-.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M180.93,263.58c.57-.91.94-1.9,1.12-2.94.12-.7.13-1.43.14-2.14.01-.98-.01-1.97-.03-2.95-.02-1.11-.05-2.21-.07-3.32-.02-1.06.6-1.61,1.33-1.87.02,0,.04,0,.1-.01-.02.3-.03.6-.05.9-.04.52-.1,1.03-.12,1.55-.03,1.06-.07,2.13-.04,3.19.01.53-.17,1.01-.27,1.51-.16.78-.31,1.57-.47,2.35-.15.71-.25,1.44-.46,2.13-.15.51-.42.98-.66,1.46-.1.21-.3.21-.52.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M207.1,245.53c-.24.04-.44.09-.65.12-.06,0-.16-.02-.18-.07-.41-.82-.81-1.65-1.2-2.48-.01-.02-.01-.05-.02-.08h2.57c-.3-.82-.45-1.72-1.43-2.06-.21-.07-.4-.19-.61-.29.51-.35.92-.33,1.38.09.55.5.86,1.12.96,1.86.11.82.02,1.62-.24,2.4-.42,1.29-.83,2.58-1.28,3.86-.28.81-.36,1.64-.32,2.49,0,.14,0,.28,0,.45-.17-.15-.28-.3-.29-.53-.03-.84.12-1.66.34-2.47.27-1.01.59-2.01.89-3.01.02-.08.05-.15.08-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M201.44,228.05c-.45.62-.9,1.23-1.35,1.85.53-.21,1.07-.42,1.61-.64-.3.55-.74.93-1.32,1.14-.61.23-1.25.14-1.88.11-.47-.03-.94-.09-1.42-.11-.86-.04-1.64.14-2.29.79.12-.38.25-.76.38-1.14,0-.03.05-.05.08-.07.85-.43,1.69-.9,2.63-1.11.48-.11.98-.14,1.46-.26.62-.15,1.22-.36,1.83-.55.07-.02.13-.04.2-.07.02.02.04.04.06.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M204.77,222.9c-.4-.92-.72-1.79-.86-2.72-.19-1.24.13-2.33.99-3.25.4-.43.84-.8,1.35-1.1.05-.03.11-.06.22-.11-.24.35-.44.64-.64.93-.37.55-.65,1.12-.77,1.78-.1.58-.02,1.13.21,1.66.18.43.41.84.6,1.26.03.06.04.17.01.21-.35.44-.72.87-1.11,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M198.09,240.9c.2-.25.39-.5.59-.76.28.16.54.32.83.49.14-.34.28-.66.4-1,.08-.25.2-.35.48-.36.49-.01.97-.09,1.48-.14-.12.73-.17,1.48-.66,2.08-.43.53-1,.61-1.62.48-.57-.11-1.05-.41-1.5-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M202.62,225.05c-.24.47-.48.89-.96,1.13-1.4.68-2.82,1.33-4.29,1.85-.76.27-1.37.73-1.89,1.33-.09.1-.18.21-.27.32,0-.52.15-.91.6-1.21.62-.4,1.29-.68,1.97-.95.76-.3,1.47-.67,2.11-1.19.74-.6,1.6-.98,2.51-1.23.06-.02.12-.02.22-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M198.95,259.77c.96.6,1.26,1.54,1.32,2.62-.48-.01-.95.04-1.4-.14-.07-.03-.16-.11-.18-.18-.24-.8-.13-1.56.25-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M203.3,241.4c.59-.18,1.16-.35,1.73-.52.1-.03.18-.08.28-.11.05-.01.12,0,.15.02.44.52.87,1.04,1.29,1.59-1.26.06-2.44-.16-3.44-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M198.96,259.63c.37-.8.74-1.6,1.11-2.4.03,0,.06.01.09.02.04.25.09.5.11.75.04.48.14.92.39,1.34.32.53.42,1.13.52,1.73.04.27.08.55.12.85-.27-.19-.39-.44-.46-.72-.11-.41-.21-.81-.3-1.22-.05-.2-.15-.29-.37-.28-.39.02-.77,0-1.16,0-.02-.03-.03-.06-.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M174.09,262.23c.14.09.27.18.41.27-.04.07-.07.14-.11.19-.34.4-.69.79-1.01,1.2-.23.3-.54.38-.88.39-.09,0-.17,0-.33,0,.35-.37.66-.7.97-1.03.31-.34.63-.67.96-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M200.93,237.08c-.9-.07-1.22-.33-1.47-1.21.46.06.92.12,1.37.19.04,0,.1.08.1.12,0,.29,0,.59,0,.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M175.71,258.89c.16.29.19.53.03.82-.29.55-.52,1.13-.78,1.7-.03.07-.07.14-.11.22-.08-.3-.06-.56.06-.83.25-.55.46-1.13.69-1.69.03-.07.06-.14.1-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M199.08,234.51c-.45.61-.39,1.31-.42,2,0,.29,0,.57.01.86,0,.35.1.68.42.97-.19-.02-.33-.02-.46-.06-.05-.01-.09-.12-.09-.18,0-.77.02-1.54.03-2.3,0-.27.03-.53.05-.8.03-.35.05-.38.45-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M203.99,240.44c-.49.16-1.38-.02-1.54-.46.57-.04,1.06.12,1.54.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M196.77,264.64c-.15-.03-.3-.07-.45-.09-.16-.02-.19-.11-.12-.22.1-.16.23-.31.37-.44.1-.09.19-.04.2.1,0,.21,0,.41,0,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M201.13,238.61h.84c-.02.1-.04.19-.06.29-.25-.09-.5-.18-.78-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M174.53,262.23c-.12-.08-.18-.11-.26-.17.09-.13.17-.26.25-.39.03,0,.05.02.08.02-.02.16-.04.32-.07.53Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M227.44,296.4h0s0,0,0,0h.02s0,0,0,0h.01s.07.03.12.06c.02,0,.04.02.06.03,0,0,0,0,0,0s0,0,0,0h0s.06.03.09.04c.04.01.07.03.11.05,0,0,.01,0,.02,0t0,0s.09.04.13.05c.02,0,.04.02.06.02h0c.06.02.12.04.18.07.06.02.11.04.17.06.05.02.1.03.15.05.14.04.28.09.44.14.3.09.63.19,1,.28.15.04.3.08.46.12.03,0,.06.01.09.02.1.03.2.05.31.07,0,0,0,0,.01,0s0,0,0,0h.02s.08.02.11.03c.13.03.27.06.41.09.11.02.22.05.34.07,0,0,.02,0,.03,0,.12.02.24.05.36.07.07.01.13.03.2.04.1.02.19.04.29.05.04,0,.07.01.11.02h0c.05,0,.1.02.15.03.11.02.23.04.35.06.02,0,.03,0,.05,0,.07.01.14.02.21.03.04,0,.08.01.13.02.06,0,.13.02.19.03.02,0,.05,0,.07,0,.16.03.33.05.49.07.18.03.37.05.57.08.04,0,.09.01.14.02.05,0,.11.02.17.02.02,0,.05,0,.07,0,.12.02.25.03.38.05,0,0,.02,0,.02,0,.15.02.3.04.45.05.03,0,.05,0,.08,0,.05,0,.09.01.14.02.03,0,.06,0,.1,0,.02,0,.03,0,.04,0,.06,0,.13.01.19.02.72.08,1.5.15,2.32.21.26.02.53.04.8.05.11,0,.22.01.33.02.07,0,.15,0,.22.01.04,0,.08,0,.12,0,.04,0,.08,0,.12,0,.04,0,.08,0,.12,0,.2,0,.4.02.6.03h.12c.24.02.48.03.72.04.03,0,.06,0,.1,0,.21,0,.43.02.64.02.11,0,.22,0,.33.01.11,0,.22,0,.33,0,.11,0,.22,0,.34,0,.4,0,.8.02,1.21.02.18,0,.35,0,.53,0,.62,0,1.22,0,1.8,0,.22,0,.44,0,.66,0h.04c.22,0,.43,0,.64-.01.47,0,.93-.02,1.38-.04.16,0,.31,0,.46-.02.14,0,.29-.01.43-.02,1.19-.05,2.3-.13,3.33-.22.11,0,.23-.02.34-.03s.22-.02.33-.03c.11-.01.22-.02.33-.03.04,0,.07,0,.1,0,.07,0,.15-.02.22-.03.47-.05.92-.11,1.36-.16.05,0,.11-.01.16-.02.59-.08,1.14-.16,1.66-.25.06,0,.12-.02.18-.03.02,0,.05,0,.07-.01,0,0,0,0,0,0,.17-.03.34-.06.5-.09.15-.03.29-.05.43-.08.08-.02.15-.03.23-.04,0,0,.02,0,.03,0,.05,0,.1-.02.15-.03.08-.02.16-.03.24-.05.55-.11,1.06-.23,1.51-.35h0c.06-.01.11-.03.17-.04.05-.02.11-.03.16-.04.02,0,.04,0,.05-.02.16-.04.32-.09.46-.13.05-.01.1-.03.14-.04.24-.07.45-.14.65-.2.04-.01.08-.03.12-.04l.11-.04s.03,0,.04-.01c.02,0,.03,0,.05-.02,0,0,0,0,0,0,0,0,0,0,.02,0h0c.12-.04.23-.08.34-.12,0,0,0,0,0,0h0s-.25-.23-.66-.57c-.17-.15-.37-.32-.6-.51-.36-.31-.8-.67-1.29-1.07-.23-.18-.47-.38-.72-.58-.94-.75-2.04-1.6-3.21-2.45-.18-.13-.37-.27-.56-.4-.49-.35-1-.7-1.51-1.05-.19-.13-.37-.25-.56-.37-.08-.06-.17-.11-.25-.16-.53-.35-1.07-.69-1.61-1.01-.13-.08-.26-.15-.39-.23-.42-.25-.85-.48-1.27-.7-.22-.11-.43-.23-.65-.33-.6-.3-1.18-.56-1.75-.78-.15-.06-.3-.11-.45-.16-.15-.05-.29-.11-.44-.15-.4-.13-.77-.23-1.14-.3-.16-.03-.31-.06-.45-.08-.2-.03-.4-.05-.6-.05-.03,0-.06,0-.09,0-.11,0-.23,0-.35,0-.14,0-.28.02-.42.03-.05,0-.09,0-.14.02-.3.04-.61.1-.94.18-.2.05-.4.1-.6.16-.19.05-.39.12-.58.18-.56.19-1.14.42-1.73.69-.22.1-.45.2-.68.31-.46.22-.92.45-1.38.7-.18.1-.36.19-.54.29-1.27.7-2.55,1.49-3.77,2.3-.21.14-.43.28-.63.43-1.42.96-2.75,1.92-3.87,2.76-.14.11-.28.21-.41.31-.21.16-.41.31-.59.46-.57.43-1.05.82-1.44,1.12-.22.18-.4.33-.55.45-.27.22-.42.34-.42.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M227.44,296.4s0,0,.02.01c0,0,.01,0,.02,0,.07.03.25.11.52.22.01,0,.03.01.04.02.02,0,.04.02.06.02,1.17.44,3.54,1.14,7.69,1.64,0,0,.02,0,.02,0,.15.02.3.04.45.05.03,0,.05,0,.08,0,2.5.28,5.6.48,9.43.52,10.56.11,16.24-1.35,18.54-2.14.12-.04.24-.08.34-.12,0,0,0,0,0,0,0,0-3.74-1.79-4.53-2.46-1.63-1.37-3.62-4.13-5.95-4.13-.84,0-1.78,1.24-3.37,2.97-1.6,1.74-4.41,3.47-8.62,3.86-7.01.66-8.02-.69-10.37-2.06-.45-.26-.22-.28-.49-.65-1.01.75-.98,1.47-1.58,1.95-.62.49-2.31.28-2.31.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M233.56,296.49c0,.36.15.65.33.65s.33-.29.33-.65-.15-.65-.33-.65-.33.29-.33.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M230.96,295.28c0,.21.44.37.98.37s.98-.17.98-.37-.44-.37-.98-.37-.98.17-.98.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M236.16,296.91c0,.44.17.79.37.79s.37-.35.37-.79-.17-.79-.37-.79-.37.35-.37.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M239.96,298.22c.24.24.52.34.62.23s0-.39-.23-.62c-.24-.24-.52-.34-.62-.23-.11.11,0,.39.23.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M232.69,295.52c-.13.31-.1.61.06.68.16.07.41-.12.54-.43.13-.31.1-.61-.06-.68s-.41.12-.54.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M242.51,297.9c-.13.31-.1.61.06.68.16.07.41-.12.54-.43.13-.31.1-.61-.06-.68s-.41.12-.54.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M254.25,291.49c-.22.25-.49.37-.61.27-.12-.1-.03-.39.19-.64.22-.25.49-.37.61-.27.12.1.03.39-.19.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M244.63,296.62c.15.3.15.6-.01.69-.16.08-.41-.09-.56-.39-.15-.3-.15-.6.01-.69s.41.09.56.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M258.5,293.05c-.25-.22-.37-.49-.27-.61.1-.12.39-.03.64.19.25.22.37.49.27.61-.1.12-.39.03-.64-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M254.62,292.48c-.3.15-.6.15-.69-.01s.09-.41.39-.56c.3-.15.6-.15.69.01.08.16-.09.41-.39.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M250.37,294.83c-.25-.22-.37-.49-.27-.61.1-.12.39-.03.64.19.25.22.37.49.27.61-.1.12-.39.03-.64-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M251.13,293.38c-.3.15-.6.15-.69-.01-.08-.16.09-.41.39-.56.3-.15.6-.15.69.01.08.16-.09.41-.39.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M253.1,288.65c.07.09.3.04.5-.12.03-.03.06-.05.08-.08.14-.14.21-.3.15-.38-.07-.09-.3-.04-.5.12-.01.01-.03.02-.04.03-.18.15-.26.34-.19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M254.67,290.92c-.07-.25-.03-.48.11-.52.13-.04.3.13.37.37.07.25.03.48-.11.52-.13.04-.3-.13-.37-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M253.95,290.64c.26.03.45.15.44.27-.01.12-.23.19-.49.16-.26-.03-.45-.15-.44-.27.01-.12.23-.19.49-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M254.97,292.04c.12-.23.32-.36.44-.29.12.07.12.3,0,.53-.12.23-.32.36-.44.29-.12-.07-.12-.3,0-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M255.05,289.66c-.02.16.25.33.61.37.17.02.33,0,.45-.03.13-.04.21-.11.22-.19.02-.16-.25-.33-.61-.37-.16-.02-.31,0-.43.02-.14.04-.24.11-.25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M257.64,291.73c.15.08.37-.04.54-.28.03-.04.05-.08.08-.12.17-.31.17-.64,0-.73-.17-.09-.44.09-.61.4,0,.02-.02.04-.02.05-.15.3-.14.59.02.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M240.03,289.69c-.3.15-.6.15-.69-.01-.08-.16.09-.41.39-.56.3-.15.6-.15.69.01s-.09.41-.39.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M244.64,286.06c.08.16.39.17.69.02.11-.06.21-.13.28-.21.05-.05.09-.11.11-.16.03-.07.03-.14,0-.19-.03-.05-.08-.09-.15-.11-.14-.04-.34,0-.53.1-.21.11-.36.26-.4.4-.02.06-.02.11,0,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M234.96,291.49c.18.03.36-.22.41-.55.02-.15.02-.3-.02-.41-.04-.13-.11-.22-.21-.24-.18-.03-.36.22-.41.55,0,.04-.01.08-.01.12-.01.28.08.5.24.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M238.88,288.01c0,.09.09.17.25.22.06.02.12.04.19.04.26.03.47-.04.49-.16,0-.06-.05-.13-.14-.18-.08-.04-.18-.07-.3-.09-.26-.03-.47.04-.49.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M240.76,288.98c.12-.23.32-.36.44-.29s.12.3,0,.53c-.12.23-.32.36-.44.29-.12-.07-.12-.3,0-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M240.46,286.87c-.02.16.24.32.58.37,0,0,.02,0,.02,0,.35.04.66-.06.67-.22,0-.03,0-.07-.02-.1-.07-.13-.3-.24-.58-.27-.35-.04-.65.06-.67.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M243.43,286.28c-.02.16.25.33.61.37s.65-.06.67-.22c.02-.16-.25-.33-.61-.37h-.08c-.29-.03-.53.05-.58.18,0,.01-.01.03-.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M245.57,285.72c0,.05.02.1.03.15.05.14.12.24.21.24.13,0,.26-.18.31-.44.01-.06.02-.12.03-.19.02-.35-.09-.65-.26-.66-.16-.01-.3.24-.33.58,0,.02,0,.03,0,.05,0,.1,0,.19,0,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M246.48,285.66c.03.08.06.16.11.25.18.31.44.49.58.41.13-.07.12-.33,0-.6-.02-.04-.04-.07-.06-.11-.18-.31-.44-.49-.58-.41-.11.06-.11.25-.05.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M243.06,288.21c.17-.31.44-.49.61-.4s.17.42,0,.73c-.17.31-.44.49-.61.4-.17-.09-.17-.42,0-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M248.09,286.33c.33.08.62,0,.66-.17,0-.02,0-.04,0-.06-.02-.16-.22-.33-.51-.4-.28-.07-.53-.02-.63.1-.02.02-.03.04-.04.07-.04.17.18.38.51.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M248.76,286.67c.05.13.28.16.52.07.2-.08.34-.22.36-.33,0-.03,0-.05,0-.07-.04-.11-.23-.15-.44-.1-.03,0-.06.02-.09.03-.24.09-.4.27-.35.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M239.97,295.52c.09-.28.29-.47.44-.42s.2.32.11.6c-.09.28-.29.47-.44.42-.15-.05-.2-.32-.11-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M247.78,287.84c-.18.14-.38.19-.44.11-.07-.08.03-.27.21-.41.18-.14.38-.19.44-.11.07.08-.03.27-.21.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M251.6,288.5c-.25.2-.52.26-.61.15-.09-.11.04-.37.29-.56s.52-.26.61-.15c.09.11-.04.37-.29.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M245.23,289.94c.09.3.03.59-.13.64s-.37-.16-.46-.46c-.09-.3-.03-.59.13-.64.16-.05.37.16.46.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M248.83,293.99c-.21-.22-.28-.49-.16-.6s.38-.03.59.19c.21.22.28.48.16.6s-.38.03-.59-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M256.67,291.49c-.2-.15-.31-.36-.23-.47.08-.11.31-.08.51.07s.31.36.23.47c-.08.11-.31.08-.51-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M251.62,289.62c.07.18.05.35-.03.39-.08.03-.21-.09-.27-.27s-.05-.35.03-.39c.08-.03.21.09.27.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M253.03,290.39c.09.25.08.49-.04.53s-.29-.13-.38-.38c-.09-.25-.08-.49.04-.53.12-.04.29.13.38.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M250.21,293.82c.27,0,.48.13.48.27,0,.14-.22.26-.49.25-.27,0-.48-.13-.48-.27,0-.14.22-.26.49-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M247.43,294.79c-.22.25-.49.37-.61.27-.12-.1-.03-.39.19-.64.22-.25.49-.37.61-.27s.03.39-.19.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M256.95,294.24c-.25-.22-.37-.49-.27-.61.1-.12.39-.03.64.19.25.22.37.49.27.61-.1.12-.39.03-.64-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M249.51,292.16c.2-.16.43-.21.5-.12.07.09-.03.3-.23.46-.2.16-.43.21-.5.12-.07-.09.03-.3.23-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M245.04,295.47c-.21-.22-.28-.48-.16-.6.12-.11.38-.03.59.19.21.22.28.49.16.6s-.38.03-.59-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M244.18,297.65c-.2-.15-.31-.36-.23-.47.08-.11.31-.08.51.07.2.15.31.36.23.47-.08.11-.31.08-.51-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M241.22,294.54c.07.18.05.35-.03.39-.08.03-.21-.09-.27-.27-.07-.18-.05-.35.03-.39.08-.03.21.09.27.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M242.63,295.32c.09.25.08.49-.04.53s-.29-.13-.38-.38-.08-.49.04-.53.29.13.38.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M242.24,297.14c.27,0,.48.13.48.27,0,.14-.22.26-.49.25-.27,0-.48-.13-.48-.27,0-.14.22-.26.49-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M232.48,294.08c.07.18.05.35-.03.39-.08.03-.21-.09-.27-.27s-.05-.35.03-.39c.08-.03.21.09.27.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M238.9,296.12c.09.25.08.49-.04.53s-.29-.13-.38-.38c-.09-.25-.08-.49.04-.53.12-.04.29.13.38.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M235.46,296.31c.27,0,.48.13.48.27s-.22.26-.49.25c-.27,0-.48-.13-.48-.27,0-.14.22-.26.49-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M240,290.1c.25-.15.53-.17.61-.03.08.14-.06.37-.31.52-.25.15-.53.17-.61.03-.08-.14.06-.37.31-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M239.4,290.78c-.1.21-.26.34-.38.28-.11-.05-.13-.26-.03-.47.1-.21.26-.34.38-.28s.13.26.03.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M250.86,287.76c.07.18.39.22.72.1.21-.08.37-.2.45-.33.04-.07.06-.15.03-.21-.07-.17-.36-.22-.68-.12-.01,0-.03,0-.04.02-.33.12-.55.37-.48.55Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M256.85,258.51c.36.03.66-.09.68-.28s-.26-.37-.62-.4-.66.09-.68.28.26.37.62.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "M255.42,261.16c.2.02.41-.43.45-1s-.08-1.05-.29-1.07-.41.43-.45,1,.08,1.05.29,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M257.49,255.79c.43.04.8-.1.82-.32s-.32-.43-.75-.47-.8.1-.82.32.32.43.75.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M259.13,251.89c.26-.23.38-.51.28-.64s-.39-.04-.64.19c-.26.23-.38.51-.28.64.1.13.39.04.64-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M255.8,259.35c.29.17.6.17.69,0,.09-.17-.08-.44-.38-.61-.29-.17-.6-.17-.69,0s.08.44.38.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M259.02,249.17c.29.17.6.17.69,0,.09-.17-.08-.44-.38-.61-.29-.17-.6-.17-.69,0s.08.44.38.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M259.19,222.61c.23.26.33.55.22.67-.11.11-.39,0-.62-.26-.23-.26-.33-.55-.22-.67.11-.11.39,0,.62.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M257.94,246.8c.31-.13.61-.1.68.08.07.18-.13.43-.44.56-.31.13-.61.1-.68-.08s.13-.43.44-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M261.11,218.25c-.24.25-.52.35-.63.23-.11-.12,0-.41.24-.66.24-.25.52-.35.63-.23.11.12,0,.41-.24.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M260.21,222.32c.13.33.09.65-.07.73s-.4-.14-.53-.46c-.13-.33-.09-.65.07-.73.17-.07.4.14.53.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M256.65,240.55c-.24.25-.52.35-.63.23-.11-.12,0-.41.24-.66.24-.25.52-.35.63-.23.11.12,0,.41-.24.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M255.28,239.61c.13.33.09.65-.07.73-.17.07-.4-.14-.53-.46-.13-.33-.09-.65.07-.73.17-.07.4.14.53.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M256.26,223.56c.1-.07.07-.31-.07-.54-.02-.04-.04-.06-.07-.1-.13-.17-.28-.25-.37-.19-.1.07-.06.31.07.54.01.02.02.03.03.04.14.2.32.31.41.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M258.66,222.11c-.25.05-.48-.02-.51-.16-.03-.14.15-.31.41-.36.25-.05.48.02.51.16.03.14-.15.31-.41.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M258.31,222.85c.05-.27.19-.46.31-.44.12.03.17.26.12.53-.05.27-.19.46-.31.44-.12-.03-.17-.26-.12-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M259.8,221.9c-.21-.15-.33-.37-.25-.5.08-.12.31-.1.53.05.21.15.33.37.25.5-.08.12-.31.1-.53-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M257.43,221.6c.16.03.35-.24.42-.61.03-.18.03-.35,0-.48-.03-.14-.09-.23-.17-.25-.16-.03-.35.24-.42.61-.03.17-.03.33-.01.45.02.15.09.26.17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M259.72,219.04c.09-.15-.01-.39-.23-.59-.04-.03-.07-.06-.11-.09-.3-.21-.62-.24-.73-.07-.11.17.05.47.34.68.02.01.03.02.05.03.28.18.58.2.68.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M256.16,237.51c.13.33.09.65-.07.73-.17.07-.4-.14-.53-.46-.13-.33-.09-.65.07-.73s.4.14.53.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M252.94,232.29c.17-.07.2-.4.08-.73-.05-.13-.11-.23-.18-.31-.05-.06-.1-.1-.15-.13-.07-.04-.13-.05-.19-.02-.06.02-.1.08-.12.15-.05.14-.04.36.05.57.09.23.23.4.36.46.06.03.11.03.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M257.51,243.05c.04-.19-.19-.41-.51-.49-.15-.04-.29-.04-.41-.02-.14.03-.23.1-.26.2-.04.19.19.41.51.49.04.01.08.02.12.02.27.04.51-.04.55-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M254.38,238.58c.08.02.18-.08.24-.24.02-.06.05-.13.06-.2.05-.27,0-.5-.12-.53-.06-.01-.13.04-.19.13-.05.08-.09.19-.12.31-.05.27,0,.5.12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M255.51,236.67c-.21-.15-.33-.37-.25-.5s.31-.1.53.05c.21.15.33.37.25.5-.08.12-.31.1-.53-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M253.39,236.79c.16.04.34-.22.41-.58,0,0,0-.02,0-.02.07-.37,0-.7-.16-.73-.03,0-.07,0-.1.01-.13.06-.26.3-.32.59-.07.37,0,.7.16.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M253.06,233.59c.16.03.35-.24.42-.61s0-.7-.16-.73c-.16-.03-.35.24-.42.61v.08c-.06.31,0,.57.12.64.01,0,.03.01.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M252.68,231.27c.05,0,.1-.01.15-.02.15-.04.25-.11.26-.2.02-.14-.15-.29-.41-.37-.06-.02-.12-.03-.18-.04-.35-.05-.66.04-.68.21-.03.17.22.34.55.41.02,0,.03,0,.05,0,.1.02.19.02.27.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M252.71,230.31c.08-.02.17-.05.26-.09.32-.16.52-.42.46-.58-.06-.14-.31-.15-.59-.05-.04.01-.08.03-.11.05-.32.16-.53.42-.46.57.05.12.23.14.45.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M254.95,234.16c-.3-.21-.45-.51-.35-.68s.43-.14.73.07c.3.21.45.51.35.68-.11.17-.43.14-.73-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M253.51,228.67c.11-.34.06-.66-.11-.72-.02,0-.04,0-.06-.01-.16,0-.34.21-.44.5-.09.29-.07.56.05.68.02.02.04.03.07.04.17.06.4-.16.5-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M253.91,227.99c.13-.04.19-.29.12-.55-.06-.22-.19-.39-.3-.41-.02,0-.05,0-.07,0-.12.03-.17.23-.14.46,0,.03.01.06.02.09.07.26.23.45.37.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M256.44,251.63c-.27-.12-.44-.35-.38-.51s.33-.18.61-.06c.27.12.44.35.38.51-.06.16-.33.18-.61.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M254.99,229.13c.13.2.16.42.07.48-.09.06-.26-.05-.39-.26-.13-.2-.16-.42-.07-.48.09-.06.26.05.39.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M255.98,225.14c.17.28.22.58.09.66-.12.09-.36-.07-.53-.35s-.22-.58-.09-.66c.12-.09.36.07.53.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M256.86,232.02c.31-.07.59.02.62.2s-.19.38-.5.44c-.31.07-.59-.02-.62-.2-.03-.18.19-.38.5-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M255.68,242.1c-.23.2-.51.25-.61.12s0-.41.24-.61c.23-.2.51-.25.61-.12s0,.41-.24.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M259.4,220.05c-.16.2-.38.29-.48.2-.1-.09-.05-.33.11-.54s.38-.29.48-.2c.1.09.05.33-.11.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M257.09,225.22c.19-.05.36-.02.38.07.02.09-.11.21-.3.27s-.36.02-.38-.07c-.02-.09.11-.21.3-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M257.99,223.8c.26-.08.49-.03.53.09s-.15.29-.41.37c-.26.08-.49.03-.53-.09-.03-.13.15-.29.41-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M255.63,240.62c.03-.28.17-.5.31-.48.14.02.24.26.21.54-.03.28-.17.5-.31.48-.14-.02-.24-.26-.21-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M256.35,243.66c.23.26.33.55.22.67-.11.11-.39,0-.62-.26-.23-.26-.33-.55-.22-.67s.39,0,.62.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M262.17,220.01c-.24.25-.52.35-.63.23-.11-.12,0-.41.24-.66.24-.25.52-.35.63-.23.11.12,0,.41-.24.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M253.92,241.21c-.14-.23-.18-.47-.08-.54.1-.07.29.06.44.29.14.23.18.47.08.54-.1.07-.29-.06-.44-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M256.83,246.25c-.23.2-.51.25-.61.12-.1-.13,0-.41.24-.61.23-.2.51-.25.61-.12s0,.41-.24.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M258.92,247.37c-.16.2-.38.29-.48.2-.1-.09-.05-.33.11-.54.16-.2.38-.29.48-.2.1.09.05.33-.11.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M255.57,250.22c.19-.05.36-.02.38.07.02.09-.11.21-.3.27-.19.05-.36.02-.38-.07-.02-.09.11-.21.3-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M256.46,248.8c.26-.08.49-.03.53.09s-.15.29-.41.37-.49.03-.53-.09.15-.29.41-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M258.25,249.37c.03-.28.17-.5.31-.48.14.02.24.26.21.54-.03.28-.17.5-.31.48-.14-.02-.24-.26-.21-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M259.87,245.91c.19-.05.36-.02.38.07.02.09-.11.21-.3.27s-.36.02-.38-.07c-.02-.09.11-.21.3-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M256.94,252.82c.26-.08.49-.03.53.09s-.15.29-.41.37c-.26.08-.49.03-.53-.09-.03-.13.15-.29.41-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M256.83,256.48c.03-.28.17-.5.31-.48s.24.26.21.54c-.03.28-.17.5-.31.48-.14-.02-.24-.26-.21-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M256.57,237.58c-.13-.28-.12-.57.02-.65.14-.07.37.1.5.38.13.28.12.57-.02.65-.14.07-.37-.1-.5-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M257.19,238.28c.2.12.31.31.25.42-.06.11-.27.11-.47-.01-.2-.12-.31-.31-.25-.42s.27-.11.47.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M256.57,285.84c.36.03.66-.09.68-.28s-.26-.37-.62-.4-.66.09-.68.28.26.37.62.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M255.14,288.49c.2.02.41-.43.45-1s-.08-1.05-.29-1.07-.41.43-.45,1,.08,1.05.29,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M257.21,283.12c.43.04.8-.1.82-.32s-.32-.43-.75-.47-.8.1-.82.32.32.43.75.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M258.85,279.22c.26-.23.38-.51.28-.64s-.39-.04-.64.19c-.26.23-.38.51-.28.64.1.13.39.04.64-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M255.52,286.68c.29.17.6.17.69,0,.09-.17-.08-.44-.38-.61-.29-.17-.6-.17-.69,0s.08.44.38.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M258.75,276.49c.29.17.6.17.69,0,.09-.17-.08-.44-.38-.61-.29-.17-.6-.17-.69,0s.08.44.38.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M257.66,274.13c.31-.13.61-.1.68.08.07.18-.13.43-.44.56-.31.13-.61.1-.68-.08s.13-.43.44-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M256.38,267.88c-.24.25-.52.35-.63.23-.11-.12,0-.41.24-.66.24-.25.52-.35.63-.23.11.12,0,.41-.24.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M255,266.94c.13.33.09.65-.07.73-.17.07-.4-.14-.53-.46-.13-.33-.09-.65.07-.73.17-.07.4.14.53.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M255.89,264.84c.13.33.09.65-.07.73-.17.07-.4-.14-.53-.46-.13-.33-.09-.65.07-.73s.4.14.53.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M252.66,259.62c.17-.07.2-.4.08-.73-.05-.13-.11-.23-.18-.31-.05-.06-.1-.1-.15-.13-.07-.04-.13-.05-.19-.02-.06.02-.1.08-.12.15-.05.14-.04.36.05.57.09.23.23.4.36.46.06.03.11.03.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M257.23,270.38c.04-.19-.19-.41-.51-.49-.15-.04-.29-.04-.41-.02-.14.03-.23.1-.26.2-.04.19.19.41.51.49.04.01.08.02.12.02.27.04.51-.04.55-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M254.11,265.9c.08.02.18-.08.24-.24.02-.06.05-.13.06-.2.05-.27,0-.5-.12-.53-.06-.01-.13.04-.19.13-.05.08-.09.19-.12.31-.05.27,0,.5.12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M255.24,264c-.21-.15-.33-.37-.25-.5s.31-.1.53.05c.21.15.33.37.25.5-.08.12-.31.1-.53-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M253.12,264.12c.16.04.34-.22.41-.58,0,0,0-.02,0-.02.07-.37,0-.7-.16-.73-.03,0-.07,0-.1.01-.13.06-.26.3-.32.59-.07.37,0,.7.16.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M252.78,260.92c.16.03.35-.24.42-.61s0-.7-.16-.73c-.16-.03-.35.24-.42.61v.08c-.06.31,0,.57.12.64.01,0,.03.01.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M252.41,258.6c.05,0,.1-.01.15-.02.15-.04.25-.11.26-.2.02-.14-.15-.29-.41-.37-.06-.02-.12-.03-.18-.04-.35-.05-.66.04-.68.21-.03.17.22.34.55.41.02,0,.03,0,.05,0,.1.02.19.02.27.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M252.43,257.64c.08-.02.17-.05.26-.09.32-.16.52-.42.46-.58-.06-.14-.31-.15-.59-.05-.04.01-.08.03-.11.05-.32.16-.53.42-.46.57.05.12.23.14.45.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M254.67,261.49c-.3-.21-.45-.51-.35-.68s.43-.14.73.07c.3.21.45.51.35.68-.11.17-.43.14-.73-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M253.23,255.99c.11-.34.06-.66-.11-.72-.02,0-.04,0-.06-.01-.16,0-.34.21-.44.5-.09.29-.07.56.05.68.02.02.04.03.07.04.17.06.4-.16.5-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M253.63,255.32c.13-.04.19-.29.12-.55-.06-.22-.19-.39-.3-.41-.02,0-.05,0-.07,0-.12.03-.17.23-.14.46,0,.03.01.06.02.09.07.26.23.45.37.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M256.16,278.96c-.27-.12-.44-.35-.38-.51s.33-.18.61-.06c.27.12.44.35.38.51-.06.16-.33.18-.61.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M254.71,256.46c.13.2.16.42.07.48-.09.06-.26-.05-.39-.26-.13-.2-.16-.42-.07-.48.09-.06.26.05.39.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M256.58,259.35c.31-.07.59.02.62.2s-.19.38-.5.44c-.31.07-.59-.02-.62-.2-.03-.18.19-.38.5-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M255.4,269.43c-.23.2-.51.25-.61.12s0-.41.24-.61c.23-.2.51-.25.61-.12s0,.41-.24.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M255.35,267.95c.03-.28.17-.5.31-.48.14.02.24.26.21.54-.03.28-.17.5-.31.48-.14-.02-.24-.26-.21-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M256.08,270.99c.23.26.33.55.22.67-.11.11-.39,0-.62-.26-.23-.26-.33-.55-.22-.67s.39,0,.62.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M253.64,268.54c-.14-.23-.18-.47-.08-.54.1-.07.29.06.44.29.14.23.18.47.08.54-.1.07-.29-.06-.44-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M256.56,273.58c-.23.2-.51.25-.61.12-.1-.13,0-.41.24-.61.23-.2.51-.25.61-.12s0,.41-.24.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M258.65,274.7c-.16.2-.38.29-.48.2-.1-.09-.05-.33.11-.54.16-.2.38-.29.48-.2.1.09.05.33-.11.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M255.29,277.55c.19-.05.36-.02.38.07.02.09-.11.21-.3.27-.19.05-.36.02-.38-.07-.02-.09.11-.21.3-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M256.19,276.13c.26-.08.49-.03.53.09s-.15.29-.41.37-.49.03-.53-.09.15-.29.41-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M257.97,276.7c.03-.28.17-.5.31-.48.14.02.24.26.21.54-.03.28-.17.5-.31.48-.14-.02-.24-.26-.21-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M259.6,273.24c.19-.05.36-.02.38.07.02.09-.11.21-.3.27s-.36.02-.38-.07c-.02-.09.11-.21.3-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M256.67,280.15c.26-.08.49-.03.53.09s-.15.29-.41.37c-.26.08-.49.03-.53-.09-.03-.13.15-.29.41-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M256.55,283.81c.03-.28.17-.5.31-.48s.24.26.21.54c-.03.28-.17.5-.31.48-.14-.02-.24-.26-.21-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M256.29,264.91c-.13-.28-.12-.57.02-.65.14-.07.37.1.5.38.13.28.12.57-.02.65-.14.07-.37-.1-.5-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M256.92,265.61c.2.12.31.31.25.42-.06.11-.27.11-.47-.01-.2-.12-.31-.31-.25-.42s.27-.11.47.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M255.17,225.86c.18-.06.26-.39.16-.76-.06-.23-.17-.41-.29-.51-.07-.05-.14-.07-.21-.05-.18.05-.25.37-.18.71,0,.01,0,.03.01.05.09.36.32.62.51.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M236.35,298.37c2.5.28,5.6.48,9.43.52,10.56.11,16.24-1.35,18.54-2.14-.94-.18-3.07-.6-3.25-.63-.22-.04-2.56,1.25-7.14,2.12-4.59.87-8.35-.16-9.19.26-.76.37-6.25.09-8.39-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M229.59,297.03s-.27.01-.26.02c.02,0,.34.02.36.02,1.17.44,1.95.74,6.1,1.24-1.49-.21-2.39-1.66-4.12-1.54-.76.05-1.34.16-2.08.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M295.53,226.39s0,0,0,0c0,0,0-.02-.01-.02h0s-.02-.03-.02-.04c0,0,0,0,0,0,0,0,0-.02-.02-.02,0-.01-.02-.02-.02-.03,0,0,0,0,0,0,0-.01-.02-.02-.03-.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01-.01,0,0,0,0,0,0-.02-.02-.04-.04-.06-.06-.02-.02-.04-.03-.06-.04,0,0-.01,0-.02-.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02-.01-.01,0-.02-.01-.03-.02,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0h0s-.01,0-.02,0c0,0,0,0-.01,0-.01,0-.02,0-.03-.01,0,0,0,0-.01,0-.02,0-.04-.01-.07-.02-.01,0-.02,0-.03,0-.03,0-.06-.01-.1-.02,0,0-.02,0-.03,0-.04,0-.08,0-.12-.01-.02,0-.03,0-.05,0-.02,0-.05,0-.07,0-.06,0-.12,0-.18-.01,0,0,0,0,0,0-.04,0-.09,0-.13,0-.02,0-.04,0-.07,0,0,0,0,0,0,0-.04,0-.08,0-.12-.02,0,0-.02,0-.03,0,0,0-.02,0-.03,0-.05,0-.11-.02-.15-.04-.05-.02-.11-.04-.16-.05h0c-.14-.05-.28-.1-.42-.13,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0-.02,0-.02,0-.04,0-.09-.02-.13-.02-.02.01-.04.03-.06.04,0,0,0,0,0,0-.02.01-.04.02-.06.03-.02,0-.03.01-.05.02,0,0,0,0,0,0-.02,0-.04.01-.06.02-.02,0-.04,0-.05.01-.01,0-.02,0-.03,0-.02,0-.04,0-.05,0,0,0-.01,0-.02,0,0,0-.02,0-.02,0-.01,0-.02,0-.03,0-.02,0-.04,0-.06,0-.01,0-.03,0-.04,0-.01,0-.02,0-.04,0,0,0,0,0-.01,0-.02,0-.03,0-.05-.02,0,0-.01,0-.02,0-.02,0-.04-.02-.05-.03,0,0-.02,0-.02-.01-.02-.01-.04-.03-.06-.04-.02-.02-.04-.03-.06-.05-.03-.03-.06-.06-.09-.09-.01-.01-.02-.02-.03-.03,0,0,0,0-.01-.01,0,0-.01-.01-.02-.02,0,0-.01-.01-.02-.02,0,0,0,0,0,0-.03-.03-.06-.05-.09-.08t0,0s-.02-.01-.03-.02c0,0,0,0,0,0-.02-.01-.04-.03-.06-.04-.03-.02-.07-.05-.1-.07-.04-.03-.07-.05-.1-.08-.01-.01-.02-.02-.03-.04-.02-.02-.03-.04-.05-.05,0,0,0,0,0,0-.02-.01-.05-.03-.07-.04-.02-.01-.04-.02-.06-.04,0,0,0,0-.01,0-.04-.03-.08-.06-.11-.1,0,0,0,0,0,0-.04-.04-.08-.08-.11-.12,0,0,0,0,0-.01-.03-.04-.06-.07-.09-.11,0-.01-.02-.02-.03-.03,0,0,0,0,0,0-.02-.03-.05-.06-.07-.1,0,0,0-.01-.01-.02-.02-.03-.04-.06-.06-.09,0,0,0-.01-.01-.02-.04-.05-.07-.11-.11-.17-.02-.03-.04-.07-.06-.1,0-.01-.02-.03-.03-.04-.03-.04-.06-.09-.09-.13,0,0,0,0,0,0-.03-.04-.05-.08-.08-.11,0-.01-.02-.02-.03-.04-.02-.03-.04-.06-.06-.08,0-.01-.02-.02-.03-.03-.03-.04-.06-.07-.09-.1-.05-.05-.09-.1-.14-.15,0,0-.02-.02-.03-.03-.05-.05-.09-.1-.14-.15,0,0,0,0,0,0-.16-.17-.31-.35-.48-.52,0,0-.01-.01-.02-.02-.03-.03-.06-.06-.09-.08,0,0-.02-.02-.03-.03-.03-.02-.05-.05-.08-.07-.01-.01-.02-.02-.04-.03-.02-.02-.05-.04-.08-.06-.01-.01-.03-.02-.04-.03-.02-.01-.04-.03-.06-.04,0,0-.01,0-.02-.01-.01-.01-.03-.02-.04-.03-.03-.02-.05-.04-.08-.05-.02,0-.03-.02-.05-.03,0,0-.02-.01-.03-.02,0,0-.01,0-.02-.01-.01,0-.03-.02-.04-.02-.01,0-.03-.02-.04-.02-.04-.02-.09-.04-.13-.07-.05-.02-.1-.05-.14-.08-.01,0-.03-.01-.04-.01-.03,0-.05-.02-.08-.03-.11-.03-.22-.06-.33-.09,0,0,0,0,0,0-.12-.04-.23-.07-.35-.11-.22-.07-.44-.14-.66-.19-.02,0-.03,0-.05-.01-.02,0-.03,0-.05-.01h0s0,0,0,0c-.07-.02-.15-.03-.22-.04-.08-.01-.16-.02-.24-.04,0,0,0,0-.01,0-.02,0-.05,0-.07-.01-.07-.01-.13-.03-.2-.04-.04-.01-.08-.02-.12-.04-.02,0-.03-.01-.05-.02,0,0,0,0-.01,0-.02,0-.05-.02-.07-.03-.01,0-.02,0-.03-.01-.02,0-.03-.02-.05-.03-.02-.01-.05-.02-.07-.04-.02,0-.03-.02-.05-.03-.02-.01-.04-.03-.06-.04-.02-.01-.03-.02-.05-.04-.02-.02-.04-.03-.06-.05-.01-.01-.03-.02-.04-.04,0,0,0,0,0,0-.03-.03-.06-.06-.08-.09,0,0-.02-.02-.02-.03-.05-.06-.09-.12-.13-.18-.02-.03-.04-.06-.06-.09-.04-.06-.07-.12-.11-.18-.06-.11-.11-.21-.16-.32-.03-.08-.07-.15-.1-.23-.02-.04-.03-.08-.05-.11-.02-.04-.04-.09-.05-.13-.02-.06-.05-.12-.07-.18-.06-.17-.12-.33-.19-.5-.02-.05-.04-.1-.06-.14-.01-.03-.03-.06-.04-.09-.03-.08-.07-.16-.1-.23,0-.01-.01-.02-.02-.04-.03-.07-.07-.13-.1-.2,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.01-.02-.03-.03-.04l-.3-.78s-.14-.32-.18-.42c-.05-.15-.11-.08-.12-.23-.01-.17-.01-.34,0-.5,0-.05.01-.1.02-.15,0-.24,0-.48-.02-.72,0-.08-.03-.18-.05-.29-.03-.1-.08-.19-.12-.29,0,0,0,0,0,0-.01-.03-.03-.05-.04-.08,0-.01-.01-.02-.02-.04-.06-.12-.12-.23-.2-.34-.01-.02-.03-.04-.04-.06-.01-.02-.03-.04-.04-.06,0,0,0,0,0,0-.15-.2-.32-.36-.53-.47-.55-.3-1.36-.31-2.02-.37-.09,0-.17-.02-.25-.03-.04,0-.08-.01-.12-.02,0,0,0,0,0,0-.04,0-.08-.01-.12-.02,0,0,0,0,0,0-.75-.11-1.48-.27-2.23-.4-.27-.05-.54-.1-.81-.14h0s0,0,0,0c-.19-.03-.39-.06-.58-.09h0s0,0,0,0c-.22-.03-.44-.07-.66-.1,0,0,0,0,0,0,0,0,0,0,0,0-.04,0-.08-.01-.11-.02,0,0,0,0,0,0,0,0-.01,0-.02,0-.02,0-.04,0-.06,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02,0-.04,0-.07,0,0,0,0,0,0,0,0,0,0,0-.01,0-.08-.01-.16-.02-.24-.03h0s-.04,0-.05,0h0s-.03,0-.05,0c-.07,0-.13-.02-.2-.02h0s0,0,0,0c-.02,0-.03,0-.05,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0,0,0-.02,0-.04,0-.06,0-.08,0-.16-.02-.23-.03,0,0,0,0,0,0-.01,0-.02,0-.03,0h0s0,0,0,0c-.06,0-.12-.01-.18-.02,0,0,0,0,0,0-.09,0-.18-.02-.27-.03,0,0-.02,0-.03,0,0,0,0,0,0,0-.14-.01-.27-.02-.41-.03,0,0,0,0,0,0,0,0,0,0,0,0-.06,0-.12,0-.17-.01-.03,0-.06,0-.09,0-.25-.02-.49-.03-.74-.04-.18,0-.36-.01-.54-.01-.11,0-.23,0-.34,0-.07,0-.14,0-.21,0-.14,0-.27,0-.41-.01-.07,0-.14,0-.21,0-.36.02-.73.03-1.13,0-.1,0-.2-.01-.3-.02-.13,0-.26-.02-.39-.03-.08,0-.15-.01-.23-.02-.03,0-.05,0-.08,0-.1,0-.19-.02-.29-.03-.07-.01-.15-.02-.22-.04-.43-.08-.88-.18-1.31-.05-.07.02-.14.05-.2.07,0,0,0,0,0,0-.17.07-.34.17-.5.27h0s-.04.03-.06.04c0,0,0,0,0,0h0s-.01,0-.02.01h0s-.07.05-.1.07c-.11.07-.21.15-.32.22-.04.03-.09.05-.13.08-.03.02-.07.04-.1.06-.07.04-.14.09-.22.13-.06.03-.11.07-.17.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02.01-.03.02,0,0,0,0,0,0,0,0,0,0,0,0-.02.01-.04.02-.06.03h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0-.04.02-.07.04-.11.07,0,0,0,0,0,0-.01,0-.03.02-.04.03,0,0-.01,0-.02.01,0,0-.02.01-.03.02,0,0,0,0-.01,0-.07.04-.14.09-.2.13-.03.02-.05.04-.07.06,0,0,0,0,0,0,0,0,0,0,0,0-.02.02-.04.03-.06.05,0,0,0,0,0,0-.01.01-.02.02-.04.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.03.02-.06.05-.08.07-.02.02-.04.04-.06.06-.02.02-.04.04-.07.06,0,0,0,0-.01.01-.02.02-.04.04-.06.06-.02.02-.03.03-.05.05-.04.04-.07.07-.11.11-.05.05-.1.1-.15.15,0,0-.01.01-.02.02-.03.03-.07.06-.1.1-.01.01-.02.02-.03.03-.04.04-.08.07-.11.11h0s0,0,0,0c-.02.03-.03.05-.05.08,0,.01-.02.03-.02.04-.05.08-.09.16-.14.24-.01.02-.02.03-.03.05,0,0,0,.01-.01.02,0,0,0,0,0,0-.03.04-.06.09-.09.13,0,0,0,0-.01.01-.01.01-.02.03-.03.04-.02.03-.05.06-.07.09-.01.02-.03.03-.04.05-.04.05-.09.1-.14.14-.07.07-.14.13-.22.19,0,0,0,0,0,0-.04.07-.08.13-.12.19,0,.01-.02.03-.03.04-.01.02-.02.03-.03.05-.01.02-.03.04-.04.05-.04.05-.07.1-.11.15-.02.02-.04.05-.06.07-.03.03-.05.06-.08.09-.06.08-.12.15-.19.23,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01.02-.02.02,0,0-.01.01-.02.02-.02.02-.03.04-.05.06-.04.05-.08.1-.11.15-.05.07-.11.15-.16.22-.04.05-.07.1-.11.14-.03.04-.06.07-.08.11-.05.06-.1.12-.15.18,0,0,0,0,0,0-.03.04-.06.07-.09.11-.08.1-.17.19-.25.28,0,0,0,0,0,.01,0,.02-.02.04-.03.06,0,0,0,0,0,0,0,0,0,.02-.01.02,0,0,0,.02-.01.02,0,0,0,.01-.01.02,0,0,0,0,0,.01,0,0-.01.02-.02.03-.01.02-.03.04-.05.05-.03.03-.05.06-.08.09,0,0,0,0,0,0,0,0-.01.01-.02.02,0,0,0,0,0,0,0,0,0,.01-.01.02-.01.01-.02.02-.03.03,0,0-.01.01-.02.02h0s0,0,0,0c0,0-.01.01-.02.02,0,0-.01.02-.02.02,0,.01-.02.02-.03.03,0,0-.02.02-.02.03,0,0,0,.01-.01.02,0,0-.01.01-.02.02,0,0-.01.01-.02.02,0,0,0,0,0,0,0,0,0,.01-.01.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01.02-.02.03,0,0-.02.02-.02.03,0,0,0,0,0,0,0,.01-.02.02-.03.03,0,0,0,0-.01.01,0,0-.01.02-.02.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.02.02-.03.04-.05.07,0,0,0,0,0,0,0,0,0,.01-.01.02,0,0-.01.02-.02.03,0,0,0,.01-.01.02,0,0,0,.01-.01.02,0,.01-.02.03-.03.04,0,0-.01.02-.02.03,0,0,0,.01-.01.02,0,.01-.01.02-.02.03,0,0,0,.01-.01.02,0,0,0,0,0,0,0,0,0,.01-.01.02,0,0,0,0,0,.01h0s-.02.03-.02.04c0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.02-.01.02,0,.01-.01.02-.02.03,0,0,0,.01-.01.02,0,0,0,.02-.01.02,0,.01-.02.03-.02.04,0,0,0,.01-.01.02,0,0,0,0,0,0,0,.01-.01.02-.02.03,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,.01,0,.01-.01.02-.02.04-.02.03-.03.06-.05.09,0,.01-.01.03-.02.04,0,0,0,.01,0,.02-.01.02-.02.04-.03.07,0,.01-.01.03-.02.04,0,0,0,.02-.01.03,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,.02-.01.03-.02.05,0,.01,0,.03-.01.04,0,.02-.01.03-.02.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,.02-.01.04-.02.05,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,.01,0,.03,0,.04,0,0,0,.01,0,.02,0,0,0,0,0,0,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,.04-.01.06,0,0,0,0,0,0,0,0,0,.02,0,.03h0s0,.01,0,.02c0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.03,0,.06,0,.08,0,0,0,0,0,0,.01.17.07.33.18.46.08-.03.16-.05.26-.05.11,0,.22,0,.33,0h0c.14,0,.28,0,.42,0,.11,0,.22,0,.34,0,.25,0,.49,0,.74.02.26,0,.52.01.78.02.18,0,.36.01.54.02,0,0,0,0,0,0,.8.03,1.6.05,2.4.05.21,0,.43,0,.64,0,.31,0,.62.01.93.02.07,0,.15,0,.22,0,.13,0,.27.01.4.02,0,0,0,0,0,0,.16,0,.33.02.49.03.03,0,.06,0,.08,0,.17.01.33.02.5.04.06,0,.11.01.17.02.11.01.22.02.33.03.07,0,.14.02.21.02.13.02.25.03.38.05.16.02.32.05.49.08.06.01.12.02.19.03h0s0,0,0,0t0,0s0,0,0,0c.02,0,.05,0,.07,0h0s.04,0,.07,0h0s.02,0,.03,0c.2,0,.39-.02.59-.02.41,0,.82.02,1.23-.03.03,0,.05,0,.08,0,0,0,0,0,.01,0,.03,0,.05,0,.07.01.01,0,.02,0,.03.01,0,0,.02,0,.03.01.01,0,.02.01.03.02,0,0,0,0,.01.01,0,0,0,0,0,0,0,0,.01.01.02.02,0,.01.01.02.02.03,0,0,0,0,0,0,0,0,0,0,0,.01,0,.01.01.02.02.04,0,0,0,0,0,0,0,0,0,.01,0,.02,0,.02,0,.05,0,.07,0,.05,0,.09,0,.14,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,.03,0,.06,0,.09,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,.01,0,.02,0,.04,0,.01,0,.03.01.04,0,.02,0,.05.01.07,0,.01,0,.02,0,.04,0,.02,0,.05,0,.07.01.08.02.16.03.24,0,.06.01.12.01.18,0,.02,0,.04,0,.06,0,0,0,0,0,0,0,.06,0,.13,0,.19,0,.02,0,.03,0,.05,0,0,0,0,0,0,0,0,0,0,0,0,.02.13.03.26.06.4.05.24.13.48.2.72.02.08.04.16.06.24,0,0,0,0,0,0h0s.05.09.07.14h0s0,0,0,.01c0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0h0s0,.01.01.02c.04.07.08.14.12.2,0,0,0,0,0,0,0,0,0,0,0,0,.02.02.03.03.05.05,0,0,0,0,.01.01.01.01.03.02.04.04.03.03.06.06.08.1.03.05.06.11.09.17.07.15.13.31.17.46.02.06.04.12.05.18,0,.02,0,.04.01.06.02.1.04.19.06.29,0,0,0,.02,0,.03.02.1.03.2.04.3.02.24.03.49.02.73,0,.16-.02.33-.04.49-.02.13-.03.27-.05.4,0,.01,0,.02,0,.03,0,0,0,.02,0,.03h0s0,.02,0,.03v.02s0,0,0,0c0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,.01,0,.03,0,.04,0,0,0,0,0,0,0,.03,0,.05,0,.08,0,.01,0,.02,0,.03,0,0,0,0,0,.01,0,.01,0,.03,0,.04h0,0s0,0,0,0h0s0,.03,0,.05c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.04,0,.07,0,.11,0,0,0,.02,0,.02,0,0,0,0,0,0,0,0,0,0,0,.01h0s0,0,0,0c0,0,0,0,0,0,0,.01,0,.02,0,.03,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0h0s0,0,0,0c-.01.15-.02.31-.04.46,0,.02,0,.03,0,.05,0,.05-.01.09-.02.14,0,.05-.02.11-.03.16,0,.03-.02.05-.03.08,0,0,0,0,0,0-.01.03-.02.06-.04.08,0,0,0,0,0,0,0,.02.01.03.01.05,0,0,0,0,0,.01,0,.03.02.06.03.09,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,.01.01.03.03.06.04.09.02.04.04.08.06.12,0,0,0,.02.01.02h0c.03.06.06.13.08.19,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.02.02.02.02.01.01.03.03.04.04,0,0,.01.02.02.03,0,0,0,0,0,0,.02.02.03.05.04.07,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,.02.01.02,0,.02.02.05.02.07,0,0,0,.02,0,.03.02.09.04.18.07.27,0,.02.01.04.02.07,0,.02,0,.03.01.05,0,0,0,0,0,0,.02.06.03.12.05.19.01.04.02.07.03.11.04.14.07.27.11.41.03.11.05.22.07.33h0s0,.02,0,.02c0,.05.02.1.03.15.02.11.03.22.04.33,0,.02,0,.04,0,.05,0,.04,0,.09.01.13,0,.09.01.18.02.27,0,.03,0,.07,0,.1,0,.05,0,.1.01.15,0,.01,0,.02,0,.03,0,0,0,.01,0,.02,0,.07.01.14.02.21,0,.02,0,.05,0,.07.01.09.02.19.04.28.03.16.05.31.08.46h0c.03.18.05.36.07.54,0,.08.02.15.02.23,0,.1.02.2.02.3,0,.04,0,.07,0,.1,0,0,0,0,0,0,0,.01,0,.03,0,.04,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06,0,.03,0,.05.01.08,0,.03,0,.05.01.08,0,.02,0,.04.01.06.01.05.02.09.04.14,0,.01.01.03.02.05,0,0,0,0,0,0,.02.04.04.08.06.12,0,.01.01.02.02.03,0,.01.01.02.02.04,0,0,0,.02.01.02.02.03.04.07.06.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.02.01.03.02.04.04,0,0,0,0,0,0h0s.06.03.09.05c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.68.22,1.35.5,2.03.72.04.01.08.02.12.04.07.02.14.04.21.06,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0,0,.09.02.17.05.26.07.04.01.09.02.13.03.03,0,.07.02.1.02,0,0-.02,0-.03,0,.08.02.17.04.25.06.1.02.17.05.24.1.05,0,.09.01.14.02.02,0,.04.01.06.02h0s.08.03.11.04c.02,0,.04,0,.05,0,.04,0,.07,0,.1.02.03.01.06.03.08.06,0,0,.01.02.02.02,0,.01.02.02.02.04,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.02.01.03,0,0,0,.02,0,.02,0,0,0,0,0,0,0,.01,0,.03,0,.04,0,0,0,.01,0,.02,0,0,0,0,0,0,0,.02,0,.04,0,.05,0,0,0,0,0,.01,0,0,0,0,0,.01,0,.02-.01.04-.02.05,0,.01-.01.02-.02.03,0,0-.01.02-.02.02,0,0,0,0,0,0,0,.02-.01.04-.02.06,0,.02-.02.03-.04.05-.02.05-.05.09-.07.13l.03-.06s-.02.04-.03.07c-.02.04-.03.07-.05.11,0,0,0,.02-.01.02-.03.04-.06.09-.09.13,0,0,0,0,0,0-.21.4-.45.77-.68,1.16-.01.02-.02.04-.03.06-.03.06-.07.12-.1.19-.01.02-.03.05-.04.07-.01.02-.02.04-.03.06-.03.06-.06.13-.09.19-.03.07-.06.13-.08.2,0,.01,0,.02-.01.04,0,.01,0,.02-.01.03,0,0,0,0,0,0,0,0,0,.02,0,.02-.01.03-.03.07-.04.1,0,.03-.02.05-.03.08-.01.04-.02.07-.04.11-.01.03-.02.06-.03.09,0,.02-.01.04-.02.07,0,.01,0,.03-.01.04-.03.11-.07.21-.1.32-.01.04-.02.07-.04.11-.02.05-.04.1-.05.15,0,.01,0,.03-.01.04-.01.04-.03.08-.04.12-.01.03-.03.07-.04.1-.02.05-.04.1-.06.15-.03.07-.07.15-.1.22-.01.03-.03.05-.04.07,0,0,0,0,0,.01-.01.04-.02.07-.04.11-.04.08-.08.16-.11.25,0,.01-.01.03-.02.04,0,0,0,.01,0,.02-.02.04-.04.09-.05.13,0,0,0,.02,0,.02,0,0,0,.02-.01.03,0,0,0,0,0,0,0,.01,0,.02-.01.03,0,0,0,0,0,0,0,.02-.02.05-.03.07,0,0,0,0,0,0,0,0,0,0,0,0-.06.16-.12.31-.18.47,0,0,0,0,0,0,0,0,0,0,0,0-.13.37-.25.74-.36,1.12-.01.05-.03.1-.04.14,0,.02-.01.05-.02.07,0,.02-.01.05-.01.07,0,.04-.01.07-.02.11,0,.01,0,.02,0,.04,0,.05-.01.09-.02.14,0,0,0,0,0,0-.02.2-.03.4-.02.6,0,.19,0,.39,0,.58,0,.03,0,.05,0,.08,0,.1,0,.19,0,.29,0,.08,0,.15,0,.23.02.07.04.13.07.19,0,0,0,0,0,0,0,.02.01.04.02.05,0,.01.01.02.02.04.03.07.05.13.08.19,0,.01.01.03.02.05.06.13.13.26.2.4,0,0,0,.02.01.03.15.3.31.58.48.86h0s0,0,0,0c.02.03.04.06.06.09,0,0,0,0,0,0,0,0,.01,0,.02,0,.01,0,.03,0,.04.02,0,0,.01,0,.02,0,.02,0,.03,0,.05,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,.02,0,.03.02.05.03.01,0,.02.02.04.03,0,0,.01.01.02.02.01.01.02.03.03.04,0,.02.02.03.02.05,0,.01,0,.02,0,.04h0c.02.1.04.19.05.29,0,.06.01.13.02.19,0,.02,0,.05,0,.07,0,.02,0,.05,0,.07,0,.06,0,.12,0,.18,0,.03,0,.06,0,.1.03.16,0,.31-.06.43,0,.01-.01.02-.02.03,0,0-.01.02-.02.03-.01.02-.03.04-.05.06,0,0,0,.01-.01.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01.02-.02.03-.03.05-.02.02-.03.03-.05.04,0,0,0,0,0,0,0,0-.02,0-.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.02,0-.03,0-.04.02-.09.04-.13.06-.01,0-.03,0-.04.01,0,0-.02,0-.03,0-.02,0-.05,0-.07.01,0,0-.01,0-.02,0-.04,0-.07,0-.11,0-.04.02-.09.04-.13.05,0,0,0,0-.01,0-.04.01-.08.03-.12.04-.38.12-.77.2-1.06.48-.28.27-.45.6-.58.96,0,0,0,0,0,0-.03.07-.05.15-.07.22,0,0,0,0,0,0-.02.07-.04.15-.06.23,0,0,0,0,0,0-.04.16-.07.31-.1.47,0,0,0,0,0,0-.03.15-.06.31-.09.46-.18.89-.53,1.74-.64,2.65-.09.7-.01,1.4-.02,2.1,0,.08,0,.17,0,.25,0,.09,0,.19-.02.28,0,.07-.02.15-.03.22-.01.09-.02.18-.04.26,0,.04-.01.08-.02.12,0,.02,0,.04-.01.06-.01.07-.02.13-.04.2-.01.06-.03.13-.04.19-.05.2-.1.41-.15.61-.03.12-.07.23-.1.35-.05.16-.09.32-.14.49-.02.08-.05.17-.07.25,0,.02-.01.05-.02.07,0,.02,0,.03-.01.05,0,.04-.02.08-.03.12,0,0,0,0,0,0-.01.05-.02.09-.03.14,0,0,0,.02,0,.02,0,0,0,0,0,0,0,.03-.01.06-.02.09,0,.04-.02.09-.03.13,0,0,0,0,0,0,0,.02,0,.05-.01.07-.01.06-.02.12-.03.19,0,.04-.01.07-.02.11,0,0,0,0,0,.01,0,0,0,0,0,0h0c-.03.2-.06.41-.09.62,0,.04-.01.07-.02.11-.01.07-.02.14-.03.22-.02.13-.04.26-.06.39-.06.32-.15.64-.26.94,0,.04-.02.08-.03.12,0-.02.01-.03.02-.05-.04.1-.06.21-.1.31-.04.1-.08.19-.14.28-.09.32-.19.65-.28.97,0,.01,0,.03-.01.04h0c-.11.36-.27.73-.34,1.09,0,.04-.02.08-.04.12,0,.05-.01.1-.03.15-.16.46-.33.91-.49,1.37h0s0,0,0,0c-.03.08-.05.15-.08.23h0s0,0,0,0c-.02.07-.05.14-.07.2-.01.04-.03.08-.04.12,0,.02-.01.03-.02.05,0,.03-.02.05-.03.08-.02.07-.05.14-.07.22-.02.05-.03.1-.05.15,0,.03-.02.05-.02.08-.03.09-.05.17-.07.26-.01.05-.03.09-.04.14,0,.01,0,.03-.01.04,0,.03-.01.06-.02.09-.03.12-.06.24-.08.35-.03.12-.05.24-.08.37,0,0,0,0,0,0-.01.06-.02.11-.03.17,0,.04-.01.07-.02.11,0,.03,0,.05-.01.08,0,.02,0,.04-.01.06-.02.1-.04.21-.06.31-.01.06-.02.12-.03.17,0,.02,0,.05-.01.07,0,0,0,0,0,0h0c-.02.09-.03.18-.05.28-.04.26-.09.51-.13.77-.06.36-.12.71-.19,1.07-.08.43-.14.85-.19,1.28,0,0,0,0,0,0,0,.07-.02.13-.02.2,0,0,0,0,0,0,0,.02,0,.05,0,.07,0,.08-.01.15-.02.23-.01.12-.02.24-.03.36,0,.09-.02.18-.02.27,0,.12-.02.23-.03.35-.02.25-.04.5-.06.75,0,.11-.02.22-.03.32h0c-.03.25-.06.5-.09.75-.05.33-.1.65-.16.97-.04.21-.08.42-.12.62-.04.22-.09.43-.14.65,0,.01,0,.02,0,.03,0,0,0,.01,0,.02-.02.07-.03.15-.05.22,0,0,0,0,0,0-.02.07-.03.15-.05.22,0,.04-.01.07-.02.11,0,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,0,0,0h0s0,0,0,0c0,0,0,.02,0,.02,0,.01,0,.02,0,.03-.03.13-.05.26-.08.39,0,0,0,0,0,0,0,.02,0,.04-.01.06,0,0,0,0,0,0,0,.01,0,.03,0,.04,0,0,0,0,0,.01,0,0,0,.01,0,.02-.01.06-.02.13-.03.19,0,0,0,0,0,.01,0,.02,0,.04-.01.07h0s0,.03,0,.05c0,0,0,0,0,0-.02.11-.03.21-.05.32,0,.03,0,.06-.01.08,0,.03,0,.06-.01.09,0,0,0,0,0,0,0,.05-.01.09-.02.14,0,.07-.02.15-.03.22,0,0,0,0,0,.01,0,.04,0,.07-.01.11,0,.04,0,.08-.01.12,0,.08-.01.16-.02.23,0,.02,0,.05,0,.07,0,.03,0,.06,0,.09,0,.13-.01.26-.01.39,0,.15,0,.31,0,.46,0,.11,0,.22,0,.33,0,.1,0,.21,0,.31,0,.04,0,.08,0,.12,0,.06,0,.13,0,.19,0,0,0,.01,0,.02,0,.02,0,.04,0,.05,0,0,0,0,0,0,0,.08-.01.15-.02.23,0,.04-.01.09-.02.13,0,.06-.02.12-.03.19-.02.11-.04.22-.07.33.01,0,.02,0,.04-.03,0-.01.02-.02.02-.03,0,.16,0,.32.03.38,0,.02.03.04.06.06,0,.17.02.18.1.07,0,0,.01-.02.02-.03.06.02.12.02.2.03-.01.04-.02.08-.02.1,0,0,0,0,0,.01-.01.07-.02.13-.03.19-.07,0-.17.01-.31.03,0,.05.01.11.02.16,0,.02,0,.03,0,.05,0,.05,0,.09,0,.14,0,.02,0,.04,0,.05,0,.01,0,.02,0,.03,0,.04,0,.07,0,.11,0,.02,0,.05,0,.07,0,.06,0,.12-.01.17,0,0,0,.02,0,.02,0,0,0,0,0,0-.01.12-.03.24-.06.36,0,0,0,0,0,0,0,0,0,0,0,0,0,.02-.01.05-.02.07,0,.03-.01.06-.02.1,0,.03-.01.06-.02.09-.01.05-.03.1-.04.15,0,.02,0,.03.01.04-.03,0-.01.04.04.11,0,.01,0,.03,0,.04,0,0-.02,0-.03-.03,0-.02-.02-.04-.05-.06-.04.15-.09.31-.13.46.04.15.07.32.06.49-.01.27-.29.8-.11,1.03.01.02.03.03.04.05.09.03.18.09.26.17.03.03.05.07.08.1.04.06.08.12.12.17.07.1.15.2.24.29h0c.07.08.15.16.24.23.01,0,.02.02.03.03.08.07.17.14.26.21.25.18.52.34.8.47.02.01.05.02.07.04.29.14.59.25.88.35t0,0c.18.06.37.12.55.17,0,0,0,0,0,0,.14.04.29.08.43.11.14.03.28.06.42.09,0,0,0,0,0,0,.14.03.28.06.41.08,0,0,0,0,0,0,.14.02.27.05.41.06,0,0,0,0,.01,0,.13.02.27.03.4.05,0,0,0,0,.01,0,.04,0,.08,0,.12,0,0,0,0,0,0,0,.01,0,.02,0,.03,0,.06,0,.12,0,.18.01.02,0,.04,0,.06,0,0,0,0,0,0,0,0,0,.01,0,.02,0,.13,0,.26,0,.4,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,.2,0,.3-.01.03,0,.07,0,.1,0,0,0,0,0,.01,0,.04,0,.08,0,.11-.01,0,0,0,0,0,0,.02,0,.03,0,.05,0,.03,0,.06,0,.09,0,.02,0,.05,0,.07,0,0,0,0,0,0,0,.02,0,.04,0,.06,0,0,0,.02,0,.03,0,0,0,0,0,0,0h0c.33-.05.65-.12.98-.23.05-.02.1-.03.15-.05,0,0,0,0,0,0,.08-.03.16-.05.24-.08.01,0,.03,0,.04-.01.08-.03.16-.06.24-.09.01,0,.03-.01.04-.02.08-.03.16-.07.23-.1.01,0,.02-.01.03-.02.08-.04.16-.08.23-.13.04-.03.08-.05.13-.08,0,0,.02-.01.02-.02.03-.02.07-.05.1-.07,0,0,0,0,.01-.01.23-.18.44-.39.68-.56,0,0,0,0,0,0,.22-.17.46-.28.71-.37.06-.02.13-.04.19-.06.04,0,.07-.02.11-.03.27-.07.56-.1.85-.12.89-.06,1.65-.46,2.44-.8.08-.03.16-.07.24-.1.02,0,.04-.01.05-.02.06-.03.13-.05.19-.07.04-.02.08-.03.12-.05.03-.01.06-.02.1-.03.04-.01.09-.03.13-.04.04-.01.09-.03.13-.04.03,0,.05-.01.08-.02.04-.01.09-.02.13-.03.03,0,.05-.01.08-.02,0,0,.02,0,.03,0,.08-.02.16-.03.25-.04.03,0,.07-.01.1-.01.1-.03.21-.04.32-.06.18-.02.39-.02.59-.03,0,0,0,0,0,0,.03,0,.05,0,.08,0,0,0,0,0,0,0,0,0,0,0,0,0,.06,0,.12,0,.18-.01,0,0,0,0,0,0,.03,0,.05,0,.08-.01,0,0,0,0,0,0,0,0,0,0,0,0,.04,0,.09-.02.13-.03,0,0,0,0,0,0,0,0,0,0,0,0,.05-.01.1-.03.14-.05,0,0,.01,0,.02,0,.03-.01.06-.03.08-.04,0,0,0,0,0,0,0,0,0,0,0,0,.02,0,.03-.02.05-.03.07-.04.12-.1.18-.16h0s0,0,0,0c0,0,0-.01.01-.02,0,0,0,0,0,0,0,0,0-.01.01-.02,0-.01.02-.02.02-.03.01-.02.02-.03.03-.05,0-.01.02-.03.02-.04,0-.02.02-.03.02-.05,0-.02.02-.03.02-.05,0-.01.01-.03.02-.04,0-.02.02-.04.02-.06,0,0,0-.01,0-.02.12-.35.15-.8.18-1.19h0c.01-.22.02-.42.04-.58.05-.41.19-.8.23-1.21,0-.03,0-.06,0-.08.03-.35.02-.69.1-1.03,0-.03.02-.06.02-.09.01-.04.03-.09.05-.13.02-.04.03-.08.05-.11,0,0,0,0,0,0,.05-.11.12-.21.2-.3.1-.12.22-.22.36-.3.04-.03.09-.05.14-.07,0,0,0,0,0,0,.19-.08.41-.13.6-.22.02-.19.03-.39.05-.58,0-.06.01-.13.02-.19,0,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0,0,0-.01,0-.03,0-.04,0-.08.02-.16.02-.24h0s0,0,0,0c0-.01,0-.02,0-.04h0s0-.01,0-.02c0,0,0,0,0,0,0-.02,0-.03,0-.05,0,0,0,0,0,0,0,0,0-.01,0-.02h0s0-.02,0-.03c0-.01,0-.02,0-.03,0-.04,0-.08,0-.12,0-.04,0-.07,0-.11,0,0,0-.01,0-.02h0s0-.08,0-.12c0-.05,0-.1,0-.15,0-.03,0-.07,0-.1,0-.08,0-.17,0-.25,0-.1-.01-.21-.02-.31,0,0,0-.02,0-.03,0-.02,0-.05,0-.07-.01-.15-.03-.31-.04-.46,0-.04,0-.09-.01-.13,0-.05,0-.09-.01-.14,0-.02,0-.05,0-.07,0-.09-.01-.19-.02-.28,0-.01,0-.03,0-.04,0-.03,0-.05,0-.08,0-.05,0-.11,0-.16,0-.08,0-.15,0-.23,0-.04,0-.08,0-.12,0,0,0,0,0,0,0-.07,0-.13.01-.2,0-.08.02-.17.03-.25,0-.06.02-.13.02-.19,0,0,0,0,0,0,.02-.13.04-.26.05-.39,0,0,0,0,0,0,0,0,0-.01,0-.02.02-.11.03-.22.05-.33h0s0-.08.01-.11h0c.03-.24.05-.48.06-.72,0,0,0,0,0,0,0,0,0,0,0-.01,0-.05,0-.11,0-.16,0-.08,0-.15,0-.23,0-.01,0-.03,0-.04h0c-.03-.5-.09-1-.17-1.49,0,0,0,0,0,0-.02-.12-.04-.25-.07-.37,0-.02,0-.03,0-.05-.03-.15-.06-.31-.09-.46-.15-.74-.44-1.48-.54-2.23,0,0,0,0,0,0,0-.03,0-.05-.01-.08,0-.08-.01-.15-.02-.23,0-.02,0-.04,0-.06,0-.03,0-.06,0-.1,0-.03,0-.07,0-.1,0-.06,0-.12,0-.17,0-.03,0-.06,0-.08,0-.1.02-.19.03-.29,0-.07.02-.14.03-.2,0-.02,0-.04.01-.06,0-.04.02-.08.02-.13.01-.06.02-.11.04-.17,0-.03.01-.05.02-.08.02-.08.04-.15.06-.23.02-.06.03-.11.05-.17,0-.03.02-.06.03-.09,0,0,0,0,0,0,.03-.1.06-.2.08-.3,0-.02.01-.05.02-.07.09-.36.17-.74.28-1.1.02-.07.04-.13.06-.2.01-.04.03-.08.04-.12.02-.06.04-.13.07-.19.03-.07.05-.13.08-.2.09-.2.2-.39.33-.57,0,0,0,0,0,0,0-.04-.01-.09-.01-.14,0-.04,0-.08,0-.12,0-.2.03-.39.06-.58,0-.02,0-.04,0-.06,0-.01,0-.03,0-.04.01-.07.03-.15.04-.22,0-.04.02-.07.02-.11.01-.06.03-.12.04-.18,0-.04.02-.08.03-.12,0,0,0,0,0,0,.01-.05.03-.11.04-.16,0-.03.02-.06.02-.09,0-.02,0-.03.01-.05.01-.05.03-.1.04-.15,0-.02.01-.04.02-.06,0-.02.01-.04.02-.06,0-.02.01-.04.02-.06.02-.06.03-.12.05-.18,0-.01,0-.03.01-.04,0,0,0-.01,0-.02.02-.08.05-.16.07-.25.03-.09.05-.19.07-.28,0-.02,0-.03.01-.05,0-.02,0-.04.01-.07,0,0,0,0,0,0,.05-.24.1-.48.14-.73,0,0,0,0,0,0,.05-.3.1-.6.15-.9,0-.05.02-.1.02-.15.01-.07.02-.14.04-.21.02-.13.04-.26.07-.38.01-.08.03-.15.05-.23,0-.02,0-.04.01-.06,0-.03.02-.07.02-.1.01-.05.03-.11.04-.16.01-.05.02-.09.04-.14.03-.1.05-.2.08-.29,0,0,0,0,0,0,.08-.29.15-.58.2-.87h0s0,0,0,0c0-.02,0-.03,0-.05.01-.07.02-.15.03-.23,0,0,0,0,0,0,0-.07,0-.15.01-.22,0-.02,0-.04,0-.06,0-.08,0-.15,0-.23,0-.07,0-.15-.01-.22,0-.02,0-.05,0-.07,0-.11-.01-.22-.02-.33,0-.07,0-.14-.01-.21,0-.02,0-.04,0-.06,0-.08-.01-.17-.02-.25,0-.02,0-.04,0-.06-.01-.09-.02-.17-.04-.25-.02-.09-.04-.18-.07-.27-.01-.05-.03-.1-.04-.15,0,0,0,0,0,0h0c-.08-.28-.17-.56-.22-.84,0-.03,0-.06-.01-.09,0,0,0,0,0,0,0-.02,0-.04,0-.06,0-.04,0-.08,0-.11,0,0,0,0,0,0,0-.03.02-.07.03-.1,0,0,0-.02,0-.03.01-.03.03-.06.04-.09,0,0,0,0,0,0,0,0,0,0,0,0,.02-.03.04-.05.06-.08,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01.01-.02.02-.02.03-.03.05-.05.01,0,.02-.02.03-.02.02-.01.03-.02.05-.04.01,0,.02-.01.03-.02,0,0,0,0,0,0,.02-.01.04-.02.06-.03,0,0,0,0,.01,0,0,0,.02,0,.03-.01.02,0,.05-.01.07-.02,0,0,0,0,0,0,0,0,.01,0,.02,0,0,0,.02,0,.03,0,.02,0,.04,0,.06,0,.02,0,.03,0,.05,0,.02,0,.04,0,.06,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,0,0,.02,0,.04,0,.07.01,0,0,.02,0,.02,0,0,0,.02,0,.03,0,.01,0,.03.01.04.02.02,0,.04.02.06.03.01,0,.02.02.04.02.02.01.04.03.05.04.01.01.02.02.03.03.02.02.03.04.05.06,0,.01.02.03.03.04.01.02.03.04.04.07.02.03.03.07.04.11.02.06.04.12.05.18,0,0,0,0,0,.01.01,0,.03,0,.04,0h0c.12,0,.26-.02.37-.04.04,0,.09-.02.13-.03.02,0,.03,0,.05-.01.03,0,.06-.02.08-.02.02,0,.04-.01.06-.02.02,0,.05-.02.07-.03.02,0,.04-.02.06-.03.02,0,.04-.02.06-.03.02-.01.04-.02.06-.03.02,0,.04-.02.06-.03.02-.01.04-.02.07-.04.02,0,.03-.02.05-.03.02-.01.05-.03.07-.04.01,0,.02-.02.04-.02h0s0,0,0,0c0,0,0,0,0,0,.02-.01.05-.03.07-.04,0,0,0,0,.01,0,0,0,0,0,0,0,.01,0,.02-.02.03-.02,0,0,0,0,.01,0,.01,0,.03-.02.04-.03,0,0,0,0,0,0,.03-.02.06-.05.1-.07,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c-.09-.23-.18-.47-.26-.71-.01-.04-.03-.08-.04-.12-.03-.09-.06-.18-.09-.27-.04-.12-.08-.25-.11-.37,0,0,0-.01,0-.02-.01-.04-.03-.09-.04-.13,0-.02,0-.03-.01-.05-.05-.16-.09-.33-.14-.5-.03-.11-.06-.23-.09-.34-.02-.07-.03-.13-.05-.2-.07-.28-.14-.57-.2-.85-.07-.29-.13-.59-.2-.88-.02-.07-.03-.14-.04-.21,0,0,0-.02,0-.03,0-.05-.01-.1-.02-.15,0-.03,0-.06,0-.09,0-.01,0-.03,0-.04,0-.08,0-.16,0-.24,0,0,0,0,0-.01,0-.01,0-.02,0-.04,0,0,0-.01,0-.02,0-.09,0-.18,0-.28,0-.04,0-.09,0-.13,0-.06,0-.12,0-.17,0-.05,0-.11,0-.16,0,0,0,0,0,0,0-.02,0-.04,0-.05,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0-.02,0-.03h0s0-.01,0-.02c0-.02,0-.04,0-.06,0-.02,0-.03,0-.05,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0,0,0-.02,0-.04,0-.06,0,0,0,0,0,0,0-.02,0-.04,0-.06,0-.01,0-.02,0-.03,0,0,0-.01,0-.02h0s0,0,0,0c0-.01,0-.03,0-.04,0-.03,0-.06,0-.1,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.02,0-.05,0-.07,0-.13-.01-.26-.02-.39,0-.02,0-.05,0-.07,0-.04,0-.07,0-.11,0-.16,0-.32,0-.49,0-.04,0-.08,0-.12,0-.13,0-.26,0-.38,0,0,0,0,0,0,0-.03,0-.07,0-.1,0,0,0,0,0,0,0-.02,0-.04,0-.07,0,0,0,0,0,0,0-.02,0-.03,0-.05,0,0,0,0,0,0,0-.01,0-.02,0-.04,0-.03,0-.06,0-.1,0,0,0,0,0,0,0,0,0-.01,0-.02,0-.03,0-.07,0-.1h0s0,0,0-.01c0,0,0,0,0,0,0-.19,0-.37,0-.56,0,0,0,0,0,0,0-.01,0-.03,0-.04,0-.01,0-.02,0-.04,0-.03,0-.06,0-.09,0-.05,0-.09,0-.14,0,0,0-.02,0-.02,0-.01,0-.02,0-.03,0,0,0,0,0,0,0-.02,0-.04,0-.05,0-.19-.02-.38-.03-.58,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.15-.02-.29-.03-.44,0,0,0,0,0,0,0-.03,0-.06,0-.09,0,0,0,0,0,0,0-.01,0-.02,0-.04,0,0,0,0,0,0,0-.02,0-.03,0-.05,0,0,0,0,0,0,0-.08-.01-.17-.02-.25h0s0,0,0,0c0-.02,0-.04,0-.07,0,0,0,0,0,0,0-.02,0-.05,0-.07,0,0,0,0,0,0,0-.04,0-.08-.01-.12,0,0,0,0,0,0,0-.05,0-.11-.01-.16,0-.03,0-.07,0-.1,0-.07-.01-.14-.02-.21,0,0,0,0,0,0,0-.02,0-.05,0-.07,0,0,0,0,0,0,0-.03,0-.05,0-.08,0,0,0,0,0,0,0,0,0-.01,0-.02,0-.01,0-.03,0-.04,0,0,0,.01,0,.02,0-.02,0-.04,0-.05,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0-.02,0-.02,0,0,0,0,0,0,0-.04,0-.07-.01-.11,0-.05,0-.1-.01-.16,0-.01,0-.02,0-.03,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.03,0-.06,0-.08,0,0,0,0,0,0,0-.04,0-.08-.01-.12,0,0,0,0,0,0,0-.05-.01-.1-.02-.16,0,0,0,0,0,0,0-.04,0-.08-.01-.12,0-.02,0-.04,0-.06h0s0-.01,0-.02c0,0,0,0,0,0,0,0,0-.02,0-.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0h0s0,0,0,0c0-.07-.01-.14-.02-.22,0-.05,0-.09-.01-.14,0,0,0,0,0,0,0-.03,0-.07-.01-.1,0,0,0,0,0,0,0,0,0-.02,0-.03,0,0,0,0,0,0,0-.06-.01-.12-.02-.18,0,0,0,0,0,0,0-.04,0-.08-.01-.12,0,0,0,0,0,0,0,0,0-.01,0-.02,0,0,0,0,0,0,0-.05,0-.09-.01-.14,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0,0,0,0,0-.04,0-.07-.01-.11,0,0,0,0,0,0,0-.02,0-.05,0-.07,0-.02,0-.04,0-.06,0,0,0,0,0,0,0-.06-.01-.12-.02-.18h0c-.01-.11-.02-.22-.03-.32-.03-.29-.06-.59-.08-.88,0-.08-.01-.16-.02-.24,0-.1-.02-.19-.02-.29-.01-.15-.02-.3-.03-.44-.01-.15-.02-.3-.03-.45-.01-.19-.02-.38-.03-.58-.01-.27-.02-.55-.03-.82,0-.08,0-.16,0-.24,0-.04,0-.08,0-.12,0-.08,0-.16,0-.24,0-.11,0-.21,0-.32,0-.11,0-.22,0-.32-.05-.18-.09-.37-.12-.56,0-.02,0-.04,0-.06,0-.07-.02-.14-.03-.2,0-.04,0-.07-.01-.11,0-.08-.01-.17-.02-.25,0-.03,0-.07,0-.1,0-.09-.01-.18-.02-.27,0-.04,0-.07,0-.11,0-.07-.01-.13-.02-.19,0-.02,0-.03,0-.05,0-.05-.02-.1-.03-.15,0,0,0-.02,0-.03-.06-.25-.16-.49-.25-.72-.06-.18-.13-.35-.17-.54h0s-.09-.08-.13-.12c-.04-.03-.07-.07-.11-.1-.02-.02-.04-.04-.06-.06-.02-.02-.03-.03-.05-.05-.02-.02-.05-.05-.07-.07-.01-.01-.02-.02-.04-.04-.02-.03-.05-.05-.07-.08,0-.01-.02-.02-.03-.03-.02-.03-.04-.05-.06-.08-.04-.04-.07-.09-.1-.14,0,0,0,0,0,0-.03-.05-.07-.1-.1-.15-.02-.03-.04-.07-.06-.1,0,0,0-.02-.01-.02-.02-.03-.03-.06-.05-.1,0,0,0-.01,0-.02,0,0,0,0,0,0,0,0,0,0,0,0-.02-.05-.04-.11-.05-.16,0,0,0-.01,0-.02-.03-.11-.05-.21-.05-.32,0,0,0,0,0-.01,0-.05,0-.1,0-.15,0,0,0,0,0,0,0-.12,0-.25,0-.38,0-.02,0-.05,0-.07,0-.02,0-.05,0-.08,0-.05,0-.11,0-.16,0,0,0,0,0,0,0,0,0,0,0,0,0-.02,0-.03,0-.05,0-.02,0-.03,0-.05,0,0,0,0,0,0h0s0-.01,0-.02c0-.08.01-.17.04-.24,0,0,0,0,0,0-.03-.22,0-.45.16-.58,0-.01.02-.02.02-.03.05-.05.12-.07.19-.08.02,0,.03,0,.05,0,0,0,0,0,0,0,.03,0,.07,0,.1,0,.02,0,.03,0,.05,0,.1.01.2.03.3.06.11.03.23.08.35.09.09.01.18.01.27.01.05,0,.11,0,.16,0,.09,0,.18.01.27.02,0,0,0,0,0,0,.11-.02.22-.04.32-.06.07-.01.14-.02.21-.02.01,0,.03,0,.04,0,.03,0,.07,0,.1,0,.3-.02.55-.04.81-.23h0s.02-.02.04-.03c0,0,0,0,0,0,.01-.01.03-.02.04-.03,0,0,0,0,0,0,0,0,.01,0,.02-.01.02-.02.04-.04.06-.06.04-.04.08-.07.11-.11,0,0,.01-.01.02-.02.03-.03.07-.06.1-.08,0,0,.02-.01.02-.02.03-.02.06-.04.09-.06,0,0,0,0,.01,0,0,0,0,0,.01,0,.03-.02.06-.03.08-.05,0,0,.01,0,.02,0,0,0,.02,0,.03-.01.01,0,.03-.01.04-.02.01,0,.02,0,.03-.01.08-.03.17-.06.27-.08.04,0,.08-.02.13-.02.05,0,.09-.01.15-.02.05,0,.1-.02.15-.03.02,0,.03,0,.05-.01.03,0,.07-.02.1-.03.04-.01.09-.03.13-.05,0,0,0,0,0,0,.08-.03.16-.06.24-.1.05-.02.1-.04.14-.06h0c.06-.02.11-.05.17-.07,0,0,.01,0,.02,0,.01,0,.02-.01.04-.02,0-.01.01-.02.02-.03h0s0-.1,0-.14c0-.02,0-.03,0-.05,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.01,0-.03,0-.04h0s0,0,0,0c0-.07.01-.17.01-.23,0-.05,0-.11.01-.16,0-.01,0-.03,0-.04,0-.05.02-.1.03-.15,0,0,0,0,0,0,.02-.12.05-.24.07-.35,0-.04.02-.09.02-.13.02-.11.04-.23.05-.35,0,0,0,0,0-.01,0-.04,0-.07,0-.11,0,0,0-.01,0-.02,0-.19,0-.37-.09-.53ZM269.81,292.13s-.07-.03-.12-.03c0,0-.01,0-.02,0,0-.02.01-.05.02-.09.05.03.1.06.14.09,0,.01-.01.02-.02.04ZM283.45,221.99s0,.01,0,.02c0,0,0,.02,0,.03,0,0,0,.01,0,.02,0,0,0,.02-.01.02,0,0,0,.01-.01.02-.05.07-.13.11-.22.11-.03,0-.07,0-.1,0,0,0-.01,0-.02,0-.03,0-.05,0-.08-.02-.05.05-.12.09-.2.1h0s0,0,0,0h0s0,0,0,0c-.03.02-.06.03-.09.05-.05.04-.09.07-.14.09,0,0-.01,0-.02.01h0s-.02,0-.03,0h0s0,0,0,0c-.11.18-.24.33-.41.46h0s0,0,0,0c-.02.07-.05.13-.09.2,0,0,0,.01-.01.02,0,.01-.01.03-.02.04-.04.09-.09.17-.13.25,0,0,0,.01-.01.02-.03.06-.06.12-.09.17,0,0,0,0,0,0,0,0,0,0,0,.01,0,.01-.01.03-.02.04,0,0,0,.01-.01.02,0,0,0,.01,0,.02,0,0,0,0,0,0h0s0,0,0,0c-.01.03-.03.05-.04.08,0,.01-.01.02-.02.03,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,0,0,.01-.02.06-.05.11-.07.17-.03.1-.07.19-.11.29,0,0,0,0,0,0-.02.04-.04.09-.06.13,0,.02-.02.04-.03.06-.08.2-.17.39-.25.59h0c-.02.06-.04.12-.07.18,0,0,0,0,0,0h0s0,.02,0,.03h0s-.02.05-.03.08c0,0,0,0,0,0h0s-.01.05-.02.07c-.02.06-.03.12-.04.18-.02.07-.03.14-.04.21,0,.02,0,.04,0,.06,0,.02,0,.03,0,.05,0,.03,0,.07-.01.1,0,.03,0,.06,0,.09,0,.01,0,.02,0,.03,0,.04,0,.08,0,.11,0,0,0,0,0,0,0,.04,0,.08,0,.13,0,.05,0,.1,0,.15,0,0,0,0,0,0,0,0,0,0,0,0,0,.04,0,.08,0,.12,0,0,0,0,0,0,0,0,0,.01,0,.02,0,.03,0,.05,0,.08,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0c.02.06.04.11.07.17,0,0,0,0,0,0,.01.03.02.06.04.08,0,0,0,0,0,0h0s0,.01,0,.02c.05.12.1.24.15.36,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,.02.02.04.04.06.07.01.02.02.03.04.05.01.01.02.03.03.04.03.02.06.05.08.08,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01.01.02.02.02.03.05.06.06.09,0,0,.01.02.02.03.02.04.04.08.06.13,0,.03.02.05.02.08,0,0,0,0,0,0,0,0,0,.02,0,.03,0,.03,0,.06,0,.09,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.02,0,.02,0,.03,0,.07-.02.1,0,0,0,0,0,0,0,.06.01.11.01.17,0,.03,0,.06,0,.09,0,.03,0,.06,0,.09,0,.02,0,.04,0,.06,0,.02,0,.03,0,.05,0,.04,0,.08-.01.11,0,0,0,.01,0,.02,0,.02,0,.04,0,.05,0,.04-.01.08-.02.12-.02.11-.04.21-.05.32,0,.02,0,.04-.01.06-.01.08-.03.16-.04.25,0,.02,0,.04,0,.06.03.03.06.05.08.09,0,0,0,.02.01.02.07,0,.13.02.19.05l.08.06c.05.05.09.11.11.18,0,.02,0,.04,0,.06,0,0,0,0,.01,0,0,0,0,0,.01,0,.02,0,.04.02.06.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.02.02.04.03.05.06.01.01.03.03.04.05,0,0,0,0,0,0,.01.02.02.04.03.06,0,.02.01.05.01.08,0,.05,0,.1,0,.15,0,0,0,0,0,0,0,.03,0,.05,0,.08,0,.04,0,.08,0,.11,0,.02,0,.04,0,.06,0,.05.02.1.03.14h0s.01.05.02.07c0,.04.01.09.02.14,0,0,0,0,0,0,0,0,0,0,0,0,.01.02.02.05.03.08,0,0,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0c.03.04.05.08.08.12.03.05.07.1.09.14.07.03.14.07.21.11,0,0,0,0,.01,0,.05.03.1.06.14.09.04.03.08.06.13.08,0,0,0,0,0,0,.02,0,.04.01.05.02,0,0,0,0,0,0,.01,0,.03.02.04.03,0,0,.02,0,.03.01,0,0,.02.01.02.02,0,0,.02.01.02.02h0s0,0,0,0c.01.01.02.02.03.04.01.02.02.03.02.05,0,.01,0,.02.01.03,0,.02,0,.04.01.07,0,.02,0,.04,0,.05,0,0,0,0,0,0,0,.02-.01.04-.02.06,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01-.01.02-.02.03-.03.04-.01.01-.03.02-.05.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01.02-.03.03-.04.05-.01.01-.02.02-.04.03,0,0,0,0,0,0-.02,0-.03.02-.05.03,0,0,0,0-.01,0,0,0-.01.01-.02.02h0s-.03.03-.04.04c0,0-.01.02-.02.02h0c-.04.05-.07.11-.1.16h0s-.02.04-.03.06c-.02.04-.05.08-.08.12-.02.02-.04.05-.06.07-.03.05-.07.09-.1.13,0,0,0,0,0,0-.03.03-.07.06-.11.09,0,0-.02.01-.03.02-.03.02-.07.04-.11.06-.01,0-.02.01-.04.02,0,0,0,0-.01,0-.04.02-.08.03-.12.05-.15.05-.34.08-.56.1-.1,0-.2.01-.3.02-.03,0-.06,0-.09,0-.07,0-.15,0-.22,0-.1,0-.2,0-.3,0-.01,0-.03,0-.04,0-.14,0-.27,0-.41,0-.04,0-.08,0-.12,0,0,0-.01,0-.02,0-.1,0-.2.01-.3.02,0,0-.02,0-.03,0-.04,0-.08,0-.11,0-.02,0-.04,0-.05,0-.03,0-.07,0-.1,0-.01,0-.03,0-.04,0,0,0-.02,0-.03,0-.03,0-.06,0-.09,0-.01,0-.03,0-.04,0-.04,0-.08-.02-.12-.03-.04-.01-.07-.03-.1-.05,0,0-.01,0-.02-.01-.01,0-.03-.02-.04-.03-.01,0-.03-.02-.04-.03-.02-.02-.05-.04-.07-.06-.01-.01-.03-.03-.04-.04-.02-.02-.03-.03-.05-.05-.02-.02-.04-.05-.06-.07-.01-.02-.03-.03-.04-.05,0-.01-.02-.02-.02-.03-.02-.03-.04-.07-.07-.1-.02-.03-.03-.05-.05-.08,0-.01-.01-.02-.02-.04-.01-.03-.03-.06-.04-.08,0-.01-.01-.03-.02-.04-.01-.03-.03-.05-.04-.08,0-.02-.01-.03-.02-.05-.01-.03-.02-.06-.04-.09-.02-.04-.03-.08-.04-.11-.03-.07-.05-.14-.07-.21,0,0,0-.02,0-.02-.03-.1-.06-.2-.09-.29,0-.02-.01-.04-.02-.06,0-.02-.01-.04-.02-.06-.02-.06-.04-.11-.05-.16-.03-.09-.06-.18-.09-.27-.06-.2-.12-.4-.18-.61-.01-.05-.03-.09-.04-.14-.02-.06-.04-.13-.05-.19,0,0,0-.02,0-.03,0,0,0,0,0-.01,0,0,0-.01,0-.02-.01-.04-.02-.08-.04-.12,0,0,0-.02,0-.02-.01-.04-.03-.09-.04-.13,0-.02-.01-.03-.02-.05-.02-.06-.04-.12-.06-.18,0,0,0-.01,0-.02,0-.02-.01-.03-.02-.05,0,0,0-.02,0-.03h0s0,0,0-.01c-.03-.09-.07-.17-.1-.26,0,0,0,0,0-.01,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0-.02-.01-.03-.04-.09-.08-.17-.12-.26-.01-.02-.02-.04-.03-.06,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0,0,0,0,0-.01,0-.03-.02-.05-.02-.08,0,0,0,0,0-.01,0-.03,0-.05-.01-.08,0,0,0,0,0,0,0-.01-.01-.02-.01-.03-.02-.06-.03-.12-.05-.18,0-.02,0-.04-.01-.06,0,0,0,0,0,0,0-.04-.01-.08-.02-.11-.04-.24-.05-.48-.08-.72,0,0,0,0,0,0,0-.05-.01-.1-.02-.14,0-.02,0-.04,0-.06,0-.03-.01-.07-.02-.1,0,0,0-.02,0-.03,0,0,0-.01,0-.02,0-.01,0-.03-.01-.04,0-.02,0-.05-.02-.07,0,0,0,0,0-.01-.01-.05-.03-.1-.04-.14-.03-.07-.05-.14-.07-.21,0-.03-.02-.05-.03-.08-.01-.04-.03-.08-.04-.12-.01-.04-.03-.08-.04-.11,0-.02-.01-.05-.02-.07-.01-.04-.03-.08-.04-.13-.01-.05-.03-.1-.04-.15,0-.02,0-.04-.01-.05-.01-.05-.02-.1-.03-.15,0-.02,0-.04-.01-.06-.01-.07-.02-.14-.03-.21-.01-.15-.03-.31-.03-.46,0-.09,0-.17,0-.26,0-.02,0-.05,0-.07,0-.08,0-.16,0-.24,0-.03,0-.06,0-.09,0-.09.01-.18.02-.27,0-.03.01-.07.02-.1,0-.03.01-.06.02-.09-.04-.08-.05-.17-.02-.29.19-.61.39-1.21.69-1.77.11-.21.21-.41.3-.63.09-.23.2-.46.41-.6.21-.15.45-.13.69-.12.29.02.58.04.88.04.31,0,.61-.02.92,0,.12,0,.24.03.36.05.07-.05.16-.08.24-.08.2,0,.42,0,.62-.03.02,0,.08-.02.09-.02.07-.01.14-.02.22-.03.11-.01.23,0,.34.02.2.04.38.17.56.28.04.02.08.05.12.07,0,0,.01,0,.02,0,.01,0,.03,0,.04.01.11.03.21.07.32.12.14.07.21.23.2.38,0,0,.01.01.02.02,0,0,0,.01.01.02,0,0,.01.01.02.02,0,0,0,.01.01.02,0,0,0,0,0,0,0,0,0,.02.01.02,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,0,0,.01,0,.02,0,.03,0,.05,0,.02,0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M282.83,291.23c0,.42.02.89.05,1.15.15.96.07,1.24-.17,1.4-.4.26-.71.32-3.32.28-.4,0-1.51.23-2.56.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.84,294.76c-.12,0-.22-.08-.24-.2-.03-.13.06-.27.19-.3,1.12-.24,2.16-.46,2.59-.46h.02c2.63.04,2.85-.03,3.18-.24.11-.07.2-.22.06-1.15-.04-.22-.05-.62-.06-1.19,0-.14.11-.25.25-.25h0c.14,0,.25.11.25.25,0,.67.03.98.05,1.12.14.9.13,1.38-.28,1.65-.46.3-.81.37-3.46.32-.39,0-1.71.28-2.5.45-.02,0-.04,0-.05,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.15,230.3c-.28,0-.56-.07-.85-.15-.18-.05-.38-.1-.59-.14-.16-.03-.58-.1-.62-.42,0-.06,0-.12.02-.18l-.66-.14s-.91-.22-1.5-.85c-.43-.45-.93-.28-.94-.27l-.59.09c-.11,0-2.28.13-3.06-.06-.79-.2-1.16-.47-1.18-.48l-.73-.7v-.12c.03-.16.19-1.55.28-1.89.01-.05.03-.11.05-.18.11-.47.35-1.44.91-2.2.22-.29.63-.58,1.24-.84.13-.06.25-.1.33-.13.02-.02.04-.04.06-.05.04-.02.07-.03.11-.03.08-.06.17-.15.23-.25.37-.58,1.75-.52,2.04-.5.05,0,1.66-.02,2.47.27.61.22.97.58,1.43,1.04.17.17.36.36.59.57.61.55.87,1.01,1.08,1.37.08.14.16.28.25.4.17.24.5.4.76.54.22.11.37.19.46.3.2.26.24.68.24,1.4,0,.37.01.45.03.55.02.1.04.22.06.54.04.78-.41,1.68-1.08,2.21-.28.22-.56.29-.84.29ZM289.73,229.51s.04,0,.07.01c.23.04.43.09.63.14.58.15.9.22,1.25-.06.55-.42.92-1.18.89-1.79-.01-.29-.03-.39-.05-.48-.02-.14-.04-.25-.04-.64,0-.55-.02-.95-.13-1.09-.03-.03-.18-.11-.29-.17-.3-.15-.7-.36-.94-.69-.1-.14-.19-.29-.28-.45-.2-.35-.43-.75-.98-1.25-.23-.21-.43-.41-.61-.59-.43-.43-.74-.74-1.25-.92-.73-.26-2.29-.24-2.31-.24-.58-.04-1.45.04-1.6.27-.09.14-.2.26-.31.35l.03.06-.24.08c-.22.13-.42.18-.5.19-.48.21-.83.44-.98.65-.5.69-.72,1.59-.83,2.03-.02.08-.04.15-.05.2-.06.23-.18,1.2-.24,1.69l.53.5h0s.32.21.97.38c.59.15,2.29.09,2.89.05l.52-.08h0s.78-.28,1.42.41c.49.52,1.24.7,1.25.7l1.87.41-.69.31s0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.43,222.04c-.09,0-.18-.05-.22-.14l-.1-.19c-.12-.07-.39-.21-.73-.4-.51-.28-.75-.65-.76-.67-.24-.26-.59-.6-.69-.65-.04-.02-.09-.03-.14-.05-.19-.06-.51-.15-.59-.57-.03-.15,0-.29.1-.4.2-.22.59-.19.7-.18h0s.58.03,1.11.4c.06.04.1.04.13.03.15-.04.31-.28.36-.39.02-.03.26-.39.46-.87.2-.47.27-1.43.27-1.44.01-.14.13-.26.27-.23.14,0,.24.13.23.27,0,.04-.08,1.05-.31,1.6-.22.53-.48.91-.49.93,0,.03-.26.52-.67.63-.19.05-.38.01-.55-.11-.41-.29-.86-.31-.86-.31-.13-.01-.26,0-.3.03.04.07.08.09.26.15.07.02.13.04.2.07.26.11.75.65.9.81.03.04.21.32.6.53.46.25.8.44.8.44l.07.04.17.32c.06.12.01.27-.11.34-.04.02-.08.03-.11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.55,229.53s-.09-.01-.14-.04c-.12-.08-.15-.23-.07-.35.01-.02.33-.5.68-.87.33-.35.69-.88.73-.94.03-.07.11-.52.14-.84.03-.33,0-.78-.05-1.22-.05-.38-.5-1.31-.67-1.63-.06-.12-.02-.27.11-.34.12-.06.27-.02.34.11.07.13.65,1.26.73,1.8.06.47.08.96.06,1.33-.01.17-.1.87-.21,1.05-.08.12-.45.67-.79,1.03-.32.33-.62.79-.62.79-.05.07-.13.11-.21.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.11,230.14s-.09,0-.13-.02l-.21-.07c-.13-.04-.21-.18-.16-.31.04-.13.18-.21.31-.16l.21.07h0c.08,0,.37-.16.48-.25l.04-.05h.08c.11-.06.37-.15.62-.35l.14-.11c.28-.21.47-.36.57-.93.09-.53.06-.99-.1-1.37-.07-.16-.29-.39-.56-.66l-.25-.25c-.06-.06-.16-.12-.25-.13-.09,0-.15.07-.15.07-.09.11-.25.12-.35.03-.1-.09-.12-.25-.03-.35.02-.02.21-.23.51-.24.21-.04.43.08.62.28l.25.25c.33.33.57.58.67.83.19.46.23,1.02.13,1.64-.13.76-.45,1.01-.76,1.24l-.13.1c-.31.25-.63.37-.75.41h0c-.14.1-.49.34-.79.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.72,229.18c-.13,0-.24-.1-.25-.23-.01-.14.09-.26.22-.27,0,0,.62-.06.99-.18l.13-.04q.22-.07.26-.2c.02-.08.02-.14.01-.24-.01-.16-.03-.38.1-.71.12-.31.12-.47.12-.71,0-.09,0-.19,0-.3.01-.2-.05-.24-.21-.33l-.1-.06s-.2-.02-.32-.02c-.17,0-.38.01-.62-.03-.5-.08-.75-.21-.77-.23-.12-.07-.16-.22-.1-.34.07-.12.22-.16.34-.1,0,0,.21.1.61.17.19.03.37.03.52.02.23,0,.44-.01.62.1l.08.05c.18.11.48.29.45.79,0,.1,0,.19,0,.27,0,.25,0,.49-.16.89-.09.23-.08.35-.07.49.01.12.02.26-.03.43-.12.38-.27.44-.6.53l-.13.04c-.43.13-1.07.2-1.09.2,0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.92,227.62c-.07,0-.13-.02-.18-.07-.04-.04-.06-.08-.08-.12-.08-.15-.28-.55-1.04-1.06-.97-.66-1.17-.94-1.2-.99-.07-.12-.03-.27.08-.34.12-.07.27-.03.34.08,0,0,.18.24,1.06.83.87.58,1.11,1.07,1.21,1.25.1.1.09.26,0,.35-.05.05-.11.07-.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.03,228.79s-.04,0-.06,0c-.71-.16-1.38-.44-1.99-.83-.12-.07-.15-.23-.07-.35s.23-.15.35-.07c.56.36,1.17.62,1.83.77.13.03.22.17.19.3-.03.12-.13.19-.24.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.62,216.78c-.13,0-.24-.1-.25-.23-.05-.58-.15-1.12-.27-1.68l-.05-.24c-.04-.2-.08-.39-.2-.51-.07-.08-.17-.13-.31-.19-.92-.42-1.98-.54-3-.65-.36-.04-.73-.08-1.09-.13-.59-.09-1.19-.21-1.76-.33l-.38-.08c-.55-.12-1.21-.24-1.87-.33-1.17-.16-2.38-.19-3.55-.23-1.36-.04-2.77-.08-4.14-.31-.14-.02-.23-.15-.2-.29.02-.14.14-.24.29-.2,1.34.23,2.72.27,4.07.31,1.18.04,2.41.07,3.6.23.68.09,1.35.22,1.91.34l.38.08c.57.12,1.15.24,1.73.33.35.05.71.09,1.07.13,1.06.12,2.15.24,3.15.69.16.08.33.16.47.31.2.22.27.49.32.76l.05.24c.12.58.23,1.13.27,1.74.01.14-.09.26-.23.27,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.14,221.28s-.01,0-.02,0c-.2-.02-.39-.11-.59-.28-.3-.26-.55-.61-.75-1.08-.13-.3-.23-.61-.33-.91l-.08-.26c-.1-.31-.22-.62-.34-.93-.15-.36-.33-.79-.6-1.15-.08-.11-.05-.27.06-.35.11-.08.27-.06.35.06.29.41.5.87.66,1.26.13.31.25.63.36.96l.09.26c.1.3.19.58.31.86.17.39.38.69.62.9.12.1.22.16.31.16.14.01.24.13.23.27-.01.13-.12.23-.25.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.32,221.24c-.43,0-.84-.04-1.2-.07-.43-.04-.86-.08-1.29-.12-.14-.01-.24-.14-.22-.27.01-.14.13-.24.27-.22.43.04.86.08,1.29.12.66.06,1.42.12,2.13-.02.2-.04.32-.1.36-.17.07-.12.22-.16.34-.09.12.07.16.22.09.34-.16.28-.47.37-.7.42-.35.07-.71.1-1.07.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.85,219.54h0c-.14,0-.25-.12-.24-.26.02-1.03.02-2.07,0-3.09,0-.23-.01-.49-.11-.69-.18-.34-.62-.5-1.04-.61-1.32-.34-2.72-.48-4.07-.61-.65-.06-1.31-.13-1.96-.21-1.11-.15-2.21-.36-3.28-.56l-3.76-.72c-.47-.09-.95-.18-1.4-.42-.12-.06-.17-.22-.1-.34.07-.12.22-.17.34-.1.38.2.83.29,1.26.37l3.76.72c1.06.2,2.16.42,3.25.56.65.08,1.29.15,1.94.21,1.37.13,2.79.27,4.15.62.49.13,1.09.34,1.36.86.15.3.16.64.17.91.02,1.03.02,2.07,0,3.11,0,.14-.11.24-.25.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.07,212.51c-.05,0-.1-.01-.14-.05-.13-.09-.18-.27-.12-.44.04-.1.1-.17.15-.22l.18-.17c.05-.05.09-.09.14-.12.21-.15.48-.17.65-.17.13,0,.25.1.26.24,0,.14-.1.25-.24.26-.16,0-.29.02-.38.08-.03.02-.05.04-.07.06l-.18.18s-.02-.02-.03-.04c.05.08.05.19,0,.28-.05.07-.13.11-.2.11ZM266.22,212.05h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.91,221.34c-.12,0-.23-.09-.25-.21-.02-.14.08-.26.21-.28.09-.01.18-.09.25-.2.08-.13.11-.3.15-.46.03-.13.17-.22.3-.19.13.03.22.16.19.3-.04.19-.09.4-.2.6-.14.25-.37.41-.61.45-.01,0-.02,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.95,222.8s-.07,0-.11-.02c-.12-.06-.18-.21-.12-.33l.92-1.92c.09-.19.2-.41.38-.57.04-.04.1-.08.15-.12.07-.05.16-.12.17-.16,0-.05-.06-.16-.09-.21-.21-.02-.42.03-.6.12-.15.08-.29.19-.44.3-.09.07-.19.15-.28.21-.38.26-.74.35-1.07.26-.16-.04-.29-.12-.41-.2-.66-.43-1.16-1.03-1.65-1.61-.29-.35-.59-.71-.92-1.02-.11-.11-.25-.23-.39-.27-.05-.01-.11-.01-.16,0,.05.07.13.13.21.2.05.04.1.08.15.12.3.28.51.67.66,1.22.04.14.26.36.46.55.25.24.48.47.57.72.04.13-.02.27-.15.32-.13.04-.27-.02-.32-.15-.05-.14-.26-.34-.44-.52-.26-.26-.52-.5-.59-.78-.12-.46-.29-.77-.52-.98-.04-.04-.08-.07-.12-.11-.17-.14-.38-.32-.45-.59l-.02-.1.05-.09c.16-.25.49-.37.81-.28.24.07.43.22.6.39.35.33.66.7.96,1.06.49.58.94,1.13,1.54,1.52.08.05.17.11.26.13.24.06.49-.07.66-.19.09-.06.17-.13.26-.19.16-.13.33-.26.52-.36.26-.13.55-.19.84-.18.06,0,.15,0,.23.06.1.05.15.14.18.19.07.12.2.33.15.57-.05.23-.23.37-.37.46-.04.03-.08.06-.11.09-.11.1-.18.25-.26.41l-.92,1.92c-.04.09-.13.14-.23.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.14,221.92c-.13,0-.24-.11-.25-.24-.02-.63-.07-1.29-.33-1.85-.21-.45-.55-.84-.89-1.22l-.41-.46c-.1-.12-.38-.43-.24-.78.12-.3.48-.4.75-.31.06.02.23.07,1.35,1.19.1.1.1.26,0,.35-.1.1-.26.1-.35,0-.55-.55-1.05-1.02-1.16-1.07-.05-.01-.12.01-.12.03,0,0-.02.07.15.26l.41.46c.34.39.72.82.96,1.34.3.65.35,1.37.38,2.04,0,.14-.1.25-.24.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.54,237.62c-1.51,0-5.93-1.56-6.27-1.77-.51-.32-1.49-4.43-1.36-7.83.11-2.94-.07-3.25-.36-3.78-.05-.09-.1-.18-.15-.28-.28-.55-.31-.75-.36-1-.02-.12-.05-.25-.11-.46-.2-.7-.06-1.07-.04-1.11.05-.13.2-.19.33-.13.12.05.18.2.13.32,0,.01-.09.27.06.78.07.23.09.38.12.51.04.23.07.38.32.87.05.1.1.18.14.26.34.6.54.97.43,4.04-.13,3.39.86,7.09,1.14,7.4.35.21,5.34,1.9,6.16,1.67.66-.19,1.02-1.67,1.09-2.18,0-.16-.09-1.36-.75-1.46-.9-.14-3.49-.19-3.52-.19l-.09-.02c-.17-.07-.51-.43-.91-1.99-.42-1.65-1.47-5.34-1.48-5.38-.01-.09-.14-1.2,0-1.86.14-.67.76-1.71.79-1.76.07-.12.22-.16.34-.09.12.07.16.22.09.34,0,.01-.61,1.02-.73,1.6-.12.58,0,1.65,0,1.67h0s1.06,3.69,1.48,5.35c.29,1.16.53,1.53.62,1.63.48,0,2.65.06,3.5.2,1.11.18,1.19,1.85,1.16,2.03-.03.23-.36,2.28-1.45,2.58-.08.02-.19.03-.31.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.16,221.02h0l-13.83-.53-.07-.07c-.07-.07-.38-.45.22-1.29.51-.71,6.17-6.86,6.41-7.12.09-.1.25-.11.35-.01.1.09.11.25.01.35-.06.06-5.88,6.38-6.37,7.07-.21.3-.26.48-.27.57l13.55.52c.14,0,.25.12.24.26,0,.13-.12.24-.25.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.71,232.31c-.21,0-.36-.03-.55-.11-.29-.13-.3-.38-.3-.49-.16-.13-.2-.25-.23-.35,0-.03-.01-.04-.02-.06-.12-.18-.06-.35,0-.45l-.11-.06v-.15s0-.23.14-.43c0,0,0,0-.01-.01-.26-.07-.69-.24-.73-.54-.03-.24.04-1.2.11-1.62.05-.29-.12-.5-.13-.51-.09-.1-.08-.26.03-.35.1-.09.26-.08.35.02.01.02.34.39.25.93-.07.42-.13,1.32-.11,1.48.03,0,.3.11.48.15l-.06.24h0s.24-.06.24-.06c.04.1.14.37-.02.58,0,0,0,.01-.01.02.08.07.15.18.13.31-.01.09-.05.16-.09.21,0,0-.01.01-.01.01.04.06.05.12.06.16l-.09.26.13-.21c.2.12.21.33.21.42.19.13.3.12.76.09.54-.04,1.51-.27,1.52-.27.13-.03.27.05.3.18.03.13-.05.27-.18.3-.04,0-1.02.24-1.54.28-.21.01-.37.03-.5.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.26,230.78c-.45,0-.61-.27-.67-.5-.1-.39.24-.75.28-.79.1-.1.26-.09.35,0s.09.26,0,.35c-.07.07-.17.22-.15.3.02.08.03.15.28.12.15-.02.51-.38.73-.81.14-.27.03-.63-.02-.81-.01-.05-.02-.08-.03-.1-.03-.13.06-.27.2-.29.13-.03.27.06.29.2.08.28.23.79,0,1.23-.21.41-.68,1.03-1.12,1.08-.05,0-.1,0-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.33,230.54c-.24,0-.43-.19-.43-.43s.19-.43.43-.43.43.19.43.43-.19.43-.43.43ZM286.33,230.04s-.07.03-.07.07c0,.08.14.08.14,0,0-.04-.03-.07-.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.61,260.07l.1-.66s.16-1.03-.05-3.07l-.1-.94c-.18-1.76-.41-3.96-.54-4.36-.09-.25-.18-1.2-.32-2.73-.12-1.3-.26-2.77-.37-3.17-.14-.51-.04-1.5.05-2.45.07-.69.13-1.34.09-1.68-.06-.51,0-1.45.04-2.28.03-.57.06-1.1.04-1.31-.03-.33-.24-.97-.36-1.35-.11-.34-.12-.39-.12-.46-.04-.11-.82-1.77-1.25-2.37-.32-.44-.59-.32-.63-.31l-.07.03-2.25.42c-.15.03-.27-.07-.29-.2-.03-.14.06-.27.2-.29l2.21-.41c.25-.12.78-.15,1.23.47.4.54,1.35,2.45,1.35,2.68,0,.01.05.13.1.29.14.43.35,1.08.38,1.46.02.25,0,.77-.04,1.39-.04.77-.09,1.73-.04,2.2.04.4-.02,1.07-.09,1.79-.09.87-.18,1.85-.07,2.27.12.45.26,1.88.39,3.26.1,1.12.22,2.4.3,2.61.15.42.32,2.04.57,4.47l.1.94c.14,1.32.12,2.22.09,2.72.35-.13.89-.19,1.54.14.24.12.37.15.43.16,0-.02,0-.04-.01-.05-.25-1.8,0-1.92.14-1.98.03-.02.09-.04.18-.03-.02-.13-.05-.28-.09-.42-.02-.03-.12-.29,0-.49.04-.06.13-.17.32-.19h.11c.28-.03.71-.07.97.27.09.12.15.22.18.31h.04c.52,0,.98-.11.99-.25.03-.27-.44-1.81-.77-2.93-.31-1.04-.61-2.02-.69-2.48-.13-.77.04-2.38.13-3.35.03-.28.06-.56.05-.62,0-.19-.32-3.72-.48-5.55-.04-1.38-.17-5.01-.27-5.48-.03-.16-.07-.42-.12-.71-.11-.68-.3-1.82-.42-2.05-.12-.23-.47-.39-.6-.44l-.08-.03-.05-.08c-.42-.67-.44-.79-.51-1.36l-.05-.34c-.14-.95.23-1.4.27-1.45.09-.1.25-.12.35-.03.1.09.12.25.03.35,0,.01-.26.33-.16,1.05l.05.35c.06.49.07.55.4,1.09.19.08.61.29.8.65.14.28.29,1.13.47,2.2.05.29.09.54.12.7.12.61.27,5.35.28,5.55.02.2.46,5.3.48,5.56,0,.08-.01.27-.06.69-.09.88-.25,2.51-.14,3.21.07.42.38,1.44.67,2.42.52,1.71.83,2.78.79,3.13-.08.77-1.49.71-1.77.69l-.32-.02.1-.3s-.02-.05-.12-.18c-.09-.11-.28-.1-.53-.08h-.02s0,.01,0,.01c.28,1.04.08,1.15-.03,1.21-.07.04-.16.06-.27,0-.01.3.03.81.09,1.25.05.13.07.4-.11.56-.26.24-.71.06-1.02-.1-.87-.43-1.43.03-1.45.04l-.51.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.17,258.23s-.02,0-.03,0c-.28-.02-.4-.34-.44-.44-.08-.21-.14-.87-.25-2.11-.17-1.84-.42-4.62-.83-5.69-.44-1.15-.35-2.67-.28-4.01.04-.75.08-1.45.03-2.04-.07-.9-.03-1.94,0-2.86.03-.79.06-1.46,0-1.78-.04-.23-.09-.66-.14-1.16-.11-1.02-.28-2.56-.51-3.02-.14-.28-.25-.51-.36-.75-.17-.38-.33-.74-.63-1.22-.43-.68-.61-.81-.97-1.06l-.13-.09c-.25-.17-1.17.04-1.71.25h-.06s-.57.07-.92.31c-.22.15-.2.28-.2.29.05.13-.02.27-.15.32-.13.05-.28-.02-.32-.15-.07-.18-.06-.56.39-.86.4-.27.97-.36,1.12-.37.32-.12,1.6-.55,2.14-.18l.08.05c.48.33.7.5,1.16,1.24.32.51.49.88.67,1.28.1.22.21.46.34.72.28.55.44,2.02.57,3.2.05.49.1.91.14,1.12.07.37.04,1.04,0,1.89-.04.9-.08,1.92,0,2.79.05.62.01,1.34-.03,2.11-.07,1.35-.15,2.75.25,3.8.43,1.14.68,3.85.86,5.83.08.9.17,1.83.22,1.99,0,.02.01.03.02.04.08-.05.18-.07.27-.02.12.07.17.21.11.33-.03.05-.16.27-.4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.82,232.66s-.08,0-.11-.03c0,0-.86-.44-1.46-.5-.44-.04-.66-.17-.8-.25-.09-.05-.11-.06-.15-.06-.13,0-.68.21-1.12.4-.13.06-.27,0-.33-.13s0-.27.13-.33c.23-.1,1.02-.44,1.32-.45.18,0,.3.07.4.13.12.07.26.15.6.18.7.07,1.61.53,1.64.55.12.06.17.21.11.34-.04.09-.13.14-.22.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.97,238.15c-1.13,0-3.29-.42-3.79-.52-.14-.03-.22-.16-.2-.29.03-.13.15-.22.29-.2,1.46.29,3.68.63,4.08.48.54-.22.82-.74.74-1.4-.08-.68-.21-.9-.22-.9-.07-.12-.04-.27.07-.34.11-.08.26-.05.34.06.03.05.2.32.3,1.13.11.89-.3,1.62-1.05,1.92-.12.05-.32.07-.57.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.07,228.4s-.05,0-.07-.01c-.13-.04-.21-.18-.17-.31.23-.76.94-1.42,1.72-1.6.61-.14,1.2.04,1.63.51.01.01.1.11.12.25.04.29-.23.47-.51.51-.14.02-.26-.07-.29-.21-.02-.14.07-.26.21-.29.01,0,.02,0,.04,0-.37-.34-.79-.34-1.09-.27-.61.14-1.17.67-1.36,1.26-.03.11-.13.18-.24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.14,229.65s-.05,0-.08-.01c-.13-.04-.2-.18-.16-.32.24-.74.98-1.39,1.8-1.59.68-.16,1.32,0,1.79.49.02.01.11.11.13.25.04.25-.18.46-.54.51-.15.02-.26-.07-.28-.21-.02-.14.07-.26.21-.29.02,0,.03,0,.05-.01-.42-.35-.91-.34-1.25-.26-.64.15-1.25.68-1.44,1.26-.03.11-.13.17-.24.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.01,228.99s-.05,0-.08-.01c-.13-.04-.2-.18-.16-.32.24-.74.98-1.39,1.8-1.59.67-.16,1.32,0,1.79.49.02.01.11.11.13.25.04.26-.18.46-.54.51-.14.02-.26-.07-.28-.21s.07-.26.21-.28c.02,0,.03,0,.05-.01-.42-.35-.91-.34-1.25-.26-.64.15-1.25.68-1.44,1.26-.03.11-.13.17-.24.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.21,251.59h-.54c-.53-.02-1.89-.13-1.94-.14l-5.8.02.18-.36c.18-.37.48-1.04.52-1.26.05-.28-.05-.72-.24-1.1-.17-.34-.17-1.44-.1-3.21,0-.2.01-.36.02-.46,0-.42.31-1.64.89-3.62.1-.34.55-1.26,1.19-2.54.3-.6.64-1.29.67-1.4.04-.13.18-.21.31-.17.13.04.21.17.17.3-.03.11-.22.5-.71,1.49-.45.9-1.06,2.13-1.14,2.4-.77,2.6-.89,3.34-.89,3.55,0,.11,0,.27-.02.47-.03.66-.11,2.67.04,2.97.24.48.35,1.02.29,1.41-.04.24-.24.71-.39,1.04l5.02-.02s1.42.12,1.93.13h.53c.14.01.25.13.25.26,0,.14-.11.25-.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.36,251.05c-.13,0-.24-.11-.25-.24-.02-.41-.38-.44-.49-.44h-.07l-.06-.03c-.91-.51-.96-.64-.99-.71-.04-.1-.03-.2,0-.32.03-.21.07-.48-.14-.71-.27-.29-.39-.59-.57-1-.13-.3-.28-.67-.54-1.18-.49-.94-.19-1.74,0-2.27.07-.2.14-.39.14-.5-.02-.37.46-1.64,1.31-3.71.15-.36.25-.62.27-.69,0-.04.04-.18,1.39-2.23.08-.12.23-.15.35-.07.12.08.15.23.07.35-.61.92-1.27,1.96-1.33,2.1,0,.03-.04.11-.29.73-.35.86-1.29,3.15-1.27,3.49.01.21-.07.44-.17.7-.18.5-.41,1.13-.03,1.87.27.53.43.91.56,1.22.17.39.26.63.47.86.38.41.31.88.27,1.13,0,.02,0,.03,0,.05.12.09.43.29.71.44.38.02.89.27.92.92,0,.14-.1.25-.24.26h-.01ZM277.98,249.49h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.74,249.15c-.08,0-.16-.04-.21-.11-.61-.91-.28-1.71-.27-1.74l.04-.07s.46-.68.92-4.6c.5-4.24,1.7-5.33,1.76-5.38.1-.09.26-.08.35.02.09.1.08.26-.02.35h0s-1.12,1.07-1.59,5.06c-.43,3.68-.86,4.61-1.01,4.83-.04.11-.18.64.23,1.25.08.11.05.27-.07.35-.04.03-.09.04-.14.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.42,249.23s-.06,0-.08-.01c-.13-.05-.2-.19-.15-.32.01-.03,1.09-3.15.97-5.97-.12-2.95,1.36-5.29,1.42-5.38.08-.12.23-.15.35-.07.12.07.15.23.07.35-.01.02-1.46,2.3-1.34,5.09.12,2.92-.96,6.02-1,6.16-.04.1-.13.17-.24.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.24,294.44c-1,0-2.37-.26-3.72-.53-.25-.05-.47-.1-.63-.13-1.17-.22-2.98-2.59-3.19-2.86l-.06-.08v-.1c.01-.07.16-1.66.68-3.27.24-.75.3-2.05.35-3.3.06-1.43.12-2.78.43-3.58.33-.88.57-3.94.73-6.17.13-1.72.21-2.71.3-3.02.23-.79,1.47-3.54,1.76-3.93.09-.17.36-1.52.6-2.71.38-1.9.81-4.06,1.13-4.68.36-.7.32-2,.28-2.86-.01-.35-.02-.62,0-.8.02-.22.09-.48.17-.79.16-.61.37-1.36.32-2.25-.06-1.08.27-1.57.68-2.18.15-.23.33-.49.51-.81.24-.44.56-.71.94-.8.44-.1.83.08,1,.17.3-.03,1.25-.08,1.81.46.72.71.32,1.28.3,1.31-.07.09-.19.13-.29.09-.1.17-.25.48-.45.98-.43,1.1-.47,1.35-.3,1.96l.05.18c.02.09.05.2.07.22.07.05.45.02.93,0h.24c1.52-.09,4.31-.25,5.03-.29.18,0,.49-.08.85-.17,1-.23,2.36-.55,3.49-.22.33.1.63.4.88.89.92,1.78,1.14,5.79.95,6.37-.23.67-1.13,4.31-1.17,4.89.08.17-.03.57-.53,2.25-.35,1.19-.79,2.67-.99,3.69-.22,1.1.05,1.76.36,2.53.22.55.47,1.17.55,2,.13,1.4,0,1.99-.11,2.57-.05.23-.09.46-.13.75-.11,1,0,4.19,0,4.22l.06,1.68-.5-1.47s-.12.09-.23.19l-.2.2c-.34.33-.43.41-.45.95-.03.75-.34,3.23-.35,3.34-.03.1-.48,1.4-1.61,1.57-.56.08-.74.05-.95-.02-.11-.03-.22-.06-.55-.04-.4.03-.73.23-1.12.46-.34.2-.72.43-1.21.59-.52.17-1.02.25-1.5.34-.48.08-.93.16-1.34.31-.41.15-.86.47-1.33.8-.45.31-.91.64-1.41.88-.27.13-.66.19-1.13.19ZM268.15,290.7c.57.74,2.02,2.44,2.82,2.59.17.03.39.08.64.13,1.31.27,3.75.77,4.53.39.46-.23.91-.54,1.34-.84.5-.35.97-.68,1.44-.86.45-.17.92-.25,1.43-.34.46-.08.94-.16,1.43-.32.44-.14.78-.34,1.1-.54.42-.25.82-.49,1.34-.53.39-.03.55,0,.73.06.13.04.25.07.73,0,.83-.12,1.2-1.17,1.2-1.18h0s.31-2.52.34-3.25c.03-.71.21-.91.61-1.3l.2-.19c.13-.13.32-.29.51-.35-.02-.85-.08-3.12.02-3.97.03-.31.08-.55.13-.8.12-.56.23-1.09.1-2.42-.07-.76-.3-1.32-.52-1.86-.33-.81-.64-1.57-.39-2.82.21-1.04.65-2.53,1-3.73.25-.84.53-1.79.53-1.96h.03c-.11-.92,1.13-5.16,1.14-5.2.15-.43-.05-4.3-.92-5.98-.19-.36-.39-.58-.58-.64-1-.3-2.29,0-3.23.22-.4.09-.71.17-.94.18-.72.04-3.51.2-5.03.27h-.24c-1.14.08-1.35.08-1.51-.59l-.04-.17c-.21-.76-.12-1.15.32-2.28.35-.89.57-1.22.68-1.34l.07-.17s.01-.02.02-.04c-.04-.08-.11-.18-.22-.28-.48-.47-1.47-.32-1.48-.32l-.1.02-.08-.06s-.33-.23-.69-.15c-.23.05-.44.24-.61.55-.19.34-.37.61-.53.85-.41.6-.65.96-.6,1.87.06.97-.17,1.8-.33,2.41-.08.28-.14.52-.16.7-.01.15,0,.42,0,.74.03.91.09,2.29-.34,3.11-.29.56-.73,2.77-1.09,4.55-.4,2.01-.56,2.73-.69,2.91-.24.31-1.45,2.99-1.68,3.77-.08.28-.18,1.56-.28,2.91-.18,2.39-.41,5.36-.76,6.31-.28.73-.34,2.1-.4,3.43-.06,1.35-.12,2.62-.38,3.43-.43,1.34-.6,2.7-.64,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.54,247.02c-.13,0-.25-.11-.25-.24,0-.14.1-.25.24-.26.01,0,1.45-.06,3.44-1,2.12-.99,3.48-.79,3.54-.78.14.02.23.15.21.29-.02.14-.15.23-.29.21-.01,0-1.29-.19-3.25.74-2.09.98-3.57,1.04-3.64,1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.23,294.44c-.09,0-.17-.05-.22-.13-.07-.12-.02-.27.1-.34l.28-.16c.1-.46.49-2.24.52-2.82,0-.15.08-.58.19-1.3.45-2.84,1.49-9.49,1.38-14.32-.14-5.97-.18-7.58.22-11.01.24-2.11.3-5.02.34-6.94.03-1.53.05-2.03.1-2.19.04-.13.18-.2.31-.16.13.04.2.18.16.31-.04.14-.05,1.07-.08,2.06-.04,1.93-.1,4.85-.35,6.99-.39,3.4-.35,5-.21,10.95.11,4.88-.93,11.56-1.38,14.41-.1.65-.18,1.13-.18,1.25-.04.71-.54,2.92-.56,3.01l-.02.11-.48.27s-.08.03-.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.79,275.4c-.07,0-.13-.03-.18-.08-.09-.1-.09-.26.01-.35.54-.5,1.03-1.04,1.48-1.61.21-.26.43-.57.53-.91.04-.13.17-.21.31-.17.13.04.21.17.17.31-.12.43-.38.78-.62,1.08-.46.59-.98,1.15-1.54,1.67-.05.04-.11.07-.17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.76,278.47s-.06,0-.09-.02c-.13-.05-.2-.19-.15-.32.63-1.71,1.37-3.39,2.22-5.01.06-.12.21-.17.34-.11.12.06.17.21.11.34-.83,1.6-1.57,3.26-2.19,4.95-.04.1-.13.16-.23.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.83,287.04c-.07,0-.13-.03-.18-.08-.09-.1-.09-.26.01-.35l3.9-3.62c.22-.21.46-.4.7-.6.33-.27.67-.55.95-.85.38-.39.65-1.05.89-1.63.06-.14.12-.28.17-.41s.21-.18.33-.13c.13.06.18.2.13.33-.05.12-.11.26-.17.4-.26.62-.55,1.33-.99,1.79-.3.32-.65.61-.99.89-.23.19-.47.39-.68.59l-3.9,3.62s-.11.07-.17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.84,288.49c-.12,0-.23-.09-.25-.21-.02-.14.07-.26.21-.29,1.58-.26,3.04-.51,4.47-.78.52-.1,1.11-.21,1.61-.47.37-.19.69-.46,1.03-.74.39-.32.8-.66,1.29-.87.13-.05.27,0,.33.13.06.13,0,.27-.13.33-.42.19-.79.49-1.17.8-.35.29-.71.58-1.12.8-.57.29-1.2.41-1.75.51-1.44.27-2.9.52-4.49.78-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.41,284.09c-.12,0-.23-.09-.25-.21-.02-.14.07-.26.21-.29,2.09-.32,4.1-.97,5.97-1.93.12-.06.27-.01.34.11.06.12.01.27-.11.34-1.92.99-3.98,1.66-6.13,1.98-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.5,262.31c-.08,0-.15-.03-.2-.1-.77-1.03-1.16-2.3-1.46-3.52-.24-.98-.44-1.98-.61-2.96-.02-.14.07-.27.21-.29.14-.01.27.07.29.21.16.97.36,1.95.6,2.92.33,1.35.69,2.44,1.37,3.34.08.11.06.27-.05.35-.04.03-.1.05-.15.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.78,269.97c-.1,0-.19-.06-.23-.15l-.9-2.17c-.33-.8-.67-1.62-.88-2.48-.26-1.06-.3-2.13-.31-2.95-.03-2.03.17-4.06.59-6.04.03-.13.15-.22.3-.19.13.03.22.16.19.3-.41,1.94-.6,3.94-.58,5.93.01.79.05,1.83.3,2.84.2.82.53,1.62.85,2.4l.9,2.18c.05.13,0,.27-.14.33-.03.01-.06.02-.1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.26,279.53c-.09,0-.18-.05-.22-.13-2.07-3.98-3.22-8.46-3.33-12.94,0-.14.11-.25.24-.26h0c.14,0,.25.11.25.24.11,4.41,1.24,8.81,3.27,12.72.06.12.02.27-.11.34-.04.02-.08.03-.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.28,286.08s-.09-.01-.13-.04c-.36-.23-.47-.66-.54-1.04l-.2-1.09c-.15-.83-.31-1.69-.35-2.56-.04-.93.06-1.86.16-2.77.04-.32.07-.65.1-.97.13-1.47.14-2.98.14-4.44v-2.69c0-.14.11-.25.25-.25h0c.14,0,.25.11.25.25v2.65c0,1.5,0,3.02-.14,4.51-.03.33-.07.65-.1.98-.1.88-.2,1.8-.16,2.69.04.83.19,1.67.34,2.49l.2,1.09c.05.29.12.59.32.71.12.07.15.23.08.34-.05.08-.13.12-.21.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.78,269.12c-.27,0-.49-.16-.69-.34-1.44-1.29-2.51-2.94-3.11-4.78-.04-.13.03-.27.16-.32.14-.04.27.03.32.16.57,1.75,1.6,3.33,2.97,4.56.12.11.25.21.36.21h.01c.08,0,.17-.07.24-.12.36-.27.65-.62.83-1.03.06-.13.21-.19.33-.12.13.06.18.2.12.33-.22.49-.56.91-.99,1.23-.12.09-.3.2-.5.21-.01,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.81,270.43c-.48,0-.93-.15-1.35-.32-.99-.39-1.7-.82-2.24-1.35-.71-.7-1.1-1.58-1.08-2.44,0-.14.14-.24.26-.24.14,0,.25.12.24.26-.02.71.32,1.47.93,2.07.49.48,1.15.88,2.08,1.25.37.15.77.28,1.17.28h.02c.4,0,.76-.17.95-.43.08-.11.24-.14.35-.06.11.08.14.23.06.35-.28.4-.78.64-1.35.65h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.57,265.24s-.06,0-.09-.02c-.11-.04-.34-.18-.27-.64.04-.23.08-.46.11-.69.07-.45.14-.92.24-1.37.04-.18.1-.35.16-.52.08-.24.16-.47.18-.73.06-.95.09-1.93.12-2.87.02-.5.03-.99.05-1.48.06-1.44.12-2.93.37-4.39.12-.69.32-1.47.9-1.95.11-.09.26-.07.35.04.09.11.07.26-.04.35-.46.38-.62,1.04-.73,1.64-.25,1.43-.3,2.9-.36,4.33-.02.49-.04.99-.05,1.48-.03.95-.06,1.93-.13,2.89-.02.32-.11.59-.2.86-.05.15-.1.3-.14.47-.1.43-.17.89-.24,1.33-.04.23-.07.46-.11.7,0,.05,0,.08,0,.11.1.06.14.18.1.3-.04.1-.13.16-.23.16ZM275.71,264.8h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.83,262.73c-.09,0-.17-.04-.22-.12-.4-.69-.33-1.48-.26-2.25l.03-.29c.06-.7.04-1.42.03-2.11-.02-.89-.03-1.81.09-2.72.16-1.17.58-2.4,1.27-3.76.13-.26.28-.54.55-.71.3-.2.78-.23,1.04.08.09.1.08.26-.02.35-.1.09-.26.08-.35-.02-.08-.09-.27-.07-.38,0-.16.11-.27.31-.38.52-.66,1.32-1.06,2.49-1.22,3.61-.12.87-.11,1.77-.09,2.64.01.71.03,1.44-.03,2.16l-.03.29c-.06.69-.13,1.4.19,1.95.07.12.03.27-.09.34-.04.02-.08.03-.13.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.19,266.11c-.06,0-.13-.02-.19-.05-.12-.07-.16-.22-.09-.34.04-.08.13-.12.21-.12,0-.03.01-.06.01-.08-.02-.93.05-1.85.2-2.76.13-.76.3-1.44.53-2.07.05-.14.11-.28.16-.42.15-.39.3-.76.37-1.15.09-.48.08-.97.06-1.49v-.18c-.05-1.46.02-2.8.2-4.08.09-.59.19-1.12.32-1.61.13-.51.36-1.13.92-1.39.12-.06.27,0,.33.12.06.12,0,.27-.12.33-.38.18-.54.67-.65,1.07-.12.47-.22.98-.31,1.56-.18,1.25-.25,2.56-.2,3.99v.18c.02.52.04,1.07-.06,1.6-.08.43-.24.84-.4,1.24-.05.14-.11.27-.16.41-.22.6-.39,1.25-.51,1.98-.15.87-.21,1.77-.19,2.66,0,.2-.08.46-.26.56-.06.03-.12.05-.18.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.8,286.68s-.04,0-.06,0c-.14-.02-.23-.15-.21-.29.01-.09.08-.16.16-.19,0-.03,0-.07-.01-.1-.2-.73-.02-1.46.16-2.17.07-.29.14-.57.19-.86.11-.7.05-1.4,0-2.14-.03-.38-.06-.76-.07-1.15-.02-.94.1-1.85.24-2.85l.08-.6c.16-1.1.32-2.24.41-3.36.15-1.83.12-3.7.09-5.51-.02-1.37-.04-2.78.01-4.17,0-.14.14-.26.26-.24.14,0,.25.12.24.26-.05,1.38-.03,2.78-.01,4.14.03,1.82.06,3.71-.09,5.56-.09,1.14-.26,2.28-.42,3.39l-.08.6c-.14.98-.25,1.87-.23,2.77,0,.37.04.74.07,1.12.06.74.12,1.5,0,2.26-.05.3-.12.6-.2.9-.17.67-.32,1.31-.16,1.92.05.18.05.44-.09.6-.07.08-.17.12-.27.12ZM275.82,286.18h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.2,294.33s-.05,0-.08-.01c-.13-.05-.2-.19-.15-.32.22-.62.32-1.27.3-1.92,0-.33-.05-.67-.08-1-.05-.46-.11-.94-.08-1.43.02-.38.09-.75.15-1.11l.04-.24c.28-1.63.35-3.29.2-4.93-.01-.14.09-.26.23-.27.12-.01.26.09.27.23.16,1.69.09,3.39-.21,5.06l-.04.24c-.07.36-.13.7-.14,1.04-.02.44.03.88.08,1.34.04.34.08.69.09,1.05.02.71-.09,1.42-.33,2.1-.04.1-.13.17-.24.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.58,287.27l-.5-.06c0-.08.02-.16.04-.23l.99-5.5c.24-1.32.48-2.69.64-4.07.07-.58.12-1.17.17-1.76.07-.81.14-1.64.26-2.46.16-1.15.41-2.3.65-3.41.29-1.36.6-2.77.74-4.18.01-.14.14-.25.27-.22.14.01.24.14.22.27-.14,1.43-.45,2.86-.74,4.23-.24,1.1-.48,2.25-.64,3.38-.11.81-.18,1.63-.25,2.43-.05.59-.1,1.18-.17,1.77-.16,1.4-.41,2.77-.65,4.1l-.94,5.23c.02.06.02.13-.01.19-.02.03-.03.07-.04.1l-.03.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.49,290.41l-.3-1.2c-.04-.17-.06-.27-.08-.37-.02-.09-.03-.19-.07-.35-.09-.36-.02-.72.05-1.03.36-1.84.43-3.73.49-5.55.01-.38.03-.75.04-1.13.04-1.01.11-2.2.27-3.42.15-1.1.38-2.19.61-3.26l.18-.86c.35-1.68.65-3.39.89-5.07.02-.14.14-.23.28-.21.14.02.23.15.21.28-.25,1.7-.55,3.41-.89,5.1l-.18.87c-.22,1.05-.45,2.14-.6,3.22-.16,1.2-.23,2.38-.27,3.37-.02.38-.03.75-.04,1.13-.03.85-.06,1.72-.12,2.58.41-2.32.84-4.64,1.3-6.94l.21-1.04c.58-2.88,1.19-5.85,1.39-8.82,0-.14.14-.26.27-.23.14,0,.24.13.23.27-.21,3-.81,5.99-1.4,8.88l-.21,1.03c-.76,3.82-1.46,7.69-2.07,11.53l-.19,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.24,294.19s-.06,0-.09-.02c-.13-.05-.2-.19-.15-.32.12-.34.42-.51.68-.67.13-.08.26-.15.35-.24.2-.19.31-.49.39-.78.29-1.01.4-2.08.52-3.11.1-.94.21-1.91.44-2.85.03-.13.17-.21.3-.18.13.03.22.17.18.3-.22.91-.33,1.86-.43,2.78-.12,1.06-.24,2.15-.53,3.2-.1.36-.24.73-.53,1.01-.13.13-.29.22-.44.31-.21.13-.4.24-.46.41-.04.1-.13.16-.23.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.43,292.19c-.18,0-.36-.07-.51-.14-.41-.19-.87-.45-1.15-.89-.12-.19-.19-.4-.27-.6-.12-.34-.23-.63-.48-.73-.1-.04-.23-.05-.42-.03-.39.04-.78.18-1.12.38l-.26.16-.1-.29c-.26-.71-.51-1.43-.78-2.14-.05-.13.02-.27.15-.32.13-.05.27.02.32.15.23.62.45,1.24.68,1.87.33-.16.69-.27,1.06-.31.19-.02.43-.03.67.07.45.19.61.63.75,1.02.07.19.13.36.22.51.15.25.41.43.67.57l.65-.25c.55-.22,1.11-.06,1.64.08.47.13.92.25,1.31.11.13-.04.27.02.32.15.04.13-.02.27-.15.32-.54.19-1.08.04-1.6-.1-.36-.1-.72-.19-1.03-.17.01.19-.08.41-.28.51-.09.05-.19.07-.29.07ZM273.27,291.65c.08.03.16.04.22.03l-.22-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.32,293.52h0c-.89,0-1.77-.23-2.55-.67-.21.21-.5.34-.85.32-.31-.01-.63-.14-.98-.38-.62-.44-1.1-1.08-1.33-1.81l-.02-.07c-.04-.12-.07-.23-.13-.31-.04-.05-.11-.08-.12-.07-.02.01-.05.05-.08.08l-.93,1.09-.18-.28c-.51-.8-.94-1.66-1.25-2.56-.05-.13.02-.27.15-.32.13-.05.27.02.32.15.27.76.61,1.49,1.03,2.17l.49-.58c.05-.06.12-.14.23-.2.27-.14.58,0,.74.21.12.15.17.32.21.47l.02.06c.2.62.6,1.18,1.14,1.55.26.18.49.28.71.29.23.01.45-.1.54-.27l.12-.24.23.14c.75.46,1.61.71,2.49.71.14,0,.25.11.25.25s-.11.25-.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.4,290.64h-.01c-.13,0-.24-.1-.26-.23-.02-.12.03-.29.25-.37.49-.2,1.01-.33,1.54-.41.82-.11,1.65-.07,2.45-.03.28.01.56.03.83.04.9.03,2.07-.01,3.04-.54.51-.28.95-.67,1.41-1.1.51-.47,1.04-.95,1.7-1.26.13-.06.27,0,.33.12.06.12,0,.27-.12.33-.58.27-1.06.71-1.57,1.17-.46.42-.94.86-1.51,1.17-1.07.58-2.33.62-3.29.6-.28,0-.56-.02-.84-.04-.78-.04-1.59-.08-2.36.03-.45.06-.88.17-1.31.33-.04.1-.18.19-.28.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.04,290.18c-.12,0-.22-.08-.25-.21-.02-.14.07-.27.2-.29.47-.08.91-.31,1.37-.55.46-.24.93-.49,1.46-.59.4-.08.81-.07,1.2-.06.79.02,1.53.02,2.26.03.43,0,.88,0,1.28-.11.69-.19,1.23-.7,1.8-1.23.56-.52,1.14-1.06,1.89-1.31.13-.04.27.03.32.16s-.03.27-.16.32c-.65.22-1.16.7-1.71,1.21-.59.55-1.2,1.12-2.01,1.34-.47.13-.96.13-1.42.13-.74,0-1.48,0-2.22-.02-.43,0-.79-.02-1.14.05-.46.09-.88.31-1.33.54-.47.25-.96.5-1.51.6-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.91,227.46h0c-.39-.01-.73-.2-1.01-.36-.28-.16-.57-.31-.84-.48-.43-.27-1.03-.7-1.16-1.36-.03-.13.06-.27.2-.29.14-.02.27.06.29.2.09.47.55.8.93,1.04.27.17.54.32.82.47.24.13.52.29.79.29.14,0,.25.12.24.26,0,.13-.12.24-.25.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.57,227.28s-.04,0-.06,0c-.86-.23-1.68-.66-2.35-1.25-.1-.09-.12-.25-.02-.35.09-.1.25-.11.35-.02.62.54,1.36.93,2.15,1.14.13.04.21.17.18.31-.03.11-.13.19-.24.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.18,226.13s-.01,0-.02,0c-.43-.04-.88-.19-1.33-.46-.39-.23-.75-.51-1.09-.78-.11-.09-.13-.24-.04-.35.08-.11.24-.13.35-.04h0c.33.26.67.53,1.03.75.39.23.77.36,1.13.39.14.01.24.13.23.27-.01.13-.12.23-.25.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.08,223.95c-.1,0-.2-.07-.24-.17-.08-.25-.32-.44-.57-.63-.37-.28-.78-.58-1.21-.79-.46-.22-.89-.34-1.31-.34h-.02c-.14,0-.25-.11-.25-.25,0-.15.14-.24.27-.25.49,0,1,.13,1.53.39.48.24.91.54,1.3.84.3.23.61.49.74.87.04.13-.02.27-.16.32-.03,0-.05.01-.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.72,231.92h-.01c-.14,0-.25-.12-.24-.26,0-.14.11-.24.25-.24h0c.08-.06.11-.11.15-.16.03-.04.05-.07.06-.1.06-.12.08-.28.1-.43.02-.14.14-.23.28-.22.14.02.23.14.22.28-.02.18-.05.4-.16.6-.02.04-.05.09-.08.13-.06.09-.12.17-.2.25-.11.1-.24.15-.37.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.6,248.82c-.06,0-.13-.01-.19-.06-.12-.08-.15-.23-.07-.35.06-.09.18-.13.28-.1.3-.11.58-.22.85-.34.29-.13.61-.29.73-.55l.03-.08c.03-.07.06-.16.12-.24.11-.15.26-.23.37-.29l.95-.51c.12-.06.27-.02.34.1.06.12.02.27-.1.34l-.95.51c-.08.04-.16.09-.2.14-.02.03-.04.08-.06.12-.01.03-.03.07-.04.1-.19.4-.58.62-.99.8-.29.12-.58.24-.87.35-.03.01-.1.04-.19.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.34,248.43c-.1,0-.19-.06-.23-.15-.05-.13,0-.27.13-.33l1.36-.58c.15-.06.32-.15.34-.25,0-.04,0-.11-.01-.17-.02-.1-.04-.22-.01-.35.06-.31.31-.47.52-.6.06-.04.11-.07.17-.11.15-.12.27-.29.4-.48.17-.26.37-.55.69-.71.12-.06.27,0,.33.12.06.12,0,.27-.12.33-.2.1-.34.31-.5.54-.14.21-.29.43-.51.6-.06.05-.13.09-.2.14-.14.09-.27.17-.29.27,0,.04,0,.11.01.17.02.1.04.23,0,.36-.08.37-.45.53-.63.6l-1.36.58s-.07.02-.1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.28,251.91c-.14,0-.25-.11-.25-.25-.02-1.17-.37-2.31-1-3.3l-.08-.12c-.14-.21-.29-.44-.37-.7-.11-.36-.08-.71-.06-1.05,0-.1.01-.19.02-.29.02-.45-.04-.9-.1-1.38l-.05-.39c-.16-1.4-.13-2.83-.1-4.21.03-1.25.06-2.55-.06-3.81-.01-.14.09-.26.23-.27.13-.02.26.09.27.23.12,1.29.09,2.6.06,3.86-.03,1.36-.06,2.77.09,4.14l.05.38c.06.47.12.96.1,1.46,0,.1-.01.2-.02.3-.02.31-.04.61.04.87.06.2.18.38.31.58l.08.13c.68,1.06,1.05,2.29,1.08,3.56,0,.14-.11.25-.25.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.06,249.36l.76-.47c.31-.2.53-.51.76-.85.2-.29.41-.59.69-.83.11-.09.26-.08.35.03.09.11.08.26-.03.35-.23.2-.41.46-.6.73-.18.26-.36.52-.59.74,0,0,0,.02,0,.03,0,.14-.1.25-.24.26l-1.1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.77,250.31c-.11,0-.21-.07-.24-.18-.04-.13.03-.27.17-.31.18-.05.34-.14.49-.25.18-.14.33-.31.49-.5l.55-.65c.09-.1.25-.12.35-.03.11.09.12.25.03.35l-.55.65c-.18.21-.35.41-.57.58-.19.15-.41.26-.64.33-.02,0-.05.01-.07.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M275.37,294.19c.89.18,1.48-.45,1.48-.45,0,0-.03,1.45.05,1.98.15.96.07,1.24-.17,1.4-.4.26-.71.32-3.32.28-.8-.01-4.43.93-4.72.85-.92-.25-1.6-2.1-.96-2.16.96-.08,1.25-.16,1.25-.16,0,0-1.81.22-1.84-.42-.01-.41.31-.94,2.21-.65,1.19.18,1.18.03,2.05-.06s1.47-.13,2.1-.19.3-.53.3-.53l1.57.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.73,298.5s-.09,0-.12-.01c-.84-.23-1.45-1.46-1.39-2.11.01-.12.04-.23.1-.31-.09-.04-.16-.08-.23-.13-.13-.11-.2-.25-.21-.42,0-.26.09-.49.28-.66.38-.34,1.1-.42,2.22-.25.8.12,1.02.09,1.38.02.16-.03.34-.06.61-.09.55-.06,1-.09,1.41-.13l.7-.06c.13-.01.17-.04.17-.04,0,0-.03-.06-.05-.09l-.28-.42,2.11.14c.75.15,1.24-.37,1.25-.38l.45-.47v.65s-.04,1.43.03,1.94c.14.9.13,1.38-.28,1.64-.46.3-.81.36-3.46.32h-.01c-.41,0-1.66.27-2.67.49-1.25.27-1.75.37-1.98.37ZM268.94,295.68l.1.49s-.34.09-1.3.17c-.03.03-.05.2.05.5.15.48.54,1.05.96,1.16.11,0,1.09-.2,1.86-.36,1.14-.25,2.32-.5,2.78-.5h.02c2.62.04,2.85-.03,3.18-.24.11-.07.2-.22.06-1.15-.05-.35-.06-1.05-.06-1.53-.3.16-.73.31-1.26.21l-1.2-.08c0,.06-.01.12-.04.18-.09.19-.28.3-.57.32l-.7.06c-.41.04-.85.07-1.4.13-.25.02-.42.05-.57.08-.4.07-.66.12-1.54-.02-1.24-.19-1.66,0-1.81.13-.08.07-.11.16-.11.27.25.24,1.06.24,1.56.18Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M301.04,298.41c-.81-4.24-2.67-8.28-5.37-11.65,3.15,2.8,5.51,6.15,6.41,11.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M297.06,288.33c.32.4.61.81.89,1.24.14.22.28.43.4.65l.19.33c.06.11.12.22.18.33.49.89.93,1.81,1.3,2.75.1.23.18.47.27.71l.13.36c.04.12.08.24.12.36l.23.73.2.73c.15.49.24.99.36,1.48l.04.19c.01.06.02.12.03.19l.07.38.14.75-.11-.76-.06-.38c0-.06-.02-.13-.03-.19l-.04-.19c-.11-.5-.19-1-.33-1.49-.06-.25-.13-.49-.2-.74l-.23-.73c-.04-.12-.07-.24-.12-.36l-.13-.36-.13-.36c-.04-.12-.09-.24-.14-.36l-.3-.7c-.1-.23-.21-.46-.32-.69-.1-.23-.23-.46-.34-.68-.06-.11-.11-.23-.18-.34l-.19-.33c-.51-.88-1.07-1.74-1.73-2.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M296.35,283.11c-.19-.22-.72-.3-.72-.27-.05.19.09.89.89.74.02,0,.04-.02.04-.05,0-.11-.05-.25-.2-.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M296.44,283.24c-.02.08.05.17,0,.23-.03.05-.1.05-.15.03-.15-.04-.27-.15-.37-.25-.1-.1-.2-.2-.24-.33-.01-.04-.03-.08-.06-.09,0,0,0,0,0,0-.05.19.09.89.89.74.02,0,.04-.02.04-.05,0-.08-.03-.18-.1-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M296.3,283.15c-.03-.05-.08-.08-.13-.11-.09-.05-.19-.09-.29-.09,0,.02.03.03.05.04.11.06.22.13.31.22.02.02.05.04.08.06,0,0,.02,0,.03,0,.01,0,0-.02,0-.04,0-.02-.02-.04-.03-.06"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M296.62,283.83c-.33-.13-.95.09-.94.12.06.24.6.91,1.39.3.02-.02.03-.05.01-.07-.07-.12-.2-.25-.46-.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M296.8,283.92c.02.1.15.15.14.25,0,.07-.08.11-.14.12-.18.05-.37,0-.55-.06-.16-.05-.33-.1-.45-.22-.03-.03-.07-.07-.12-.07,0,0,0,0,0,0,.06.24.6.91,1.39.3.02-.02.03-.05.01-.07-.05-.09-.14-.18-.28-.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M296.59,283.9c-.06-.04-.13-.04-.2-.04-.13,0-.26.01-.36.07.02.02.05.02.08.02.16,0,.31.02.47.05.04,0,.08.02.12.02.01,0,.02,0,.03-.01,0-.01,0-.03-.02-.04-.02-.02-.05-.04-.07-.05"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M297.22,284.61c-.4-.16-1.14.11-1.13.14.07.29.72,1.09,1.66.36.03-.02.03-.06.02-.08-.08-.14-.24-.3-.55-.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M297.44,284.72c.02.12.18.18.17.3,0,.08-.09.13-.17.15-.22.05-.45-.01-.66-.07-.19-.06-.39-.12-.54-.26-.04-.04-.09-.09-.14-.08,0,0,0,0,0,0,.07.29.72,1.09,1.66.36.03-.02.03-.06.02-.08-.06-.1-.16-.21-.34-.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M297.18,284.7c-.07-.05-.16-.05-.24-.05-.15,0-.31.01-.44.09.02.02.06.02.09.02.19,0,.37.02.56.06.05.01.09.02.14.02.01,0,.03,0,.04-.01.01-.02,0-.04-.02-.05-.03-.02-.05-.04-.09-.06"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M297.83,285.66c-.45-.18-1.29.12-1.28.16.07.33.82,1.24,1.89.41.03-.02.04-.06.02-.09-.09-.16-.27-.34-.63-.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M298.08,285.78c.02.13.2.21.19.34,0,.09-.1.14-.19.17-.25.06-.51-.01-.75-.08-.22-.07-.45-.14-.61-.29-.05-.04-.1-.1-.16-.09,0,0,0,0,0,0,.07.33.82,1.24,1.89.41.03-.02.04-.06.02-.09-.07-.12-.18-.24-.38-.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M297.79,285.76c-.08-.06-.18-.06-.27-.06-.17,0-.35.01-.49.1.03.02.07.03.1.03.21,0,.42.03.63.07.05.01.11.03.16.03.02,0,.03,0,.04-.02.01-.02,0-.04-.02-.06-.03-.03-.06-.05-.1-.07"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M298.66,286.97c-.44-.25-1.35-.05-1.34,0,.03.35.68,1.39,1.89.68.03-.02.05-.06.03-.09-.08-.18-.23-.38-.58-.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M298.9,287.13c0,.14.18.24.15.38-.02.09-.13.13-.22.14-.26.03-.52-.08-.76-.19-.22-.1-.44-.2-.59-.39-.04-.05-.09-.11-.15-.11,0,0,0,0,0,0,.03.35.68,1.39,1.89.68.03-.02.05-.06.03-.1-.06-.13-.16-.28-.34-.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M298.61,287.07c-.07-.07-.18-.09-.27-.1-.18-.02-.36-.03-.52.03.03.03.06.04.1.04.22.04.44.09.64.16.05.02.11.04.16.05.02,0,.04,0,.05-.01.02-.02,0-.05-.02-.06-.03-.03-.06-.06-.09-.08"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M299.31,288.49c-.44-.3-1.41-.17-1.41-.12,0,.37.6,1.52,1.94.88.04-.02.05-.06.04-.1-.06-.19-.21-.42-.56-.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M299.54,288.67c0,.15.17.27.13.41-.03.09-.15.13-.24.13-.28,0-.54-.13-.79-.26-.22-.12-.45-.25-.59-.46-.04-.06-.08-.13-.15-.13,0,0,0,0,0,0,0,.37.6,1.52,1.94.88.04-.02.05-.06.04-.1-.05-.14-.14-.3-.33-.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M299.24,288.59c-.07-.08-.18-.11-.28-.13-.18-.04-.38-.06-.56,0,.02.03.07.04.1.05.23.06.45.13.66.22.05.03.11.05.17.07.02,0,.04,0,.05,0,.02-.02,0-.05-.01-.07-.03-.03-.06-.07-.09-.09"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M299.75,290.06c-.49-.36-1.6-.24-1.6-.19,0,.42.62,1.75,2.16,1.07.04-.02.06-.07.05-.11-.07-.22-.23-.49-.61-.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M300.01,290.27c-.01.17.19.31.13.47-.04.11-.17.14-.28.14-.32,0-.61-.17-.88-.33-.25-.15-.5-.3-.65-.54-.04-.07-.09-.15-.17-.16,0,0,0,0,0,0,0,.42.62,1.75,2.16,1.07.04-.02.06-.07.05-.11-.05-.16-.15-.35-.35-.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M299.67,290.16c-.08-.09-.2-.13-.31-.15-.21-.05-.43-.09-.63-.03.03.04.07.05.12.06.25.08.51.16.74.28.06.03.12.06.19.08.02,0,.04,0,.06,0,.02-.02,0-.05,0-.08-.03-.04-.06-.08-.1-.11"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M300.07,291.75c-.51-.43-1.73-.4-1.74-.34-.04.46.54,1.97,2.28,1.35.05-.02.07-.07.06-.12-.05-.25-.21-.55-.61-.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M300.33,292.01c-.02.18.18.36.1.53-.05.11-.2.14-.32.13-.35-.03-.66-.23-.94-.44-.26-.18-.52-.37-.67-.65-.04-.08-.09-.17-.17-.19,0,0,0,0,0,0-.04.46.54,1.97,2.28,1.35.05-.02.07-.07.06-.12-.04-.18-.13-.4-.34-.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M299.97,291.86c-.08-.11-.21-.16-.33-.2-.22-.07-.46-.13-.69-.09.03.04.08.06.12.08.27.1.54.22.79.37.06.04.13.08.2.1.02,0,.04.01.06,0,.02-.02.01-.06,0-.09-.03-.05-.06-.09-.1-.13"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M300.75,291.33c.2-.64,1.24-1.27,1.28-1.23.28.36.62,1.95-1.19,2.37-.05.01-.1-.02-.12-.06-.09-.24-.12-.58.03-1.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M300.67,291.69c.12.14.05.4.2.5.1.07.24.01.34-.06.28-.21.42-.55.56-.88.12-.29.24-.59.22-.91,0-.09-.02-.19.04-.25,0,0,0,0,0,0,.28.36.62,1.95-1.19,2.37-.05.01-.1-.02-.12-.06-.07-.18-.1-.41-.05-.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M300.9,291.37c0-.13.09-.24.17-.34.15-.18.32-.36.53-.44,0,.05-.03.09-.06.13-.17.24-.34.48-.47.74-.03.07-.06.14-.11.19-.01.02-.03.03-.05.03-.03,0-.04-.04-.04-.07,0-.05,0-.11.01-.16"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M300.34,289.69c.18-.6,1.16-1.18,1.19-1.14.26.34.57,1.81-1.11,2.21-.05.01-.09-.01-.11-.06-.08-.22-.12-.54.03-1.01Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M300.26,290.03c.11.13.04.37.19.47.1.06.23.01.32-.06.26-.2.4-.51.52-.82.11-.27.22-.55.2-.84,0-.08-.02-.18.04-.23,0,0,0,0,0,0,.26.34.57,1.81-1.11,2.21-.05.01-.09-.01-.11-.06-.06-.16-.09-.38-.05-.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M300.47,289.73c0-.12.08-.23.16-.32.14-.17.29-.33.5-.41,0,.05-.03.09-.05.12-.16.22-.32.44-.44.69-.03.06-.06.13-.1.18-.01.02-.03.03-.05.03-.03,0-.04-.04-.04-.07,0-.05,0-.1.01-.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M299.83,288.17c.12-.52.91-1.09.95-1.05.25.27.61,1.52-.81,1.96-.04.01-.08,0-.1-.04-.08-.18-.13-.45-.04-.87Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M299.79,288.47c.1.1.06.32.19.39.09.05.2,0,.27-.07.21-.19.31-.46.39-.73.08-.24.16-.49.12-.74-.01-.07-.03-.15.02-.2,0,0,0,0,0,0,.25.27.61,1.52-.81,1.96-.04.01-.08,0-.1-.04-.06-.14-.1-.32-.09-.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M299.95,288.2c0-.1.06-.2.12-.28.11-.15.23-.31.4-.39,0,.04-.02.08-.04.11-.12.2-.24.4-.33.62-.02.06-.04.11-.08.16,0,.01-.02.03-.04.03-.03,0-.04-.03-.04-.06,0-.04,0-.09,0-.13"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M299.21,286.6c.12-.52.91-1.09.95-1.05.25.27.61,1.52-.81,1.96-.04.01-.08,0-.1-.04-.08-.18-.13-.45-.04-.87Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M299.17,286.9c.1.1.06.32.19.39.09.05.2,0,.27-.07.21-.19.31-.46.39-.73.08-.24.16-.49.12-.74-.01-.07-.03-.15.02-.2,0,0,0,0,0,0,.25.27.61,1.52-.81,1.96-.04.01-.08,0-.1-.04-.06-.14-.1-.32-.09-.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M299.33,286.63c0-.1.06-.2.12-.28.11-.15.23-.31.4-.39,0,.04-.02.08-.04.11-.12.2-.24.4-.33.62-.02.06-.04.11-.08.16,0,.01-.02.03-.04.03-.03,0-.04-.03-.04-.06,0-.04,0-.09,0-.13"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M298.25,285.24c0-.51.65-1.2.68-1.18.29.21.87,1.31-.37,2-.03.02-.08,0-.1-.02-.12-.16-.21-.4-.21-.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M298.26,285.52c.12.08.12.28.25.33.09.03.18-.04.24-.12.16-.22.2-.5.23-.76.03-.24.05-.49-.03-.71-.02-.06-.05-.14-.02-.19,0,0,0,0,0,0,.29.21.87,1.31-.37,2-.03.02-.08,0-.1-.02-.09-.12-.16-.28-.19-.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M298.36,285.24c-.02-.1.01-.2.05-.29.07-.16.16-.33.3-.44.01.04,0,.08-.02.11-.08.21-.15.42-.19.64,0,.06-.02.11-.04.17,0,.02-.02.03-.03.03-.02,0-.04-.02-.05-.05-.01-.04-.02-.08-.03-.12"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M297.49,284.24c-.03-.48.52-1.16.56-1.14.28.17.89,1.16-.22,1.89-.03.02-.07.01-.09-.01-.12-.14-.23-.36-.25-.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M297.53,284.5c.11.06.13.26.26.29.09.02.17-.05.22-.13.14-.21.15-.48.16-.73,0-.22.02-.46-.08-.66-.03-.06-.06-.12-.03-.18,0,0,0,0,0,0,.28.17.89,1.16-.22,1.89-.03.02-.07.01-.09-.01-.09-.1-.17-.25-.21-.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M297.6,284.23c-.03-.09,0-.18.03-.27.06-.16.12-.32.25-.43.01.03,0,.07,0,.1-.06.2-.11.4-.13.61,0,.05,0,.11-.03.16,0,.01-.01.03-.03.03-.02,0-.04-.02-.05-.04-.01-.04-.03-.07-.03-.11"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M296.82,283.59c-.04-.35.34-.88.36-.86.21.12.7.82-.08,1.4-.02.02-.05.01-.07,0-.09-.1-.18-.25-.21-.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M296.86,283.78c.09.04.11.18.2.2.06.01.12-.04.15-.1.09-.16.09-.36.09-.54,0-.17,0-.34-.08-.48-.02-.04-.05-.09-.03-.13,0,0,0,0,0,0,.21.12.7.82-.08,1.4-.02.02-.05.01-.07,0-.07-.07-.13-.18-.18-.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M296.9,283.58c-.02-.06,0-.14.01-.2.03-.12.08-.24.17-.33.01.02,0,.05,0,.08-.04.15-.07.3-.07.46,0,.04,0,.08-.01.12,0,.01,0,.02-.02.03-.02,0-.03-.01-.04-.03-.01-.03-.02-.05-.03-.08"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M296.42,283.41c.58.53,1.08,1.14,1.53,1.78.55.78,1.03,1.6,1.43,2.47.46.99.82,2.03,1.07,3.1.29,1.2.44,2.44.47,3.68.03,1.4-.1,2.82-.41,4.19-.04.18-.08.36-.13.54-.02.06-.1.03-.09-.02.28-1.4.46-2.82.47-4.25,0-1.24-.11-2.48-.36-3.7-.22-1.08-.55-2.13-.98-3.14-.38-.89-.83-1.74-1.37-2.54-.44-.66-.94-1.29-1.5-1.87-.06-.06-.12-.12-.18-.18-.03-.03.02-.08.05-.05h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M310.59,282.26c-.18-.15-.61-.15-.61-.13-.02.16.18.69.79.49.02,0,.03-.02.02-.04-.02-.09-.07-.2-.21-.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M310.68,282.35c0,.06.06.13.03.19-.02.04-.07.05-.11.05-.12-.01-.23-.09-.33-.16-.09-.06-.18-.13-.23-.23-.01-.03-.03-.06-.06-.07,0,0,0,0,0,0-.02.16.18.69.79.49.02,0,.03-.02.02-.04-.01-.06-.05-.14-.12-.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M310.56,282.3s-.07-.06-.11-.07c-.08-.03-.16-.05-.24-.03,0,.01.03.02.04.03.1.04.19.08.28.13.02.01.04.03.07.04,0,0,.02,0,.02,0,0,0,0-.02,0-.03,0-.02-.02-.03-.03-.05"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M310.89,282.8c-.28-.07-.74.19-.73.21.07.18.59.65,1.14.07.01-.02.02-.04,0-.06-.07-.08-.19-.17-.41-.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M311.05,282.85c.03.07.14.1.14.18,0,.05-.05.09-.1.11-.14.06-.3.04-.45.02-.13-.02-.27-.04-.38-.12-.03-.02-.07-.05-.1-.04,0,0,0,0,0,0,.07.18.59.65,1.14.07.01-.02.02-.04,0-.06-.05-.06-.13-.13-.26-.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M310.88,282.86s-.11-.02-.17-.01c-.1.02-.2.04-.28.1.02.01.04,0,.06,0,.13-.01.25-.02.38-.01.03,0,.06,0,.1,0,0,0,.02,0,.02-.01,0-.01,0-.03-.02-.03-.02-.01-.04-.02-.06-.03"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M311.47,283.35c-.34-.08-.89.22-.88.25.09.22.71.78,1.37.09.02-.02.02-.05,0-.07-.08-.1-.23-.21-.49-.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M311.65,283.41c.03.09.17.12.17.22,0,.06-.06.11-.12.14-.17.07-.36.05-.54.02-.16-.02-.33-.05-.46-.14-.04-.03-.08-.06-.12-.05,0,0,0,0,0,0,.09.22.71.78,1.37.09.02-.02.02-.05,0-.07-.06-.07-.15-.15-.31-.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M311.45,283.43c-.06-.03-.13-.02-.2-.01-.12.02-.24.05-.34.12.02.01.05.01.07,0,.15-.02.3-.03.45-.02.04,0,.08,0,.11,0,.01,0,.02,0,.03-.02,0-.01,0-.03-.02-.04-.02-.01-.05-.03-.08-.04"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M312.08,284.11c-.38-.09-1.01.25-1,.28.1.25.8.89,1.55.1.02-.02.02-.05,0-.08-.09-.12-.26-.23-.56-.31Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M312.29,284.17c.04.1.19.14.19.25,0,.07-.07.13-.13.16-.19.08-.4.05-.61.02-.18-.03-.37-.05-.52-.16-.04-.03-.09-.07-.14-.05,0,0,0,0,0,0,.1.25.8.89,1.55.1.02-.02.02-.05,0-.08-.07-.08-.18-.17-.35-.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M312.06,284.19c-.07-.03-.15-.03-.22-.01-.14.02-.27.05-.38.14.02.02.06.01.08,0,.17-.02.34-.03.51-.02.04,0,.09,0,.13,0,.01,0,.03,0,.03-.02,0-.02,0-.03-.03-.04-.03-.02-.06-.03-.09-.04"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M312.9,285.06c-.38-.15-1.08.12-1.07.15.07.27.71,1.03,1.59.32.02-.02.03-.05.01-.08-.08-.13-.23-.28-.53-.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M313.1,285.15c.02.11.17.17.17.28,0,.08-.09.12-.16.14-.21.06-.42,0-.63-.06-.18-.05-.38-.11-.52-.24-.04-.04-.08-.08-.14-.07,0,0,0,0,0,0,.07.27.71,1.03,1.59.32.02-.02.03-.05.01-.08-.06-.1-.16-.2-.32-.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M312.87,285.14c-.07-.05-.15-.05-.23-.05-.14,0-.29.02-.41.09.02.02.06.02.09.02.18,0,.36.02.53.05.04,0,.09.02.13.02.01,0,.03,0,.03-.01,0-.02,0-.04-.02-.05-.03-.02-.05-.04-.08-.06"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M313.59,286.18c-.39-.19-1.14.04-1.14.07.05.29.66,1.14,1.65.46.03-.02.04-.05.02-.08-.07-.15-.22-.31-.53-.46Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M313.8,286.3c.01.12.17.2.15.31-.01.08-.1.12-.18.14-.22.04-.45-.04-.66-.12-.19-.07-.39-.14-.52-.29-.04-.04-.08-.09-.14-.09,0,0,0,0,0,0,.05.29.66,1.14,1.65.46.03-.02.04-.05.02-.08-.05-.11-.15-.23-.32-.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M313.55,286.27c-.06-.05-.15-.06-.24-.07-.15,0-.31,0-.44.06.02.02.06.03.09.03.19.02.37.05.55.1.05.01.09.03.14.03.01,0,.03,0,.04-.01.01-.02,0-.04-.02-.05-.02-.02-.05-.05-.08-.06"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M314.13,287.38c-.43-.23-1.3,0-1.3.04.04.33.7,1.32,1.85.59.03-.02.04-.06.03-.09-.08-.17-.24-.36-.58-.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M314.37,287.52c.01.13.19.23.16.36-.02.09-.12.13-.21.15-.25.04-.51-.06-.74-.16-.21-.09-.43-.18-.58-.35-.04-.05-.09-.11-.15-.1,0,0,0,0,0,0,.04.33.7,1.32,1.85.59.03-.02.04-.06.03-.09-.06-.12-.16-.26-.35-.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M314.08,287.47c-.07-.06-.17-.08-.27-.09-.17-.01-.35-.02-.51.05.03.03.06.03.1.04.21.03.42.07.63.13.05.02.1.04.16.04.02,0,.03,0,.04-.01.01-.02,0-.04-.02-.06-.03-.03-.06-.05-.09-.08"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M314.59,288.69c-.46-.28-1.43-.11-1.42-.06.02.37.66,1.5,1.98.8.04-.02.05-.06.04-.1-.07-.19-.23-.42-.59-.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M314.84,288.86c0,.15.18.27.15.41-.03.1-.14.14-.24.15-.28.02-.55-.11-.8-.23-.23-.11-.46-.23-.61-.43-.04-.06-.09-.12-.16-.13,0,0,0,0,0,0,.02.37.66,1.5,1.98.8.04-.02.05-.06.04-.1-.05-.14-.16-.3-.35-.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M314.53,288.79c-.07-.07-.18-.1-.29-.12-.19-.03-.38-.05-.56.02.03.03.07.04.11.05.23.05.46.11.68.2.06.02.11.05.17.06.02,0,.04,0,.05,0,.02-.02,0-.05-.01-.07-.03-.03-.06-.06-.09-.09"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M315.09,288.27c.08-.53.83-1.16.87-1.13.27.25.73,1.48-.66,2.03-.04.01-.08,0-.1-.04-.1-.18-.17-.45-.11-.87Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M315.06,288.57c.11.1.08.31.22.37.09.04.2-.02.27-.09.2-.2.27-.49.34-.76.06-.25.12-.5.06-.75-.02-.07-.04-.15,0-.2,0,0,0,0,0,0,.27.25.73,1.48-.66,2.03-.04.01-.08,0-.1-.04-.07-.13-.13-.31-.13-.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M315.2,288.28c-.01-.1.04-.2.1-.29.1-.16.21-.32.37-.42,0,.04-.01.08-.03.11-.11.21-.21.42-.28.64-.02.06-.03.12-.06.17,0,.01-.02.03-.04.03-.03,0-.04-.03-.04-.05,0-.04-.01-.09-.01-.13"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M314.56,287.01c.07-.5.78-1.08.81-1.05.25.24.68,1.37-.62,1.89-.03.01-.07,0-.09-.03-.09-.17-.16-.41-.1-.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M314.54,287.29c.1.09.08.29.2.35.08.04.18-.02.25-.08.18-.19.25-.46.31-.71.06-.23.11-.47.06-.7-.01-.06-.03-.14,0-.19,0,0,0,0,0,0,.25.24.68,1.37-.62,1.89-.03.01-.07,0-.09-.03-.07-.12-.12-.29-.12-.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M314.67,287.03c0-.1.04-.19.09-.27.09-.15.19-.3.34-.39,0,.04-.01.07-.03.11-.1.19-.2.39-.26.6-.02.05-.03.11-.06.16,0,.01-.02.03-.04.03-.02,0-.04-.03-.04-.05,0-.04-.01-.08,0-.12"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M313.98,285.87c.03-.43.6-.98.63-.95.23.19.67,1.13-.41,1.66-.03.01-.06,0-.08-.02-.09-.14-.16-.35-.14-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M313.97,286.11c.09.07.09.24.2.29.07.03.15-.03.21-.09.15-.17.19-.41.22-.63.03-.2.07-.41,0-.6-.02-.05-.04-.12,0-.16,0,0,0,0,0,0,.23.19.67,1.13-.41,1.66-.03.01-.06,0-.08-.02-.07-.1-.12-.24-.14-.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M314.07,285.87c-.01-.08.02-.16.06-.24.07-.13.15-.27.27-.35,0,.03,0,.06-.02.09-.07.17-.14.35-.19.53-.01.05-.02.09-.04.14,0,.01-.02.03-.03.03-.02,0-.03-.02-.04-.04,0-.03-.01-.07-.02-.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M313.29,284.69c.03-.43.6-.98.63-.95.23.19.67,1.13-.41,1.66-.03.01-.06,0-.08-.02-.09-.14-.16-.35-.14-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M313.29,284.93c.09.07.09.24.2.29.07.03.15-.03.21-.09.15-.17.19-.41.22-.63.03-.2.07-.41,0-.6-.02-.05-.04-.12,0-.16,0,0,0,0,0,0,.23.19.67,1.13-.41,1.66-.03.01-.06,0-.08-.02-.07-.1-.12-.24-.14-.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M313.38,284.7c-.01-.08.02-.16.06-.24.07-.13.15-.27.27-.35,0,.03,0,.06-.02.09-.07.17-.14.35-.19.53-.01.05-.02.09-.04.14,0,.01-.02.03-.03.03-.02,0-.03-.02-.04-.04,0-.03-.01-.07-.02-.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M312.36,283.72c-.06-.41.37-1.03.4-1.02.25.13.85.93-.06,1.64-.02.02-.06.02-.08,0-.11-.11-.22-.29-.26-.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M312.4,283.95c.1.05.13.21.24.23.08.01.14-.06.18-.12.1-.19.1-.42.09-.64,0-.19-.02-.4-.11-.56-.03-.05-.06-.1-.04-.15,0,0,0,0,0,0,.25.13.85.93-.06,1.64-.02.02-.06.02-.08,0-.08-.08-.16-.2-.22-.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M312.45,283.71c-.03-.07-.01-.16,0-.24.04-.14.08-.28.18-.39.01.03,0,.06,0,.09-.04.18-.07.35-.07.54,0,.05,0,.09-.01.14,0,.01,0,.03-.02.03-.02,0-.03-.01-.04-.03-.02-.03-.03-.06-.04-.09"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M311.64,283.02c-.08-.38.28-.99.31-.97.24.1.85.81.05,1.53-.02.02-.05.02-.08,0-.11-.1-.22-.26-.28-.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M311.7,283.23c.1.04.13.19.24.2.07,0,.13-.06.16-.13.08-.18.06-.4.04-.6-.02-.18-.04-.37-.14-.52-.03-.04-.06-.09-.05-.14,0,0,0,0,0,0,.24.1.85.81.05,1.53-.02.02-.05.02-.08,0-.08-.07-.16-.18-.23-.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M311.72,283c-.03-.07-.02-.15,0-.22.03-.13.06-.27.15-.37.01.02.01.06,0,.08-.02.17-.04.33-.03.5,0,.04,0,.09,0,.13,0,.01,0,.03-.02.03-.02,0-.03-.01-.04-.03-.02-.03-.03-.06-.04-.08"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M311.03,282.58c-.07-.27.16-.74.19-.73.18.07.66.57.1,1.12-.01.01-.04.02-.06,0-.09-.07-.17-.18-.23-.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M311.08,282.73c.07.02.11.13.18.14.05,0,.09-.05.11-.1.05-.14.03-.29,0-.44-.02-.13-.05-.27-.13-.38-.02-.03-.05-.06-.04-.1,0,0,0,0,0,0,.18.07.66.57.1,1.12-.01.01-.04.02-.06,0-.06-.05-.13-.12-.18-.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M311.09,282.57s-.02-.11-.01-.16c.01-.1.03-.2.09-.28.01.02.01.04,0,.06,0,.12-.02.25,0,.37,0,.03,0,.06,0,.09,0,0,0,.02-.01.02-.01,0-.02,0-.03-.02-.01-.02-.02-.04-.03-.06"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M310.68,282.49c.52.35,1,.78,1.44,1.23.53.55,1.01,1.15,1.44,1.79.49.73.9,1.52,1.23,2.33.38.92.65,1.89.82,2.87.19,1.11.26,2.25.18,3.37-.01.15-.03.3-.04.46,0,.06-.1.06-.09,0,.05-1.14.02-2.28-.14-3.41-.14-.99-.39-1.97-.73-2.91-.3-.83-.69-1.63-1.16-2.39-.4-.66-.87-1.28-1.39-1.86-.43-.48-.91-.92-1.42-1.31-.05-.04-.11-.08-.16-.12-.03-.03,0-.08.03-.06h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M314.44,297.6c.28-8.29-5.25-12.43-7.69-14.24,2.72.42,9.02,5.06,9.07,13.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M307.99,284.02c.98.66,1.88,1.41,2.7,2.24.82.84,1.54,1.77,2.11,2.79.57,1.02,1.02,2.1,1.36,3.22.34,1.12.57,2.28.69,3.45-.04-1.18-.22-2.35-.54-3.49-.31-1.14-.76-2.25-1.34-3.28-.58-1.04-1.33-1.97-2.18-2.8-.85-.83-1.8-1.54-2.82-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M308.17,298.5s0-.01,0-.01,0,.01,0,.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M306.89,299.6c-.35-4.31-1.77-8.52-4.1-12.16,2.84,3.12,4.82,6.71,5.14,12.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M304.01,289.15c.28.43.52.87.75,1.33.11.23.23.45.33.69l.16.35c.05.12.1.23.15.35.39.94.73,1.9,1,2.88.07.24.13.49.19.74l.09.37c.03.12.05.25.08.37l.15.75.12.75c.09.5.14,1.01.2,1.51l.02.19c0,.06,0,.13.01.19l.03.38.06.76-.03-.76-.02-.38c0-.06,0-.13,0-.19l-.02-.19c-.05-.51-.09-1.02-.17-1.52-.04-.25-.07-.5-.12-.76l-.15-.75c-.03-.12-.05-.25-.08-.37l-.09-.37-.09-.37c-.03-.12-.06-.25-.1-.37l-.22-.73c-.08-.24-.16-.48-.25-.72-.08-.24-.18-.48-.27-.72-.05-.12-.09-.24-.14-.36l-.15-.35c-.41-.93-.88-1.84-1.46-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M308.71,297.94c-2.4-4.45-8.64-6.38-11.03-6.51,1.79-.36,9.91-.25,13.76,7.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M311.4,299.54c-.28-9.12,4.79-12.33,4.79-12.33,0,0-3.21,4.12-3.41,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M307.12,298.94s0-.01,0-.01,0,.01,0,.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M299.08,291.45c1.17.14,2.32.4,3.43.77,1.11.37,2.18.87,3.15,1.52.97.64,1.87,1.41,2.68,2.25.81.84,1.54,1.77,2.19,2.75-.57-1.03-1.27-1.99-2.07-2.86-.8-.87-1.7-1.65-2.69-2.31-.99-.66-2.08-1.15-3.21-1.5-1.13-.35-2.3-.55-3.48-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M298.24,298.1c-2.4-4.45-8.64-6.38-11.03-6.51,1.79-.36,9.91-.25,13.76,7.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M288.62,291.61c1.17.14,2.32.4,3.43.77,1.11.37,2.18.87,3.15,1.52.97.64,1.87,1.41,2.68,2.25.81.84,1.54,1.77,2.19,2.75-.57-1.03-1.27-1.99-2.07-2.86-.8-.87-1.7-1.65-2.69-2.31-.99-.66-2.08-1.15-3.21-1.5-1.13-.35-2.3-.55-3.48-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M304.67,297.42c-.59-3.97-2.16-7.79-4.53-11.03,2.82,2.72,4.87,5.93,5.5,10.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M301.37,287.9c.28.38.53.78.77,1.19.12.21.24.41.35.62l.17.31c.05.1.1.21.16.32.42.85.79,1.71,1.1,2.61.08.22.15.45.22.67l.11.34c.04.11.06.23.1.34l.19.68.16.69c.12.46.19.92.28,1.39l.03.17c0,.06.02.12.03.18l.05.35.1.7-.07-.71-.04-.35c0-.06-.01-.12-.02-.18l-.03-.18c-.08-.47-.14-.94-.25-1.4-.05-.23-.1-.46-.15-.69l-.18-.69c-.03-.11-.06-.23-.09-.34l-.11-.34c-.07-.22-.14-.45-.22-.68l-.25-.67c-.09-.22-.18-.44-.27-.66-.09-.22-.19-.43-.29-.65-.05-.11-.1-.22-.15-.32l-.16-.32c-.44-.84-.92-1.66-1.51-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M315.08,288.42c-.28.32-.52.68-.74,1.04-.11.18-.21.37-.32.56-.1.19-.19.38-.29.57-.37.77-.67,1.57-.94,2.39-.27.81-.47,1.64-.65,2.48-.09.42-.15.84-.23,1.26-.05.42-.11.85-.16,1.27.09-.42.17-.83.26-1.25l.29-1.24.16-.62.08-.31.09-.31.17-.61c.06-.2.13-.4.19-.61.26-.81.55-1.61.89-2.38l.26-.58c.1-.19.18-.38.29-.57.19-.38.41-.74.66-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M309.22,297.05c-1.78-7.69,1.82-11.82,1.82-11.82,0,0-2.19,4.55-.4,11.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M310.29,286.7c-.19.38-.32.79-.44,1.2-.06.2-.1.41-.16.62-.05.21-.09.42-.13.63-.15.84-.23,1.7-.26,2.55-.04.85-.01,1.71.04,2.56.03.43.08.85.12,1.27.06.42.12.85.18,1.27-.02-.43-.06-.85-.08-1.27l-.06-1.27v-.64s-.02-.32-.02-.32v-.32s0-.64,0-.64c0-.21.02-.42.02-.64.03-.85.1-1.69.22-2.53l.1-.63c.04-.21.07-.42.12-.62.09-.42.19-.83.34-1.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M303.38,284c-.25-.15-.77-.06-.77-.03.01.2.36.81,1.08.43.02-.01.03-.03.02-.05-.04-.1-.13-.22-.32-.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M303.51,284.1c0,.08.1.14.08.22-.01.05-.08.07-.13.08-.15.01-.3-.06-.44-.12-.12-.06-.25-.12-.33-.23-.02-.03-.05-.07-.09-.07,0,0,0,0,0,0,.01.2.36.81,1.08.43.02-.01.03-.03.02-.05-.03-.08-.08-.16-.19-.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M303.35,284.06s-.1-.05-.16-.06c-.1-.02-.21-.03-.3,0,.01.02.04.02.06.03.12.03.25.06.37.11.03.01.06.03.09.03,0,0,.02,0,.03,0,0-.01,0-.03,0-.04-.02-.02-.03-.03-.05-.05"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M303.86,284.6c-.36-.02-.87.38-.86.41.13.21.86.68,1.41-.15.01-.02.01-.05,0-.07-.1-.09-.27-.17-.55-.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M304.06,284.63c.05.09.19.1.21.19.01.06-.04.12-.1.16-.16.1-.36.11-.54.11-.17,0-.34,0-.49-.06-.04-.02-.09-.05-.13-.03,0,0,0,0,0,0,.13.21.86.68,1.41-.15.01-.02.01-.05,0-.07-.08-.07-.18-.13-.35-.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M303.86,284.68c-.07-.02-.14,0-.2.02-.12.04-.24.09-.32.18.02,0,.05,0,.08,0,.15-.04.3-.08.46-.09.04,0,.08,0,.12-.02.01,0,.02,0,.03-.02,0-.02-.01-.03-.03-.04-.03-.01-.05-.02-.08-.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M304.68,285.16c-.43-.03-1.04.46-1.03.49.15.25,1.03.81,1.69-.18.02-.03.01-.06-.01-.08-.12-.11-.32-.21-.66-.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M304.92,285.19c.06.1.23.12.26.23.02.08-.05.15-.11.19-.19.12-.43.13-.65.14-.2,0-.41.01-.59-.08-.05-.02-.11-.05-.16-.03,0,0,0,0,0,0,.15.25,1.03.81,1.69-.18.02-.03.01-.06-.01-.08-.09-.08-.22-.15-.42-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M304.68,285.25c-.08-.03-.17,0-.24.03-.14.05-.29.11-.39.22.03.01.06,0,.09,0,.18-.05.36-.1.55-.11.05,0,.1,0,.14-.02.01,0,.03-.01.03-.02,0-.02-.02-.03-.04-.04-.03-.01-.07-.02-.1-.03"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M305.59,285.95c-.49-.03-1.18.52-1.16.56.17.29,1.17.92,1.92-.2.02-.03.01-.07-.01-.1-.14-.12-.36-.23-.74-.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M305.86,285.99c.06.12.26.13.29.26.02.09-.05.17-.13.22-.22.14-.48.15-.74.16-.23,0-.47.01-.67-.09-.06-.03-.12-.06-.18-.03,0,0,0,0,0,0,.17.29,1.17.92,1.92-.2.02-.03.01-.07-.01-.1-.1-.09-.25-.17-.47-.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M305.58,286.06c-.09-.03-.19,0-.28.03-.16.05-.33.12-.44.25.03.01.07,0,.11,0,.2-.06.41-.11.62-.13.05,0,.11,0,.16-.03.01,0,.03-.01.03-.03,0-.02-.02-.04-.04-.05-.04-.02-.07-.03-.11-.03"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M306.79,286.94c-.5-.1-1.29.37-1.28.41.14.32,1.08,1.11,2.01.05.02-.03.02-.07,0-.1-.13-.14-.34-.29-.73-.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M307.06,287.02c.05.13.25.17.26.31,0,.09-.08.17-.16.21-.24.11-.52.09-.78.06-.24-.02-.48-.05-.68-.18-.06-.04-.12-.08-.18-.06,0,0,0,0,0,0,.14.32,1.08,1.11,2.01.05.02-.03.02-.07,0-.1-.09-.11-.24-.21-.46-.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M306.77,287.05c-.09-.04-.19-.03-.29,0-.17.03-.35.08-.49.2.03.02.07.01.11,0,.22-.03.44-.06.66-.05.06,0,.11,0,.17,0,.02,0,.03,0,.04-.02,0-.02-.01-.04-.03-.06-.04-.02-.07-.04-.11-.05"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M307.88,288.18c-.52-.15-1.39.29-1.38.33.12.35,1.05,1.26,2.11.22.03-.03.03-.07,0-.11-.12-.16-.34-.33-.74-.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M308.16,288.28c.04.14.25.2.25.35,0,.1-.1.17-.19.2-.26.1-.56.05-.83,0-.25-.05-.5-.09-.7-.25-.06-.04-.12-.09-.19-.08,0,0,0,0,0,0,.12.35,1.05,1.26,2.11.22.03-.03.03-.07,0-.11-.09-.12-.23-.24-.46-.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M307.85,288.29c-.09-.05-.2-.04-.31-.03-.19.02-.38.06-.53.17.03.02.08.02.12.02.23-.01.47-.02.7,0,.06,0,.12.02.18,0,.02,0,.04,0,.04-.02.01-.02-.01-.05-.03-.06-.04-.02-.07-.05-.11-.06"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M308.79,289.53c-.58-.18-1.59.27-1.58.32.12.4,1.14,1.47,2.39.34.03-.03.04-.08.01-.12-.13-.19-.37-.39-.83-.54Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M309.11,289.65c.04.16.27.24.27.41,0,.11-.12.19-.22.22-.3.1-.63.03-.94-.04-.28-.06-.57-.13-.79-.31-.06-.05-.13-.11-.21-.1,0,0,0,0,0,0,.12.4,1.14,1.47,2.39.34.03-.03.04-.08.01-.12-.1-.14-.25-.29-.51-.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "M308.75,289.66c-.1-.06-.23-.06-.35-.05-.21.02-.43.05-.61.17.04.03.09.03.13.02.27,0,.53,0,.79.03.07.01.13.02.2.02.02,0,.04,0,.05-.02.01-.03-.01-.05-.03-.07-.04-.03-.08-.05-.13-.08"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M309.63,291.04c-.62-.25-1.77.17-1.76.22.1.45,1.13,1.7,2.59.57.04-.03.05-.09.02-.13-.13-.22-.37-.46-.86-.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M309.96,291.2c.03.18.28.29.26.47-.01.12-.14.2-.26.23-.34.08-.7-.02-1.03-.12-.3-.09-.61-.19-.84-.4-.06-.06-.14-.13-.22-.12,0,0,0,0,0,0,.1.45,1.13,1.7,2.59.57.04-.03.05-.09.02-.13-.1-.16-.25-.33-.52-.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M309.57,291.17c-.11-.08-.24-.08-.38-.08-.23,0-.48.02-.68.14.04.03.09.04.14.04.29.01.58.04.87.1.07.02.14.04.22.04.02,0,.05,0,.06-.02.02-.03,0-.06-.03-.08-.04-.04-.09-.07-.13-.09"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M310.15,290.42c-.02-.67.78-1.6.83-1.57.38.25,1.2,1.66-.38,2.63-.04.03-.1.02-.13-.02-.16-.2-.3-.51-.31-1.04Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M310.18,290.79c.16.09.17.36.35.41.12.03.24-.06.31-.17.2-.29.23-.66.25-1.01.02-.31.04-.64-.08-.93-.03-.08-.08-.17-.04-.25,0,0,0,0,0,0,.38.25,1.2,1.66-.38,2.63-.04.03-.1.02-.13-.02-.12-.15-.22-.35-.28-.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M310.29,290.42c-.03-.13,0-.26.06-.38.08-.22.19-.44.37-.59.02.05,0,.1-.01.14-.09.28-.17.56-.21.85,0,.07-.02.15-.04.22,0,.02-.02.04-.04.05-.03,0-.05-.03-.06-.06-.02-.05-.03-.1-.04-.16"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M309.24,288.99c-.01-.62.73-1.49.77-1.46.36.24,1.11,1.54-.36,2.44-.04.02-.09.01-.12-.02-.15-.18-.28-.48-.29-.97Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M309.27,289.34c.15.09.16.34.32.38.11.03.22-.06.28-.15.19-.27.21-.61.24-.94.02-.29.04-.6-.07-.86-.03-.07-.07-.16-.03-.23,0,0,0,0,0,0,.36.24,1.11,1.54-.36,2.44-.04.02-.09.01-.12-.02-.11-.14-.21-.33-.26-.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M309.37,288.99c-.03-.12,0-.24.05-.35.08-.2.17-.41.34-.55.02.04,0,.09-.01.13-.08.26-.16.52-.2.79,0,.07-.02.14-.04.2,0,.02-.02.04-.04.04-.03,0-.05-.03-.06-.05-.02-.05-.03-.1-.04-.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M308.28,287.71c-.05-.53.53-1.32.57-1.3.32.18,1.05,1.25-.15,2.12-.03.02-.08.02-.1-.01-.14-.15-.27-.39-.31-.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M308.33,288.01c.13.07.16.28.3.31.1.02.18-.07.23-.15.14-.24.14-.54.14-.82,0-.25,0-.51-.12-.74-.03-.06-.07-.13-.04-.2,0,0,0,0,0,0,.32.18,1.05,1.25-.15,2.12-.03.02-.08.02-.1-.01-.1-.11-.2-.27-.26-.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M308.4,287.7c-.03-.1,0-.21.02-.31.05-.18.12-.36.26-.49.02.04,0,.08,0,.12-.06.23-.1.46-.12.69,0,.06,0,.12-.02.18,0,.02-.01.03-.03.04-.02,0-.04-.02-.05-.04-.02-.04-.03-.08-.04-.12"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M307.2,286.42c-.05-.53.53-1.32.57-1.3.32.18,1.05,1.25-.15,2.12-.03.02-.08.02-.1-.01-.14-.15-.27-.39-.31-.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M307.25,286.71c.13.07.16.28.3.31.1.02.18-.07.23-.15.14-.24.14-.54.14-.82,0-.25,0-.51-.12-.74-.03-.06-.07-.13-.04-.2,0,0,0,0,0,0,.32.18,1.05,1.25-.15,2.12-.03.02-.08.02-.1-.01-.1-.11-.2-.27-.26-.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M307.31,286.4c-.03-.1,0-.21.02-.31.05-.18.12-.36.26-.49.02.04,0,.08,0,.12-.06.23-.1.46-.12.69,0,.06,0,.12-.02.18,0,.02-.01.03-.03.04-.02,0-.04-.02-.05-.04-.02-.04-.03-.08-.04-.12"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M305.85,285.43c-.15-.49.24-1.34.28-1.33.34.11,1.23.97.27,2.02-.03.03-.07.03-.1.01-.16-.11-.33-.31-.45-.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M305.96,285.69c.14.04.2.23.34.23.1,0,.16-.1.19-.19.09-.25.03-.53-.03-.8-.05-.24-.1-.48-.26-.67-.04-.05-.09-.11-.08-.18,0,0,0,0,0,0,.34.11,1.23.97.27,2.02-.03.03-.07.03-.1.01-.12-.08-.24-.21-.35-.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M305.96,285.39c-.05-.09-.05-.19-.04-.29.02-.18.04-.36.15-.51.02.03.02.07.02.11,0,.22,0,.45.02.67,0,.06.02.11.01.17,0,.02,0,.04-.02.04-.02.01-.05,0-.06-.03-.02-.03-.05-.07-.06-.11"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M304.82,284.71c-.17-.45.13-1.27.17-1.26.32.08,1.21.82.39,1.86-.02.03-.06.03-.09.02-.16-.09-.33-.27-.46-.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M304.94,284.95c.13.03.2.2.33.19.09,0,.14-.1.17-.19.06-.24,0-.5-.08-.74-.06-.22-.13-.44-.28-.6-.04-.05-.09-.1-.09-.16,0,0,0,0,0,0,.32.08,1.21.82.39,1.86-.02.03-.06.03-.09.02-.11-.07-.24-.18-.35-.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M304.92,284.67c-.05-.08-.06-.18-.06-.27,0-.17.02-.34.1-.49.02.03.02.07.03.1,0,.21.02.42.07.62.01.05.02.1.02.16,0,.02,0,.03-.02.04-.02.01-.04,0-.06-.02-.03-.03-.05-.06-.07-.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M303.98,284.31c-.15-.32.05-.94.08-.93.24.04.93.55.36,1.35-.02.02-.04.03-.07.02-.12-.06-.25-.19-.37-.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M304.07,284.48c.1.01.16.14.25.13.06,0,.1-.08.11-.14.04-.18-.03-.37-.09-.54-.05-.16-.11-.32-.23-.43-.03-.03-.07-.07-.07-.11,0,0,0,0,0,0,.24.04.93.55.36,1.35-.02.02-.04.03-.07.02-.09-.05-.18-.13-.27-.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M304.05,284.28c-.04-.05-.05-.13-.05-.2,0-.12,0-.25.06-.36.02.02.02.05.02.07.01.15.03.31.07.46.01.04.02.08.02.11,0,.01,0,.02-.01.03-.01,0-.03,0-.04-.01-.02-.02-.04-.04-.05-.07"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M303.54,284.27c.72.32,1.39.75,2.02,1.21.76.56,1.48,1.2,2.12,1.89.75.8,1.42,1.68,2,2.61.65,1.05,1.18,2.17,1.59,3.33.47,1.33.79,2.71.93,4.11.02.18.03.37.05.55,0,.06-.09.06-.09,0-.17-1.41-.45-2.81-.89-4.16-.38-1.18-.89-2.33-1.51-3.41-.55-.95-1.19-1.85-1.92-2.68-.64-.72-1.33-1.39-2.09-1.98-.63-.49-1.3-.93-2.01-1.3-.08-.04-.15-.08-.23-.12-.04-.02,0-.08.03-.06h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M293.05,288.81c-.21-.15-.67-.09-.67-.07,0,.18.27.73.91.43.02,0,.03-.03.02-.05-.03-.09-.1-.2-.26-.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M293.16,288.9c0,.07.08.13.06.2-.02.04-.07.06-.12.06-.13,0-.26-.07-.37-.13-.1-.06-.21-.12-.28-.22-.02-.03-.04-.06-.07-.06,0,0,0,0,0,0,0,.18.27.73.91.43.02,0,.03-.03.02-.05-.02-.07-.07-.15-.15-.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M293.02,288.86s-.08-.05-.13-.06c-.09-.02-.18-.03-.26,0,.01.02.03.02.05.03.11.03.21.06.31.11.03.01.05.03.08.03,0,0,.02,0,.02,0,0,0,0-.02,0-.03-.01-.02-.03-.03-.04-.05"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M293.44,289.36c-.31-.04-.78.29-.77.31.1.19.71.64,1.24-.05.01-.02.01-.05,0-.06-.08-.08-.22-.16-.47-.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M293.61,289.4c.04.08.16.1.18.18,0,.06-.04.11-.09.13-.14.08-.32.08-.48.07-.15,0-.3-.01-.43-.08-.04-.02-.08-.04-.11-.03,0,0,0,0,0,0,.1.19.71.64,1.24-.05.01-.02.01-.05,0-.06-.06-.06-.15-.12-.3-.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M293.43,289.43c-.06-.02-.12,0-.18,0-.11.03-.21.07-.29.14.02,0,.05,0,.07,0,.13-.03.27-.05.4-.06.03,0,.07,0,.1,0,0,0,.02,0,.02-.02,0-.01-.01-.03-.02-.03-.02-.01-.05-.02-.07-.03"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M294.12,289.89c-.37-.05-.94.34-.92.37.12.23.85.76,1.49-.06.02-.02.01-.05,0-.07-.1-.1-.27-.2-.56-.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M294.32,289.93c.04.09.19.12.21.22.01.07-.05.13-.11.16-.17.09-.38.09-.58.08-.18,0-.36-.01-.51-.1-.04-.02-.09-.05-.14-.03,0,0,0,0,0,0,.12.23.85.76,1.49-.06.02-.02.01-.05,0-.07-.07-.07-.18-.15-.35-.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M294.11,289.97c-.07-.03-.14,0-.21,0-.13.03-.26.08-.35.17.02.01.05,0,.08,0,.16-.03.32-.06.49-.07.04,0,.08,0,.12-.01.01,0,.02,0,.03-.02,0-.02-.01-.03-.03-.04-.03-.01-.06-.02-.09-.03"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M294.87,290.63c-.42-.05-1.06.39-1.04.42.14.26.97.86,1.69-.07.02-.03.02-.06,0-.08-.11-.11-.3-.22-.64-.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M295.1,290.68c.05.11.22.13.24.25.01.08-.06.14-.13.18-.2.11-.43.1-.65.1-.2,0-.41-.02-.58-.11-.05-.03-.11-.06-.16-.04,0,0,0,0,0,0,.14.26.97.86,1.69-.07.02-.03.02-.06,0-.08-.08-.08-.21-.16-.4-.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M294.86,290.73c-.08-.03-.16-.01-.24.01-.14.04-.29.09-.4.19.03.01.06,0,.09,0,.18-.04.36-.07.55-.08.05,0,.09,0,.14-.01.01,0,.03,0,.03-.02,0-.02-.01-.04-.03-.04-.03-.02-.06-.03-.1-.04"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M295.86,291.56c-.43-.11-1.15.26-1.14.29.1.29.88,1.03,1.75.16.02-.02.03-.06,0-.09-.1-.13-.28-.27-.62-.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M296.1,291.64c.04.12.21.16.21.29,0,.08-.08.14-.15.17-.22.08-.46.05-.69,0-.2-.03-.42-.07-.59-.19-.05-.03-.1-.08-.16-.06,0,0,0,0,0,0,.1.29.88,1.03,1.75.16.02-.02.03-.06,0-.09-.08-.1-.19-.2-.39-.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M295.84,291.66c-.08-.04-.17-.03-.25-.02-.15.02-.31.05-.44.15.03.02.06.02.1.01.19-.02.39-.03.58,0,.05,0,.1.01.15,0,.01,0,.03,0,.04-.02,0-.02,0-.04-.03-.05-.03-.02-.06-.04-.1-.05"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M296.74,292.7c-.44-.15-1.23.17-1.22.21.09.31.84,1.15,1.83.31.03-.02.03-.06.01-.09-.1-.15-.27-.31-.62-.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M296.98,292.8c.03.12.21.19.2.32,0,.09-.09.14-.18.17-.23.07-.49.01-.72-.05-.21-.05-.43-.11-.6-.25-.05-.04-.1-.09-.16-.08,0,0,0,0,0,0,.09.31.84,1.15,1.83.31.03-.02.03-.06.01-.09-.07-.11-.19-.23-.38-.33Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M296.71,292.8c-.08-.05-.17-.05-.26-.04-.16,0-.33.03-.47.12.03.02.06.02.1.02.2,0,.41,0,.61.04.05,0,.1.02.15.02.01,0,.03,0,.04-.02.01-.02,0-.04-.02-.06-.03-.02-.06-.04-.1-.06"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M297.47,293.92c-.5-.19-1.4.15-1.39.19.09.35.91,1.34,2.07.42.03-.02.04-.07.02-.1-.1-.17-.3-.36-.69-.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M297.73,294.05c.03.14.23.22.21.37,0,.1-.11.16-.21.18-.27.07-.55,0-.82-.08-.24-.07-.49-.14-.67-.31-.05-.05-.11-.1-.18-.1,0,0,0,0,0,0,.09.35.91,1.34,2.07.42.03-.02.04-.07.02-.1-.08-.13-.2-.26-.42-.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M297.42,294.03c-.08-.06-.2-.06-.3-.06-.19,0-.38.02-.54.11.03.03.07.03.11.03.23,0,.46.02.69.07.06.01.12.03.17.03.02,0,.04,0,.05-.02.01-.02,0-.05-.03-.06-.03-.03-.07-.05-.11-.07"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M298.11,295.28c-.53-.25-1.55.05-1.54.1.07.4.89,1.55,2.23.63.04-.02.05-.07.03-.11-.1-.2-.3-.42-.71-.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M298.39,295.45c.02.16.23.27.2.42-.02.11-.14.16-.24.18-.3.06-.61-.05-.89-.16-.26-.09-.52-.2-.71-.4-.05-.06-.11-.12-.19-.12,0,0,0,0,0,0,.07.4.89,1.55,2.23.63.04-.02.05-.07.03-.11-.07-.15-.2-.31-.43-.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M298.05,295.4c-.09-.07-.21-.09-.32-.09-.2-.01-.42,0-.6.08.03.03.08.04.12.04.25.03.51.06.75.14.06.02.12.04.19.04.02,0,.04,0,.05-.02.02-.02,0-.05-.02-.07-.03-.03-.07-.06-.11-.09"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M298.6,294.77c.02-.58.77-1.35.81-1.32.32.24.95,1.51-.48,2.27-.04.02-.09,0-.11-.03-.13-.18-.23-.46-.22-.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M298.61,295.1c.13.09.13.33.28.38.1.03.21-.04.28-.13.19-.24.24-.56.28-.86.04-.27.07-.56-.02-.81-.03-.07-.06-.16-.02-.22,0,0,0,0,0,0,.32.24.95,1.51-.48,2.27-.04.02-.09,0-.11-.03-.09-.13-.18-.32-.21-.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M298.73,294.78c-.02-.11.02-.22.07-.33.09-.19.19-.37.35-.49.01.04,0,.09-.02.13-.09.24-.18.48-.23.73-.01.06-.02.13-.05.19,0,.02-.02.04-.04.04-.03,0-.05-.03-.05-.05-.01-.05-.02-.09-.03-.14"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M297.88,293.48c.02-.54.71-1.26.75-1.23.3.23.89,1.4-.45,2.11-.04.02-.08,0-.1-.03-.12-.17-.22-.43-.2-.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M297.89,293.78c.12.08.12.3.26.35.1.03.19-.04.26-.12.18-.22.22-.52.26-.8.03-.25.07-.52-.02-.76-.02-.07-.05-.15-.02-.2,0,0,0,0,0,0,.3.23.89,1.4-.45,2.11-.04.02-.08,0-.1-.03-.09-.12-.16-.3-.19-.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M298,293.48c-.02-.1.02-.21.06-.31.08-.17.17-.35.33-.46.01.04,0,.08-.02.12-.09.22-.17.45-.21.68-.01.06-.02.12-.05.17,0,.02-.02.03-.04.04-.03,0-.04-.03-.05-.05-.01-.04-.02-.09-.02-.13"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M297.12,292.31c-.02-.47.53-1.12.56-1.1.27.17.85,1.15-.25,1.84-.03.02-.07.01-.09-.01-.11-.14-.21-.35-.23-.72Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M297.15,292.57c.11.06.12.25.25.29.08.02.16-.05.21-.12.14-.2.16-.46.17-.71.01-.22.02-.45-.06-.65-.02-.06-.06-.12-.03-.17,0,0,0,0,0,0,.27.17.85,1.15-.25,1.84-.03.02-.07.01-.09-.01-.08-.1-.16-.25-.2-.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M297.22,292.31c-.03-.09,0-.18.04-.27.06-.15.13-.31.25-.41.01.03,0,.07,0,.1-.06.19-.12.39-.14.59,0,.05-.01.1-.03.15,0,.01-.01.03-.03.03-.02,0-.04-.02-.05-.04-.01-.04-.02-.07-.03-.11"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M296.24,291.12c-.02-.47.53-1.12.56-1.1.27.17.85,1.15-.25,1.84-.03.02-.07.01-.09-.01-.11-.14-.21-.35-.23-.72Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M296.27,291.38c.11.06.12.25.25.29.08.02.16-.05.21-.12.14-.2.16-.46.17-.71.01-.22.02-.45-.06-.65-.02-.06-.06-.12-.03-.17,0,0,0,0,0,0,.27.17.85,1.15-.25,1.84-.03.02-.07.01-.09-.01-.08-.1-.16-.25-.2-.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M296.35,291.12c-.03-.09,0-.18.04-.27.06-.15.13-.31.25-.41.01.03,0,.07,0,.1-.06.19-.12.39-.14.59,0,.05-.01.1-.03.15,0,.01-.01.03-.03.03-.02,0-.04-.02-.05-.04-.01-.04-.02-.07-.03-.11"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M295.12,290.19c-.11-.44.28-1.16.31-1.14.29.11,1.02.91.13,1.77-.02.02-.06.02-.09,0-.13-.11-.27-.29-.35-.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M295.2,290.43c.12.04.16.21.29.22.08,0,.14-.08.18-.15.09-.22.06-.46.02-.7-.03-.21-.07-.42-.19-.6-.03-.05-.08-.1-.06-.16,0,0,0,0,0,0,.29.11,1.02.91.13,1.77-.02.02-.06.02-.09,0-.1-.08-.2-.2-.28-.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M295.22,290.16c-.04-.08-.03-.17-.02-.26.02-.16.06-.31.15-.44.02.03.01.06.01.1-.02.19-.03.39-.02.59,0,.05.01.1,0,.15,0,.01,0,.03-.02.04-.02,0-.04-.01-.05-.03-.02-.03-.04-.06-.05-.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M294.27,289.51c-.13-.4.18-1.1.22-1.09.27.08,1.01.78.24,1.64-.02.02-.06.03-.08,0-.13-.09-.27-.25-.37-.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M294.35,289.73c.11.03.17.19.28.19.08,0,.13-.08.15-.15.07-.21.02-.43-.03-.65-.04-.19-.09-.39-.21-.54-.03-.04-.08-.09-.07-.14,0,0,0,0,0,0,.27.08,1.01.78.24,1.64-.02.02-.06.03-.08,0-.1-.07-.2-.17-.28-.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M294.35,289.48c-.04-.07-.04-.16-.03-.24.01-.15.03-.3.12-.42.02.02.02.06.02.09,0,.18,0,.37.02.55,0,.05.02.09.01.14,0,.01,0,.03-.02.04-.02,0-.04,0-.05-.02-.02-.03-.04-.06-.05-.09"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M293.55,289.11c-.11-.29.09-.81.12-.81.21.05.78.53.24,1.2-.01.02-.04.02-.06.01-.1-.06-.21-.18-.3-.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M293.63,289.27c.08.02.13.13.21.13.06,0,.09-.06.11-.12.04-.16,0-.32-.05-.48-.04-.14-.08-.28-.18-.39-.03-.03-.06-.06-.05-.1,0,0,0,0,0,0,.21.05.78.53.24,1.2-.01.02-.04.02-.06.01-.07-.05-.15-.12-.22-.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M293.62,289.09s-.04-.11-.03-.17c0-.11.01-.22.07-.31.01.02.02.04.02.07,0,.13.01.27.04.4,0,.03.02.07.01.1,0,0,0,.02-.01.03-.01,0-.03,0-.04-.02-.02-.02-.03-.04-.04-.06"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M293.18,289.05c.61.32,1.17.73,1.7,1.16.64.53,1.22,1.12,1.75,1.76.61.74,1.15,1.54,1.6,2.38.51.95.91,1.96,1.21,2.99.34,1.18.54,2.41.59,3.64,0,.16,0,.33,0,.49,0,.06-.09.06-.09,0-.08-1.24-.24-2.47-.55-3.67-.27-1.05-.65-2.08-1.13-3.05-.43-.86-.94-1.68-1.53-2.44-.51-.66-1.09-1.28-1.71-1.84-.52-.46-1.08-.88-1.68-1.25-.06-.04-.13-.08-.19-.12-.04-.02,0-.08.03-.06h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M371.61,118.25c-5.45,2.11-10.36,6.11-13.01,11.37-7.64-12.03-27-14.19-39.92-12.59,10.74,1.11,23.56,3.11,32.25,9.77,2.8,2.2,4.75,5.15,6.11,8.43q2.15,5.17,3.68-.19c3.94-13.82,19.5-17.46,31.68-20.35-7.06.04-14.15.9-20.79,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M327.14,104.98q2.5,5.02,3.79-.17c.56-2.26,1.19-4.21,2.73-6.24s3.5-3.42,5.6-4.68c4.5-2.68,9.45-4.35,14.53-5.73-4.07-.18-8.15.42-12.05,1.59-5.43,1.63-10.58,4.82-13.12,9.76-2.34-2.9-5.56-4.72-8.95-6.09-5.91-2.26-12.24-3.27-18.54-3.1,5.25,1.46,10.49,3.02,15.42,5.23,2.41,1.1,4.9,2.16,6.67,3.91,2,1.99,2.89,3.48,3.92,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M371.72,79.31c1.57,2.23,1.29,2.5,1.8-.26.24-1.32,1.15-2.76,1.93-3.55,2.06-2.07,4.88-3.39,7.64-4.4,1.44-.52,2.92-.96,4.43-1.35-1.57-.03-3.14.14-4.68.43-4.06.76-8.73,2.72-10.58,6.61-.7-.75-1.51-1.38-2.37-1.94-4.03-2.48-8.66-3.7-13.31-4.19,6.76,2.03,12.84,4.54,15.14,8.64Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M97.66,403.76h-4.13c-.3-2.92-2.08-4.38-5.34-4.38-1.6,0-2.81.35-3.65,1.04-.73.61-1.09,1.42-1.09,2.43s.39,1.75,1.16,2.18c.46.26.99.49,1.58.67.59.18,1.76.48,3.53.88,2.86.67,4.85,1.37,5.95,2.08,1.98,1.28,2.97,3.06,2.97,5.34,0,2.54-1,4.51-2.99,5.9-1.73,1.21-4,1.82-6.82,1.82-3.47,0-6.12-.87-7.95-2.61-1.6-1.52-2.41-3.57-2.44-6.14h4.26c.11,3.56,2.24,5.34,6.38,5.34,1.78,0,3.14-.39,4.08-1.17.83-.68,1.24-1.6,1.24-2.74,0-.64-.15-1.17-.46-1.6-.31-.43-.82-.83-1.52-1.19-.59-.29-1.86-.67-3.78-1.14-3.41-.85-5.67-1.62-6.76-2.31-1.71-1.1-2.56-2.75-2.56-4.96,0-2.35.94-4.18,2.83-5.5,1.63-1.15,3.74-1.72,6.34-1.72,3.69,0,6.33,1.15,7.91,3.45.78,1.15,1.21,2.59,1.27,4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M117.52,415.57c-.48,2.04-1.53,3.6-3.12,4.68-1.38.95-3.03,1.42-4.97,1.42-2.83,0-5.06-.95-6.69-2.86-1.41-1.66-2.11-3.78-2.11-6.36,0-3.02.91-5.44,2.74-7.27,1.6-1.59,3.57-2.38,5.91-2.38,1.83,0,3.43.48,4.81,1.44,1.21.85,2.13,1.98,2.74,3.4.64,1.44.95,3.29.94,5.55h-13.22c.07,1.91.58,3.34,1.55,4.3.84.85,1.97,1.27,3.39,1.27,2.08,0,3.5-1.06,4.26-3.19h3.77ZM113.82,410.55c-.13-1.6-.66-2.83-1.59-3.7-.79-.76-1.79-1.14-2.99-1.14-1.39,0-2.48.47-3.29,1.42-.71.82-1.15,1.96-1.34,3.42h9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M124.9,396.51v24.66h-3.95v-24.66h3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M137.82,396.47v3.04c-.57-.07-1.1-.1-1.57-.1-.85,0-1.42.15-1.71.44s-.44.86-.44,1.69v1.74h3.39v2.89h-3.34v15h-3.95v-15h-2.96v-2.89h2.96v-1.06c0-1.17.07-2.04.21-2.63.14-.58.39-1.1.77-1.55.95-1.12,2.47-1.68,4.56-1.68.59,0,1.29.04,2.08.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M149.99,396.51h9.43c1.85,0,3.41.2,4.67.59,1.26.4,2.39,1.04,3.39,1.93,2.43,2.18,3.65,5.31,3.65,9.38,0,4.36-1.16,7.7-3.49,10.01-1.01,1.01-2.11,1.72-3.3,2.13s-2.75.61-4.69.61h-9.66v-24.66ZM154.34,400.21v17.26h4.72c1.48,0,2.62-.13,3.44-.4.82-.26,1.53-.74,2.14-1.42,1.43-1.58,2.15-3.92,2.15-7.02,0-2.94-.74-5.13-2.21-6.56-1.29-1.25-3.1-1.87-5.44-1.87h-4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M190.48,415.57c-.48,2.04-1.53,3.6-3.12,4.68-1.38.95-3.03,1.42-4.97,1.42-2.83,0-5.06-.95-6.69-2.86-1.41-1.66-2.11-3.78-2.11-6.36,0-3.02.91-5.44,2.74-7.27,1.6-1.59,3.57-2.38,5.91-2.38,1.83,0,3.43.48,4.81,1.44,1.21.85,2.13,1.98,2.74,3.4.64,1.44.95,3.29.94,5.55h-13.22c.07,1.91.58,3.34,1.55,4.3.84.85,1.97,1.27,3.39,1.27,2.08,0,3.5-1.06,4.26-3.19h3.77ZM186.78,410.55c-.13-1.6-.66-2.83-1.59-3.7-.79-.76-1.79-1.14-2.99-1.14-1.39,0-2.48.47-3.29,1.42-.71.82-1.15,1.96-1.34,3.42h9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M197.57,403.28v2.38c1.33-1.92,3.29-2.88,5.87-2.88s4.72.98,6.21,2.94c1.3,1.7,1.95,3.89,1.95,6.59,0,3.03-.82,5.4-2.46,7.12-1.42,1.49-3.25,2.23-5.5,2.23-2.54,0-4.48-.95-5.82-2.84v8.95h-3.95v-24.5h3.7ZM202.63,405.94c-1.65,0-2.92.63-3.8,1.88-.77,1.09-1.16,2.54-1.16,4.34,0,2.14.5,3.76,1.5,4.87.88.98,2.05,1.47,3.52,1.47,1.62,0,2.87-.63,3.75-1.88.77-1.1,1.16-2.54,1.16-4.31,0-2.09-.51-3.72-1.52-4.87-.88-1-2.03-1.5-3.45-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M230.81,415.57c-.48,2.04-1.53,3.6-3.12,4.68-1.38.95-3.03,1.42-4.97,1.42-2.83,0-5.06-.95-6.69-2.86-1.41-1.66-2.11-3.78-2.11-6.36,0-3.02.91-5.44,2.74-7.27,1.6-1.59,3.57-2.38,5.91-2.38,1.83,0,3.43.48,4.81,1.44,1.21.85,2.13,1.98,2.74,3.4.64,1.44.95,3.29.94,5.55h-13.22c.07,1.91.58,3.34,1.55,4.3.84.85,1.97,1.27,3.39,1.27,2.08,0,3.5-1.06,4.26-3.19h3.77ZM227.11,410.55c-.13-1.6-.66-2.83-1.59-3.7-.79-.76-1.79-1.14-2.99-1.14-1.39,0-2.48.47-3.29,1.42-.71.82-1.15,1.96-1.34,3.42h9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M237.85,403.28v2.64c.77-1.1,1.63-1.9,2.58-2.4.95-.5,2.08-.74,3.39-.74,1.12,0,2.15.23,3.07.68.92.45,1.62,1.07,2.1,1.85.33.54.56,1.13.69,1.78.13.64.19,1.54.19,2.68v11.4h-3.95v-10.41c0-1.35-.11-2.33-.33-2.92-.2-.54-.57-.97-1.12-1.28-.55-.31-1.2-.47-1.95-.47-.87,0-1.65.21-2.34.62s-1.2.98-1.53,1.69c-.36.8-.55,2.08-.55,3.82v8.95h-3.95v-17.89h3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M270.77,396.51v24.66h-3.68v-2.46c-1.15,1.97-3.06,2.96-5.75,2.96s-4.81-.96-6.31-2.89c-1.3-1.68-1.95-3.88-1.95-6.59,0-3.08.83-5.47,2.48-7.17,1.44-1.49,3.32-2.23,5.62-2.23,2.64,0,4.53.95,5.65,2.84v-9.12h3.95ZM261.98,405.94c-1.63,0-2.88.63-3.75,1.88-.77,1.09-1.16,2.53-1.16,4.33,0,2.09.5,3.71,1.5,4.86.88,1,2.03,1.5,3.45,1.5,1.66,0,2.93-.63,3.82-1.88.76-1.1,1.14-2.57,1.14-4.39,0-2.1-.5-3.72-1.5-4.84-.87-.97-2.04-1.45-3.5-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M290.96,415.57c-.48,2.04-1.53,3.6-3.12,4.68-1.38.95-3.03,1.42-4.97,1.42-2.83,0-5.06-.95-6.69-2.86-1.41-1.66-2.11-3.78-2.11-6.36,0-3.02.91-5.44,2.74-7.27,1.6-1.59,3.57-2.38,5.91-2.38,1.83,0,3.43.48,4.81,1.44,1.21.85,2.13,1.98,2.74,3.4.64,1.44.95,3.29.94,5.55h-13.22c.07,1.91.58,3.34,1.55,4.3.84.85,1.97,1.27,3.39,1.27,2.08,0,3.5-1.06,4.26-3.19h3.77ZM287.26,410.55c-.13-1.6-.66-2.83-1.59-3.7-.79-.76-1.79-1.14-2.99-1.14-1.39,0-2.48.47-3.29,1.42-.71.82-1.15,1.96-1.34,3.42h9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M298,403.28v2.64c.77-1.1,1.63-1.9,2.58-2.4.95-.5,2.08-.74,3.39-.74,1.12,0,2.15.23,3.07.68.92.45,1.62,1.07,2.1,1.85.33.54.56,1.13.69,1.78.13.64.19,1.54.19,2.68v11.4h-3.95v-10.41c0-1.35-.11-2.33-.33-2.92-.2-.54-.57-.97-1.12-1.28-.55-.31-1.2-.47-1.95-.47-.87,0-1.65.21-2.34.62s-1.2.98-1.53,1.69c-.36.8-.55,2.08-.55,3.82v8.95h-3.95v-17.89h3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M322.69,403.28v2.89h-3.6v9.42c0,1.15.12,1.87.36,2.17s.82.45,1.74.45c.47,0,.97-.04,1.5-.12v3.12c-1.02.1-1.92.15-2.69.15-2.17,0-3.59-.53-4.26-1.6-.25-.43-.42-.94-.49-1.54s-.11-1.78-.11-3.55v-8.51h-2.99v-2.89h2.99v-5.34h3.95v5.34h3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M354.44,396.51l-8.39,24.66h-4.84l-8.33-24.66h4.56l4.13,12.75c.93,2.83,1.62,5.49,2.1,7.96.53-2.49,1.25-5.14,2.16-7.95l4.15-12.77h4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M360.38,396.51v3.75h-3.95v-3.75h3.95ZM360.38,403.28v17.89h-3.95v-17.89h3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M368.7,396.51v24.66h-3.95v-24.66h3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M377.03,396.51v24.66h-3.95v-24.66h3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M380.78,408.84c.36-4.03,2.97-6.05,7.83-6.05,1.65,0,3.07.23,4.26.69,1.05.4,1.83.94,2.35,1.62.55.74.83,1.86.83,3.37l-.12,5.45-.03,2.1c0,1.18.05,1.9.15,2.16.1.26.38.39.86.39.2,0,.49-.02.86-.05v2.76c-1.04.26-1.88.4-2.54.4-1.7,0-2.67-.72-2.91-2.15-1.64,1.43-3.75,2.15-6.31,2.15-1.95,0-3.47-.54-4.56-1.63-.95-.95-1.42-2.17-1.42-3.68,0-1.71.6-3.02,1.8-3.93.65-.5,1.31-.84,1.98-1.02.67-.19,2.07-.41,4.2-.66,1.93-.24,3.1-.48,3.53-.72.42-.24.64-.77.64-1.59,0-1.82-1.23-2.73-3.7-2.73-1.27,0-2.2.24-2.81.72-.61.48-.99,1.29-1.14,2.42h-3.73ZM392.11,412.25c-.51.28-.96.46-1.35.54-.4.09-1.33.23-2.81.43-1.62.22-2.68.58-3.19,1.07-.48.48-.73,1.12-.73,1.9,0,.84.28,1.49.85,1.96.57.47,1.37.7,2.4.7.95,0,1.83-.17,2.65-.52s1.41-.8,1.76-1.36c.17-.28.28-.58.33-.91s.08-.9.08-1.72v-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M416.79,403.26v15.83c0,1.46-.08,2.62-.26,3.47-.17.85-.48,1.62-.92,2.31-1.37,2.19-3.84,3.29-7.43,3.29-4.88,0-7.55-1.82-8.01-5.45h3.96c.36,1.77,1.75,2.66,4.16,2.66,1.75,0,2.98-.47,3.7-1.4.64-.82.96-2.1.97-3.87l.03-2.1c-1.28,2-3.18,3.01-5.7,3.01s-4.5-.91-5.91-2.74c-1.23-1.6-1.85-3.66-1.85-6.2,0-2.98.83-5.33,2.48-7.04,1.44-1.49,3.28-2.23,5.52-2.23,1.25,0,2.33.24,3.21.71.89.47,1.67,1.23,2.34,2.26v-2.51h3.7ZM408.25,405.95c-1.56,0-2.77.6-3.62,1.8-.73,1.05-1.09,2.43-1.09,4.15,0,1.97.47,3.49,1.42,4.56.83.92,1.92,1.39,3.27,1.39,1.55,0,2.76-.62,3.63-1.85.75-1.07,1.12-2.46,1.12-4.16,0-1.96-.48-3.46-1.44-4.51-.83-.91-1.93-1.37-3.3-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M436.88,415.57c-.48,2.04-1.53,3.6-3.12,4.68-1.38.95-3.03,1.42-4.97,1.42-2.83,0-5.06-.95-6.69-2.86-1.41-1.66-2.11-3.78-2.11-6.36,0-3.02.91-5.44,2.74-7.27,1.6-1.59,3.57-2.38,5.91-2.38,1.83,0,3.43.48,4.81,1.44,1.21.85,2.13,1.98,2.74,3.4.64,1.44.95,3.29.94,5.55h-13.22c.07,1.91.58,3.34,1.55,4.3.84.85,1.97,1.27,3.39,1.27,2.08,0,3.5-1.06,4.26-3.19h3.77ZM433.18,410.55c-.13-1.6-.66-2.83-1.59-3.7-.79-.76-1.79-1.14-2.99-1.14-1.39,0-2.48.47-3.29,1.42-.71.82-1.15,1.96-1.34,3.42h9.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M50.02,454.21h-2.11c-.15-1.49-1.06-2.24-2.73-2.24-.82,0-1.44.18-1.87.53-.37.31-.56.72-.56,1.24s.2.9.59,1.12c.24.13.51.25.81.34.3.09.9.24,1.8.45,1.46.34,2.48.7,3.04,1.06,1.01.65,1.52,1.56,1.52,2.73,0,1.3-.51,2.31-1.53,3.02-.88.62-2.05.93-3.49.93-1.77,0-3.13-.44-4.06-1.33-.82-.78-1.23-1.83-1.25-3.14h2.18c.05,1.82,1.14,2.73,3.26,2.73.91,0,1.61-.2,2.09-.6.42-.35.63-.82.63-1.4,0-.33-.08-.6-.24-.82-.16-.22-.42-.42-.78-.61-.3-.15-.95-.34-1.94-.58-1.75-.43-2.9-.83-3.46-1.18-.87-.56-1.31-1.41-1.31-2.53,0-1.2.48-2.14,1.45-2.81.83-.59,1.91-.88,3.24-.88,1.89,0,3.24.59,4.05,1.77.4.59.62,1.33.65,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M64.54,453.96l-2.87,9.15h-2.07l-1.2-4.49c-.17-.65-.35-1.48-.54-2.48-.22,1.09-.41,1.92-.55,2.47l-1.15,4.51h-2.09l-2.89-9.15h2.15l1.06,3.86c.23.84.49,1.92.79,3.22.28-1.4.52-2.5.72-3.3l.95-3.78h2.03l1.14,4.32c.15.59.35,1.49.59,2.7.26-1.23.47-2.12.63-2.68l1.24-4.34h2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M65.53,456.81c.19-2.06,1.52-3.09,4-3.09.84,0,1.57.12,2.18.35.53.2.93.48,1.2.83.28.38.42.95.42,1.72l-.06,2.79-.02,1.07c0,.6.03.97.08,1.1.05.13.2.2.44.2.1,0,.25,0,.44-.03v1.41c-.53.13-.96.2-1.3.2-.87,0-1.36-.37-1.49-1.1-.84.73-1.91,1.1-3.23,1.1-1,0-1.77-.28-2.33-.84-.48-.48-.73-1.11-.73-1.88,0-.87.31-1.54.92-2.01.33-.25.67-.43,1.01-.52s1.06-.21,2.15-.34c.98-.12,1.59-.25,1.8-.37s.33-.39.33-.82c0-.93-.63-1.39-1.89-1.39-.65,0-1.13.12-1.44.37-.31.25-.51.66-.58,1.24h-1.91ZM71.33,458.55c-.26.14-.49.23-.69.28-.2.05-.68.12-1.44.22-.83.11-1.37.3-1.63.55-.25.25-.37.57-.37.97,0,.43.14.76.43,1,.29.24.7.36,1.23.36.48,0,.94-.09,1.36-.27.42-.18.72-.41.9-.7.09-.14.14-.3.17-.46s.04-.46.04-.88v-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M86.91,456.39v6.72h-1.41l-.35-1.5c-.97,1.21-2.28,1.81-3.92,1.81-1.9,0-3.42-.68-4.54-2.04-.97-1.18-1.45-2.67-1.45-4.48,0-2.13.64-3.82,1.94-5.07,1.12-1.09,2.53-1.63,4.24-1.63s3.03.52,4.04,1.56c.77.79,1.2,1.71,1.3,2.75h-2.15c-.13-.8-.52-1.43-1.17-1.87-.56-.39-1.24-.58-2.04-.58-1.3,0-2.31.48-3.02,1.45-.61.84-.92,1.96-.92,3.34,0,1.57.4,2.77,1.21,3.6.7.73,1.63,1.09,2.8,1.09,1.41,0,2.42-.55,3.01-1.66.25-.46.39-1.06.44-1.82h-3.41v-1.68h5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M94.35,453.77v1.95c-.3-.03-.54-.05-.72-.05-.72,0-1.31.23-1.78.68-.32.32-.54.7-.66,1.13-.12.43-.18,1.09-.18,1.97v3.67h-2.02v-9.15h1.89v1.82c.37-.74.83-1.28,1.38-1.6.48-.29,1.05-.43,1.72-.43.09,0,.21,0,.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M94.98,456.81c.19-2.06,1.52-3.09,4-3.09.84,0,1.57.12,2.18.35.53.2.93.48,1.2.83.28.38.42.95.42,1.72l-.06,2.79-.02,1.07c0,.6.03.97.08,1.1.05.13.2.2.44.2.1,0,.25,0,.44-.03v1.41c-.53.13-.96.2-1.3.2-.87,0-1.36-.37-1.49-1.1-.84.73-1.91,1.1-3.23,1.1-1,0-1.77-.28-2.33-.84-.48-.48-.73-1.11-.73-1.88,0-.87.31-1.54.92-2.01.33-.25.67-.43,1.01-.52s1.06-.21,2.15-.34c.98-.12,1.59-.25,1.8-.37s.33-.39.33-.82c0-.93-.63-1.39-1.89-1.39-.65,0-1.13.12-1.44.37-.31.25-.51.66-.58,1.24h-1.91ZM100.78,458.55c-.26.14-.49.23-.69.28-.2.05-.68.12-1.44.22-.83.11-1.37.3-1.63.55-.25.25-.37.57-.37.97,0,.43.14.76.43,1,.29.24.7.36,1.23.36.48,0,.94-.09,1.36-.27.42-.18.72-.41.9-.7.09-.14.14-.3.17-.46s.04-.46.04-.88v-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M106.96,453.96v1.28c.41-.55.84-.94,1.29-1.18.45-.24.98-.36,1.6-.36,1.21,0,2.05.52,2.54,1.55.76-1.04,1.74-1.55,2.96-1.55.54,0,1.02.1,1.46.31.44.21.79.49,1.04.86.33.47.5,1.14.5,2v6.23h-2.02v-5.62c0-.65-.06-1.1-.19-1.34-.24-.5-.72-.75-1.44-.75-.41,0-.78.1-1.1.29-.32.19-.55.47-.71.82-.13.3-.2.87-.2,1.69v4.91h-2.02v-5.73c0-.75-.11-1.26-.34-1.52-.28-.31-.67-.46-1.18-.46-.4,0-.77.1-1.1.31-.33.21-.58.49-.74.84-.16.34-.24.9-.24,1.66v4.9h-2.02v-9.15h1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M120.17,456.81c.19-2.06,1.52-3.09,4-3.09.85,0,1.57.12,2.18.35.54.2.94.48,1.2.83.28.38.42.95.42,1.72l-.06,2.79-.02,1.07c0,.6.02.97.07,1.1.05.13.2.2.44.2.1,0,.25,0,.44-.03v1.41c-.53.13-.96.2-1.3.2-.87,0-1.36-.37-1.49-1.1-.84.73-1.91,1.1-3.23,1.1-1,0-1.77-.28-2.33-.84-.48-.48-.73-1.11-.73-1.88,0-.87.31-1.54.92-2.01.33-.25.67-.43,1.01-.52.34-.1,1.06-.21,2.14-.34.99-.12,1.59-.25,1.8-.37s.32-.39.32-.82c0-.93-.63-1.39-1.89-1.39-.65,0-1.12.12-1.44.37s-.5.66-.58,1.24h-1.91ZM125.97,458.55c-.26.14-.49.23-.69.28-.2.05-.68.12-1.44.22-.83.11-1.37.3-1.63.55-.25.25-.37.57-.37.97,0,.43.14.76.44,1,.29.24.7.36,1.23.36.48,0,.94-.09,1.36-.27.42-.18.72-.41.9-.7.08-.14.14-.3.17-.46.03-.17.04-.46.04-.88v-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M141.18,450.5l4.86,12.61h-2.37l-1.22-3.35h-4.98l-1.23,3.35h-2.3l4.88-12.61h2.37ZM141.88,458.08l-1.03-2.81c-.36-.97-.64-1.86-.87-2.64-.2.66-.5,1.53-.89,2.61l-1.04,2.85h3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M155.01,453.96l-3.39,8.98c-.34.9-.6,1.52-.76,1.86s-.34.63-.53.88c-.5.62-1.21.93-2.12.93-.34,0-.8-.04-1.38-.11v-1.7c.49.08.83.12,1.03.12.48,0,.83-.23,1.05-.68.29-.59.46-1.06.51-1.44l-3.49-8.84h2.22l1.77,4.92c.16.46.38,1.17.64,2.13.28-.99.51-1.74.68-2.25l1.64-4.79h2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M164.09,453.96v9.15h-1.89v-1.36c-.75,1.08-1.76,1.61-3.02,1.61-1.09,0-1.92-.35-2.49-1.05-.42-.51-.62-1.34-.62-2.49v-5.86h2.02v5.22c0,.54.02.94.05,1.19.04.25.11.46.21.63.29.45.78.68,1.48.68.89,0,1.54-.39,1.95-1.17.2-.39.3-1.07.3-2.05v-4.49h2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M171.57,453.77v1.95c-.3-.03-.54-.05-.72-.05-.72,0-1.31.23-1.78.68-.32.32-.54.7-.66,1.13-.12.43-.18,1.09-.18,1.97v3.67h-2.02v-9.15h1.89v1.82c.37-.74.83-1.28,1.38-1.6.48-.29,1.05-.43,1.72-.43.09,0,.21,0,.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M180.42,453.96l-3.28,9.15h-2.26l-3.34-9.15h2.2l1.43,4.14c.37,1.08.67,2.12.9,3.11.19-.82.49-1.87.91-3.13l1.37-4.11h2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M189.76,460.25c-.25,1.04-.78,1.84-1.6,2.39-.7.48-1.55.73-2.54.73-1.45,0-2.59-.49-3.42-1.46-.72-.85-1.08-1.93-1.08-3.25,0-1.54.47-2.78,1.4-3.72.82-.81,1.83-1.22,3.03-1.22.93,0,1.75.25,2.46.74.62.43,1.09,1.01,1.4,1.74.33.74.49,1.68.48,2.84h-6.76c.03.97.3,1.71.79,2.2.43.43,1.01.65,1.73.65,1.06,0,1.79-.54,2.18-1.63h1.93ZM187.87,457.68c-.07-.82-.34-1.45-.81-1.89-.41-.39-.92-.58-1.53-.58-.71,0-1.27.24-1.68.73-.36.42-.59,1-.68,1.75h4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M200.06,450.5v12.61h-1.88v-1.26c-.59,1.01-1.57,1.51-2.94,1.51s-2.46-.49-3.23-1.48c-.66-.86-1-1.99-1-3.37,0-1.58.42-2.8,1.27-3.67.74-.76,1.7-1.14,2.87-1.14,1.35,0,2.31.49,2.89,1.45v-4.66h2.02ZM195.56,455.32c-.83,0-1.47.32-1.92.96-.39.56-.59,1.29-.59,2.21,0,1.07.26,1.9.77,2.48.45.51,1.04.77,1.77.77.85,0,1.5-.32,1.95-.96.39-.56.58-1.31.58-2.25,0-1.08-.26-1.9-.77-2.47-.45-.5-1.04-.74-1.79-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M201.99,456.81c.19-2.06,1.52-3.09,4-3.09.85,0,1.57.12,2.18.35.54.2.94.48,1.2.83.28.38.42.95.42,1.72l-.06,2.79-.02,1.07c0,.6.02.97.07,1.1.05.13.2.2.44.2.1,0,.25,0,.44-.03v1.41c-.53.13-.96.2-1.3.2-.87,0-1.36-.37-1.49-1.1-.84.73-1.91,1.1-3.23,1.1-1,0-1.77-.28-2.33-.84-.48-.48-.73-1.11-.73-1.88,0-.87.31-1.54.92-2.01.33-.25.67-.43,1.01-.52.34-.1,1.06-.21,2.14-.34.99-.12,1.59-.25,1.8-.37s.32-.39.32-.82c0-.93-.63-1.39-1.89-1.39-.65,0-1.12.12-1.44.37s-.5.66-.58,1.24h-1.91ZM207.79,458.55c-.26.14-.49.23-.69.28-.2.05-.68.12-1.44.22-.83.11-1.37.3-1.63.55-.25.25-.37.57-.37.97,0,.43.14.76.44,1,.29.24.7.36,1.23.36.48,0,.94-.09,1.36-.27.42-.18.72-.41.9-.7.08-.14.14-.3.17-.46.03-.17.04-.46.04-.88v-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M216.78,450.5h2.21v15.76h-2.21v-15.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M236.31,450.5l-4.72,7.6v5.01h-2.22v-5.03l-4.75-7.58h2.55l2.44,4.04c.31.51.61,1.08.91,1.71.36-.76.66-1.35.9-1.76l2.42-4h2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M241.46,453.72c1.51,0,2.68.49,3.51,1.48.73.86,1.09,1.97,1.09,3.34,0,1.59-.47,2.82-1.4,3.68-.82.76-1.88,1.14-3.2,1.14-1.51,0-2.69-.5-3.53-1.49-.73-.86-1.1-1.97-1.1-3.34,0-1.56.48-2.78,1.44-3.67.83-.77,1.89-1.16,3.2-1.16ZM241.44,455.33c-.85,0-1.51.32-1.97.97-.4.57-.61,1.31-.61,2.23,0,1.08.26,1.91.78,2.47.46.5,1.06.74,1.82.74.85,0,1.5-.32,1.95-.97.39-.56.59-1.32.59-2.26,0-1.05-.26-1.87-.78-2.44-.45-.5-1.05-.74-1.79-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M256.06,453.95v8.09c0,.75-.04,1.34-.13,1.77-.09.43-.24.83-.47,1.18-.7,1.12-1.97,1.68-3.8,1.68-2.49,0-3.86-.93-4.1-2.79h2.03c.19.91.89,1.36,2.13,1.36.89,0,1.53-.24,1.89-.72.33-.42.49-1.08.5-1.98l.02-1.07c-.65,1.03-1.62,1.54-2.91,1.54s-2.3-.47-3.02-1.4c-.63-.82-.95-1.87-.95-3.17,0-1.53.42-2.73,1.27-3.6.74-.76,1.68-1.14,2.82-1.14.64,0,1.19.12,1.64.36s.85.63,1.2,1.16v-1.28h1.89ZM251.7,455.33c-.8,0-1.42.31-1.85.92-.37.54-.56,1.24-.56,2.12,0,1.01.24,1.79.73,2.33.42.47.98.71,1.67.71.79,0,1.41-.32,1.86-.95.38-.55.57-1.26.57-2.13,0-1-.25-1.77-.73-2.31-.42-.47-.99-.7-1.69-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M257.95,456.81c.19-2.06,1.52-3.09,4-3.09.85,0,1.57.12,2.18.35.54.2.94.48,1.2.83.28.38.42.95.42,1.72l-.06,2.79-.02,1.07c0,.6.02.97.07,1.1.05.13.2.2.44.2.1,0,.25,0,.44-.03v1.41c-.53.13-.96.2-1.3.2-.87,0-1.36-.37-1.49-1.1-.84.73-1.91,1.1-3.23,1.1-1,0-1.77-.28-2.33-.84-.48-.48-.73-1.11-.73-1.88,0-.87.31-1.54.92-2.01.33-.25.67-.43,1.01-.52.34-.1,1.06-.21,2.14-.34.99-.12,1.59-.25,1.8-.37s.32-.39.32-.82c0-.93-.63-1.39-1.89-1.39-.65,0-1.12.12-1.44.37s-.5.66-.58,1.24h-1.91ZM263.74,458.55c-.26.14-.49.23-.69.28-.2.05-.68.12-1.44.22-.83.11-1.37.3-1.63.55-.25.25-.37.57-.37.97,0,.43.14.76.44,1,.29.24.7.36,1.23.36.48,0,.94-.09,1.36-.27.42-.18.72-.41.9-.7.08-.14.14-.3.17-.46.03-.17.04-.46.04-.88v-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M272.74,450.5h2.21v15.76h-2.21v-15.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M292.21,450.5v12.61h-2.28l-4.08-6.44c-.95-1.49-1.58-2.59-1.91-3.3.07.94.11,2.23.11,3.87v5.87h-2.1v-12.61h2.29l4.14,6.56c.84,1.33,1.45,2.39,1.84,3.18-.02-.44-.04-.96-.05-1.54v-.3c-.02-.45-.03-.74-.04-.88-.02-.6-.02-1.02-.02-1.25v-5.78h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M296.6,450.5v1.92h-2.02v-1.92h2.02ZM296.6,453.96v9.15h-2.02v-9.15h2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M306.02,456.63h-1.94c-.07-.5-.26-.87-.57-1.09-.31-.23-.78-.34-1.39-.34-.55,0-.97.11-1.27.32-.25.19-.38.44-.38.75,0,.36.16.62.49.79.29.15.91.32,1.84.52,1.23.26,2.11.57,2.64.95.6.42.9,1.04.9,1.85,0,.98-.4,1.74-1.21,2.28-.71.47-1.63.71-2.77.71-2.62,0-3.99-1.06-4.11-3.18h1.93c.13,1.13.86,1.69,2.2,1.69.64,0,1.13-.13,1.5-.41.31-.24.47-.54.47-.91s-.17-.64-.5-.83c-.29-.16-.85-.34-1.67-.53-.89-.21-1.49-.36-1.78-.45-.29-.09-.57-.21-.85-.36-.34-.19-.61-.46-.8-.8s-.29-.72-.29-1.14c0-.91.38-1.61,1.12-2.1.65-.42,1.52-.63,2.61-.63,1.46,0,2.52.38,3.18,1.13.36.42.57,1.02.64,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M307.68,456.81c.19-2.06,1.52-3.09,4-3.09.85,0,1.57.12,2.18.35.54.2.94.48,1.2.83.28.38.42.95.42,1.72l-.06,2.79-.02,1.07c0,.6.02.97.07,1.1.05.13.2.2.44.2.1,0,.25,0,.44-.03v1.41c-.53.13-.96.2-1.3.2-.87,0-1.36-.37-1.49-1.1-.84.73-1.91,1.1-3.23,1.1-1,0-1.77-.28-2.33-.84-.48-.48-.73-1.11-.73-1.88,0-.87.31-1.54.92-2.01.33-.25.67-.43,1.01-.52.34-.1,1.06-.21,2.14-.34.99-.12,1.59-.25,1.8-.37s.32-.39.32-.82c0-.93-.63-1.39-1.89-1.39-.65,0-1.12.12-1.44.37s-.5.66-.58,1.24h-1.91ZM313.48,458.55c-.26.14-.49.23-.69.28-.2.05-.68.12-1.44.22-.83.11-1.37.3-1.63.55-.25.25-.37.57-.37.97,0,.43.14.76.44,1,.29.24.7.36,1.23.36.48,0,.94-.09,1.36-.27.42-.18.72-.41.9-.7.08-.14.14-.3.17-.46.03-.17.04-.46.04-.88v-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M323.09,453.77v1.95c-.3-.03-.54-.05-.72-.05-.72,0-1.31.23-1.78.68-.32.32-.54.7-.66,1.13-.12.43-.18,1.09-.18,1.97v3.67h-2.02v-9.15h1.89v1.82c.37-.74.83-1.28,1.38-1.6.48-.29,1.05-.43,1.72-.43.09,0,.21,0,.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M332.32,453.95v8.09c0,.75-.04,1.34-.13,1.77-.09.43-.24.83-.47,1.18-.7,1.12-1.97,1.68-3.8,1.68-2.49,0-3.86-.93-4.1-2.79h2.03c.19.91.89,1.36,2.13,1.36.89,0,1.53-.24,1.89-.72.33-.42.49-1.08.5-1.98l.02-1.07c-.65,1.03-1.62,1.54-2.91,1.54s-2.3-.47-3.02-1.4c-.63-.82-.95-1.87-.95-3.17,0-1.53.42-2.73,1.27-3.6.74-.76,1.68-1.14,2.82-1.14.64,0,1.19.12,1.64.36s.85.63,1.2,1.16v-1.28h1.89ZM327.95,455.33c-.8,0-1.42.31-1.85.92-.37.54-.56,1.24-.56,2.12,0,1.01.24,1.79.73,2.33.42.47.98.71,1.67.71.79,0,1.41-.32,1.86-.95.38-.55.57-1.26.57-2.13,0-1-.25-1.77-.73-2.31-.42-.47-.99-.7-1.69-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M334.2,456.81c.19-2.06,1.52-3.09,4-3.09.85,0,1.57.12,2.18.35.54.2.94.48,1.2.83.28.38.42.95.42,1.72l-.06,2.79-.02,1.07c0,.6.02.97.07,1.1.05.13.2.2.44.2.1,0,.25,0,.44-.03v1.41c-.53.13-.96.2-1.3.2-.87,0-1.36-.37-1.49-1.1-.84.73-1.91,1.1-3.23,1.1-1,0-1.77-.28-2.33-.84-.48-.48-.73-1.11-.73-1.88,0-.87.31-1.54.92-2.01.33-.25.67-.43,1.01-.52.34-.1,1.06-.21,2.14-.34.99-.12,1.59-.25,1.8-.37s.32-.39.32-.82c0-.93-.63-1.39-1.89-1.39-.65,0-1.12.12-1.44.37s-.5.66-.58,1.24h-1.91ZM339.99,458.55c-.26.14-.49.23-.69.28-.2.05-.68.12-1.44.22-.83.11-1.37.3-1.63.55-.25.25-.37.57-.37.97,0,.43.14.76.44,1,.29.24.7.36,1.23.36.48,0,.94-.09,1.36-.27.42-.18.72-.41.9-.7.08-.14.14-.3.17-.46.03-.17.04-.46.04-.88v-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M348.99,450.5h2.21v15.76h-2.21v-15.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M364.04,450.5l4.86,12.61h-2.37l-1.22-3.35h-4.98l-1.23,3.35h-2.3l4.87-12.61h2.37ZM364.74,458.08l-1.03-2.81c-.35-.97-.64-1.86-.87-2.64-.2.66-.5,1.53-.89,2.61l-1.04,2.85h3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M378.14,453.95v8.09c0,.75-.04,1.34-.13,1.77-.09.43-.24.83-.47,1.18-.7,1.12-1.97,1.68-3.8,1.68-2.49,0-3.86-.93-4.1-2.79h2.03c.19.91.89,1.36,2.13,1.36.89,0,1.53-.24,1.89-.72.33-.42.49-1.08.5-1.98l.02-1.07c-.65,1.03-1.62,1.54-2.91,1.54s-2.3-.47-3.02-1.4c-.63-.82-.95-1.87-.95-3.17,0-1.53.42-2.73,1.27-3.6.74-.76,1.68-1.14,2.82-1.14.64,0,1.19.12,1.64.36s.85.63,1.2,1.16v-1.28h1.89ZM373.77,455.33c-.8,0-1.42.31-1.85.92-.37.54-.56,1.24-.56,2.12,0,1.01.24,1.79.73,2.33.42.47.98.71,1.67.71.79,0,1.41-.32,1.86-.95.38-.55.57-1.26.57-2.13,0-1-.25-1.77-.73-2.31-.42-.47-.99-.7-1.69-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M385.6,453.77v1.95c-.3-.03-.54-.05-.72-.05-.72,0-1.31.23-1.78.68-.32.32-.54.7-.66,1.13-.12.43-.18,1.09-.18,1.97v3.67h-2.02v-9.15h1.89v1.82c.37-.74.83-1.28,1.38-1.6.48-.29,1.05-.43,1.72-.43.09,0,.21,0,.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M390.7,453.72c1.51,0,2.68.49,3.51,1.48.73.86,1.09,1.97,1.09,3.34,0,1.59-.47,2.82-1.4,3.68-.82.76-1.88,1.14-3.2,1.14-1.51,0-2.69-.5-3.53-1.49-.73-.86-1.1-1.97-1.1-3.34,0-1.56.48-2.78,1.44-3.67.83-.77,1.89-1.16,3.2-1.16ZM390.68,455.33c-.85,0-1.51.32-1.97.97-.4.57-.61,1.31-.61,2.23,0,1.08.26,1.91.78,2.47.46.5,1.06.74,1.82.74.85,0,1.5-.32,1.95-.97.39-.56.59-1.32.59-2.26,0-1.05-.26-1.87-.78-2.44-.45-.5-1.05-.74-1.79-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M401.68,450.5h2.21v15.76h-2.21v-15.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M420,450.5v1.89h-4.02v10.72h-2.22v-10.72h-4.02v-1.89h10.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M425.38,453.72c1.51,0,2.68.49,3.51,1.48.73.86,1.09,1.97,1.09,3.34,0,1.59-.47,2.82-1.4,3.68-.82.76-1.88,1.14-3.2,1.14-1.51,0-2.69-.5-3.53-1.49-.73-.86-1.1-1.97-1.1-3.34,0-1.56.48-2.78,1.44-3.67.83-.77,1.89-1.16,3.2-1.16ZM425.36,455.33c-.85,0-1.51.32-1.97.97-.41.57-.61,1.31-.61,2.23,0,1.08.26,1.91.78,2.47.46.5,1.06.74,1.83.74.85,0,1.5-.32,1.95-.97.39-.56.59-1.32.59-2.26,0-1.05-.26-1.87-.78-2.44-.45-.5-1.05-.74-1.79-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M439.63,453.96v9.15h-1.89v-1.36c-.75,1.08-1.76,1.61-3.02,1.61-1.09,0-1.92-.35-2.49-1.05-.42-.51-.62-1.34-.62-2.49v-5.86h2.02v5.22c0,.54.02.94.05,1.19.04.25.11.46.21.63.29.45.78.68,1.48.68.89,0,1.54-.39,1.95-1.17.2-.39.3-1.07.3-2.05v-4.49h2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M447.12,453.77v1.95c-.3-.03-.54-.05-.72-.05-.72,0-1.31.23-1.78.68-.32.32-.54.7-.66,1.13-.12.43-.18,1.09-.18,1.97v3.67h-2.02v-9.15h1.89v1.82c.37-.74.83-1.28,1.38-1.6.48-.29,1.05-.43,1.72-.43.09,0,.21,0,.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M450.09,450.5v1.92h-2.02v-1.92h2.02ZM450.09,453.96v9.15h-2.02v-9.15h2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M459.51,456.63h-1.94c-.07-.5-.26-.87-.57-1.09-.31-.23-.78-.34-1.39-.34-.55,0-.97.11-1.27.32-.25.19-.38.44-.38.75,0,.36.16.62.49.79.29.15.91.32,1.84.52,1.23.26,2.11.57,2.64.95.6.42.9,1.04.9,1.85,0,.98-.4,1.74-1.21,2.28-.71.47-1.63.71-2.77.71-2.62,0-3.99-1.06-4.11-3.18h1.93c.13,1.13.86,1.69,2.2,1.69.64,0,1.13-.13,1.5-.41.31-.24.47-.54.47-.91s-.17-.64-.5-.83c-.29-.16-.85-.34-1.67-.53-.89-.21-1.49-.36-1.78-.45-.29-.09-.57-.21-.85-.36-.34-.19-.61-.46-.8-.8s-.29-.72-.29-1.14c0-.91.38-1.61,1.12-2.1.65-.42,1.52-.63,2.61-.63,1.46,0,2.52.38,3.18,1.13.36.42.57,1.02.64,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M463.33,453.96v1.28c.41-.55.84-.94,1.29-1.18.45-.24.98-.36,1.6-.36,1.21,0,2.05.52,2.54,1.55.76-1.04,1.74-1.55,2.96-1.55.54,0,1.02.1,1.46.31.44.21.79.49,1.04.86.33.47.5,1.14.5,2v6.23h-2.02v-5.62c0-.65-.06-1.1-.19-1.34-.24-.5-.72-.75-1.44-.75-.41,0-.78.1-1.1.29-.32.19-.55.47-.71.82-.13.3-.2.87-.2,1.69v4.91h-2.02v-5.73c0-.75-.11-1.26-.34-1.52-.28-.31-.67-.46-1.18-.46-.4,0-.77.1-1.1.31-.33.21-.58.49-.74.84-.16.34-.24.9-.24,1.66v4.9h-2.02v-9.15h1.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M55.79,349.83l1.05-1.76c.43.7.79,1.56,1.08,2.58.29,1.02.44,2.34.44,3.98s-.2,2.94-.59,4.13-.94,2.22-1.64,3.08l-.53.82c-.74.78-1.58,1.49-2.52,2.11-.94.62-1.93,1.15-2.99,1.58l.35-.59c1.52,1.84,3.3,3.75,5.33,5.74,2.03,1.99,4.18,3.91,6.45,5.74l-4.28,4.34c-2.15-1.95-4.17-3.86-6.06-5.71-1.9-1.86-3.57-3.6-5.01-5.25s-2.64-3.07-3.57-4.28c-.86-1.17-1.42-2.15-1.67-2.93-.25-.78-.38-1.5-.38-2.17,0-.9.33-1.78,1-2.64s1.78-1.29,3.34-1.29c1.02,0,1.92.21,2.73.64.8.43,1.53,1.04,2.2,1.82.66.78,1.31,1.76,1.93,2.93l-3.93-1.64c.82-.55,1.45-1.2,1.9-1.96.45-.76.77-1.59.97-2.49.19-.9.29-1.82.29-2.75,0-1.25-.15-2.4-.44-3.46s-.62-1.84-.97-2.34l3.63,1.76h-14.65v-5.57h27.66v5.57h-11.13ZM62.18,361.44c1.21,0,2.32-.05,3.34-.15,1.01-.1,2.07-.26,3.16-.5l.59,5.68c-1.05.2-2.12.33-3.19.41-1.08.08-2.16.12-3.25.12-1.48,0-2.91-.09-4.28-.26-1.37-.18-2.62-.43-3.75-.76-1.13-.33-2.09-.69-2.87-1.08l.94-4.86c.94.27,1.89.52,2.87.73.98.21,2,.38,3.08.5s2.2.18,3.37.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M99.04,349.83h-5.8v30.88h-6.68v-11.19l1.7,1.93c-1.52,1.05-3.07,1.9-4.63,2.52s-3.52.94-5.86.94-4.21-.41-5.95-1.23-3.12-1.99-4.16-3.52-1.55-3.38-1.55-5.57c0-3.32,1.14-5.92,3.43-7.79,2.29-1.88,5.3-2.81,9.05-2.81.7,0,1.46.02,2.26.06.8.04,1.55.1,2.26.18.7.08,1.25.18,1.64.29l-.47,5.68c-.66-.16-1.42-.28-2.26-.38-.84-.1-1.67-.15-2.49-.15-2.19,0-3.86.43-5.01,1.29-1.15.86-1.73,2.05-1.73,3.57,0,1.72.54,2.94,1.61,3.66,1.07.72,2.35,1.08,3.84,1.08s2.81-.24,3.98-.73c1.17-.49,2.22-1.14,3.13-1.96s1.75-1.68,2.49-2.58l-1.29,4.45v-18.63h-22.79v-5.57h35.28v5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M111.75,349.83v16.93c0,1.37-.3,2.37-.91,3.02-.61.64-1.48.97-2.61.97-.86,0-1.75-.25-2.67-.76-.92-.51-1.79-1.17-2.61-1.99s-1.48-1.71-1.99-2.67c-.51-.96-.76-1.88-.76-2.78,0-.98.26-1.81.79-2.49s1.57-1.03,3.13-1.03h.94v-9.2h-6.91v-5.57h35.57v5.57h-5.74v30.88h-6.68v-30.88h-9.55ZM109.24,382.24l-3.52-4.86,15.59-8.85,2.87,4.22-14.94,9.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M144.39,349.83v30.88h-6.68v-30.88h-4.86v-5.57h17.29v5.57h-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M181.25,349.83v30.88h-6.74v-13.59h-11.66v1.46c0,1.52-.32,2.61-.97,3.25s-1.51.97-2.61.97c-.82,0-1.69-.25-2.61-.76-.92-.51-1.78-1.17-2.58-1.99s-1.46-1.71-1.99-2.67c-.53-.96-.79-1.85-.79-2.67,0-.9.27-1.65.82-2.26.55-.61,1.58-.91,3.11-.91h.94v-11.72h-6.86v-5.57h37.68v5.57h-5.74ZM174.51,349.83h-11.66v11.72h11.66v-11.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M226.05,368.38c-.38,5-2.26,8.87-5.63,11.62-2.94,2.41-6.63,3.61-11.08,3.61-5.76,0-10.29-2.02-13.59-6.05-2.87-3.52-4.31-8.01-4.31-13.47,0-6.14,1.92-11.04,5.75-14.69,3.32-3.17,7.48-4.75,12.47-4.75,4.68,0,8.57,1.43,11.67,4.28,2.69,2.46,4.17,5.48,4.43,9.06h-7.99c-.46-2.22-1.5-3.92-3.11-5.08-1.39-1-3.11-1.49-5.15-1.49-3.25,0-5.78,1.29-7.57,3.88-1.56,2.27-2.34,5.23-2.34,8.86,0,4.15,1,7.37,3.01,9.66,1.74,2.01,4.02,3.01,6.82,3.01,2.59,0,4.62-.82,6.1-2.46,1.29-1.43,2.1-3.43,2.41-6h8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M243.22,355.04c4.48,0,8,1.46,10.56,4.38,2.21,2.54,3.31,5.81,3.31,9.81,0,4.6-1.44,8.21-4.31,10.83-2.49,2.27-5.69,3.41-9.61,3.41-4.5,0-8.03-1.48-10.6-4.43-2.24-2.56-3.36-5.83-3.36-9.81,0-4.55,1.46-8.13,4.38-10.75,2.52-2.29,5.73-3.44,9.63-3.44ZM243.12,360.49c-2.16,0-3.82.88-4.98,2.64-1,1.54-1.49,3.58-1.49,6.12,0,2.95.65,5.2,1.94,6.75,1.14,1.34,2.68,2.02,4.61,2.02,2.17,0,3.83-.88,4.95-2.64,1-1.53,1.49-3.58,1.49-6.15,0-2.94-.66-5.18-1.97-6.72-1.13-1.34-2.65-2.02-4.56-2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M268.99,355.76v3.68c1.13-1.54,2.38-2.67,3.75-3.37,1.37-.71,2.97-1.06,4.82-1.06,3.6,0,6.12,1.49,7.54,4.48,2.19-2.99,5.14-4.48,8.86-4.48,3.09,0,5.43.95,7.02,2.84,1.38,1.64,2.07,3.88,2.07,6.72v18.15h-7.37v-16.11c0-1.74-.19-2.96-.57-3.66-.7-1.28-1.95-1.92-3.76-1.92-2.21,0-3.74.9-4.61,2.71-.4.81-.6,2.26-.6,4.33v14.64h-7.34v-16.43c0-1.59-.19-2.75-.57-3.49-.65-1.18-1.82-1.77-3.51-1.77-1.05,0-1.99.25-2.84.76-.85.51-1.48,1.21-1.89,2.1-.43.88-.65,2.27-.65,4.18v14.64h-7.37v-26.96h7.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M316.39,355.76v3.68c1.13-1.54,2.38-2.67,3.75-3.37,1.37-.71,2.97-1.06,4.82-1.06,3.6,0,6.12,1.49,7.54,4.48,2.19-2.99,5.14-4.48,8.86-4.48,3.09,0,5.43.95,7.02,2.84,1.38,1.64,2.07,3.88,2.07,6.72v18.15h-7.37v-16.11c0-1.74-.19-2.96-.57-3.66-.7-1.28-1.95-1.92-3.76-1.92-2.21,0-3.74.9-4.61,2.71-.4.81-.6,2.26-.6,4.33v14.64h-7.34v-16.43c0-1.59-.19-2.75-.57-3.49-.65-1.18-1.82-1.77-3.51-1.77-1.05,0-1.99.25-2.84.76-.85.51-1.48,1.21-1.89,2.1-.43.88-.65,2.27-.65,4.18v14.64h-7.37v-26.96h7.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M381.83,355.76v26.96h-7.02v-3.83c-2.12,3.05-5.09,4.58-8.89,4.58-3.32,0-5.83-1.08-7.52-3.24-1.21-1.53-1.82-3.99-1.82-7.39v-17.08h7.37v14.89c0,1.54.05,2.65.15,3.31s.29,1.22.57,1.67c.76,1.21,2.08,1.82,3.96,1.82,2.34,0,4.02-1,5.05-3.01.51-.98.77-2.75.77-5.3v-13.37h7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M395.38,355.76v3.76c1.18-1.58,2.48-2.72,3.91-3.44,1.43-.71,3.12-1.07,5.08-1.07,1.71,0,3.24.33,4.61.98,1.36.66,2.41,1.56,3.14,2.73.55.86.92,1.81,1.13,2.84.21,1.03.31,2.43.31,4.21v16.95h-7.37v-15.48c0-1.74-.16-3.02-.47-3.83-.28-.73-.8-1.31-1.54-1.73-.75-.42-1.62-.63-2.61-.63-1.13,0-2.15.27-3.06.8-.91.53-1.58,1.25-2.02,2.17-.5,1.03-.75,2.62-.75,4.78v13.94h-7.37v-26.96h7.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M427.24,345.56v6.32h-7.37v-6.32h7.37ZM427.24,355.76v26.96h-7.37v-26.96h7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M447.41,355.76v4.98h-5.48v12.72c0,1.68.19,2.74.57,3.2s1.28.68,2.69.68c.58,0,1.32-.05,2.22-.15v5.63c-1.66.18-3.17.27-4.53.27-1.92,0-3.44-.2-4.56-.6-1.11-.4-1.97-1.05-2.59-1.94-.5-.7-.82-1.51-.96-2.43-.14-.92-.21-2.57-.21-4.94v-12.45h-4.51v-4.98h4.51v-8.12h7.37v8.12h5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M476.01,355.76l-9.88,26.84c-1.01,2.72-1.84,4.63-2.49,5.74s-1.48,2-2.49,2.68c-.81.56-1.63.93-2.45,1.09s-2.18.25-4.07.25h-.75l-3.01-.07v-6.1h2.96c1.51,0,2.59-.27,3.25-.8.66-.53.98-1.4.98-2.61,0-.7-.08-1.25-.22-1.64l-9.61-25.37h7.97l4.48,13.22c.45,1.36,1,3.45,1.67,6.27.75-2.95,1.36-5.16,1.84-6.62l4.18-12.87h7.64Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-412",
    x1: 39.02,
    y1: 438.81,
    x2: 39.02,
    y2: 438.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-414",
    x1: 39.02,
    y1: 438.81,
    x2: 43.04,
    y2: 438.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-413",
    x1: 44.04,
    y1: 438.81,
    x2: 476.26,
    y2: 438.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-412",
    x1: 476.26,
    y1: 438.81,
    x2: 476.26,
    y2: 438.81
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwagramaLogo);
export default __webpack_public_path__ + "static/media/swagramaLogo.d66e26416421be0bb77e2864d75876a6.svg";
export { ForwardRef as ReactComponent };